var Tm = Object.defineProperty;
var Mm = (r, e, t) => e in r ? Tm(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t;
var Sa = (r, e, t) => Mm(r, typeof e != "symbol" ? e + "" : e, t);
let $r = class extends Error {
  constructor(e) {
    super(e), this.name = "AbortError";
  }
};
function Im(...r) {
  if (r.length > 0) {
    const e = String(r[0]);
    e.includes(":error") ? console.error(...r) : e.includes(":warning") ? console.warn(...r) : e.includes(":info") ? console.info(...r) : e.includes(":verbose") ? console.debug(...r) : console.debug(...r);
  }
}
const Ra = typeof process < "u" && process.env && process.env.DEBUG || void 0;
let rn, Er = [], Tr = [];
const Yt = [];
Ra && jr(Ra);
const je = Object.assign((r) => an(r), {
  enable: jr,
  enabled: Fr,
  disable: qm,
  log: Im
});
function jr(r) {
  rn = r, Er = [], Tr = [];
  const e = /\*/g, t = r.split(",").map((a) => a.trim().replace(e, ".*?"));
  for (const a of t)
    a.startsWith("-") ? Tr.push(new RegExp(`^${a.substr(1)}$`)) : Er.push(new RegExp(`^${a}$`));
  for (const a of Yt)
    a.enabled = Fr(a.namespace);
}
function Fr(r) {
  if (r.endsWith("*"))
    return !0;
  for (const e of Tr)
    if (e.test(r))
      return !1;
  for (const e of Er)
    if (e.test(r))
      return !0;
  return !1;
}
function qm() {
  const r = rn || "";
  return jr(""), r;
}
function an(r) {
  const e = Object.assign(t, {
    enabled: Fr(r),
    destroy: Om,
    log: je.log,
    namespace: r,
    extend: _m
  });
  function t(...a) {
    e.enabled && (a.length > 0 && (a[0] = `${r} ${a[0]}`), e.log(...a));
  }
  return Yt.push(e), e;
}
function Om() {
  const r = Yt.indexOf(this);
  return r >= 0 ? (Yt.splice(r, 1), !0) : !1;
}
function _m(r) {
  const e = an(`${this.namespace}:${r}`);
  return e.log = this.log, e;
}
const Mr = ["verbose", "info", "warning", "error"], wa = {
  verbose: 400,
  info: 300,
  warning: 200,
  error: 100
};
function Ba(r, e) {
  e.log = (...t) => {
    r.log(...t);
  };
}
function Ea(r) {
  return Mr.includes(r);
}
function nn(r) {
  const e = /* @__PURE__ */ new Set(), t = typeof process < "u" && process.env && process.env[r.logLevelEnvVarName] || void 0;
  let a;
  const n = je(r.namespace);
  n.log = (...c) => {
    je.log(...c);
  };
  function i(c) {
    if (c && !Ea(c))
      throw new Error(`Unknown log level '${c}'. Acceptable values: ${Mr.join(",")}`);
    a = c;
    const d = [];
    for (const p of e)
      s(p) && d.push(p.namespace);
    je.enable(d.join(","));
  }
  t && (Ea(t) ? i(t) : console.error(`${r.logLevelEnvVarName} set to unknown log level '${t}'; logging is not enabled. Acceptable values: ${Mr.join(", ")}.`));
  function s(c) {
    return !!(a && wa[c.level] <= wa[a]);
  }
  function o(c, d) {
    const p = Object.assign(c.extend(d), {
      level: d
    });
    if (Ba(c, p), s(p)) {
      const y = je.disable();
      je.enable(y + "," + p.namespace);
    }
    return e.add(p), p;
  }
  function l() {
    return a;
  }
  function m(c) {
    const d = n.extend(c);
    return Ba(n, d), {
      error: o(d, "error"),
      warning: o(d, "warning"),
      info: o(d, "info"),
      verbose: o(d, "verbose")
    };
  }
  return {
    setLogLevel: i,
    getLogLevel: l,
    createClientLogger: m,
    logger: n
  };
}
const Hm = nn({
  logLevelEnvVarName: "TYPESPEC_RUNTIME_LOG_LEVEL",
  namespace: "typeSpecRuntime"
});
function sn(r) {
  return Hm.createClientLogger(r);
}
function Ft(r) {
  return r.toLowerCase();
}
function* Dm(r) {
  for (const e of r.values())
    yield [e.name, e.value];
}
class Lm {
  constructor(e) {
    if (this._headersMap = /* @__PURE__ */ new Map(), e)
      for (const t of Object.keys(e))
        this.set(t, e[t]);
  }
  /**
   * Set a header in this collection with the provided name and value. The name is
   * case-insensitive.
   * @param name - The name of the header to set. This value is case-insensitive.
   * @param value - The value of the header to set.
   */
  set(e, t) {
    this._headersMap.set(Ft(e), { name: e, value: String(t).trim() });
  }
  /**
   * Get the header value for the provided header name, or undefined if no header exists in this
   * collection with the provided name.
   * @param name - The name of the header. This value is case-insensitive.
   */
  get(e) {
    var t;
    return (t = this._headersMap.get(Ft(e))) === null || t === void 0 ? void 0 : t.value;
  }
  /**
   * Get whether or not this header collection contains a header entry for the provided header name.
   * @param name - The name of the header to set. This value is case-insensitive.
   */
  has(e) {
    return this._headersMap.has(Ft(e));
  }
  /**
   * Remove the header with the provided headerName.
   * @param name - The name of the header to remove.
   */
  delete(e) {
    this._headersMap.delete(Ft(e));
  }
  /**
   * Get the JSON object representation of this HTTP header collection.
   */
  toJSON(e = {}) {
    const t = {};
    if (e.preserveCase)
      for (const a of this._headersMap.values())
        t[a.name] = a.value;
    else
      for (const [a, n] of this._headersMap)
        t[a] = n.value;
    return t;
  }
  /**
   * Get the string representation of this HTTP header collection.
   */
  toString() {
    return JSON.stringify(this.toJSON({ preserveCase: !0 }));
  }
  /**
   * Iterate over tuples of header [name, value] pairs.
   */
  [Symbol.iterator]() {
    return Dm(this._headersMap);
  }
}
function Mt(r) {
  return new Lm(r);
}
function km() {
  let r = "";
  for (let e = 0; e < 32; e++) {
    const t = Math.floor(Math.random() * 16);
    e === 12 ? r += "4" : e === 16 ? r += t & 3 | 8 : r += t.toString(16), (e === 7 || e === 11 || e === 15 || e === 19) && (r += "-");
  }
  return r;
}
var gr;
const Am = typeof ((gr = globalThis == null ? void 0 : globalThis.crypto) === null || gr === void 0 ? void 0 : gr.randomUUID) == "function" ? globalThis.crypto.randomUUID.bind(globalThis.crypto) : km;
function Kr() {
  return Am();
}
class Um {
  constructor(e) {
    var t, a, n, i, s, o, l;
    this.url = e.url, this.body = e.body, this.headers = (t = e.headers) !== null && t !== void 0 ? t : Mt(), this.method = (a = e.method) !== null && a !== void 0 ? a : "GET", this.timeout = (n = e.timeout) !== null && n !== void 0 ? n : 0, this.multipartBody = e.multipartBody, this.formData = e.formData, this.disableKeepAlive = (i = e.disableKeepAlive) !== null && i !== void 0 ? i : !1, this.proxySettings = e.proxySettings, this.streamResponseStatusCodes = e.streamResponseStatusCodes, this.withCredentials = (s = e.withCredentials) !== null && s !== void 0 ? s : !1, this.abortSignal = e.abortSignal, this.onUploadProgress = e.onUploadProgress, this.onDownloadProgress = e.onDownloadProgress, this.requestId = e.requestId || Kr(), this.allowInsecureConnection = (o = e.allowInsecureConnection) !== null && o !== void 0 ? o : !1, this.enableBrowserStreams = (l = e.enableBrowserStreams) !== null && l !== void 0 ? l : !1, this.requestOverrides = e.requestOverrides, this.authSchemes = e.authSchemes;
  }
}
function $m(r) {
  return new Um(r);
}
const Ta = /* @__PURE__ */ new Set(["Deserialize", "Serialize", "Retry", "Sign"]);
class Zt {
  constructor(e) {
    var t;
    this._policies = [], this._policies = (t = e == null ? void 0 : e.slice(0)) !== null && t !== void 0 ? t : [], this._orderedPolicies = void 0;
  }
  addPolicy(e, t = {}) {
    if (t.phase && t.afterPhase)
      throw new Error("Policies inside a phase cannot specify afterPhase.");
    if (t.phase && !Ta.has(t.phase))
      throw new Error(`Invalid phase name: ${t.phase}`);
    if (t.afterPhase && !Ta.has(t.afterPhase))
      throw new Error(`Invalid afterPhase name: ${t.afterPhase}`);
    this._policies.push({
      policy: e,
      options: t
    }), this._orderedPolicies = void 0;
  }
  removePolicy(e) {
    const t = [];
    return this._policies = this._policies.filter((a) => e.name && a.policy.name === e.name || e.phase && a.options.phase === e.phase ? (t.push(a.policy), !1) : !0), this._orderedPolicies = void 0, t;
  }
  sendRequest(e, t) {
    return this.getOrderedPolicies().reduceRight((i, s) => (o) => s.sendRequest(o, i), (i) => e.sendRequest(i))(t);
  }
  getOrderedPolicies() {
    return this._orderedPolicies || (this._orderedPolicies = this.orderPolicies()), this._orderedPolicies;
  }
  clone() {
    return new Zt(this._policies);
  }
  static create() {
    return new Zt();
  }
  orderPolicies() {
    const e = [], t = /* @__PURE__ */ new Map();
    function a(u) {
      return {
        name: u,
        policies: /* @__PURE__ */ new Set(),
        hasRun: !1,
        hasAfterPolicies: !1
      };
    }
    const n = a("Serialize"), i = a("None"), s = a("Deserialize"), o = a("Retry"), l = a("Sign"), m = [n, i, s, o, l];
    function c(u) {
      return u === "Retry" ? o : u === "Serialize" ? n : u === "Deserialize" ? s : u === "Sign" ? l : i;
    }
    for (const u of this._policies) {
      const h = u.policy, R = u.options, M = h.name;
      if (t.has(M))
        throw new Error("Duplicate policy names not allowed in pipeline");
      const T = {
        policy: h,
        dependsOn: /* @__PURE__ */ new Set(),
        dependants: /* @__PURE__ */ new Set()
      };
      R.afterPhase && (T.afterPhase = c(R.afterPhase), T.afterPhase.hasAfterPolicies = !0), t.set(M, T), c(R.phase).policies.add(T);
    }
    for (const u of this._policies) {
      const { policy: h, options: R } = u, M = h.name, T = t.get(M);
      if (!T)
        throw new Error(`Missing node for policy ${M}`);
      if (R.afterPolicies)
        for (const $ of R.afterPolicies) {
          const f = t.get($);
          f && (T.dependsOn.add(f), f.dependants.add(T));
        }
      if (R.beforePolicies)
        for (const $ of R.beforePolicies) {
          const f = t.get($);
          f && (f.dependsOn.add(T), T.dependants.add(f));
        }
    }
    function d(u) {
      u.hasRun = !0;
      for (const h of u.policies)
        if (!(h.afterPhase && (!h.afterPhase.hasRun || h.afterPhase.policies.size)) && h.dependsOn.size === 0) {
          e.push(h.policy);
          for (const R of h.dependants)
            R.dependsOn.delete(h);
          t.delete(h.policy.name), u.policies.delete(h);
        }
    }
    function p() {
      for (const u of m) {
        if (d(u), u.policies.size > 0 && u !== i) {
          i.hasRun || d(i);
          return;
        }
        u.hasAfterPolicies && d(i);
      }
    }
    let y = 0;
    for (; t.size > 0; ) {
      y++;
      const u = e.length;
      if (p(), e.length <= u && y > 1)
        throw new Error("Cannot satisfy policy dependencies due to requirements cycle.");
    }
    return e;
  }
}
function jm() {
  return Zt.create();
}
function on(r) {
  return typeof r == "object" && r !== null && !Array.isArray(r) && !(r instanceof RegExp) && !(r instanceof Date);
}
function Gr(r) {
  if (on(r)) {
    const e = typeof r.name == "string", t = typeof r.message == "string";
    return e && t;
  }
  return !1;
}
const Fm = Symbol(), hr = "REDACTED", Km = [
  "x-ms-client-request-id",
  "x-ms-return-client-request-id",
  "x-ms-useragent",
  "x-ms-correlation-request-id",
  "x-ms-request-id",
  "client-request-id",
  "ms-cv",
  "return-client-request-id",
  "traceparent",
  "Access-Control-Allow-Credentials",
  "Access-Control-Allow-Headers",
  "Access-Control-Allow-Methods",
  "Access-Control-Allow-Origin",
  "Access-Control-Expose-Headers",
  "Access-Control-Max-Age",
  "Access-Control-Request-Headers",
  "Access-Control-Request-Method",
  "Origin",
  "Accept",
  "Accept-Encoding",
  "Cache-Control",
  "Connection",
  "Content-Length",
  "Content-Type",
  "Date",
  "ETag",
  "Expires",
  "If-Match",
  "If-Modified-Since",
  "If-None-Match",
  "If-Unmodified-Since",
  "Last-Modified",
  "Pragma",
  "Request-Id",
  "Retry-After",
  "Server",
  "Transfer-Encoding",
  "User-Agent",
  "WWW-Authenticate"
], Gm = ["api-version"];
class Xr {
  constructor({ additionalAllowedHeaderNames: e = [], additionalAllowedQueryParameters: t = [] } = {}) {
    e = Km.concat(e), t = Gm.concat(t), this.allowedHeaderNames = new Set(e.map((a) => a.toLowerCase())), this.allowedQueryParameters = new Set(t.map((a) => a.toLowerCase()));
  }
  /**
   * Sanitizes an object for logging.
   * @param obj - The object to sanitize
   * @returns - The sanitized object as a string
   */
  sanitize(e) {
    const t = /* @__PURE__ */ new Set();
    return JSON.stringify(e, (a, n) => {
      if (n instanceof Error)
        return Object.assign(Object.assign({}, n), { name: n.name, message: n.message });
      if (a === "headers")
        return this.sanitizeHeaders(n);
      if (a === "url")
        return this.sanitizeUrl(n);
      if (a === "query")
        return this.sanitizeQuery(n);
      if (a === "body")
        return;
      if (a === "response")
        return;
      if (a === "operationSpec")
        return;
      if (Array.isArray(n) || on(n)) {
        if (t.has(n))
          return "[Circular]";
        t.add(n);
      }
      return n;
    }, 2);
  }
  /**
   * Sanitizes a URL for logging.
   * @param value - The URL to sanitize
   * @returns - The sanitized URL as a string
   */
  sanitizeUrl(e) {
    if (typeof e != "string" || e === null || e === "")
      return e;
    const t = new URL(e);
    if (!t.search)
      return e;
    for (const [a] of t.searchParams)
      this.allowedQueryParameters.has(a.toLowerCase()) || t.searchParams.set(a, hr);
    return t.toString();
  }
  sanitizeHeaders(e) {
    const t = {};
    for (const a of Object.keys(e))
      this.allowedHeaderNames.has(a.toLowerCase()) ? t[a] = e[a] : t[a] = hr;
    return t;
  }
  sanitizeQuery(e) {
    if (typeof e != "object" || e === null)
      return e;
    const t = {};
    for (const a of Object.keys(e))
      this.allowedQueryParameters.has(a.toLowerCase()) ? t[a] = e[a] : t[a] = hr;
    return t;
  }
}
const Xm = new Xr();
let Xe = class mn extends Error {
  constructor(e, t = {}) {
    super(e), this.name = "RestError", this.code = t.code, this.statusCode = t.statusCode, Object.defineProperty(this, "request", { value: t.request, enumerable: !1 }), Object.defineProperty(this, "response", { value: t.response, enumerable: !1 }), Object.defineProperty(this, Fm, {
      value: () => `RestError: ${this.message} 
 ${Xm.sanitize(Object.assign(Object.assign({}, this), { request: this.request, response: this.response }))}`,
      enumerable: !1
    }), Object.setPrototypeOf(this, mn.prototype);
  }
};
Xe.REQUEST_SEND_ERROR = "REQUEST_SEND_ERROR";
Xe.PARSE_ERROR = "PARSE_ERROR";
function Wm(r) {
  return r instanceof Xe ? !0 : Gr(r) && r.name === "RestError";
}
function Me(r, e) {
  switch (e) {
    case "utf-8":
      return Qm(r);
    case "base64":
      return ln(r);
    case "base64url":
      return Jm(r);
    case "hex":
      return Ym(r);
  }
}
function Qm(r) {
  return new TextEncoder().encode(r);
}
function ln(r) {
  return new Uint8Array([...atob(r)].map((e) => e.charCodeAt(0)));
}
function Jm(r) {
  const e = r.replace(/-/g, "+").replace(/_/g, "/");
  return ln(e);
}
const Ma = new Set("0123456789abcdefABCDEF");
function Ym(r) {
  const e = new Uint8Array(r.length / 2);
  for (let t = 0; t < r.length / 2; ++t) {
    const a = r[2 * t], n = r[2 * t + 1];
    if (!Ma.has(a) || !Ma.has(n))
      return e.slice(0, t);
    e[t] = parseInt(`${a}${n}`, 16);
  }
  return e;
}
function Zm(r) {
  return !!(r && typeof r.pipe == "function");
}
function Wr(r) {
  return !!(r && typeof r.getReader == "function" && typeof r.tee == "function");
}
function Vm(r) {
  return typeof r.stream == "function";
}
function el(r) {
  return (typeof Blob == "function" || typeof Blob == "object") && r instanceof Blob;
}
class tl {
  /**
   * Makes a request over an underlying transport layer and returns the response.
   * @param request - The request to be made.
   */
  async sendRequest(e) {
    if (new URL(e.url).protocol !== "https:" && !e.allowInsecureConnection)
      throw new Error(`Cannot connect to ${e.url} while allowInsecureConnection is false.`);
    if (e.proxySettings)
      throw new Error("HTTP proxy is not supported in browser environment");
    try {
      return await rl(e);
    } catch (n) {
      throw il(n, e);
    }
  }
}
async function rl(r) {
  const { abortController: e, abortControllerCleanup: t } = nl(r);
  try {
    const a = sl(r.headers), { streaming: n, body: i } = ml(r), s = Object.assign(Object.assign({ body: i, method: r.method, headers: a, signal: e.signal }, "credentials" in Request.prototype ? { credentials: r.withCredentials ? "include" : "same-origin" } : {}), "cache" in Request.prototype ? { cache: "no-store" } : {});
    n && (s.duplex = "half");
    const o = await fetch(r.url, Object.assign(Object.assign({}, s), r.requestOverrides));
    return el(r.body) && r.onUploadProgress && r.onUploadProgress({ loadedBytes: r.body.size }), al(o, r, t);
  } catch (a) {
    throw t == null || t(), a;
  }
}
async function al(r, e, t) {
  var a, n;
  const i = ol(r), s = {
    request: e,
    headers: i,
    status: r.status
  }, o = Wr(r.body) ? cn(r.body, {
    onProgress: e.onDownloadProgress,
    onEnd: t
  }) : r.body;
  if (
    // Value of POSITIVE_INFINITY in streamResponseStatusCodes is considered as any status code
    !((a = e.streamResponseStatusCodes) === null || a === void 0) && a.has(Number.POSITIVE_INFINITY) || !((n = e.streamResponseStatusCodes) === null || n === void 0) && n.has(s.status)
  )
    if (e.enableBrowserStreams)
      s.browserStreamBody = o ?? void 0;
    else {
      const l = new Response(o);
      s.blobBody = l.blob(), t == null || t();
    }
  else {
    const l = new Response(o);
    s.bodyAsText = await l.text(), t == null || t();
  }
  return s;
}
function nl(r) {
  const e = new AbortController();
  let t, a;
  if (r.abortSignal) {
    if (r.abortSignal.aborted)
      throw new $r("The operation was aborted. Request has already been canceled.");
    a = (n) => {
      n.type === "abort" && e.abort();
    }, r.abortSignal.addEventListener("abort", a), t = () => {
      var n;
      a && ((n = r.abortSignal) === null || n === void 0 || n.removeEventListener("abort", a));
    };
  }
  return r.timeout > 0 && setTimeout(() => {
    e.abort();
  }, r.timeout), { abortController: e, abortControllerCleanup: t };
}
function il(r, e) {
  var t;
  return r && (r == null ? void 0 : r.name) === "AbortError" ? r : new Xe(`Error sending request: ${r.message}`, {
    code: (t = r == null ? void 0 : r.code) !== null && t !== void 0 ? t : Xe.REQUEST_SEND_ERROR,
    request: e
  });
}
function sl(r) {
  const e = new Headers();
  for (const [t, a] of r)
    e.append(t, a);
  return e;
}
function ol(r) {
  const e = Mt();
  for (const [t, a] of r.headers)
    e.set(t, a);
  return e;
}
function ml(r) {
  const e = typeof r.body == "function" ? r.body() : r.body;
  if (Zm(e))
    throw new Error("Node streams are not supported in browser environment.");
  return Wr(e) ? { streaming: !0, body: cn(e, { onProgress: r.onUploadProgress }) } : { streaming: !1, body: e };
}
function cn(r, e = {}) {
  let t = 0;
  const { onProgress: a, onEnd: n } = e;
  if (cl(r))
    return r.pipeThrough(new TransformStream({
      transform(i, s) {
        if (i === null) {
          s.terminate();
          return;
        }
        s.enqueue(i), t += i.length, a && a({ loadedBytes: t });
      },
      flush() {
        n == null || n();
      }
    }));
  {
    const i = r.getReader();
    return new ReadableStream({
      async pull(s) {
        var o;
        const { done: l, value: m } = await i.read();
        if (l || !m) {
          n == null || n(), s.close(), i.releaseLock();
          return;
        }
        t += (o = m == null ? void 0 : m.length) !== null && o !== void 0 ? o : 0, s.enqueue(m), a && a({ loadedBytes: t });
      },
      cancel(s) {
        return n == null || n(), i.cancel(s);
      }
    });
  }
}
function ll() {
  return new tl();
}
function cl(r) {
  return r.pipeThrough !== void 0 && self.TransformStream !== void 0;
}
function dl() {
  return ll();
}
const pl = sn("ts-http-runtime"), ul = "logPolicy";
function yl(r = {}) {
  var e;
  const t = (e = r.logger) !== null && e !== void 0 ? e : pl.info, a = new Xr({
    additionalAllowedHeaderNames: r.additionalAllowedHeaderNames,
    additionalAllowedQueryParameters: r.additionalAllowedQueryParameters
  });
  return {
    name: ul,
    async sendRequest(n, i) {
      if (!t.enabled)
        return i(n);
      t(`Request: ${a.sanitize(n)}`);
      const s = await i(n);
      return t(`Response status code: ${s.status}`), t(`Headers: ${a.sanitize(s.headers)}`), s;
    }
  };
}
const dn = "redirectPolicy", Ia = ["GET", "HEAD"];
function fl(r = {}) {
  const { maxRetries: e = 20 } = r;
  return {
    name: dn,
    async sendRequest(t, a) {
      const n = await a(t);
      return pn(a, n, e);
    }
  };
}
async function pn(r, e, t, a = 0) {
  const { request: n, status: i, headers: s } = e, o = s.get("location");
  if (o && (i === 300 || i === 301 && Ia.includes(n.method) || i === 302 && Ia.includes(n.method) || i === 303 && n.method === "POST" || i === 307) && a < t) {
    const l = new URL(o, n.url);
    n.url = l.toString(), i === 303 && (n.method = "GET", n.headers.delete("Content-Length"), delete n.body), n.headers.delete("Authorization");
    const m = await r(n);
    return pn(r, m, t, a + 1);
  }
  return e;
}
const Ir = 3, gl = "decompressResponsePolicy";
function hl() {
  throw new Error("decompressResponsePolicy is not supported in browser environment");
}
function xl(r, e) {
  return r = Math.ceil(r), e = Math.floor(e), Math.floor(Math.random() * (e - r + 1)) + r;
}
function Nl(r, e) {
  const t = e.retryDelayInMs * Math.pow(2, r), a = Math.min(e.maxRetryDelayInMs, t);
  return { retryAfterInMs: a / 2 + xl(0, a / 2) };
}
const bl = "The operation was aborted.";
function Cl(r, e, t) {
  return new Promise((a, n) => {
    let i, s;
    const o = () => n(new $r(t != null && t.abortErrorMsg ? t == null ? void 0 : t.abortErrorMsg : bl)), l = () => {
      t != null && t.abortSignal && s && t.abortSignal.removeEventListener("abort", s);
    };
    if (s = () => (i && clearTimeout(i), l(), o()), t != null && t.abortSignal && t.abortSignal.aborted)
      return o();
    i = setTimeout(() => {
      l(), a(e);
    }, r), t != null && t.abortSignal && t.abortSignal.addEventListener("abort", s);
  });
}
function Pl(r, e) {
  const t = r.headers.get(e);
  if (!t)
    return;
  const a = Number(t);
  if (!Number.isNaN(a))
    return a;
}
const qr = "Retry-After", vl = ["retry-after-ms", "x-ms-retry-after-ms", qr];
function un(r) {
  if (r && [429, 503].includes(r.status))
    try {
      for (const n of vl) {
        const i = Pl(r, n);
        if (i === 0 || i)
          return i * (n === qr ? 1e3 : 1);
      }
      const e = r.headers.get(qr);
      if (!e)
        return;
      const a = Date.parse(e) - Date.now();
      return Number.isFinite(a) ? Math.max(0, a) : void 0;
    } catch {
      return;
    }
}
function zl(r) {
  return Number.isFinite(un(r));
}
function Sl() {
  return {
    name: "throttlingRetryStrategy",
    retry({ response: r }) {
      const e = un(r);
      return Number.isFinite(e) ? {
        retryAfterInMs: e
      } : { skipStrategy: !0 };
    }
  };
}
const Rl = 1e3, wl = 1e3 * 64;
function Bl(r = {}) {
  var e, t;
  const a = (e = r.retryDelayInMs) !== null && e !== void 0 ? e : Rl, n = (t = r.maxRetryDelayInMs) !== null && t !== void 0 ? t : wl;
  return {
    name: "exponentialRetryStrategy",
    retry({ retryCount: i, response: s, responseError: o }) {
      const l = Tl(o), m = l && r.ignoreSystemErrors, c = El(s), d = c && r.ignoreHttpStatusCodes;
      return s && (zl(s) || !c) || d || m ? { skipStrategy: !0 } : o && !l && !c ? { errorToThrow: o } : Nl(i, {
        retryDelayInMs: a,
        maxRetryDelayInMs: n
      });
    }
  };
}
function El(r) {
  return !!(r && r.status !== void 0 && (r.status >= 500 || r.status === 408) && r.status !== 501 && r.status !== 505);
}
function Tl(r) {
  return r ? r.code === "ETIMEDOUT" || r.code === "ESOCKETTIMEDOUT" || r.code === "ECONNREFUSED" || r.code === "ECONNRESET" || r.code === "ENOENT" || r.code === "ENOTFOUND" : !1;
}
const Ml = sn("ts-http-runtime retryPolicy"), Il = "retryPolicy";
function ql(r, e = { maxRetries: Ir }) {
  const t = e.logger || Ml;
  return {
    name: Il,
    async sendRequest(a, n) {
      var i, s;
      let o, l, m = -1;
      e: for (; ; ) {
        m += 1, o = void 0, l = void 0;
        try {
          t.info(`Retry ${m}: Attempting to send request`, a.requestId), o = await n(a), t.info(`Retry ${m}: Received a response from request`, a.requestId);
        } catch (c) {
          if (t.error(`Retry ${m}: Received an error from request`, a.requestId), l = c, !c || l.name !== "RestError")
            throw c;
          o = l.response;
        }
        if (!((i = a.abortSignal) === null || i === void 0) && i.aborted)
          throw t.error(`Retry ${m}: Request aborted.`), new $r();
        if (m >= ((s = e.maxRetries) !== null && s !== void 0 ? s : Ir)) {
          if (t.info(`Retry ${m}: Maximum retries reached. Returning the last received response, or throwing the last received error.`), l)
            throw l;
          if (o)
            return o;
          throw new Error("Maximum retries reached with no response or error to throw");
        }
        t.info(`Retry ${m}: Processing ${r.length} retry strategies.`);
        t: for (const c of r) {
          const d = c.logger || t;
          d.info(`Retry ${m}: Processing retry strategy ${c.name}.`);
          const p = c.retry({
            retryCount: m,
            response: o,
            responseError: l
          });
          if (p.skipStrategy) {
            d.info(`Retry ${m}: Skipped.`);
            continue t;
          }
          const { errorToThrow: y, retryAfterInMs: u, redirectTo: h } = p;
          if (y)
            throw d.error(`Retry ${m}: Retry strategy ${c.name} throws error:`, y), y;
          if (u || u === 0) {
            d.info(`Retry ${m}: Retry strategy ${c.name} retries after ${u}`), await Cl(u, void 0, { abortSignal: a.abortSignal });
            continue e;
          }
          if (h) {
            d.info(`Retry ${m}: Retry strategy ${c.name} redirects to ${h}`), a.url = h;
            continue e;
          }
        }
        if (l)
          throw t.info("None of the retry strategies could work with the received error. Throwing it."), l;
        if (o)
          return t.info("None of the retry strategies could work with the received response. Returning it."), o;
      }
    }
  };
}
const Ol = "defaultRetryPolicy";
function _l(r = {}) {
  var e;
  return {
    name: Ol,
    sendRequest: ql([Sl(), Bl(r)], {
      maxRetries: (e = r.maxRetries) !== null && e !== void 0 ? e : Ir
    }).sendRequest
  };
}
var xr, Nr, br, Cr;
typeof self == "object" && typeof (self == null ? void 0 : self.importScripts) == "function" && (((xr = self.constructor) === null || xr === void 0 ? void 0 : xr.name) === "DedicatedWorkerGlobalScope" || ((Nr = self.constructor) === null || Nr === void 0 ? void 0 : Nr.name) === "ServiceWorkerGlobalScope" || ((br = self.constructor) === null || br === void 0 || br.name));
typeof Deno < "u" && typeof Deno.version < "u" && typeof Deno.version.deno < "u";
typeof Bun < "u" && typeof Bun.version < "u";
const Qr = typeof globalThis.process < "u" && !!globalThis.process.version && !!(!((Cr = globalThis.process.versions) === null || Cr === void 0) && Cr.node), Hl = "formDataPolicy";
function Dl(r) {
  var e;
  const t = {};
  for (const [a, n] of r.entries())
    (e = t[a]) !== null && e !== void 0 || (t[a] = []), t[a].push(n);
  return t;
}
function Ll() {
  return {
    name: Hl,
    async sendRequest(r, e) {
      if (Qr && typeof FormData < "u" && r.body instanceof FormData && (r.formData = Dl(r.body), r.body = void 0), r.formData) {
        const t = r.headers.get("Content-Type");
        t && t.indexOf("application/x-www-form-urlencoded") !== -1 ? r.body = kl(r.formData) : await Al(r.formData, r), r.formData = void 0;
      }
      return e(r);
    }
  };
}
function kl(r) {
  const e = new URLSearchParams();
  for (const [t, a] of Object.entries(r))
    if (Array.isArray(a))
      for (const n of a)
        e.append(t, n.toString());
    else
      e.append(t, a.toString());
  return e.toString();
}
async function Al(r, e) {
  const t = e.headers.get("Content-Type");
  if (t && !t.startsWith("multipart/form-data"))
    return;
  e.headers.set("Content-Type", t ?? "multipart/form-data");
  const a = [];
  for (const [n, i] of Object.entries(r))
    for (const s of Array.isArray(i) ? i : [i])
      if (typeof s == "string")
        a.push({
          headers: Mt({
            "Content-Disposition": `form-data; name="${n}"`
          }),
          body: Me(s, "utf-8")
        });
      else {
        if (s == null || typeof s != "object")
          throw new Error(`Unexpected value for key ${n}: ${s}. Value should be serialized to string first.`);
        {
          const o = s.name || "blob", l = Mt();
          l.set("Content-Disposition", `form-data; name="${n}"; filename="${o}"`), l.set("Content-Type", s.type || "application/octet-stream"), a.push({
            headers: l,
            body: s
          });
        }
      }
  e.multipartBody = { parts: a };
}
const yn = "proxyPolicy is not supported in browser environment";
function Ul() {
  throw new Error(yn);
}
function $l() {
  throw new Error(yn);
}
const jl = "agentPolicy";
function Fl(r) {
  return {
    name: jl,
    sendRequest: async (e, t) => (e.agent || (e.agent = r), t(e))
  };
}
const Kl = "tlsPolicy";
function Gl(r) {
  return {
    name: Kl,
    sendRequest: async (e, t) => (e.tlsSettings || (e.tlsSettings = r), t(e))
  };
}
function Xl(r) {
  return new Response(r).blob();
}
async function Wl(r) {
  if (r instanceof Blob || r instanceof Uint8Array)
    return r;
  if (Wr(r))
    return Xl(r);
  throw new Error("Unsupported source type. Only Blob, Uint8Array, and ReadableStream are supported in browser.");
}
async function Ql(r) {
  const e = [];
  for (const t of r)
    e.push(await Wl(typeof t == "function" ? t() : t));
  return new Blob(e);
}
function Jl() {
  return `----AzSDKFormBoundary${Kr()}`;
}
function Yl(r) {
  let e = "";
  for (const [t, a] of r)
    e += `${t}: ${a}\r
`;
  return e;
}
function Zl(r) {
  return r instanceof Uint8Array ? r.byteLength : Vm(r) ? r.size === -1 ? void 0 : r.size : void 0;
}
function Vl(r) {
  let e = 0;
  for (const t of r) {
    const a = Zl(t);
    if (a === void 0)
      return;
    e += a;
  }
  return e;
}
async function ec(r, e, t) {
  const a = [
    Me(`--${t}`, "utf-8"),
    ...e.flatMap((i) => [
      Me(`\r
`, "utf-8"),
      Me(Yl(i.headers), "utf-8"),
      Me(`\r
`, "utf-8"),
      i.body,
      Me(`\r
--${t}`, "utf-8")
    ]),
    Me(`--\r
\r
`, "utf-8")
  ], n = Vl(a);
  n && r.headers.set("Content-Length", n), r.body = await Ql(a);
}
const fn = "multipartPolicy", tc = 70, rc = new Set("abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'()+,-./:=?");
function ac(r) {
  if (r.length > tc)
    throw new Error(`Multipart boundary "${r}" exceeds maximum length of 70 characters`);
  if (Array.from(r).some((e) => !rc.has(e)))
    throw new Error(`Multipart boundary "${r}" contains invalid characters`);
}
function nc() {
  return {
    name: fn,
    async sendRequest(r, e) {
      var t;
      if (!r.multipartBody)
        return e(r);
      if (r.body)
        throw new Error("multipartBody and regular body cannot be set at the same time");
      let a = r.multipartBody.boundary;
      const n = (t = r.headers.get("Content-Type")) !== null && t !== void 0 ? t : "multipart/mixed", i = n.match(/^(multipart\/[^ ;]+)(?:; *boundary=(.+))?$/);
      if (!i)
        throw new Error(`Got multipart request body, but content-type header was not multipart: ${n}`);
      const [, s, o] = i;
      if (o && a && o !== a)
        throw new Error(`Multipart boundary was specified as ${o} in the header, but got ${a} in the request body`);
      return a ?? (a = o), a ? ac(a) : a = Jl(), r.headers.set("Content-Type", `${s}; boundary=${a}`), await ec(r, r.multipartBody.parts, a), r.multipartBody = void 0, e(r);
    }
  };
}
function gn() {
  return jm();
}
const ic = nn({
  logLevelEnvVarName: "AZURE_LOG_LEVEL",
  namespace: "azure"
});
function Jr(r) {
  return ic.createClientLogger(r);
}
const Ye = Jr("core-rest-pipeline");
function sc(r = {}) {
  return yl(Object.assign({ logger: Ye.info }, r));
}
const oc = dn;
function mc(r = {}) {
  return fl(r);
}
function lc() {
  return "x-ms-useragent";
}
function cc(r) {
  const e = [
    { name: "Firefox", regex: /Firefox\/([\d.]+)/ },
    { name: "Safari", regex: /Version\/([\d.]+).*Safari/ }
  ];
  for (const t of e) {
    const a = r.match(t.regex);
    if (a)
      return { brand: t.name, version: a[1] };
  }
}
function dc(r) {
  const e = ["Google Chrome", "Microsoft Edge", "Opera", "Brave", "Chromium"];
  for (const t of e) {
    const a = r.find((n) => n.brand === t);
    if (a)
      return a;
  }
}
async function pc(r) {
  const e = globalThis.navigator;
  let t = "unknown";
  if (e != null && e.userAgentData) {
    const a = await e.userAgentData.getHighEntropyValues([
      "architecture",
      "platformVersion"
    ]);
    t = `${a.architecture}-${a.platform}-${a.platformVersion}`;
    const n = dc(e.userAgentData.brands);
    n && r.set(n.brand, n.version);
  } else if (e != null && e.platform) {
    t = e.platform;
    const a = cc(e.userAgent);
    a && r.set(a.brand, a.version);
  } else typeof globalThis.EdgeRuntime == "string" && r.set("EdgeRuntime", globalThis.EdgeRuntime);
  r.set("OS", t);
}
const hn = "1.21.0";
function uc(r) {
  const e = [];
  for (const [t, a] of r) {
    const n = a ? `${t}/${a}` : t;
    e.push(n);
  }
  return e.join(" ");
}
function yc() {
  return lc();
}
async function xn(r) {
  const e = /* @__PURE__ */ new Map();
  e.set("core-rest-pipeline", hn), await pc(e);
  const t = uc(e);
  return r ? `${r} ${t}` : t;
}
const qa = yc(), fc = "userAgentPolicy";
function gc(r = {}) {
  const e = xn(r.userAgentPrefix);
  return {
    name: fc,
    async sendRequest(t, a) {
      return t.headers.has(qa) || t.headers.set(qa, await e), a(t);
    }
  };
}
class Yr extends Error {
  constructor(e) {
    super(e), this.name = "AbortError";
  }
}
function hc(r, e) {
  const { cleanupBeforeAbort: t, abortSignal: a, abortErrorMsg: n } = e ?? {};
  return new Promise((i, s) => {
    function o() {
      s(new Yr(n ?? "The operation was aborted."));
    }
    function l() {
      a == null || a.removeEventListener("abort", m);
    }
    function m() {
      t == null || t(), l(), o();
    }
    if (a != null && a.aborted)
      return o();
    try {
      r((c) => {
        l(), i(c);
      }, (c) => {
        l(), s(c);
      });
    } catch (c) {
      s(c);
    }
    a == null || a.addEventListener("abort", m);
  });
}
const xc = "The delay was aborted.";
function Nn(r, e) {
  let t;
  const { abortSignal: a, abortErrorMsg: n } = {};
  return hc((i) => {
    t = setTimeout(i, r);
  }, {
    cleanupBeforeAbort: () => clearTimeout(t),
    abortSignal: a,
    abortErrorMsg: n ?? xc
  });
}
function At(r) {
  if (Gr(r))
    return r.message;
  {
    let e;
    try {
      typeof r == "object" && r ? e = JSON.stringify(r) : e = String(r);
    } catch {
      e = "[unable to stringify input]";
    }
    return `Unknown error ${e}`;
  }
}
function Nc(r) {
  return Gr(r);
}
function Vt() {
  return Kr();
}
const W = Qr, Oa = Qr, bn = Symbol("rawContent");
function Cn(r) {
  return typeof r[bn] == "function";
}
function bc(r) {
  return Cn(r) ? r[bn]() : r;
}
const Pn = fn;
function Cc() {
  const r = nc();
  return {
    name: Pn,
    sendRequest: async (e, t) => {
      if (e.multipartBody)
        for (const a of e.multipartBody.parts)
          Cn(a.body) && (a.body = bc(a.body));
      return r.sendRequest(e, t);
    }
  };
}
const Pc = gl;
function vc() {
  return hl();
}
function zc(r = {}) {
  return _l(r);
}
function Sc() {
  return Ll();
}
function Ze(r) {
  return Ul();
}
function Rc(r, e) {
  return $l();
}
const wc = "setClientRequestIdPolicy";
function Bc(r = "x-ms-client-request-id") {
  return {
    name: wc,
    async sendRequest(e, t) {
      return e.headers.has(r) || e.headers.set(r, e.requestId), t(e);
    }
  };
}
function Ec(r) {
  return Fl(r);
}
function Tc(r) {
  return Gl(r);
}
const St = {
  span: Symbol.for("@azure/core-tracing span"),
  namespace: Symbol.for("@azure/core-tracing namespace")
};
function Mc(r = {}) {
  let e = new Rt(r.parentContext);
  return r.span && (e = e.setValue(St.span, r.span)), r.namespace && (e = e.setValue(St.namespace, r.namespace)), e;
}
class Rt {
  constructor(e) {
    this._contextMap = e instanceof Rt ? new Map(e._contextMap) : /* @__PURE__ */ new Map();
  }
  setValue(e, t) {
    const a = new Rt(this);
    return a._contextMap.set(e, t), a;
  }
  getValue(e) {
    return this._contextMap.get(e);
  }
  deleteValue(e) {
    const t = new Rt(this);
    return t._contextMap.delete(e), t;
  }
}
const Pr = {
  instrumenterImplementation: void 0
};
function Ic() {
  return {
    end: () => {
    },
    isRecording: () => !1,
    recordException: () => {
    },
    setAttribute: () => {
    },
    setStatus: () => {
    },
    addEvent: () => {
    }
  };
}
function qc() {
  return {
    createRequestHeaders: () => ({}),
    parseTraceparentHeader: () => {
    },
    startSpan: (r, e) => ({
      span: Ic(),
      tracingContext: Mc({ parentContext: e.tracingContext })
    }),
    withContext(r, e, ...t) {
      return e(...t);
    }
  };
}
function Kt() {
  return Pr.instrumenterImplementation || (Pr.instrumenterImplementation = qc()), Pr.instrumenterImplementation;
}
function vn(r) {
  const { namespace: e, packageName: t, packageVersion: a } = r;
  function n(m, c, d) {
    var p;
    const y = Kt().startSpan(m, Object.assign(Object.assign({}, d), { packageName: t, packageVersion: a, tracingContext: (p = c == null ? void 0 : c.tracingOptions) === null || p === void 0 ? void 0 : p.tracingContext }));
    let u = y.tracingContext;
    const h = y.span;
    u.getValue(St.namespace) || (u = u.setValue(St.namespace, e)), h.setAttribute("az.namespace", u.getValue(St.namespace));
    const R = Object.assign({}, c, {
      tracingOptions: Object.assign(Object.assign({}, c == null ? void 0 : c.tracingOptions), { tracingContext: u })
    });
    return {
      span: h,
      updatedOptions: R
    };
  }
  async function i(m, c, d, p) {
    const { span: y, updatedOptions: u } = n(m, c, p);
    try {
      const h = await s(u.tracingOptions.tracingContext, () => Promise.resolve(d(u, y)));
      return y.setStatus({ status: "success" }), h;
    } catch (h) {
      throw y.setStatus({ status: "error", error: h }), h;
    } finally {
      y.end();
    }
  }
  function s(m, c, ...d) {
    return Kt().withContext(m, c, ...d);
  }
  function o(m) {
    return Kt().parseTraceparentHeader(m);
  }
  function l(m) {
    return Kt().createRequestHeaders(m);
  }
  return {
    startSpan: n,
    withSpan: i,
    withContext: s,
    parseTraceparentHeader: o,
    createRequestHeaders: l
  };
}
const It = Xe;
function Zr(r) {
  return Wm(r);
}
const Oc = "tracingPolicy";
function _c(r = {}) {
  const e = xn(r.userAgentPrefix), t = new Xr({
    additionalAllowedQueryParameters: r.additionalAllowedQueryParameters
  }), a = Hc();
  return {
    name: Oc,
    async sendRequest(n, i) {
      var s;
      if (!a)
        return i(n);
      const o = await e, l = {
        "http.url": t.sanitizeUrl(n.url),
        "http.method": n.method,
        "http.user_agent": o,
        requestId: n.requestId
      };
      o && (l["http.user_agent"] = o);
      const { span: m, tracingContext: c } = (s = Dc(a, n, l)) !== null && s !== void 0 ? s : {};
      if (!m || !c)
        return i(n);
      try {
        const d = await a.withContext(c, i, n);
        return kc(m, d), d;
      } catch (d) {
        throw Lc(m, d), d;
      }
    }
  };
}
function Hc() {
  try {
    return vn({
      namespace: "",
      packageName: "@azure/core-rest-pipeline",
      packageVersion: hn
    });
  } catch (r) {
    Ye.warning(`Error when creating the TracingClient: ${At(r)}`);
    return;
  }
}
function Dc(r, e, t) {
  try {
    const { span: a, updatedOptions: n } = r.startSpan(`HTTP ${e.method}`, { tracingOptions: e.tracingOptions }, {
      spanKind: "client",
      spanAttributes: t
    });
    if (!a.isRecording()) {
      a.end();
      return;
    }
    const i = r.createRequestHeaders(n.tracingOptions.tracingContext);
    for (const [s, o] of Object.entries(i))
      e.headers.set(s, o);
    return { span: a, tracingContext: n.tracingOptions.tracingContext };
  } catch (a) {
    Ye.warning(`Skipping creating a tracing span due to an error: ${At(a)}`);
    return;
  }
}
function Lc(r, e) {
  try {
    r.setStatus({
      status: "error",
      error: Nc(e) ? e : void 0
    }), Zr(e) && e.statusCode && r.setAttribute("http.status_code", e.statusCode), r.end();
  } catch (t) {
    Ye.warning(`Skipping tracing span processing due to an error: ${At(t)}`);
  }
}
function kc(r, e) {
  try {
    r.setAttribute("http.status_code", e.status);
    const t = e.headers.get("x-ms-request-id");
    t && r.setAttribute("serviceRequestId", t), e.status >= 400 && r.setStatus({
      status: "error"
    }), r.end();
  } catch (t) {
    Ye.warning(`Skipping tracing span processing due to an error: ${At(t)}`);
  }
}
function zn(r) {
  if (r instanceof AbortSignal)
    return { abortSignal: r };
  if (r.aborted)
    return { abortSignal: AbortSignal.abort(r.reason) };
  const e = new AbortController();
  let t = !0;
  function a() {
    t && (r.removeEventListener("abort", n), t = !1);
  }
  function n() {
    e.abort(r.reason), a();
  }
  return r.addEventListener("abort", n), { abortSignal: e.signal, cleanup: a };
}
const Ac = "wrapAbortSignalLikePolicy";
function Uc() {
  return {
    name: Ac,
    sendRequest: async (r, e) => {
      if (!r.abortSignal)
        return e(r);
      const { abortSignal: t, cleanup: a } = zn(r.abortSignal);
      r.abortSignal = t;
      try {
        return await e(r);
      } finally {
        a == null || a();
      }
    }
  };
}
function $c(r) {
  var e;
  const t = gn();
  return Oa && (r.agent && t.addPolicy(Ec(r.agent)), r.tlsOptions && t.addPolicy(Tc(r.tlsOptions)), t.addPolicy(Rc(r.proxyOptions)), t.addPolicy(vc())), t.addPolicy(Uc()), t.addPolicy(Sc(), { beforePolicies: [Pn] }), t.addPolicy(gc(r.userAgentOptions)), t.addPolicy(Bc((e = r.telemetryOptions) === null || e === void 0 ? void 0 : e.clientRequestIdHeaderName)), t.addPolicy(Cc(), { afterPhase: "Deserialize" }), t.addPolicy(zc(r.retryOptions), { phase: "Retry" }), t.addPolicy(_c(Object.assign(Object.assign({}, r.userAgentOptions), r.loggingOptions)), {
    afterPhase: "Retry"
  }), Oa && t.addPolicy(mc(r.redirectOptions), { afterPhase: "Retry" }), t.addPolicy(sc(r.loggingOptions), { afterPhase: "Sign" }), t;
}
function Sn() {
  const r = dl();
  return {
    async sendRequest(e) {
      const { abortSignal: t, cleanup: a } = e.abortSignal ? zn(e.abortSignal) : {};
      try {
        return e.abortSignal = t, await r.sendRequest(e);
      } finally {
        a == null || a();
      }
    }
  };
}
function ir(r) {
  return Mt(r);
}
function Rn(r) {
  return $m(r);
}
const jc = {
  forcedRefreshWindowInMs: 1e3,
  // Force waiting for a refresh 1s before the token expires
  retryIntervalInMs: 3e3,
  // Allow refresh attempts every 3s
  refreshWindowInMs: 1e3 * 60 * 2
  // Start refreshing 2m before expiry
};
async function Fc(r, e, t) {
  async function a() {
    if (Date.now() < t)
      try {
        return await r();
      } catch {
        return null;
      }
    else {
      const i = await r();
      if (i === null)
        throw new Error("Failed to refresh access token.");
      return i;
    }
  }
  let n = await a();
  for (; n === null; )
    await Nn(e), n = await a();
  return n;
}
function Kc(r, e) {
  let t = null, a = null, n;
  const i = Object.assign(Object.assign({}, jc), e), s = {
    /**
     * Produces true if a refresh job is currently in progress.
     */
    get isRefreshing() {
      return t !== null;
    },
    /**
     * Produces true if the cycler SHOULD refresh (we are within the refresh
     * window and not already refreshing)
     */
    get shouldRefresh() {
      var l;
      return s.isRefreshing ? !1 : a != null && a.refreshAfterTimestamp && a.refreshAfterTimestamp < Date.now() ? !0 : ((l = a == null ? void 0 : a.expiresOnTimestamp) !== null && l !== void 0 ? l : 0) - i.refreshWindowInMs < Date.now();
    },
    /**
     * Produces true if the cycler MUST refresh (null or nearly-expired
     * token).
     */
    get mustRefresh() {
      return a === null || a.expiresOnTimestamp - i.forcedRefreshWindowInMs < Date.now();
    }
  };
  function o(l, m) {
    var c;
    return s.isRefreshing || (t = Fc(
      () => r.getToken(l, m),
      i.retryIntervalInMs,
      // If we don't have a token, then we should timeout immediately
      (c = a == null ? void 0 : a.expiresOnTimestamp) !== null && c !== void 0 ? c : Date.now()
    ).then((p) => (t = null, a = p, n = m.tenantId, a)).catch((p) => {
      throw t = null, a = null, n = void 0, p;
    })), t;
  }
  return async (l, m) => {
    const c = !!m.claims, d = n !== m.tenantId;
    return c && (a = null), d || c || s.mustRefresh ? o(l, m) : (s.shouldRefresh && o(l, m), a);
  };
}
const Gc = "bearerTokenAuthenticationPolicy";
async function Gt(r, e) {
  try {
    return [await e(r), void 0];
  } catch (t) {
    if (Zr(t) && t.response)
      return [t.response, t];
    throw t;
  }
}
async function Xc(r) {
  const { scopes: e, getAccessToken: t, request: a } = r, n = {
    abortSignal: a.abortSignal,
    tracingOptions: a.tracingOptions,
    enableCae: !0
  }, i = await t(e, n);
  i && r.request.headers.set("Authorization", `Bearer ${i.token}`);
}
function _a(r) {
  return r.status === 401 && r.headers.has("WWW-Authenticate");
}
async function Ha(r, e) {
  var t;
  const { scopes: a } = r, n = await r.getAccessToken(a, {
    enableCae: !0,
    claims: e
  });
  return n ? (r.request.headers.set("Authorization", `${(t = n.tokenType) !== null && t !== void 0 ? t : "Bearer"} ${n.token}`), !0) : !1;
}
function Vr(r) {
  var e, t, a;
  const { credential: n, scopes: i, challengeCallbacks: s } = r, o = r.logger || Ye, l = {
    authorizeRequest: (t = (e = s == null ? void 0 : s.authorizeRequest) === null || e === void 0 ? void 0 : e.bind(s)) !== null && t !== void 0 ? t : Xc,
    authorizeRequestOnChallenge: (a = s == null ? void 0 : s.authorizeRequestOnChallenge) === null || a === void 0 ? void 0 : a.bind(s)
  }, m = n ? Kc(
    n
    /* , options */
  ) : () => Promise.resolve(null);
  return {
    name: Gc,
    /**
     * If there's no challenge parameter:
     * - It will try to retrieve the token using the cache, or the credential's getToken.
     * - Then it will try the next policy with or without the retrieved token.
     *
     * It uses the challenge parameters to:
     * - Skip a first attempt to get the token from the credential if there's no cached token,
     *   since it expects the token to be retrievable only after the challenge.
     * - Prepare the outgoing request if the `prepareRequest` method has been provided.
     * - Send an initial request to receive the challenge if it fails.
     * - Process a challenge if the response contains it.
     * - Retrieve a token with the challenge information, then re-send the request.
     */
    async sendRequest(c, d) {
      if (!c.url.toLowerCase().startsWith("https://"))
        throw new Error("Bearer token authentication is not permitted for non-TLS protected (non-https) URLs.");
      await l.authorizeRequest({
        scopes: Array.isArray(i) ? i : [i],
        request: c,
        getAccessToken: m,
        logger: o
      });
      let p, y, u;
      if ([p, y] = await Gt(c, d), _a(p)) {
        let h = Da(p.headers.get("WWW-Authenticate"));
        if (h) {
          let R;
          try {
            R = atob(h);
          } catch {
            return o.warning(`The WWW-Authenticate header contains "claims" that cannot be parsed. Unable to perform the Continuous Access Evaluation authentication flow. Unparsable claims: ${h}`), p;
          }
          u = await Ha({
            scopes: Array.isArray(i) ? i : [i],
            response: p,
            request: c,
            getAccessToken: m,
            logger: o
          }, R), u && ([p, y] = await Gt(c, d));
        } else if (l.authorizeRequestOnChallenge && (u = await l.authorizeRequestOnChallenge({
          scopes: Array.isArray(i) ? i : [i],
          request: c,
          response: p,
          getAccessToken: m,
          logger: o
        }), u && ([p, y] = await Gt(c, d)), _a(p) && (h = Da(p.headers.get("WWW-Authenticate")), h))) {
          let R;
          try {
            R = atob(h);
          } catch {
            return o.warning(`The WWW-Authenticate header contains "claims" that cannot be parsed. Unable to perform the Continuous Access Evaluation authentication flow. Unparsable claims: ${h}`), p;
          }
          u = await Ha({
            scopes: Array.isArray(i) ? i : [i],
            response: p,
            request: c,
            getAccessToken: m,
            logger: o
          }, R), u && ([p, y] = await Gt(c, d));
        }
      }
      if (y)
        throw y;
      return p;
    }
  };
}
function Wc(r) {
  const e = /(\w+)\s+((?:\w+=(?:"[^"]*"|[^,]*),?\s*)+)/g, t = /(\w+)="([^"]*)"/g, a = [];
  let n;
  for (; (n = e.exec(r)) !== null; ) {
    const i = n[1], s = n[2], o = {};
    let l;
    for (; (l = t.exec(s)) !== null; )
      o[l[1]] = l[2];
    a.push({ scheme: i, params: o });
  }
  return a;
}
function Da(r) {
  var e;
  return r ? (e = Wc(r).find((a) => a.scheme === "Bearer" && a.params.claims && a.params.error === "insufficient_claims")) === null || e === void 0 ? void 0 : e.params.claims : void 0;
}
function Qc(r, e) {
  var t = {};
  for (var a in r) Object.prototype.hasOwnProperty.call(r, a) && e.indexOf(a) < 0 && (t[a] = r[a]);
  if (r != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, a = Object.getOwnPropertySymbols(r); n < a.length; n++)
      e.indexOf(a[n]) < 0 && Object.prototype.propertyIsEnumerable.call(r, a[n]) && (t[a[n]] = r[a[n]]);
  return t;
}
function La(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], a = 0;
  if (t) return t.call(r);
  if (r && typeof r.length == "number") return {
    next: function() {
      return r && a >= r.length && (r = void 0), { value: r && r[a++], done: !r };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function I(r) {
  return this instanceof I ? (this.v = r, this) : new I(r);
}
function ne(r, e, t) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var a = t.apply(r, e || []), n, i = [];
  return n = Object.create((typeof AsyncIterator == "function" ? AsyncIterator : Object).prototype), o("next"), o("throw"), o("return", s), n[Symbol.asyncIterator] = function() {
    return this;
  }, n;
  function s(y) {
    return function(u) {
      return Promise.resolve(u).then(y, d);
    };
  }
  function o(y, u) {
    a[y] && (n[y] = function(h) {
      return new Promise(function(R, M) {
        i.push([y, h, R, M]) > 1 || l(y, h);
      });
    }, u && (n[y] = u(n[y])));
  }
  function l(y, u) {
    try {
      m(a[y](u));
    } catch (h) {
      p(i[0][3], h);
    }
  }
  function m(y) {
    y.value instanceof I ? Promise.resolve(y.value.v).then(c, d) : p(i[0][2], y);
  }
  function c(y) {
    l("next", y);
  }
  function d(y) {
    l("throw", y);
  }
  function p(y, u) {
    y(u), i.shift(), i.length && l(i[0][0], i[0][1]);
  }
}
function We(r) {
  var e, t;
  return e = {}, a("next"), a("throw", function(n) {
    throw n;
  }), a("return"), e[Symbol.iterator] = function() {
    return this;
  }, e;
  function a(n, i) {
    e[n] = r[n] ? function(s) {
      return (t = !t) ? { value: I(r[n](s)), done: !1 } : i ? i(s) : s;
    } : i;
  }
}
function oe(r) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var e = r[Symbol.asyncIterator], t;
  return e ? e.call(r) : (r = typeof La == "function" ? La(r) : r[Symbol.iterator](), t = {}, a("next"), a("throw"), a("return"), t[Symbol.asyncIterator] = function() {
    return this;
  }, t);
  function a(i) {
    t[i] = r[i] && function(s) {
      return new Promise(function(o, l) {
        s = r[i](s), n(o, l, s.done, s.value);
      });
    };
  }
  function n(i, s, o, l) {
    Promise.resolve(l).then(function(m) {
      i({ value: m, done: o });
    }, s);
  }
}
function le(r) {
  const e = r;
  return e && typeof e.getToken == "function" && (e.signRequest === void 0 || e.getToken.length > 0);
}
const wn = "DisableKeepAlivePolicy";
function Jc() {
  return {
    name: wn,
    async sendRequest(r, e) {
      return r.disableKeepAlive = !0, e(r);
    }
  };
}
function Yc(r) {
  return r.getOrderedPolicies().some((e) => e.name === wn);
}
function Bn(r) {
  let e = "";
  for (let t = 0; t < r.length; t++)
    e += String.fromCharCode(r[t]);
  return btoa(e);
}
function En(r) {
  const e = atob(r), t = new Uint8Array(e.length);
  for (let a = 0; a < e.length; a++)
    t[a] = e.charCodeAt(a);
  return t;
}
const te = "$", qt = "_";
function Zc(r, e) {
  return e !== "Composite" && e !== "Dictionary" && (typeof r == "string" || typeof r == "number" || typeof r == "boolean" || (e == null ? void 0 : e.match(/^(Date|DateTime|DateTimeRfc1123|UnixTime|ByteArray|Base64Url)$/i)) !== null || r === void 0 || r === null);
}
const Vc = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function ed(r) {
  return Vc.test(r);
}
const td = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/i;
function rd(r) {
  return td.test(r);
}
function ad(r) {
  const e = Object.assign(Object.assign({}, r.headers), r.body);
  return r.hasNullableType && Object.getOwnPropertyNames(e).length === 0 ? r.shouldWrapBody ? { body: null } : null : r.shouldWrapBody ? Object.assign(Object.assign({}, r.headers), { body: r.body }) : e;
}
function ka(r, e) {
  var t, a;
  const n = r.parsedHeaders;
  if (r.request.method === "HEAD")
    return Object.assign(Object.assign({}, n), { body: r.parsedBody });
  const i = e && e.bodyMapper, s = !!(i != null && i.nullable), o = i == null ? void 0 : i.type.name;
  if (o === "Stream")
    return Object.assign(Object.assign({}, n), { blobBody: r.blobBody, readableStreamBody: r.readableStreamBody });
  const l = o === "Composite" && i.type.modelProperties || {}, m = Object.keys(l).some((c) => l[c].serializedName === "");
  if (o === "Sequence" || m) {
    const c = (t = r.parsedBody) !== null && t !== void 0 ? t : [];
    for (const d of Object.keys(l))
      l[d].serializedName && (c[d] = (a = r.parsedBody) === null || a === void 0 ? void 0 : a[d]);
    if (n)
      for (const d of Object.keys(n))
        c[d] = n[d];
    return s && !r.parsedBody && !n && Object.getOwnPropertyNames(l).length === 0 ? null : c;
  }
  return ad({
    body: r.parsedBody,
    headers: n,
    hasNullableType: s,
    shouldWrapBody: Zc(r.parsedBody, o)
  });
}
class nd {
  constructor(e = {}, t = !1) {
    this.modelMappers = e, this.isXML = t;
  }
  /**
   * @deprecated Removing the constraints validation on client side.
   */
  validateConstraints(e, t, a) {
    const n = (i, s) => {
      throw new Error(`"${a}" with value "${t}" should satisfy the constraint "${i}": ${s}.`);
    };
    if (e.constraints && t !== void 0 && t !== null) {
      const { ExclusiveMaximum: i, ExclusiveMinimum: s, InclusiveMaximum: o, InclusiveMinimum: l, MaxItems: m, MaxLength: c, MinItems: d, MinLength: p, MultipleOf: y, Pattern: u, UniqueItems: h } = e.constraints;
      if (i !== void 0 && t >= i && n("ExclusiveMaximum", i), s !== void 0 && t <= s && n("ExclusiveMinimum", s), o !== void 0 && t > o && n("InclusiveMaximum", o), l !== void 0 && t < l && n("InclusiveMinimum", l), m !== void 0 && t.length > m && n("MaxItems", m), c !== void 0 && t.length > c && n("MaxLength", c), d !== void 0 && t.length < d && n("MinItems", d), p !== void 0 && t.length < p && n("MinLength", p), y !== void 0 && t % y !== 0 && n("MultipleOf", y), u) {
        const R = typeof u == "string" ? new RegExp(u) : u;
        (typeof t != "string" || t.match(R) === null) && n("Pattern", u);
      }
      h && t.some((R, M, T) => T.indexOf(R) !== M) && n("UniqueItems", h);
    }
  }
  /**
   * Serialize the given object based on its metadata defined in the mapper
   *
   * @param mapper - The mapper which defines the metadata of the serializable object
   *
   * @param object - A valid Javascript object to be serialized
   *
   * @param objectName - Name of the serialized object
   *
   * @param options - additional options to serialization
   *
   * @returns A valid serialized Javascript object
   */
  serialize(e, t, a, n = { xml: {} }) {
    var i, s, o;
    const l = {
      xml: {
        rootName: (i = n.xml.rootName) !== null && i !== void 0 ? i : "",
        includeRoot: (s = n.xml.includeRoot) !== null && s !== void 0 ? s : !1,
        xmlCharKey: (o = n.xml.xmlCharKey) !== null && o !== void 0 ? o : qt
      }
    };
    let m = {};
    const c = e.type.name;
    a || (a = e.serializedName), c.match(/^Sequence$/i) !== null && (m = []), e.isConstant && (t = e.defaultValue);
    const { required: d, nullable: p } = e;
    if (d && p && t === void 0)
      throw new Error(`${a} cannot be undefined.`);
    if (d && !p && t == null)
      throw new Error(`${a} cannot be null or undefined.`);
    if (!d && p === !1 && t === null)
      throw new Error(`${a} cannot be null.`);
    return t == null || c.match(/^any$/i) !== null ? m = t : c.match(/^(Number|String|Boolean|Object|Stream|Uuid)$/i) !== null ? m = cd(c, a, t) : c.match(/^Enum$/i) !== null ? m = dd(a, e.type.allowedValues, t) : c.match(/^(Date|DateTime|TimeSpan|DateTimeRfc1123|UnixTime)$/i) !== null ? m = yd(c, t, a) : c.match(/^ByteArray$/i) !== null ? m = pd(a, t) : c.match(/^Base64Url$/i) !== null ? m = ud(a, t) : c.match(/^Sequence$/i) !== null ? m = fd(this, e, t, a, !!this.isXML, l) : c.match(/^Dictionary$/i) !== null ? m = gd(this, e, t, a, !!this.isXML, l) : c.match(/^Composite$/i) !== null && (m = xd(this, e, t, a, !!this.isXML, l)), m;
  }
  /**
   * Deserialize the given object based on its metadata defined in the mapper
   *
   * @param mapper - The mapper which defines the metadata of the serializable object
   *
   * @param responseBody - A valid Javascript entity to be deserialized
   *
   * @param objectName - Name of the deserialized object
   *
   * @param options - Controls behavior of XML parser and builder.
   *
   * @returns A valid deserialized Javascript object
   */
  deserialize(e, t, a, n = { xml: {} }) {
    var i, s, o, l;
    const m = {
      xml: {
        rootName: (i = n.xml.rootName) !== null && i !== void 0 ? i : "",
        includeRoot: (s = n.xml.includeRoot) !== null && s !== void 0 ? s : !1,
        xmlCharKey: (o = n.xml.xmlCharKey) !== null && o !== void 0 ? o : qt
      },
      ignoreUnknownProperties: (l = n.ignoreUnknownProperties) !== null && l !== void 0 ? l : !1
    };
    if (t == null)
      return this.isXML && e.type.name === "Sequence" && !e.xmlIsWrapped && (t = []), e.defaultValue !== void 0 && (t = e.defaultValue), t;
    let c;
    const d = e.type.name;
    if (a || (a = e.serializedName), d.match(/^Composite$/i) !== null)
      c = bd(this, e, t, a, m);
    else {
      if (this.isXML) {
        const p = m.xml.xmlCharKey;
        t[te] !== void 0 && t[p] !== void 0 && (t = t[p]);
      }
      d.match(/^Number$/i) !== null ? (c = parseFloat(t), isNaN(c) && (c = t)) : d.match(/^Boolean$/i) !== null ? t === "true" ? c = !0 : t === "false" ? c = !1 : c = t : d.match(/^(String|Enum|Object|Stream|Uuid|TimeSpan|any)$/i) !== null ? c = t : d.match(/^(Date|DateTime|DateTimeRfc1123)$/i) !== null ? c = new Date(t) : d.match(/^UnixTime$/i) !== null ? c = ld(t) : d.match(/^ByteArray$/i) !== null ? c = En(t) : d.match(/^Base64Url$/i) !== null ? c = od(t) : d.match(/^Sequence$/i) !== null ? c = Pd(this, e, t, a, m) : d.match(/^Dictionary$/i) !== null && (c = Cd(this, e, t, a, m));
    }
    return e.isConstant && (c = e.defaultValue), c;
  }
}
function Ve(r = {}, e = !1) {
  return new nd(r, e);
}
function id(r, e) {
  let t = r.length;
  for (; t - 1 >= 0 && r[t - 1] === e; )
    --t;
  return r.substr(0, t);
}
function sd(r) {
  if (!r)
    return;
  if (!(r instanceof Uint8Array))
    throw new Error("Please provide an input of type Uint8Array for converting to Base64Url.");
  const e = Bn(r);
  return id(e, "=").replace(/\+/g, "-").replace(/\//g, "_");
}
function od(r) {
  if (r) {
    if (r && typeof r.valueOf() != "string")
      throw new Error("Please provide an input of type string for converting to Uint8Array");
    return r = r.replace(/-/g, "+").replace(/_/g, "/"), En(r);
  }
}
function Or(r) {
  const e = [];
  let t = "";
  if (r) {
    const a = r.split(".");
    for (const n of a)
      n.charAt(n.length - 1) === "\\" ? t += n.substr(0, n.length - 1) + "." : (t += n, e.push(t), t = "");
  }
  return e;
}
function md(r) {
  if (r)
    return typeof r.valueOf() == "string" && (r = new Date(r)), Math.floor(r.getTime() / 1e3);
}
function ld(r) {
  if (r)
    return new Date(r * 1e3);
}
function cd(r, e, t) {
  if (t != null) {
    if (r.match(/^Number$/i) !== null) {
      if (typeof t != "number")
        throw new Error(`${e} with value ${t} must be of type number.`);
    } else if (r.match(/^String$/i) !== null) {
      if (typeof t.valueOf() != "string")
        throw new Error(`${e} with value "${t}" must be of type string.`);
    } else if (r.match(/^Uuid$/i) !== null) {
      if (!(typeof t.valueOf() == "string" && rd(t)))
        throw new Error(`${e} with value "${t}" must be of type string and a valid uuid.`);
    } else if (r.match(/^Boolean$/i) !== null) {
      if (typeof t != "boolean")
        throw new Error(`${e} with value ${t} must be of type boolean.`);
    } else if (r.match(/^Stream$/i) !== null) {
      const a = typeof t;
      if (a !== "string" && typeof t.pipe != "function" && // NodeJS.ReadableStream
      typeof t.tee != "function" && // browser ReadableStream
      !(t instanceof ArrayBuffer) && !ArrayBuffer.isView(t) && // File objects count as a type of Blob, so we want to use instanceof explicitly
      !((typeof Blob == "function" || typeof Blob == "object") && t instanceof Blob) && a !== "function")
        throw new Error(`${e} must be a string, Blob, ArrayBuffer, ArrayBufferView, ReadableStream, or () => ReadableStream.`);
    }
  }
  return t;
}
function dd(r, e, t) {
  if (!e)
    throw new Error(`Please provide a set of allowedValues to validate ${r} as an Enum Type.`);
  if (!e.some((n) => typeof n.valueOf() == "string" ? n.toLowerCase() === t.toLowerCase() : n === t))
    throw new Error(`${t} is not a valid value for ${r}. The valid values are: ${JSON.stringify(e)}.`);
  return t;
}
function pd(r, e) {
  if (e != null) {
    if (!(e instanceof Uint8Array))
      throw new Error(`${r} must be of type Uint8Array.`);
    e = Bn(e);
  }
  return e;
}
function ud(r, e) {
  if (e != null) {
    if (!(e instanceof Uint8Array))
      throw new Error(`${r} must be of type Uint8Array.`);
    e = sd(e);
  }
  return e;
}
function yd(r, e, t) {
  if (e != null) {
    if (r.match(/^Date$/i) !== null) {
      if (!(e instanceof Date || typeof e.valueOf() == "string" && !isNaN(Date.parse(e))))
        throw new Error(`${t} must be an instanceof Date or a string in ISO8601 format.`);
      e = e instanceof Date ? e.toISOString().substring(0, 10) : new Date(e).toISOString().substring(0, 10);
    } else if (r.match(/^DateTime$/i) !== null) {
      if (!(e instanceof Date || typeof e.valueOf() == "string" && !isNaN(Date.parse(e))))
        throw new Error(`${t} must be an instanceof Date or a string in ISO8601 format.`);
      e = e instanceof Date ? e.toISOString() : new Date(e).toISOString();
    } else if (r.match(/^DateTimeRfc1123$/i) !== null) {
      if (!(e instanceof Date || typeof e.valueOf() == "string" && !isNaN(Date.parse(e))))
        throw new Error(`${t} must be an instanceof Date or a string in RFC-1123 format.`);
      e = e instanceof Date ? e.toUTCString() : new Date(e).toUTCString();
    } else if (r.match(/^UnixTime$/i) !== null) {
      if (!(e instanceof Date || typeof e.valueOf() == "string" && !isNaN(Date.parse(e))))
        throw new Error(`${t} must be an instanceof Date or a string in RFC-1123/ISO8601 format for it to be serialized in UnixTime/Epoch format.`);
      e = md(e);
    } else if (r.match(/^TimeSpan$/i) !== null && !ed(e))
      throw new Error(`${t} must be a string in ISO 8601 format. Instead was "${e}".`);
  }
  return e;
}
function fd(r, e, t, a, n, i) {
  var s;
  if (!Array.isArray(t))
    throw new Error(`${a} must be of type Array.`);
  let o = e.type.element;
  if (!o || typeof o != "object")
    throw new Error(`element" metadata for an Array must be defined in the mapper and it must of type "object" in ${a}.`);
  o.type.name === "Composite" && o.type.className && (o = (s = r.modelMappers[o.type.className]) !== null && s !== void 0 ? s : o);
  const l = [];
  for (let m = 0; m < t.length; m++) {
    const c = r.serialize(o, t[m], a, i);
    if (n && o.xmlNamespace) {
      const d = o.xmlNamespacePrefix ? `xmlns:${o.xmlNamespacePrefix}` : "xmlns";
      o.type.name === "Composite" ? (l[m] = Object.assign({}, c), l[m][te] = { [d]: o.xmlNamespace }) : (l[m] = {}, l[m][i.xml.xmlCharKey] = c, l[m][te] = { [d]: o.xmlNamespace });
    } else
      l[m] = c;
  }
  return l;
}
function gd(r, e, t, a, n, i) {
  if (typeof t != "object")
    throw new Error(`${a} must be of type object.`);
  const s = e.type.value;
  if (!s || typeof s != "object")
    throw new Error(`"value" metadata for a Dictionary must be defined in the mapper and it must of type "object" in ${a}.`);
  const o = {};
  for (const l of Object.keys(t)) {
    const m = r.serialize(s, t[l], a, i);
    o[l] = In(s, m, n, i);
  }
  if (n && e.xmlNamespace) {
    const l = e.xmlNamespacePrefix ? `xmlns:${e.xmlNamespacePrefix}` : "xmlns", m = o;
    return m[te] = { [l]: e.xmlNamespace }, m;
  }
  return o;
}
function hd(r, e, t) {
  const a = e.type.additionalProperties;
  if (!a && e.type.className) {
    const n = Tn(r, e, t);
    return n == null ? void 0 : n.type.additionalProperties;
  }
  return a;
}
function Tn(r, e, t) {
  const a = e.type.className;
  if (!a)
    throw new Error(`Class name for model "${t}" is not provided in the mapper "${JSON.stringify(e, void 0, 2)}".`);
  return r.modelMappers[a];
}
function Mn(r, e, t) {
  let a = e.type.modelProperties;
  if (!a) {
    const n = Tn(r, e, t);
    if (!n)
      throw new Error(`mapper() cannot be null or undefined for model "${e.type.className}".`);
    if (a = n == null ? void 0 : n.type.modelProperties, !a)
      throw new Error(`modelProperties cannot be null or undefined in the mapper "${JSON.stringify(n)}" of type "${e.type.className}" for object "${t}".`);
  }
  return a;
}
function xd(r, e, t, a, n, i) {
  if (er(r, e) && (e = qn(r, e, t, "clientName")), t != null) {
    const s = {}, o = Mn(r, e, a);
    for (const m of Object.keys(o)) {
      const c = o[m];
      if (c.readOnly)
        continue;
      let d, p = s;
      if (r.isXML)
        c.xmlIsWrapped ? d = c.xmlName : d = c.xmlElementName || c.xmlName;
      else {
        const y = Or(c.serializedName);
        d = y.pop();
        for (const u of y) {
          const h = p[u];
          h == null && (t[m] !== void 0 && t[m] !== null || c.defaultValue !== void 0) && (p[u] = {}), p = p[u];
        }
      }
      if (p != null) {
        if (n && e.xmlNamespace) {
          const M = e.xmlNamespacePrefix ? `xmlns:${e.xmlNamespacePrefix}` : "xmlns";
          p[te] = Object.assign(Object.assign({}, p[te]), { [M]: e.xmlNamespace });
        }
        const y = c.serializedName !== "" ? a + "." + c.serializedName : a;
        let u = t[m];
        const h = er(r, e);
        h && h.clientName === m && u == null && (u = e.serializedName);
        const R = r.serialize(c, u, y, i);
        if (R !== void 0 && d !== void 0 && d !== null) {
          const M = In(c, R, n, i);
          n && c.xmlIsAttribute ? (p[te] = p[te] || {}, p[te][d] = R) : n && c.xmlIsWrapped ? p[d] = { [c.xmlElementName]: M } : p[d] = M;
        }
      }
    }
    const l = hd(r, e, a);
    if (l) {
      const m = Object.keys(o);
      for (const c in t)
        m.every((p) => p !== c) && (s[c] = r.serialize(l, t[c], a + '["' + c + '"]', i));
    }
    return s;
  }
  return t;
}
function In(r, e, t, a) {
  if (!t || !r.xmlNamespace)
    return e;
  const i = { [r.xmlNamespacePrefix ? `xmlns:${r.xmlNamespacePrefix}` : "xmlns"]: r.xmlNamespace };
  if (["Composite"].includes(r.type.name)) {
    if (e[te])
      return e;
    {
      const o = Object.assign({}, e);
      return o[te] = i, o;
    }
  }
  const s = {};
  return s[a.xml.xmlCharKey] = e, s[te] = i, s;
}
function Nd(r, e) {
  return [te, e.xml.xmlCharKey].includes(r);
}
function bd(r, e, t, a, n) {
  var i, s;
  const o = (i = n.xml.xmlCharKey) !== null && i !== void 0 ? i : qt;
  er(r, e) && (e = qn(r, e, t, "serializedName"));
  const l = Mn(r, e, a);
  let m = {};
  const c = [];
  for (const p of Object.keys(l)) {
    const y = l[p], u = Or(l[p].serializedName);
    c.push(u[0]);
    const { serializedName: h, xmlName: R, xmlElementName: M } = y;
    let T = a;
    h !== "" && h !== void 0 && (T = a + "." + h);
    const $ = y.headerCollectionPrefix;
    if ($) {
      const f = {};
      for (const g of Object.keys(t))
        g.startsWith($) && (f[g.substring($.length)] = r.deserialize(y.type.value, t[g], T, n)), c.push(g);
      m[p] = f;
    } else if (r.isXML)
      if (y.xmlIsAttribute && t[te])
        m[p] = r.deserialize(y, t[te][R], T, n);
      else if (y.xmlIsMsText)
        t[o] !== void 0 ? m[p] = t[o] : typeof t == "string" && (m[p] = t);
      else {
        const f = M || R || h;
        if (y.xmlIsWrapped) {
          const g = t[R], N = (s = g == null ? void 0 : g[M]) !== null && s !== void 0 ? s : [];
          m[p] = r.deserialize(y, N, T, n), c.push(R);
        } else {
          const g = t[f];
          m[p] = r.deserialize(y, g, T, n), c.push(f);
        }
      }
    else {
      let f, g = t, N = 0;
      for (const q of u) {
        if (!g)
          break;
        N++, g = g[q];
      }
      g === null && N < u.length && (g = void 0), f = g;
      const w = e.type.polymorphicDiscriminator;
      w && p === w.clientName && f == null && (f = e.serializedName);
      let E;
      if (Array.isArray(t[p]) && l[p].serializedName === "") {
        f = t[p];
        const q = r.deserialize(y, f, T, n);
        for (const [O, ie] of Object.entries(m))
          Object.prototype.hasOwnProperty.call(q, O) || (q[O] = ie);
        m = q;
      } else (f !== void 0 || y.defaultValue !== void 0) && (E = r.deserialize(y, f, T, n), m[p] = E);
    }
  }
  const d = e.type.additionalProperties;
  if (d) {
    const p = (y) => {
      for (const u in l)
        if (Or(l[u].serializedName)[0] === y)
          return !1;
      return !0;
    };
    for (const y in t)
      p(y) && (m[y] = r.deserialize(d, t[y], a + '["' + y + '"]', n));
  } else if (t && !n.ignoreUnknownProperties)
    for (const p of Object.keys(t))
      m[p] === void 0 && !c.includes(p) && !Nd(p, n) && (m[p] = t[p]);
  return m;
}
function Cd(r, e, t, a, n) {
  const i = e.type.value;
  if (!i || typeof i != "object")
    throw new Error(`"value" metadata for a Dictionary must be defined in the mapper and it must of type "object" in ${a}`);
  if (t) {
    const s = {};
    for (const o of Object.keys(t))
      s[o] = r.deserialize(i, t[o], a, n);
    return s;
  }
  return t;
}
function Pd(r, e, t, a, n) {
  var i;
  let s = e.type.element;
  if (!s || typeof s != "object")
    throw new Error(`element" metadata for an Array must be defined in the mapper and it must of type "object" in ${a}`);
  if (t) {
    Array.isArray(t) || (t = [t]), s.type.name === "Composite" && s.type.className && (s = (i = r.modelMappers[s.type.className]) !== null && i !== void 0 ? i : s);
    const o = [];
    for (let l = 0; l < t.length; l++)
      o[l] = r.deserialize(s, t[l], `${a}[${l}]`, n);
    return o;
  }
  return t;
}
function vd(r, e, t) {
  const a = [t];
  for (; a.length; ) {
    const n = a.shift(), i = e === n ? e : n + "." + e;
    if (Object.prototype.hasOwnProperty.call(r, i))
      return r[i];
    for (const [s, o] of Object.entries(r))
      s.startsWith(n + ".") && o.type.uberParent === n && o.type.className && a.push(o.type.className);
  }
}
function qn(r, e, t, a) {
  var n;
  const i = er(r, e);
  if (i) {
    let s = i[a];
    if (s) {
      a === "serializedName" && (s = s.replace(/\\/gi, ""));
      const o = t[s], l = (n = e.type.uberParent) !== null && n !== void 0 ? n : e.type.className;
      if (typeof o == "string" && l) {
        const m = vd(r.modelMappers.discriminators, o, l);
        m && (e = m);
      }
    }
  }
  return e;
}
function er(r, e) {
  return e.type.polymorphicDiscriminator || Aa(r, e.type.uberParent) || Aa(r, e.type.className);
}
function Aa(r, e) {
  return e && r.modelMappers[e] && r.modelMappers[e].type.polymorphicDiscriminator;
}
const Ke = {
  Base64Url: "Base64Url",
  Boolean: "Boolean",
  ByteArray: "ByteArray",
  Composite: "Composite",
  Date: "Date",
  DateTime: "DateTime",
  DateTimeRfc1123: "DateTimeRfc1123",
  Dictionary: "Dictionary",
  Enum: "Enum",
  Number: "Number",
  Object: "Object",
  Sequence: "Sequence",
  String: "String",
  Stream: "Stream",
  TimeSpan: "TimeSpan",
  UnixTime: "UnixTime"
}, Ua = {
  operationRequestMap: /* @__PURE__ */ new WeakMap()
};
function Qe(r, e, t) {
  let a = e.parameterPath;
  const n = e.mapper;
  let i;
  if (typeof a == "string" && (a = [a]), Array.isArray(a)) {
    if (a.length > 0)
      if (n.isConstant)
        i = n.defaultValue;
      else {
        let s = $a(r, a);
        !s.propertyFound && t && (s = $a(t, a));
        let o = !1;
        s.propertyFound || (o = n.required || a[0] === "options" && a.length === 2), i = o ? n.defaultValue : s.propertyValue;
      }
  } else {
    n.required && (i = {});
    for (const s in a) {
      const o = n.type.modelProperties[s], l = a[s], m = Qe(r, {
        parameterPath: l,
        mapper: o
      }, t);
      m !== void 0 && (i || (i = {}), i[s] = m);
    }
  }
  return i;
}
function $a(r, e) {
  const t = { propertyFound: !1 };
  let a = 0;
  for (; a < e.length; ++a) {
    const n = e[a];
    if (r && n in r)
      r = r[n];
    else
      break;
  }
  return a === e.length && (t.propertyValue = r, t.propertyFound = !0), t;
}
const On = Symbol.for("@azure/core-client original request");
function zd(r) {
  return On in r;
}
function et(r) {
  if (zd(r))
    return et(r[On]);
  let e = Ua.operationRequestMap.get(r);
  return e || (e = {}, Ua.operationRequestMap.set(r, e)), e;
}
const Sd = ["application/json", "text/json"], Rd = ["application/xml", "application/atom+xml"], wd = "deserializationPolicy";
function Bd(r = {}) {
  var e, t, a, n, i, s, o;
  const l = (t = (e = r.expectedContentTypes) === null || e === void 0 ? void 0 : e.json) !== null && t !== void 0 ? t : Sd, m = (n = (a = r.expectedContentTypes) === null || a === void 0 ? void 0 : a.xml) !== null && n !== void 0 ? n : Rd, c = r.parseXML, d = r.serializerOptions, p = {
    xml: {
      rootName: (i = d == null ? void 0 : d.xml.rootName) !== null && i !== void 0 ? i : "",
      includeRoot: (s = d == null ? void 0 : d.xml.includeRoot) !== null && s !== void 0 ? s : !1,
      xmlCharKey: (o = d == null ? void 0 : d.xml.xmlCharKey) !== null && o !== void 0 ? o : qt
    }
  };
  return {
    name: wd,
    async sendRequest(y, u) {
      const h = await u(y);
      return Md(l, m, h, p, c);
    }
  };
}
function Ed(r) {
  let e;
  const t = r.request, a = et(t), n = a == null ? void 0 : a.operationSpec;
  return n && (a != null && a.operationResponseGetter ? e = a == null ? void 0 : a.operationResponseGetter(n, r) : e = n.responses[r.status]), e;
}
function Td(r) {
  const e = r.request, t = et(e), a = t == null ? void 0 : t.shouldDeserialize;
  let n;
  return a === void 0 ? n = !0 : typeof a == "boolean" ? n = a : n = a(r), n;
}
async function Md(r, e, t, a, n) {
  const i = await Od(r, e, t, a, n);
  if (!Td(i))
    return i;
  const s = et(i.request), o = s == null ? void 0 : s.operationSpec;
  if (!o || !o.responses)
    return i;
  const l = Ed(i), { error: m, shouldReturnResponse: c } = qd(i, o, l, a);
  if (m)
    throw m;
  if (c)
    return i;
  if (l) {
    if (l.bodyMapper) {
      let d = i.parsedBody;
      o.isXML && l.bodyMapper.type.name === Ke.Sequence && (d = typeof d == "object" ? d[l.bodyMapper.xmlElementName] : []);
      try {
        i.parsedBody = o.serializer.deserialize(l.bodyMapper, d, "operationRes.parsedBody", a);
      } catch (p) {
        throw new It(`Error ${p} occurred in deserializing the responseBody - ${i.bodyAsText}`, {
          statusCode: i.status,
          request: i.request,
          response: i
        });
      }
    } else o.httpMethod === "HEAD" && (i.parsedBody = t.status >= 200 && t.status < 300);
    l.headersMapper && (i.parsedHeaders = o.serializer.deserialize(l.headersMapper, i.headers.toJSON(), "operationRes.parsedHeaders", { xml: {}, ignoreUnknownProperties: !0 }));
  }
  return i;
}
function Id(r) {
  const e = Object.keys(r.responses);
  return e.length === 0 || e.length === 1 && e[0] === "default";
}
function qd(r, e, t, a) {
  var n, i, s, o, l;
  const m = 200 <= r.status && r.status < 300;
  if (Id(e) ? m : !!t)
    if (t) {
      if (!t.isError)
        return { error: null, shouldReturnResponse: !1 };
    } else
      return { error: null, shouldReturnResponse: !1 };
  const d = t ?? e.responses.default, p = !((n = r.request.streamResponseStatusCodes) === null || n === void 0) && n.has(r.status) ? `Unexpected status code: ${r.status}` : r.bodyAsText, y = new It(p, {
    statusCode: r.status,
    request: r.request,
    response: r
  });
  if (!d && !(!((s = (i = r.parsedBody) === null || i === void 0 ? void 0 : i.error) === null || s === void 0) && s.code && (!((l = (o = r.parsedBody) === null || o === void 0 ? void 0 : o.error) === null || l === void 0) && l.message)))
    throw y;
  const u = d == null ? void 0 : d.bodyMapper, h = d == null ? void 0 : d.headersMapper;
  try {
    if (r.parsedBody) {
      const R = r.parsedBody;
      let M;
      if (u) {
        let $ = R;
        if (e.isXML && u.type.name === Ke.Sequence) {
          $ = [];
          const f = u.xmlElementName;
          typeof R == "object" && f && ($ = R[f]);
        }
        M = e.serializer.deserialize(u, $, "error.response.parsedBody", a);
      }
      const T = R.error || M || R;
      y.code = T.code, T.message && (y.message = T.message), u && (y.response.parsedBody = M);
    }
    r.headers && h && (y.response.parsedHeaders = e.serializer.deserialize(h, r.headers.toJSON(), "operationRes.parsedHeaders"));
  } catch (R) {
    y.message = `Error "${R.message}" occurred in deserializing the responseBody - "${r.bodyAsText}" for the default response.`;
  }
  return { error: y, shouldReturnResponse: !1 };
}
async function Od(r, e, t, a, n) {
  var i;
  if (!(!((i = t.request.streamResponseStatusCodes) === null || i === void 0) && i.has(t.status)) && t.bodyAsText) {
    const s = t.bodyAsText, o = t.headers.get("Content-Type") || "", l = o ? o.split(";").map((m) => m.toLowerCase()) : [];
    try {
      if (l.length === 0 || l.some((m) => r.indexOf(m) !== -1))
        return t.parsedBody = JSON.parse(s), t;
      if (l.some((m) => e.indexOf(m) !== -1)) {
        if (!n)
          throw new Error("Parsing XML not supported.");
        const m = await n(s, a.xml);
        return t.parsedBody = m, t;
      }
    } catch (m) {
      const c = `Error "${m}" occurred while parsing the response body - ${t.bodyAsText}.`, d = m.code || It.PARSE_ERROR;
      throw new It(c, {
        code: d,
        statusCode: t.status,
        request: t.request,
        response: t
      });
    }
  }
  return t;
}
function _d(r) {
  const e = /* @__PURE__ */ new Set();
  for (const t in r.responses) {
    const a = r.responses[t];
    a.bodyMapper && a.bodyMapper.type.name === Ke.Stream && e.add(Number(t));
  }
  return e;
}
function Se(r) {
  const { parameterPath: e, mapper: t } = r;
  let a;
  return typeof e == "string" ? a = e : Array.isArray(e) ? a = e.join(".") : a = t.serializedName, a;
}
const Hd = "serializationPolicy";
function _n(r = {}) {
  const e = r.stringifyXML;
  return {
    name: Hd,
    async sendRequest(t, a) {
      const n = et(t), i = n == null ? void 0 : n.operationSpec, s = n == null ? void 0 : n.operationArguments;
      return i && s && (Dd(t, s, i), Ld(t, s, i, e)), a(t);
    }
  };
}
function Dd(r, e, t) {
  var a, n;
  if (t.headerParameters)
    for (const s of t.headerParameters) {
      let o = Qe(e, s);
      if (o != null || s.mapper.required) {
        o = t.serializer.serialize(s.mapper, o, Se(s));
        const l = s.mapper.headerCollectionPrefix;
        if (l)
          for (const m of Object.keys(o))
            r.headers.set(l + m, o[m]);
        else
          r.headers.set(s.mapper.serializedName || Se(s), o);
      }
    }
  const i = (n = (a = e.options) === null || a === void 0 ? void 0 : a.requestOptions) === null || n === void 0 ? void 0 : n.customHeaders;
  if (i)
    for (const s of Object.keys(i))
      r.headers.set(s, i[s]);
}
function Ld(r, e, t, a = function() {
  throw new Error("XML serialization unsupported!");
}) {
  var n, i, s, o, l;
  const m = (n = e.options) === null || n === void 0 ? void 0 : n.serializerOptions, c = {
    xml: {
      rootName: (i = m == null ? void 0 : m.xml.rootName) !== null && i !== void 0 ? i : "",
      includeRoot: (s = m == null ? void 0 : m.xml.includeRoot) !== null && s !== void 0 ? s : !1,
      xmlCharKey: (o = m == null ? void 0 : m.xml.xmlCharKey) !== null && o !== void 0 ? o : qt
    }
  }, d = c.xml.xmlCharKey;
  if (t.requestBody && t.requestBody.mapper) {
    r.body = Qe(e, t.requestBody);
    const p = t.requestBody.mapper, { required: y, serializedName: u, xmlName: h, xmlElementName: R, xmlNamespace: M, xmlNamespacePrefix: T, nullable: $ } = p, f = p.type.name;
    try {
      if (r.body !== void 0 && r.body !== null || $ && r.body === null || y) {
        const g = Se(t.requestBody);
        r.body = t.serializer.serialize(p, r.body, g, c);
        const N = f === Ke.Stream;
        if (t.isXML) {
          const w = T ? `xmlns:${T}` : "xmlns", E = kd(M, w, f, r.body, c);
          f === Ke.Sequence ? r.body = a(Ad(E, R || h || u, w, M), { rootName: h || u, xmlCharKey: d }) : N || (r.body = a(E, {
            rootName: h || u,
            xmlCharKey: d
          }));
        } else {
          if (f === Ke.String && (!((l = t.contentType) === null || l === void 0) && l.match("text/plain") || t.mediaType === "text"))
            return;
          N || (r.body = JSON.stringify(r.body));
        }
      }
    } catch (g) {
      throw new Error(`Error "${g.message}" occurred in serializing the payload - ${JSON.stringify(u, void 0, "  ")}.`);
    }
  } else if (t.formDataParameters && t.formDataParameters.length > 0) {
    r.formData = {};
    for (const p of t.formDataParameters) {
      const y = Qe(e, p);
      if (y != null) {
        const u = p.mapper.serializedName || Se(p);
        r.formData[u] = t.serializer.serialize(p.mapper, y, Se(p), c);
      }
    }
  }
}
function kd(r, e, t, a, n) {
  if (r && !["Composite", "Sequence", "Dictionary"].includes(t)) {
    const i = {};
    return i[n.xml.xmlCharKey] = a, i[te] = { [e]: r }, i;
  }
  return a;
}
function Ad(r, e, t, a) {
  if (Array.isArray(r) || (r = [r]), !t || !a)
    return { [e]: r };
  const n = { [e]: r };
  return n[te] = { [t]: a }, n;
}
function Hn(r = {}) {
  const e = $c(r ?? {});
  return r.credentialOptions && e.addPolicy(Vr({
    credential: r.credentialOptions.credential,
    scopes: r.credentialOptions.credentialScopes
  })), e.addPolicy(_n(r.serializationOptions), { phase: "Serialize" }), e.addPolicy(Bd(r.deserializationOptions), {
    phase: "Deserialize"
  }), e;
}
let vr;
function Ud() {
  return vr || (vr = Sn()), vr;
}
const $d = {
  CSV: ",",
  SSV: " ",
  Multi: "Multi",
  TSV: "	",
  Pipes: "|"
};
function jd(r, e, t, a) {
  const n = Fd(e, t, a);
  let i = !1, s = ja(r, n);
  if (e.path) {
    let m = ja(e.path, n);
    e.path === "/{nextLink}" && m.startsWith("/") && (m = m.substring(1)), Kd(m) ? (s = m, i = !0) : s = Gd(s, m);
  }
  const { queryParams: o, sequenceParams: l } = Xd(e, t, a);
  return s = Qd(s, o, l, i), s;
}
function ja(r, e) {
  let t = r;
  for (const [a, n] of e)
    t = t.split(a).join(n);
  return t;
}
function Fd(r, e, t) {
  var a;
  const n = /* @__PURE__ */ new Map();
  if (!((a = r.urlParameters) === null || a === void 0) && a.length)
    for (const i of r.urlParameters) {
      let s = Qe(e, i, t);
      const o = Se(i);
      s = r.serializer.serialize(i.mapper, s, o), i.skipEncoding || (s = encodeURIComponent(s)), n.set(`{${i.mapper.serializedName || o}}`, s);
    }
  return n;
}
function Kd(r) {
  return r.includes("://");
}
function Gd(r, e) {
  if (!e)
    return r;
  const t = new URL(r);
  let a = t.pathname;
  a.endsWith("/") || (a = `${a}/`), e.startsWith("/") && (e = e.substring(1));
  const n = e.indexOf("?");
  if (n !== -1) {
    const i = e.substring(0, n), s = e.substring(n + 1);
    a = a + i, s && (t.search = t.search ? `${t.search}&${s}` : s);
  } else
    a = a + e;
  return t.pathname = a, t.toString();
}
function Xd(r, e, t) {
  var a;
  const n = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Set();
  if (!((a = r.queryParameters) === null || a === void 0) && a.length)
    for (const s of r.queryParameters) {
      s.mapper.type.name === "Sequence" && s.mapper.serializedName && i.add(s.mapper.serializedName);
      let o = Qe(e, s, t);
      if (o != null || s.mapper.required) {
        o = r.serializer.serialize(s.mapper, o, Se(s));
        const l = s.collectionFormat ? $d[s.collectionFormat] : "";
        if (Array.isArray(o) && (o = o.map((m) => m ?? "")), s.collectionFormat === "Multi" && o.length === 0)
          continue;
        Array.isArray(o) && (s.collectionFormat === "SSV" || s.collectionFormat === "TSV") && (o = o.join(l)), s.skipEncoding || (Array.isArray(o) ? o = o.map((m) => encodeURIComponent(m)) : o = encodeURIComponent(o)), Array.isArray(o) && (s.collectionFormat === "CSV" || s.collectionFormat === "Pipes") && (o = o.join(l)), n.set(s.mapper.serializedName || Se(s), o);
      }
    }
  return {
    queryParams: n,
    sequenceParams: i
  };
}
function Wd(r) {
  const e = /* @__PURE__ */ new Map();
  if (!r || r[0] !== "?")
    return e;
  r = r.slice(1);
  const t = r.split("&");
  for (const a of t) {
    const [n, i] = a.split("=", 2), s = e.get(n);
    s ? Array.isArray(s) ? s.push(i) : e.set(n, [s, i]) : e.set(n, i);
  }
  return e;
}
function Qd(r, e, t, a = !1) {
  if (e.size === 0)
    return r;
  const n = new URL(r), i = Wd(n.search);
  for (const [o, l] of e) {
    const m = i.get(o);
    if (Array.isArray(m))
      if (Array.isArray(l)) {
        m.push(...l);
        const c = new Set(m);
        i.set(o, Array.from(c));
      } else
        m.push(l);
    else m ? (Array.isArray(l) ? l.unshift(m) : t.has(o) && i.set(o, [m, l]), a || i.set(o, l)) : i.set(o, l);
  }
  const s = [];
  for (const [o, l] of i)
    if (typeof l == "string")
      s.push(`${o}=${l}`);
    else if (Array.isArray(l))
      for (const m of l)
        s.push(`${o}=${m}`);
    else
      s.push(`${o}=${l}`);
  return n.search = s.length ? `?${s.join("&")}` : "", n.toString();
}
const Jd = Jr("core-client");
class Yd {
  /**
   * The ServiceClient constructor
   * @param options - The service client options that govern the behavior of the client.
   */
  constructor(e = {}) {
    var t, a;
    if (this._requestContentType = e.requestContentType, this._endpoint = (t = e.endpoint) !== null && t !== void 0 ? t : e.baseUri, e.baseUri && Jd.warning("The baseUri option for SDK Clients has been deprecated, please use endpoint instead."), this._allowInsecureConnection = e.allowInsecureConnection, this._httpClient = e.httpClient || Ud(), this.pipeline = e.pipeline || Zd(e), !((a = e.additionalPolicies) === null || a === void 0) && a.length)
      for (const { policy: n, position: i } of e.additionalPolicies) {
        const s = i === "perRetry" ? "Sign" : void 0;
        this.pipeline.addPolicy(n, {
          afterPhase: s
        });
      }
  }
  /**
   * Send the provided httpRequest.
   */
  async sendRequest(e) {
    return this.pipeline.sendRequest(this._httpClient, e);
  }
  /**
   * Send an HTTP request that is populated using the provided OperationSpec.
   * @typeParam T - The typed result of the request, based on the OperationSpec.
   * @param operationArguments - The arguments that the HTTP request's templated values will be populated from.
   * @param operationSpec - The OperationSpec to use to populate the httpRequest.
   */
  async sendOperationRequest(e, t) {
    const a = t.baseUrl || this._endpoint;
    if (!a)
      throw new Error("If operationSpec.baseUrl is not specified, then the ServiceClient must have a endpoint string property that contains the base URL to use.");
    const n = jd(a, t, e, this), i = Rn({
      url: n
    });
    i.method = t.httpMethod;
    const s = et(i);
    s.operationSpec = t, s.operationArguments = e;
    const o = t.contentType || this._requestContentType;
    o && t.requestBody && i.headers.set("Content-Type", o);
    const l = e.options;
    if (l) {
      const m = l.requestOptions;
      m && (m.timeout && (i.timeout = m.timeout), m.onUploadProgress && (i.onUploadProgress = m.onUploadProgress), m.onDownloadProgress && (i.onDownloadProgress = m.onDownloadProgress), m.shouldDeserialize !== void 0 && (s.shouldDeserialize = m.shouldDeserialize), m.allowInsecureConnection && (i.allowInsecureConnection = !0)), l.abortSignal && (i.abortSignal = l.abortSignal), l.tracingOptions && (i.tracingOptions = l.tracingOptions);
    }
    this._allowInsecureConnection && (i.allowInsecureConnection = !0), i.streamResponseStatusCodes === void 0 && (i.streamResponseStatusCodes = _d(t));
    try {
      const m = await this.sendRequest(i), c = ka(m, t.responses[m.status]);
      return l != null && l.onResponse && l.onResponse(m, c), c;
    } catch (m) {
      if (typeof m == "object" && (m != null && m.response)) {
        const c = m.response, d = ka(c, t.responses[m.statusCode] || t.responses.default);
        m.details = d, l != null && l.onResponse && l.onResponse(c, d, m);
      }
      throw m;
    }
  }
}
function Zd(r) {
  const e = Vd(r), t = r.credential && e ? { credentialScopes: e, credential: r.credential } : void 0;
  return Hn(Object.assign(Object.assign({}, r), { credentialOptions: t }));
}
function Vd(r) {
  if (r.credentialScopes)
    return r.credentialScopes;
  if (r.endpoint)
    return `${r.endpoint}/.default`;
  if (r.baseUri)
    return `${r.baseUri}/.default`;
  if (r.credential && !r.credentialScopes)
    throw new Error("When using credentials, the ServiceClientOptions must contain either a endpoint or a credentialScopes. Unable to create a bearerTokenAuthenticationPolicy");
}
const Dn = {
  DefaultScope: "/.default",
  /**
   * Defines constants for use with HTTP headers.
   */
  HeaderConstants: {
    /**
     * The Authorization header.
     */
    AUTHORIZATION: "authorization"
  }
};
function ep(r) {
  return /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/.test(r);
}
const Ln = async (r) => {
  var e;
  const t = ip(r.request), a = ap(r.response);
  if (a) {
    const n = np(a), i = rp(r, n), s = tp(n);
    if (!s)
      return !1;
    const o = await r.getAccessToken(i, Object.assign(Object.assign({}, t), { tenantId: s }));
    return o ? (r.request.headers.set(Dn.HeaderConstants.AUTHORIZATION, `${(e = o.tokenType) !== null && e !== void 0 ? e : "Bearer"} ${o.token}`), !0) : !1;
  }
  return !1;
};
function tp(r) {
  const a = new URL(r.authorization_uri).pathname.split("/")[1];
  if (a && ep(a))
    return a;
}
function rp(r, e) {
  if (!e.resource_id)
    return r.scopes;
  const t = new URL(e.resource_id);
  t.pathname = Dn.DefaultScope;
  let a = t.toString();
  return a === "https://disk.azure.com/.default" && (a = "https://disk.azure.com//.default"), [a];
}
function ap(r) {
  const e = r.headers.get("WWW-Authenticate");
  if (r.status === 401 && e)
    return e;
}
function np(r) {
  return `${r.slice(7).trim()} `.split(" ").filter((n) => n).map((n) => (([i, s]) => ({ [i]: s }))(n.trim().split("="))).reduce((n, i) => Object.assign(Object.assign({}, n), i), {});
}
function ip(r) {
  return {
    abortSignal: r.abortSignal,
    requestOptions: {
      timeout: r.timeout
    },
    tracingOptions: r.tracingOptions
  };
}
const kn = Symbol("Original PipelineRequest"), sp = Symbol.for("@azure/core-client original request");
function ea(r, e = {}) {
  const a = r[kn], n = ir(r.headers.toJson({ preserveCase: !0 }));
  if (a)
    return a.headers = n, a;
  {
    const i = Rn({
      url: r.url,
      method: r.method,
      headers: n,
      withCredentials: r.withCredentials,
      timeout: r.timeout,
      requestId: r.requestId,
      abortSignal: r.abortSignal,
      body: r.body,
      formData: r.formData,
      disableKeepAlive: !!r.keepAlive,
      onDownloadProgress: r.onDownloadProgress,
      onUploadProgress: r.onUploadProgress,
      proxySettings: r.proxySettings,
      streamResponseStatusCodes: r.streamResponseStatusCodes,
      agent: r.agent,
      requestOverrides: r.requestOverrides
    });
    return e.originalRequest && (i[sp] = e.originalRequest), i;
  }
}
function sr(r, e) {
  var t;
  const a = (t = e == null ? void 0 : e.originalRequest) !== null && t !== void 0 ? t : r, n = {
    url: r.url,
    method: r.method,
    headers: ta(r.headers),
    withCredentials: r.withCredentials,
    timeout: r.timeout,
    requestId: r.headers.get("x-ms-client-request-id") || r.requestId,
    abortSignal: r.abortSignal,
    body: r.body,
    formData: r.formData,
    keepAlive: !!r.disableKeepAlive,
    onDownloadProgress: r.onDownloadProgress,
    onUploadProgress: r.onUploadProgress,
    proxySettings: r.proxySettings,
    streamResponseStatusCodes: r.streamResponseStatusCodes,
    agent: r.agent,
    requestOverrides: r.requestOverrides,
    clone() {
      throw new Error("Cannot clone a non-proxied WebResourceLike");
    },
    prepare() {
      throw new Error("WebResourceLike.prepare() is not supported by @azure/core-http-compat");
    },
    validateRequestProperties() {
    }
  };
  return e != null && e.createProxy ? new Proxy(n, {
    get(i, s, o) {
      return s === kn ? r : s === "clone" ? () => sr(ea(n, { originalRequest: a }), {
        createProxy: !0,
        originalRequest: a
      }) : Reflect.get(i, s, o);
    },
    set(i, s, o, l) {
      return s === "keepAlive" && (r.disableKeepAlive = !o), typeof s == "string" && [
        "url",
        "method",
        "withCredentials",
        "timeout",
        "requestId",
        "abortSignal",
        "body",
        "formData",
        "onDownloadProgress",
        "onUploadProgress",
        "proxySettings",
        "streamResponseStatusCodes",
        "agent",
        "requestOverrides"
      ].includes(s) && (r[s] = o), Reflect.set(i, s, o, l);
    }
  }) : n;
}
function ta(r) {
  return new ra(r.toJSON({ preserveCase: !0 }));
}
function Pt(r) {
  return r.toLowerCase();
}
class ra {
  constructor(e) {
    if (this._headersMap = {}, e)
      for (const t in e)
        this.set(t, e[t]);
  }
  /**
   * Set a header in this collection with the provided name and value. The name is
   * case-insensitive.
   * @param headerName - The name of the header to set. This value is case-insensitive.
   * @param headerValue - The value of the header to set.
   */
  set(e, t) {
    this._headersMap[Pt(e)] = {
      name: e,
      value: t.toString()
    };
  }
  /**
   * Get the header value for the provided header name, or undefined if no header exists in this
   * collection with the provided name.
   * @param headerName - The name of the header.
   */
  get(e) {
    const t = this._headersMap[Pt(e)];
    return t ? t.value : void 0;
  }
  /**
   * Get whether or not this header collection contains a header entry for the provided header name.
   */
  contains(e) {
    return !!this._headersMap[Pt(e)];
  }
  /**
   * Remove the header with the provided headerName. Return whether or not the header existed and
   * was removed.
   * @param headerName - The name of the header to remove.
   */
  remove(e) {
    const t = this.contains(e);
    return delete this._headersMap[Pt(e)], t;
  }
  /**
   * Get the headers that are contained this collection as an object.
   */
  rawHeaders() {
    return this.toJson({ preserveCase: !0 });
  }
  /**
   * Get the headers that are contained in this collection as an array.
   */
  headersArray() {
    const e = [];
    for (const t in this._headersMap)
      e.push(this._headersMap[t]);
    return e;
  }
  /**
   * Get the header names that are contained in this collection.
   */
  headerNames() {
    const e = [], t = this.headersArray();
    for (let a = 0; a < t.length; ++a)
      e.push(t[a].name);
    return e;
  }
  /**
   * Get the header values that are contained in this collection.
   */
  headerValues() {
    const e = [], t = this.headersArray();
    for (let a = 0; a < t.length; ++a)
      e.push(t[a].value);
    return e;
  }
  /**
   * Get the JSON object representation of this HTTP header collection.
   */
  toJson(e = {}) {
    const t = {};
    if (e.preserveCase)
      for (const a in this._headersMap) {
        const n = this._headersMap[a];
        t[n.name] = n.value;
      }
    else
      for (const a in this._headersMap) {
        const n = this._headersMap[a];
        t[Pt(n.name)] = n.value;
      }
    return t;
  }
  /**
   * Get the string representation of this HTTP header collection.
   */
  toString() {
    return JSON.stringify(this.toJson({ preserveCase: !0 }));
  }
  /**
   * Create a deep clone/copy of this HttpHeaders collection.
   */
  clone() {
    const e = {};
    for (const t in this._headersMap) {
      const a = this._headersMap[t];
      e[a.name] = a.value;
    }
    return new ra(e);
  }
}
const An = Symbol("Original FullOperationResponse");
function Un(r, e) {
  let t = sr(r.request), a = ta(r.headers);
  return e != null && e.createProxy ? new Proxy(r, {
    get(n, i, s) {
      return i === "headers" ? a : i === "request" ? t : i === An ? r : Reflect.get(n, i, s);
    },
    set(n, i, s, o) {
      return i === "headers" ? a = s : i === "request" && (t = s), Reflect.set(n, i, s, o);
    }
  }) : Object.assign(Object.assign({}, r), {
    request: t,
    headers: a
  });
}
function $n(r) {
  const t = r[An], a = ir(r.headers.toJson({ preserveCase: !0 }));
  return t ? (t.headers = a, t) : Object.assign(Object.assign({}, r), { headers: a, request: ea(r.request) });
}
class op extends Yd {
  constructor(e) {
    var t, a;
    super(e), ((t = e.keepAliveOptions) === null || t === void 0 ? void 0 : t.enable) === !1 && !Yc(this.pipeline) && this.pipeline.addPolicy(Jc()), ((a = e.redirectOptions) === null || a === void 0 ? void 0 : a.handleRedirects) === !1 && this.pipeline.removePolicy({
      name: oc
    });
  }
  /**
   * Compatible send operation request function.
   *
   * @param operationArguments - Operation arguments
   * @param operationSpec - Operation Spec
   * @returns
   */
  async sendOperationRequest(e, t) {
    var a;
    const n = (a = e == null ? void 0 : e.options) === null || a === void 0 ? void 0 : a.onResponse;
    let i;
    function s(l, m, c) {
      i = l, n && n(l, m, c);
    }
    e.options = Object.assign(Object.assign({}, e.options), { onResponse: s });
    const o = await super.sendOperationRequest(e, t);
    return i && Object.defineProperty(o, "_response", {
      value: Un(i)
    }), o;
  }
}
var Fa;
(function(r) {
  r[r.ERROR = 1] = "ERROR", r[r.INFO = 3] = "INFO", r[r.OFF = 0] = "OFF", r[r.WARNING = 2] = "WARNING";
})(Fa || (Fa = {}));
const mp = {
  log(r, e) {
  },
  shouldLog(r) {
    return !1;
  }
}, lp = "RequestPolicyFactoryPolicy";
function cp(r) {
  const e = r.slice().reverse();
  return {
    name: lp,
    async sendRequest(t, a) {
      let n = {
        async sendRequest(o) {
          const l = await a(ea(o));
          return Un(l, { createProxy: !0 });
        }
      };
      for (const o of e)
        n = o.create(n, mp);
      const i = sr(t, { createProxy: !0 }), s = await n.sendRequest(i);
      return $n(s);
    }
  };
}
function dp(r) {
  return {
    sendRequest: async (e) => {
      const t = await r.sendRequest(sr(e, { createProxy: !0 }));
      return $n(t);
    }
  };
}
const wt = "$", jn = "_";
if (!document || !DOMParser || !Node || !XMLSerializer)
  throw new Error('This library depends on the following DOM objects: ["document", "DOMParser", "Node", "XMLSerializer"] to parse XML, but some of these are undefined. You may provide a polyfill to make these globally available in order to support your environment. For more information, please refer to https://aka.ms/azsdk/js/web-workers. ');
let Ie;
try {
  typeof self.trustedTypes < "u" && (Ie = self.trustedTypes.createPolicy("@azure/core-xml#xml.browser", {
    createHTML: (r) => r
  }));
} catch {
  console.warn('Could not create trusted types policy "@azure/core-xml#xml.browser"');
}
const vt = document.implementation.createDocument(null, null, null), Fn = new DOMParser();
function pp(r, e = {}) {
  var t, a, n, i, s, o;
  try {
    const l = {
      rootName: (t = e.rootName) !== null && t !== void 0 ? t : "",
      includeRoot: (a = e.includeRoot) !== null && a !== void 0 ? a : !1,
      xmlCharKey: (n = e.xmlCharKey) !== null && n !== void 0 ? n : jn,
      cdataPropName: (i = e.cdataPropName) !== null && i !== void 0 ? i : "__cdata",
      stopNodes: (s = e.stopNodes) !== null && s !== void 0 ? s : []
    }, m = Fn.parseFromString((o = Ie == null ? void 0 : Ie.createHTML(r)) !== null && o !== void 0 ? o : r, "application/xml");
    yp(m);
    let c;
    return l.includeRoot ? c = _r(m, l) : c = _r(m.childNodes[0], l), Promise.resolve(c);
  } catch (l) {
    return Promise.reject(l);
  }
}
let zt;
function up() {
  var r, e;
  if (zt === void 0)
    try {
      const t = (r = Ie == null ? void 0 : Ie.createHTML("INVALID")) !== null && r !== void 0 ? r : "INVALID";
      zt = (e = Fn.parseFromString(t, "text/xml").getElementsByTagName("parsererror")[0].namespaceURI) !== null && e !== void 0 ? e : "";
    } catch {
      zt = "";
    }
  return zt;
}
function yp(r) {
  const e = r.getElementsByTagName("parsererror");
  if (e.length > 0 && up()) {
    for (let t = 0; t < e.length; t++)
      if (e[t].namespaceURI === zt)
        throw new Error(e[t].innerHTML);
  }
}
function fp(r) {
  return !!r.attributes;
}
function gp(r) {
  return fp(r) && r.hasAttributes() ? r : void 0;
}
function _r(r, e) {
  var t;
  let a = {};
  const n = r.childNodes.length, i = r.childNodes[0], s = i && n === 1 && i.nodeType === Node.TEXT_NODE && i.nodeValue || void 0, o = gp(r);
  if (o) {
    a[wt] = {};
    for (let l = 0; l < o.attributes.length; l++) {
      const m = o.attributes[l];
      a[wt][m.nodeName] = m.nodeValue;
    }
    s && (a[e.xmlCharKey] = s);
  } else n === 0 ? a = "" : s && (a = s);
  if (!s)
    for (let l = 0; l < n; l++) {
      const m = r.childNodes[l];
      if ((m == null ? void 0 : m.nodeType) === Node.CDATA_SECTION_NODE)
        a = m.textContent;
      else if (((t = m == null ? void 0 : m.firstChild) === null || t === void 0 ? void 0 : t.nodeType) === Node.CDATA_SECTION_NODE)
        a[m.nodeName] = m.textContent;
      else if (m.nodeType !== Node.TEXT_NODE) {
        const c = _r(m, e);
        a[m.nodeName] ? Array.isArray(a[m.nodeName]) ? a[m.nodeName].push(c) : a[m.nodeName] = [a[m.nodeName], c] : a[m.nodeName] = c;
      }
    }
  return a;
}
const hp = new XMLSerializer();
function Kn(r, e = {}) {
  var t, a, n, i, s;
  const o = {
    rootName: (t = e.rootName) !== null && t !== void 0 ? t : "root",
    includeRoot: (a = e.includeRoot) !== null && a !== void 0 ? a : !1,
    xmlCharKey: (n = e.xmlCharKey) !== null && n !== void 0 ? n : jn,
    cdataPropName: (i = e.cdataPropName) !== null && i !== void 0 ? i : "__cdata",
    stopNodes: (s = e.stopNodes) !== null && s !== void 0 ? s : []
  }, l = Hr(r, o.rootName, o)[0];
  return '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>' + hp.serializeToString(l).replace(/ xmlns=""/g, "");
}
function xp(r) {
  const e = [];
  for (const t of Object.keys(r)) {
    const a = vt.createAttribute(t);
    a.value = r[t].toString(), e.push(a);
  }
  return e;
}
function Hr(r, e, t) {
  var a;
  if (r == null || typeof r == "string" || typeof r == "number" || typeof r == "boolean") {
    const n = vt.createElement(e);
    return n.textContent = r == null ? "" : r.toString(), [n];
  } else if (Array.isArray(r)) {
    const n = [];
    for (const i of r)
      for (const s of Hr(i, e, t))
        n.push(s);
    return n;
  } else if (typeof r == "object") {
    let n;
    !((a = r[wt]) === null || a === void 0) && a.xmlns ? n = vt.createElementNS(r[wt].xmlns, e) : n = vt.createElement(e);
    for (const i of Object.keys(r))
      if (i === wt)
        for (const s of xp(r[i]))
          n.attributes.setNamedItem(s);
      else if (i === t.xmlCharKey)
        n.textContent = r[i].toString();
      else if (i === t.cdataPropName) {
        const s = vt.createCDATASection(r[i].toString());
        n.appendChild(s);
      } else
        for (const s of Hr(r[i], i, t))
          n.appendChild(s);
    return [n];
  } else
    throw new Error(`Illegal value passed to buildObject: ${r}`);
}
const Q = Jr("storage-blob");
class aa {
  /**
   * The main method to implement that manipulates a request/response.
   */
  constructor(e, t) {
    this._nextPolicy = e, this._options = t;
  }
  /**
   * Get whether or not a log with the provided log level should be logged.
   * @param logLevel - The log level of the log that will be logged.
   * @returns Whether or not a log with the provided log level should be logged.
   */
  shouldLog(e) {
    return this._options.shouldLog(e);
  }
  /**
   * Attempt to log the provided message to the provided logger. If no logger was provided or if
   * the log level does not meat the logger's threshold, then nothing will be logged.
   * @param logLevel - The log level of this log.
   * @param message - The message of this log.
   */
  log(e, t) {
    this._options.log(e, t);
  }
}
const Gn = "12.27.0", na = "2025-05-05", zr = 256 * 1024 * 1024, Sr = 4e3 * 1024 * 1024, Xt = 5e4, Np = 8 * 1024 * 1024, Dr = 4 * 1024 * 1024, bp = 5, Xn = "https://storage.azure.com/.default", de = {
  Parameters: {
    FORCE_BROWSER_NO_CACHE: "_",
    SNAPSHOT: "snapshot",
    VERSIONID: "versionid",
    TIMEOUT: "timeout"
  }
}, Cp = {
  HTTP_ACCEPTED: 202
}, fe = {
  CONTENT_ID: "Content-ID",
  CONTENT_LENGTH: "Content-Length",
  CONTENT_TRANSFER_ENCODING: "Content-Transfer-Encoding",
  CONTENT_TYPE: "Content-Type",
  COOKIE: "Cookie",
  X_MS_ERROR_CODE: "x-ms-error-code",
  X_MS_VERSION: "x-ms-version"
}, ye = "", Wn = "*", Ka = 256, he = `\r
`, Qn = "HTTP/1.1", Pp = "AES256", vp = "DefaultEndpointsProtocol=http;AccountName=devstoreaccount1;AccountKey=Eby8vdM02xNOcqFlqUwJPLlmEtlCDXJ1OUzFT50uSRZ6IFsuFq2UVErCz4I6tq/K1SZFPTOtr/KBHBeksoGMGw==;BlobEndpoint=http://127.0.0.1:10000/devstoreaccount1;", zp = [
  "Access-Control-Allow-Origin",
  "Cache-Control",
  "Content-Length",
  "Content-Type",
  "Date",
  "Request-Id",
  "traceparent",
  "Transfer-Encoding",
  "User-Agent",
  "x-ms-client-request-id",
  "x-ms-date",
  "x-ms-error-code",
  "x-ms-request-id",
  "x-ms-return-client-request-id",
  "x-ms-version",
  "Accept-Ranges",
  "Content-Disposition",
  "Content-Encoding",
  "Content-Language",
  "Content-MD5",
  "Content-Range",
  "ETag",
  "Last-Modified",
  "Server",
  "Vary",
  "x-ms-content-crc64",
  "x-ms-copy-action",
  "x-ms-copy-completion-time",
  "x-ms-copy-id",
  "x-ms-copy-progress",
  "x-ms-copy-status",
  "x-ms-has-immutability-policy",
  "x-ms-has-legal-hold",
  "x-ms-lease-state",
  "x-ms-lease-status",
  "x-ms-range",
  "x-ms-request-server-encrypted",
  "x-ms-server-encrypted",
  "x-ms-snapshot",
  "x-ms-source-range",
  "If-Match",
  "If-Modified-Since",
  "If-None-Match",
  "If-Unmodified-Since",
  "x-ms-access-tier",
  "x-ms-access-tier-change-time",
  "x-ms-access-tier-inferred",
  "x-ms-account-kind",
  "x-ms-archive-status",
  "x-ms-blob-append-offset",
  "x-ms-blob-cache-control",
  "x-ms-blob-committed-block-count",
  "x-ms-blob-condition-appendpos",
  "x-ms-blob-condition-maxsize",
  "x-ms-blob-content-disposition",
  "x-ms-blob-content-encoding",
  "x-ms-blob-content-language",
  "x-ms-blob-content-length",
  "x-ms-blob-content-md5",
  "x-ms-blob-content-type",
  "x-ms-blob-public-access",
  "x-ms-blob-sequence-number",
  "x-ms-blob-type",
  "x-ms-copy-destination-snapshot",
  "x-ms-creation-time",
  "x-ms-default-encryption-scope",
  "x-ms-delete-snapshots",
  "x-ms-delete-type-permanent",
  "x-ms-deny-encryption-scope-override",
  "x-ms-encryption-algorithm",
  "x-ms-if-sequence-number-eq",
  "x-ms-if-sequence-number-le",
  "x-ms-if-sequence-number-lt",
  "x-ms-incremental-copy",
  "x-ms-lease-action",
  "x-ms-lease-break-period",
  "x-ms-lease-duration",
  "x-ms-lease-id",
  "x-ms-lease-time",
  "x-ms-page-write",
  "x-ms-proposed-lease-id",
  "x-ms-range-get-content-md5",
  "x-ms-rehydrate-priority",
  "x-ms-sequence-number-action",
  "x-ms-sku-name",
  "x-ms-source-content-md5",
  "x-ms-source-if-match",
  "x-ms-source-if-modified-since",
  "x-ms-source-if-none-match",
  "x-ms-source-if-unmodified-since",
  "x-ms-tag-count",
  "x-ms-encryption-key-sha256",
  "x-ms-copy-source-error-code",
  "x-ms-copy-source-status-code",
  "x-ms-if-tags",
  "x-ms-source-if-tags"
], Sp = [
  "comp",
  "maxresults",
  "rscc",
  "rscd",
  "rsce",
  "rscl",
  "rsct",
  "se",
  "si",
  "sip",
  "sp",
  "spr",
  "sr",
  "srt",
  "ss",
  "st",
  "sv",
  "include",
  "marker",
  "prefix",
  "copyid",
  "restype",
  "blockid",
  "blocklisttype",
  "delimiter",
  "prevsnapshot",
  "ske",
  "skoid",
  "sks",
  "skt",
  "sktid",
  "skv",
  "snapshot"
], Rp = "BlobUsesCustomerSpecifiedEncryption", wp = "BlobDoesNotUseCustomerSpecifiedEncryption", Bp = [
  "10000",
  "10001",
  "10002",
  "10003",
  "10004",
  "10100",
  "10101",
  "10102",
  "10103",
  "10104",
  "11000",
  "11001",
  "11002",
  "11003",
  "11004",
  "11100",
  "11101",
  "11102",
  "11103",
  "11104"
];
function Ep(r) {
  const e = new URL(r);
  let t = e.pathname;
  return t = t || "/", t = Mp(t), e.pathname = t, e.toString();
}
function Tp(r) {
  let e = "";
  if (r.search("DevelopmentStorageProxyUri=") !== -1) {
    const t = r.split(";");
    for (const a of t)
      a.trim().startsWith("DevelopmentStorageProxyUri=") && (e = a.trim().match("DevelopmentStorageProxyUri=(.*)")[1]);
  }
  return e;
}
function Te(r, e) {
  const t = r.split(";");
  for (const a of t)
    if (a.trim().startsWith(e))
      return a.trim().match(e + "=(.*)")[1];
  return "";
}
function tt(r) {
  let e = "";
  r.startsWith("UseDevelopmentStorage=true") && (e = Tp(r), r = vp);
  let t = Te(r, "BlobEndpoint");
  if (t = t.endsWith("/") ? t.slice(0, -1) : t, r.search("DefaultEndpointsProtocol=") !== -1 && r.search("AccountKey=") !== -1) {
    let a = "", n = "", i = Buffer.from("accountKey", "base64"), s = "";
    if (n = Te(r, "AccountName"), i = Buffer.from(Te(r, "AccountKey"), "base64"), !t) {
      a = Te(r, "DefaultEndpointsProtocol");
      const o = a.toLowerCase();
      if (o !== "https" && o !== "http")
        throw new Error("Invalid DefaultEndpointsProtocol in the provided Connection String. Expecting 'https' or 'http'");
      if (s = Te(r, "EndpointSuffix"), !s)
        throw new Error("Invalid EndpointSuffix in the provided Connection String");
      t = `${a}://${n}.blob.${s}`;
    }
    if (n) {
      if (i.length === 0)
        throw new Error("Invalid AccountKey in the provided Connection String");
    } else throw new Error("Invalid AccountName in the provided Connection String");
    return {
      kind: "AccountConnString",
      url: t,
      accountName: n,
      accountKey: i,
      proxyUri: e
    };
  } else {
    let a = Te(r, "SharedAccessSignature"), n = Te(r, "AccountName");
    if (n || (n = ei(t)), t) {
      if (!a)
        throw new Error("Invalid SharedAccessSignature in the provided SAS Connection String");
    } else throw new Error("Invalid BlobEndpoint in the provided SAS Connection String");
    return a.startsWith("?") && (a = a.substring(1)), { kind: "SASConnString", url: t, accountName: n, accountSas: a };
  }
}
function Mp(r) {
  return encodeURIComponent(r).replace(/%2F/g, "/").replace(/'/g, "%27").replace(/\+/g, "%20").replace(/%25/g, "%");
}
function X(r, e) {
  const t = new URL(r);
  let a = t.pathname;
  return a = a ? a.endsWith("/") ? `${a}${e}` : `${a}/${e}` : e, t.pathname = a, t.toString();
}
function xe(r, e, t) {
  const a = new URL(r), n = encodeURIComponent(e), i = t ? encodeURIComponent(t) : void 0, s = a.search === "" ? "?" : a.search, o = [];
  for (const l of s.slice(1).split("&"))
    if (l) {
      const [m] = l.split("=", 2);
      m !== n && o.push(l);
    }
  return i && o.push(`${n}=${i}`), a.search = o.length ? `?${o.join("&")}` : "", a.toString();
}
function Ga(r, e) {
  var t;
  return (t = new URL(r).searchParams.get(e)) !== null && t !== void 0 ? t : void 0;
}
function Jn(r, e) {
  const t = new URL(r);
  return t.hostname = e, t.toString();
}
function Yn(r) {
  try {
    return new URL(r).pathname;
  } catch {
    return;
  }
}
function Ip(r) {
  try {
    const e = new URL(r);
    return e.protocol.endsWith(":") ? e.protocol.slice(0, -1) : e.protocol;
  } catch {
    return;
  }
}
function qp(r) {
  const e = new URL(r), t = e.pathname;
  if (!t)
    throw new RangeError("Invalid url without valid path.");
  let a = e.search || "";
  return a = a.trim(), a !== "" && (a = a.startsWith("?") ? a : `?${a}`), `${t}${a}`;
}
function Ot(r, e) {
  const t = new URL(r);
  let a = t.search;
  return a ? a += "&" + e : a = e, t.search = a, t.toString();
}
function k(r, e = !0) {
  const t = r.toISOString();
  return e ? t.substring(0, t.length - 1) + "0000Z" : t.substring(0, t.length - 5) + "Z";
}
function Op(r) {
  return W ? Buffer.from(r).toString("base64") : btoa(r);
}
function Xa(r, e) {
  r.length > 42 && (r = r.slice(0, 42));
  const i = r + _p(e.toString(), 48 - r.length, "0");
  return Op(i);
}
async function Zn(r, e, t) {
  return new Promise((a, n) => {
    let i;
    const s = () => {
      i !== void 0 && clearTimeout(i), n(t);
    };
    i = setTimeout(() => {
      e !== void 0 && e.removeEventListener("abort", s), a();
    }, r), e !== void 0 && e.addEventListener("abort", s);
  });
}
function _p(r, e, t = " ") {
  return String.prototype.padStart ? r.padStart(e, t) : (t = t || " ", r.length > e ? r : (e = e - r.length, e > t.length && (t += t.repeat(e / t.length)), t.slice(0, e) + r));
}
function Vn(r, e) {
  return r.toLocaleLowerCase() === e.toLocaleLowerCase();
}
function ei(r) {
  const e = new URL(r);
  let t;
  try {
    return e.hostname.split(".")[1] === "blob" ? t = e.hostname.split(".")[0] : ia(e) ? t = e.pathname.split("/")[1] : t = "", t;
  } catch {
    throw new Error("Unable to extract accountName with provided information.");
  }
}
function ia(r) {
  const e = r.host;
  return /^.*:.*:.*$|^(localhost|host.docker.internal)(:[0-9]+)?$|^(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])(\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])){3}(:[0-9]+)?$/.test(e) || !!r.port && Bp.includes(r.port);
}
function qe(r) {
  if (r === void 0)
    return;
  const e = [];
  for (const t in r)
    if (Object.prototype.hasOwnProperty.call(r, t)) {
      const a = r[t];
      e.push(`${encodeURIComponent(t)}=${encodeURIComponent(a)}`);
    }
  return e.join("&");
}
function Hp(r) {
  if (r === void 0)
    return;
  const e = {
    blobTagSet: []
  };
  for (const t in r)
    if (Object.prototype.hasOwnProperty.call(r, t)) {
      const a = r[t];
      e.blobTagSet.push({
        key: t,
        value: a
      });
    }
  return e;
}
function Bt(r) {
  if (r === void 0)
    return;
  const e = {};
  for (const t of r.blobTagSet)
    e[t.key] = t.value;
  return e;
}
function Wa(r) {
  if (r !== void 0)
    switch (r.kind) {
      case "csv":
        return {
          format: {
            type: "delimited",
            delimitedTextConfiguration: {
              columnSeparator: r.columnSeparator || ",",
              fieldQuote: r.fieldQuote || "",
              recordSeparator: r.recordSeparator,
              escapeChar: r.escapeCharacter || "",
              headersPresent: r.hasHeaders || !1
            }
          }
        };
      case "json":
        return {
          format: {
            type: "json",
            jsonTextConfiguration: {
              recordSeparator: r.recordSeparator
            }
          }
        };
      case "arrow":
        return {
          format: {
            type: "arrow",
            arrowConfiguration: {
              schema: r.schema
            }
          }
        };
      case "parquet":
        return {
          format: {
            type: "parquet"
          }
        };
      default:
        throw Error("Invalid BlobQueryTextConfiguration.");
    }
}
function tr(r) {
  if (!r || "policy-id" in r)
    return;
  const e = [];
  for (const t in r) {
    const a = t.split("_"), n = "or-";
    a[0].startsWith(n) && (a[0] = a[0].substring(n.length));
    const i = {
      ruleId: a[1],
      replicationStatus: r[t]
    }, s = e.findIndex((o) => o.policyId === a[0]);
    s > -1 ? e[s].rules.push(i) : e.push({
      policyId: a[0],
      rules: [i]
    });
  }
  return e;
}
function _t(r) {
  return r ? r.scheme + " " + r.value : void 0;
}
function Ge(r) {
  return r.encoded ? decodeURIComponent(r.content) : r.content;
}
function Dp(r) {
  return Object.assign(Object.assign({}, r), { segment: {
    blobItems: r.segment.blobItems.map((e) => Object.assign(Object.assign({}, e), { name: Ge(e.name) }))
  } });
}
function Lp(r) {
  var e;
  return Object.assign(Object.assign({}, r), { segment: {
    blobPrefixes: (e = r.segment.blobPrefixes) === null || e === void 0 ? void 0 : e.map((t) => Object.assign(Object.assign({}, t), { name: Ge(t.name) })),
    blobItems: r.segment.blobItems.map((t) => Object.assign(Object.assign({}, t), { name: Ge(t.name) }))
  } });
}
function* Qa(r) {
  let e = [], t = [];
  r.pageRange && (e = r.pageRange), r.clearRange && (t = r.clearRange);
  let a = 0, n = 0;
  for (; a < e.length && n < t.length; )
    e[a].start < t[n].start ? (yield {
      start: e[a].start,
      end: e[a].end,
      isClear: !1
    }, ++a) : (yield {
      start: t[n].start,
      end: t[n].end,
      isClear: !0
    }, ++n);
  for (; a < e.length; ++a)
    yield {
      start: e[a].start,
      end: e[a].end,
      isClear: !1
    };
  for (; n < t.length; ++n)
    yield {
      start: t[n].start,
      end: t[n].end,
      isClear: !0
    };
}
function Wt(r) {
  const e = r.split("/");
  for (let t = 0; t < e.length; t++)
    e[t] = encodeURIComponent(e[t]);
  return e.join("/");
}
function C(r) {
  if ("_response" in r)
    return r;
  throw new TypeError(`Unexpected response object ${r}`);
}
var Ht;
(function(r) {
  r[r.EXPONENTIAL = 0] = "EXPONENTIAL", r[r.FIXED = 1] = "FIXED";
})(Ht || (Ht = {}));
const ze = {
  maxRetryDelayInMs: 120 * 1e3,
  maxTries: 4,
  retryDelayInMs: 4 * 1e3,
  retryPolicyType: Ht.EXPONENTIAL,
  secondaryHost: "",
  tryTimeoutInMs: void 0
  // Use server side default timeout strategy
}, kp = new Yr("The operation was aborted.");
class Ap extends aa {
  /**
   * Creates an instance of RetryPolicy.
   *
   * @param nextPolicy -
   * @param options -
   * @param retryOptions -
   */
  constructor(e, t, a = ze) {
    super(e, t), this.retryOptions = {
      retryPolicyType: a.retryPolicyType ? a.retryPolicyType : ze.retryPolicyType,
      maxTries: a.maxTries && a.maxTries >= 1 ? Math.floor(a.maxTries) : ze.maxTries,
      tryTimeoutInMs: a.tryTimeoutInMs && a.tryTimeoutInMs >= 0 ? a.tryTimeoutInMs : ze.tryTimeoutInMs,
      retryDelayInMs: a.retryDelayInMs && a.retryDelayInMs >= 0 ? Math.min(a.retryDelayInMs, a.maxRetryDelayInMs ? a.maxRetryDelayInMs : ze.maxRetryDelayInMs) : ze.retryDelayInMs,
      maxRetryDelayInMs: a.maxRetryDelayInMs && a.maxRetryDelayInMs >= 0 ? a.maxRetryDelayInMs : ze.maxRetryDelayInMs,
      secondaryHost: a.secondaryHost ? a.secondaryHost : ze.secondaryHost
    };
  }
  /**
   * Sends request.
   *
   * @param request -
   */
  async sendRequest(e) {
    return this.attemptSendRequest(e, !1, 1);
  }
  /**
   * Decide and perform next retry. Won't mutate request parameter.
   *
   * @param request -
   * @param secondaryHas404 -  If attempt was against the secondary & it returned a StatusNotFound (404), then
   *                                   the resource was not found. This may be due to replication delay. So, in this
   *                                   case, we'll never try the secondary again for this operation.
   * @param attempt -           How many retries has been attempted to performed, starting from 1, which includes
   *                                   the attempt will be performed by this method call.
   */
  async attemptSendRequest(e, t, a) {
    const n = e.clone(), i = t || !this.retryOptions.secondaryHost || !(e.method === "GET" || e.method === "HEAD" || e.method === "OPTIONS") || a % 2 === 1;
    i || (n.url = Jn(n.url, this.retryOptions.secondaryHost)), this.retryOptions.tryTimeoutInMs && (n.url = xe(n.url, de.Parameters.TIMEOUT, Math.floor(this.retryOptions.tryTimeoutInMs / 1e3).toString()));
    let s;
    try {
      if (Q.info(`RetryPolicy: =====> Try=${a} ${i ? "Primary" : "Secondary"}`), s = await this._nextPolicy.sendRequest(n), !this.shouldRetry(i, a, s))
        return s;
      t = t || !i && s.status === 404;
    } catch (o) {
      if (Q.error(`RetryPolicy: Caught error, message: ${o.message}, code: ${o.code}`), !this.shouldRetry(i, a, s, o))
        throw o;
    }
    return await this.delay(i, a, e.abortSignal), this.attemptSendRequest(e, t, ++a);
  }
  /**
   * Decide whether to retry according to last HTTP response and retry counters.
   *
   * @param isPrimaryRetry -
   * @param attempt -
   * @param response -
   * @param err -
   */
  shouldRetry(e, t, a, n) {
    if (t >= this.retryOptions.maxTries)
      return Q.info(`RetryPolicy: Attempt(s) ${t} >= maxTries ${this.retryOptions.maxTries}, no further try.`), !1;
    const i = [
      "ETIMEDOUT",
      "ESOCKETTIMEDOUT",
      "ECONNREFUSED",
      "ECONNRESET",
      "ENOENT",
      "ENOTFOUND",
      "TIMEOUT",
      "EPIPE",
      "REQUEST_SEND_ERROR"
      // For default xhr based http client provided in ms-rest-js
    ];
    if (n) {
      for (const s of i)
        if (n.name.toUpperCase().includes(s) || n.message.toUpperCase().includes(s) || n.code && n.code.toString().toUpperCase() === s)
          return Q.info(`RetryPolicy: Network error ${s} found, will retry.`), !0;
    }
    if (a || n) {
      const s = a ? a.status : n ? n.statusCode : 0;
      if (!e && s === 404)
        return Q.info("RetryPolicy: Secondary access with 404, will retry."), !0;
      if (s === 503 || s === 500)
        return Q.info(`RetryPolicy: Will retry for status code ${s}.`), !0;
    }
    return (n == null ? void 0 : n.code) === "PARSE_ERROR" && (n != null && n.message.startsWith('Error "Error: Unclosed root tag')) ? (Q.info("RetryPolicy: Incomplete XML response likely due to service timeout, will retry."), !0) : !1;
  }
  /**
   * Delay a calculated time between retries.
   *
   * @param isPrimaryRetry -
   * @param attempt -
   * @param abortSignal -
   */
  async delay(e, t, a) {
    let n = 0;
    if (e)
      switch (this.retryOptions.retryPolicyType) {
        case Ht.EXPONENTIAL:
          n = Math.min((Math.pow(2, t - 1) - 1) * this.retryOptions.retryDelayInMs, this.retryOptions.maxRetryDelayInMs);
          break;
        case Ht.FIXED:
          n = this.retryOptions.retryDelayInMs;
          break;
      }
    else
      n = Math.random() * 1e3;
    return Q.info(`RetryPolicy: Delay for ${n}ms`), Zn(n, a, kp);
  }
}
class Up {
  /**
   * Creates an instance of StorageRetryPolicyFactory.
   * @param retryOptions -
   */
  constructor(e) {
    this.retryOptions = e;
  }
  /**
   * Creates a StorageRetryPolicy object.
   *
   * @param nextPolicy -
   * @param options -
   */
  create(e, t) {
    return new Ap(e, t, this.retryOptions);
  }
}
class K {
}
class $p extends aa {
  /**
   * Sends out request.
   *
   * @param request -
   */
  sendRequest(e) {
    return this._nextPolicy.sendRequest(this.signRequest(e));
  }
  /**
   * Child classes must implement this method with request signing. This method
   * will be executed in {@link sendRequest}.
   *
   * @param request -
   */
  signRequest(e) {
    return e;
  }
}
class jp extends $p {
  /**
   * Creates an instance of AnonymousCredentialPolicy.
   * @param nextPolicy -
   * @param options -
   */
  // The base class has a protected constructor. Adding a public one to enable constructing of this class.
  /* eslint-disable-next-line @typescript-eslint/no-useless-constructor*/
  constructor(e, t) {
    super(e, t);
  }
}
class Fp {
  /**
   * Creates a RequestPolicy object.
   *
   * @param _nextPolicy -
   * @param _options -
   */
  create(e, t) {
    throw new Error("Method should be implemented in children classes.");
  }
}
class F extends Fp {
  /**
   * Creates an {@link AnonymousCredentialPolicy} object.
   *
   * @param nextPolicy -
   * @param options -
   */
  create(e, t) {
    return new jp(e, t);
  }
}
let Rr;
function Kp() {
  return Rr || (Rr = Sn()), Rr;
}
const Gp = "storageBrowserPolicy";
function Xp() {
  return {
    name: Gp,
    async sendRequest(r, e) {
      return W || ((r.method === "GET" || r.method === "HEAD") && (r.url = xe(r.url, de.Parameters.FORCE_BROWSER_NO_CACHE, (/* @__PURE__ */ new Date()).getTime().toString())), r.headers.delete(fe.COOKIE), r.headers.delete(fe.CONTENT_LENGTH)), e(r);
    }
  };
}
const Wp = "storageRetryPolicy";
var Dt;
(function(r) {
  r[r.EXPONENTIAL = 0] = "EXPONENTIAL", r[r.FIXED = 1] = "FIXED";
})(Dt || (Dt = {}));
const $e = {
  maxRetryDelayInMs: 120 * 1e3,
  maxTries: 4,
  retryDelayInMs: 4 * 1e3,
  retryPolicyType: Dt.EXPONENTIAL,
  secondaryHost: "",
  tryTimeoutInMs: void 0
  // Use server side default timeout strategy
}, Qp = [
  "ETIMEDOUT",
  "ESOCKETTIMEDOUT",
  "ECONNREFUSED",
  "ECONNRESET",
  "ENOENT",
  "ENOTFOUND",
  "TIMEOUT",
  "EPIPE",
  "REQUEST_SEND_ERROR"
], Jp = new Yr("The operation was aborted.");
function Yp(r = {}) {
  var e, t, a, n, i, s;
  const o = (e = r.retryPolicyType) !== null && e !== void 0 ? e : $e.retryPolicyType, l = (t = r.maxTries) !== null && t !== void 0 ? t : $e.maxTries, m = (a = r.retryDelayInMs) !== null && a !== void 0 ? a : $e.retryDelayInMs, c = (n = r.maxRetryDelayInMs) !== null && n !== void 0 ? n : $e.maxRetryDelayInMs, d = (i = r.secondaryHost) !== null && i !== void 0 ? i : $e.secondaryHost, p = (s = r.tryTimeoutInMs) !== null && s !== void 0 ? s : $e.tryTimeoutInMs;
  function y({ isPrimaryRetry: h, attempt: R, response: M, error: T }) {
    var $, f;
    if (R >= l)
      return Q.info(`RetryPolicy: Attempt(s) ${R} >= maxTries ${l}, no further try.`), !1;
    if (T) {
      for (const g of Qp)
        if (T.name.toUpperCase().includes(g) || T.message.toUpperCase().includes(g) || T.code && T.code.toString().toUpperCase() === g)
          return Q.info(`RetryPolicy: Network error ${g} found, will retry.`), !0;
      if ((T == null ? void 0 : T.code) === "PARSE_ERROR" && (T != null && T.message.startsWith('Error "Error: Unclosed root tag')))
        return Q.info("RetryPolicy: Incomplete XML response likely due to service timeout, will retry."), !0;
    }
    if (M || T) {
      const g = (f = ($ = M == null ? void 0 : M.status) !== null && $ !== void 0 ? $ : T == null ? void 0 : T.statusCode) !== null && f !== void 0 ? f : 0;
      if (!h && g === 404)
        return Q.info("RetryPolicy: Secondary access with 404, will retry."), !0;
      if (g === 503 || g === 500)
        return Q.info(`RetryPolicy: Will retry for status code ${g}.`), !0;
    }
    return !1;
  }
  function u(h, R) {
    let M = 0;
    if (h)
      switch (o) {
        case Dt.EXPONENTIAL:
          M = Math.min((Math.pow(2, R - 1) - 1) * m, c);
          break;
        case Dt.FIXED:
          M = m;
          break;
      }
    else
      M = Math.random() * 1e3;
    return Q.info(`RetryPolicy: Delay for ${M}ms`), M;
  }
  return {
    name: Wp,
    async sendRequest(h, R) {
      p && (h.url = xe(h.url, de.Parameters.TIMEOUT, String(Math.floor(p / 1e3))));
      const M = h.url, T = d ? Jn(h.url, d) : void 0;
      let $ = !1, f = 1, g = !0, N, w;
      for (; g; ) {
        const E = $ || !T || !["GET", "HEAD", "OPTIONS"].includes(h.method) || f % 2 === 1;
        h.url = E ? M : T, N = void 0, w = void 0;
        try {
          Q.info(`RetryPolicy: =====> Try=${f} ${E ? "Primary" : "Secondary"}`), N = await R(h), $ = $ || !E && N.status === 404;
        } catch (q) {
          if (Zr(q))
            Q.error(`RetryPolicy: Caught error, message: ${q.message}, code: ${q.code}`), w = q;
          else
            throw Q.error(`RetryPolicy: Caught error, message: ${At(q)}`), q;
        }
        g = y({ isPrimaryRetry: E, attempt: f, response: N, error: w }), g && await Zn(u(E, f), h.abortSignal, Jp), f++;
      }
      if (N)
        return N;
      throw w ?? new It("RetryPolicy failed without known error.");
    }
  };
}
const Zp = "storageSharedKeyCredentialPolicy";
function ti(r) {
  return {
    name: Zp,
    async sendRequest(e, t) {
      return t(e);
    }
  };
}
class Vp extends aa {
  /**
   * Creates an instance of StorageBrowserPolicy.
   * @param nextPolicy -
   * @param options -
   */
  // The base class has a protected constructor. Adding a public one to enable constructing of this class.
  /* eslint-disable-next-line @typescript-eslint/no-useless-constructor*/
  constructor(e, t) {
    super(e, t);
  }
  /**
   * Sends out request.
   *
   * @param request -
   */
  async sendRequest(e) {
    return W ? this._nextPolicy.sendRequest(e) : ((e.method.toUpperCase() === "GET" || e.method.toUpperCase() === "HEAD") && (e.url = xe(e.url, de.Parameters.FORCE_BROWSER_NO_CACHE, (/* @__PURE__ */ new Date()).getTime().toString())), e.headers.remove(fe.COOKIE), e.headers.remove(fe.CONTENT_LENGTH), this._nextPolicy.sendRequest(e));
  }
}
class eu {
  /**
   * Creates a StorageBrowserPolicyFactory object.
   *
   * @param nextPolicy -
   * @param options -
   */
  create(e, t) {
    return new Vp(e, t);
  }
}
const tu = "StorageCorrectContentLengthPolicy";
function ru() {
  return {
    name: tu,
    async sendRequest(r, e) {
      return e(r);
    }
  };
}
function _e(r) {
  if (!r || typeof r != "object")
    return !1;
  const e = r;
  return Array.isArray(e.factories) && typeof e.options == "object" && typeof e.toServiceClientOptions == "function";
}
class ri {
  /**
   * Creates an instance of Pipeline. Customize HTTPClient by implementing IHttpClient interface.
   *
   * @param factories -
   * @param options -
   */
  constructor(e, t = {}) {
    this.factories = e, this.options = t;
  }
  /**
   * Transfer Pipeline object to ServiceClientOptions object which is required by
   * ServiceClient constructor.
   *
   * @returns The ServiceClientOptions object from this Pipeline.
   */
  toServiceClientOptions() {
    return {
      httpClient: this.options.httpClient,
      requestPolicyFactories: this.factories
    };
  }
}
function j(r, e = {}) {
  r || (r = new F());
  const t = new ri([], e);
  return t._credential = r, t;
}
function au(r) {
  const e = [
    nu,
    ii,
    iu,
    su,
    ou,
    mu,
    cu
  ];
  if (r.factories.length) {
    const t = r.factories.filter((a) => !e.some((n) => n(a)));
    if (t.length) {
      const a = t.some((n) => lu(n));
      return {
        wrappedPolicies: cp(t),
        afterRetry: a
      };
    }
  }
}
function ai(r) {
  var e;
  const t = r.options, { httpClient: a } = t, n = Qc(t, ["httpClient"]);
  let i = r._coreHttpClient;
  i || (i = a ? dp(a) : Kp(), r._coreHttpClient = i);
  let s = r._corePipeline;
  if (!s) {
    const o = `azsdk-js-azure-storage-blob/${Gn}`, l = n.userAgentOptions && n.userAgentOptions.userAgentPrefix ? `${n.userAgentOptions.userAgentPrefix} ${o}` : `${o}`;
    s = Hn(Object.assign(Object.assign({}, n), { loggingOptions: {
      additionalAllowedHeaderNames: zp,
      additionalAllowedQueryParameters: Sp,
      logger: Q.info
    }, userAgentOptions: {
      userAgentPrefix: l
    }, serializationOptions: {
      stringifyXML: Kn,
      serializerOptions: {
        xml: {
          // Use customized XML char key of "#" so we can deserialize metadata
          // with "_" key
          xmlCharKey: "#"
        }
      }
    }, deserializationOptions: {
      parseXML: pp,
      serializerOptions: {
        xml: {
          // Use customized XML char key of "#" so we can deserialize metadata
          // with "_" key
          xmlCharKey: "#"
        }
      }
    } })), s.removePolicy({ phase: "Retry" }), s.removePolicy({ name: Pc }), s.addPolicy(ru()), s.addPolicy(Yp(n.retryOptions), { phase: "Retry" }), s.addPolicy(Xp());
    const m = au(r);
    m && s.addPolicy(m.wrappedPolicies, m.afterRetry ? { afterPhase: "Retry" } : void 0);
    const c = ni(r);
    le(c) ? s.addPolicy(Vr({
      credential: c,
      scopes: (e = n.audience) !== null && e !== void 0 ? e : Xn,
      challengeCallbacks: { authorizeRequestOnChallenge: Ln }
    }), { phase: "Sign" }) : c instanceof K && s.addPolicy(ti({
      accountName: c.accountName,
      accountKey: c.accountKey
    }), { phase: "Sign" }), r._corePipeline = s;
  }
  return Object.assign(Object.assign({}, n), { allowInsecureConnection: !0, httpClient: i, pipeline: s });
}
function ni(r) {
  if (r._credential)
    return r._credential;
  let e = new F();
  for (const t of r.factories)
    if (le(t.credential))
      e = t.credential;
    else if (ii(t))
      return t;
  return e;
}
function ii(r) {
  return r instanceof K ? !0 : r.constructor.name === "StorageSharedKeyCredential";
}
function nu(r) {
  return r instanceof F ? !0 : r.constructor.name === "AnonymousCredential";
}
function iu(r) {
  return le(r.credential);
}
function su(r) {
  return r instanceof eu ? !0 : r.constructor.name === "StorageBrowserPolicyFactory";
}
function ou(r) {
  return r instanceof Up ? !0 : r.constructor.name === "StorageRetryPolicyFactory";
}
function mu(r) {
  return r.constructor.name === "TelemetryPolicyFactory";
}
function lu(r) {
  return r.constructor.name === "InjectorPolicyFactory";
}
function cu(r) {
  const e = [
    "GenerateClientRequestIdPolicy",
    "TracingPolicy",
    "LogPolicy",
    "ProxyPolicy",
    "DisableResponseDecompressionPolicy",
    "KeepAlivePolicy",
    "DeserializationPolicy"
  ], t = {
    sendRequest: async (s) => ({
      request: s,
      headers: s.headers.clone(),
      status: 500
    })
  }, a = {
    log(s, o) {
    },
    shouldLog(s) {
      return !1;
    }
  }, i = r.create(t, a).constructor.name;
  return e.some((s) => i.startsWith(s));
}
const sa = {
  serializedName: "BlobServiceProperties",
  xmlName: "StorageServiceProperties",
  type: {
    name: "Composite",
    className: "BlobServiceProperties",
    modelProperties: {
      blobAnalyticsLogging: {
        serializedName: "Logging",
        xmlName: "Logging",
        type: {
          name: "Composite",
          className: "Logging"
        }
      },
      hourMetrics: {
        serializedName: "HourMetrics",
        xmlName: "HourMetrics",
        type: {
          name: "Composite",
          className: "Metrics"
        }
      },
      minuteMetrics: {
        serializedName: "MinuteMetrics",
        xmlName: "MinuteMetrics",
        type: {
          name: "Composite",
          className: "Metrics"
        }
      },
      cors: {
        serializedName: "Cors",
        xmlName: "Cors",
        xmlIsWrapped: !0,
        xmlElementName: "CorsRule",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "CorsRule"
            }
          }
        }
      },
      defaultServiceVersion: {
        serializedName: "DefaultServiceVersion",
        xmlName: "DefaultServiceVersion",
        type: {
          name: "String"
        }
      },
      deleteRetentionPolicy: {
        serializedName: "DeleteRetentionPolicy",
        xmlName: "DeleteRetentionPolicy",
        type: {
          name: "Composite",
          className: "RetentionPolicy"
        }
      },
      staticWebsite: {
        serializedName: "StaticWebsite",
        xmlName: "StaticWebsite",
        type: {
          name: "Composite",
          className: "StaticWebsite"
        }
      }
    }
  }
}, du = {
  serializedName: "Logging",
  type: {
    name: "Composite",
    className: "Logging",
    modelProperties: {
      version: {
        serializedName: "Version",
        required: !0,
        xmlName: "Version",
        type: {
          name: "String"
        }
      },
      deleteProperty: {
        serializedName: "Delete",
        required: !0,
        xmlName: "Delete",
        type: {
          name: "Boolean"
        }
      },
      read: {
        serializedName: "Read",
        required: !0,
        xmlName: "Read",
        type: {
          name: "Boolean"
        }
      },
      write: {
        serializedName: "Write",
        required: !0,
        xmlName: "Write",
        type: {
          name: "Boolean"
        }
      },
      retentionPolicy: {
        serializedName: "RetentionPolicy",
        xmlName: "RetentionPolicy",
        type: {
          name: "Composite",
          className: "RetentionPolicy"
        }
      }
    }
  }
}, pu = {
  serializedName: "RetentionPolicy",
  type: {
    name: "Composite",
    className: "RetentionPolicy",
    modelProperties: {
      enabled: {
        serializedName: "Enabled",
        required: !0,
        xmlName: "Enabled",
        type: {
          name: "Boolean"
        }
      },
      days: {
        constraints: {
          InclusiveMinimum: 1
        },
        serializedName: "Days",
        xmlName: "Days",
        type: {
          name: "Number"
        }
      }
    }
  }
}, uu = {
  serializedName: "Metrics",
  type: {
    name: "Composite",
    className: "Metrics",
    modelProperties: {
      version: {
        serializedName: "Version",
        xmlName: "Version",
        type: {
          name: "String"
        }
      },
      enabled: {
        serializedName: "Enabled",
        required: !0,
        xmlName: "Enabled",
        type: {
          name: "Boolean"
        }
      },
      includeAPIs: {
        serializedName: "IncludeAPIs",
        xmlName: "IncludeAPIs",
        type: {
          name: "Boolean"
        }
      },
      retentionPolicy: {
        serializedName: "RetentionPolicy",
        xmlName: "RetentionPolicy",
        type: {
          name: "Composite",
          className: "RetentionPolicy"
        }
      }
    }
  }
}, yu = {
  serializedName: "CorsRule",
  type: {
    name: "Composite",
    className: "CorsRule",
    modelProperties: {
      allowedOrigins: {
        serializedName: "AllowedOrigins",
        required: !0,
        xmlName: "AllowedOrigins",
        type: {
          name: "String"
        }
      },
      allowedMethods: {
        serializedName: "AllowedMethods",
        required: !0,
        xmlName: "AllowedMethods",
        type: {
          name: "String"
        }
      },
      allowedHeaders: {
        serializedName: "AllowedHeaders",
        required: !0,
        xmlName: "AllowedHeaders",
        type: {
          name: "String"
        }
      },
      exposedHeaders: {
        serializedName: "ExposedHeaders",
        required: !0,
        xmlName: "ExposedHeaders",
        type: {
          name: "String"
        }
      },
      maxAgeInSeconds: {
        constraints: {
          InclusiveMinimum: 0
        },
        serializedName: "MaxAgeInSeconds",
        required: !0,
        xmlName: "MaxAgeInSeconds",
        type: {
          name: "Number"
        }
      }
    }
  }
}, fu = {
  serializedName: "StaticWebsite",
  type: {
    name: "Composite",
    className: "StaticWebsite",
    modelProperties: {
      enabled: {
        serializedName: "Enabled",
        required: !0,
        xmlName: "Enabled",
        type: {
          name: "Boolean"
        }
      },
      indexDocument: {
        serializedName: "IndexDocument",
        xmlName: "IndexDocument",
        type: {
          name: "String"
        }
      },
      errorDocument404Path: {
        serializedName: "ErrorDocument404Path",
        xmlName: "ErrorDocument404Path",
        type: {
          name: "String"
        }
      },
      defaultIndexDocumentPath: {
        serializedName: "DefaultIndexDocumentPath",
        xmlName: "DefaultIndexDocumentPath",
        type: {
          name: "String"
        }
      }
    }
  }
}, b = {
  serializedName: "StorageError",
  type: {
    name: "Composite",
    className: "StorageError",
    modelProperties: {
      message: {
        serializedName: "Message",
        xmlName: "Message",
        type: {
          name: "String"
        }
      },
      code: {
        serializedName: "Code",
        xmlName: "Code",
        type: {
          name: "String"
        }
      },
      authenticationErrorDetail: {
        serializedName: "AuthenticationErrorDetail",
        xmlName: "AuthenticationErrorDetail",
        type: {
          name: "String"
        }
      }
    }
  }
}, si = {
  serializedName: "BlobServiceStatistics",
  xmlName: "StorageServiceStats",
  type: {
    name: "Composite",
    className: "BlobServiceStatistics",
    modelProperties: {
      geoReplication: {
        serializedName: "GeoReplication",
        xmlName: "GeoReplication",
        type: {
          name: "Composite",
          className: "GeoReplication"
        }
      }
    }
  }
}, gu = {
  serializedName: "GeoReplication",
  type: {
    name: "Composite",
    className: "GeoReplication",
    modelProperties: {
      status: {
        serializedName: "Status",
        required: !0,
        xmlName: "Status",
        type: {
          name: "Enum",
          allowedValues: ["live", "bootstrap", "unavailable"]
        }
      },
      lastSyncOn: {
        serializedName: "LastSyncTime",
        required: !0,
        xmlName: "LastSyncTime",
        type: {
          name: "DateTimeRfc1123"
        }
      }
    }
  }
}, oi = {
  serializedName: "ListContainersSegmentResponse",
  xmlName: "EnumerationResults",
  type: {
    name: "Composite",
    className: "ListContainersSegmentResponse",
    modelProperties: {
      serviceEndpoint: {
        serializedName: "ServiceEndpoint",
        required: !0,
        xmlName: "ServiceEndpoint",
        xmlIsAttribute: !0,
        type: {
          name: "String"
        }
      },
      prefix: {
        serializedName: "Prefix",
        xmlName: "Prefix",
        type: {
          name: "String"
        }
      },
      marker: {
        serializedName: "Marker",
        xmlName: "Marker",
        type: {
          name: "String"
        }
      },
      maxPageSize: {
        serializedName: "MaxResults",
        xmlName: "MaxResults",
        type: {
          name: "Number"
        }
      },
      containerItems: {
        serializedName: "ContainerItems",
        required: !0,
        xmlName: "Containers",
        xmlIsWrapped: !0,
        xmlElementName: "Container",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "ContainerItem"
            }
          }
        }
      },
      continuationToken: {
        serializedName: "NextMarker",
        xmlName: "NextMarker",
        type: {
          name: "String"
        }
      }
    }
  }
}, hu = {
  serializedName: "ContainerItem",
  xmlName: "Container",
  type: {
    name: "Composite",
    className: "ContainerItem",
    modelProperties: {
      name: {
        serializedName: "Name",
        required: !0,
        xmlName: "Name",
        type: {
          name: "String"
        }
      },
      deleted: {
        serializedName: "Deleted",
        xmlName: "Deleted",
        type: {
          name: "Boolean"
        }
      },
      version: {
        serializedName: "Version",
        xmlName: "Version",
        type: {
          name: "String"
        }
      },
      properties: {
        serializedName: "Properties",
        xmlName: "Properties",
        type: {
          name: "Composite",
          className: "ContainerProperties"
        }
      },
      metadata: {
        serializedName: "Metadata",
        xmlName: "Metadata",
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } }
        }
      }
    }
  }
}, xu = {
  serializedName: "ContainerProperties",
  type: {
    name: "Composite",
    className: "ContainerProperties",
    modelProperties: {
      lastModified: {
        serializedName: "Last-Modified",
        required: !0,
        xmlName: "Last-Modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      etag: {
        serializedName: "Etag",
        required: !0,
        xmlName: "Etag",
        type: {
          name: "String"
        }
      },
      leaseStatus: {
        serializedName: "LeaseStatus",
        xmlName: "LeaseStatus",
        type: {
          name: "Enum",
          allowedValues: ["locked", "unlocked"]
        }
      },
      leaseState: {
        serializedName: "LeaseState",
        xmlName: "LeaseState",
        type: {
          name: "Enum",
          allowedValues: [
            "available",
            "leased",
            "expired",
            "breaking",
            "broken"
          ]
        }
      },
      leaseDuration: {
        serializedName: "LeaseDuration",
        xmlName: "LeaseDuration",
        type: {
          name: "Enum",
          allowedValues: ["infinite", "fixed"]
        }
      },
      publicAccess: {
        serializedName: "PublicAccess",
        xmlName: "PublicAccess",
        type: {
          name: "Enum",
          allowedValues: ["container", "blob"]
        }
      },
      hasImmutabilityPolicy: {
        serializedName: "HasImmutabilityPolicy",
        xmlName: "HasImmutabilityPolicy",
        type: {
          name: "Boolean"
        }
      },
      hasLegalHold: {
        serializedName: "HasLegalHold",
        xmlName: "HasLegalHold",
        type: {
          name: "Boolean"
        }
      },
      defaultEncryptionScope: {
        serializedName: "DefaultEncryptionScope",
        xmlName: "DefaultEncryptionScope",
        type: {
          name: "String"
        }
      },
      preventEncryptionScopeOverride: {
        serializedName: "DenyEncryptionScopeOverride",
        xmlName: "DenyEncryptionScopeOverride",
        type: {
          name: "Boolean"
        }
      },
      deletedOn: {
        serializedName: "DeletedTime",
        xmlName: "DeletedTime",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      remainingRetentionDays: {
        serializedName: "RemainingRetentionDays",
        xmlName: "RemainingRetentionDays",
        type: {
          name: "Number"
        }
      },
      isImmutableStorageWithVersioningEnabled: {
        serializedName: "ImmutableStorageWithVersioningEnabled",
        xmlName: "ImmutableStorageWithVersioningEnabled",
        type: {
          name: "Boolean"
        }
      }
    }
  }
}, mi = {
  serializedName: "KeyInfo",
  type: {
    name: "Composite",
    className: "KeyInfo",
    modelProperties: {
      startsOn: {
        serializedName: "Start",
        required: !0,
        xmlName: "Start",
        type: {
          name: "String"
        }
      },
      expiresOn: {
        serializedName: "Expiry",
        required: !0,
        xmlName: "Expiry",
        type: {
          name: "String"
        }
      }
    }
  }
}, li = {
  serializedName: "UserDelegationKey",
  type: {
    name: "Composite",
    className: "UserDelegationKey",
    modelProperties: {
      signedObjectId: {
        serializedName: "SignedOid",
        required: !0,
        xmlName: "SignedOid",
        type: {
          name: "String"
        }
      },
      signedTenantId: {
        serializedName: "SignedTid",
        required: !0,
        xmlName: "SignedTid",
        type: {
          name: "String"
        }
      },
      signedStartsOn: {
        serializedName: "SignedStart",
        required: !0,
        xmlName: "SignedStart",
        type: {
          name: "String"
        }
      },
      signedExpiresOn: {
        serializedName: "SignedExpiry",
        required: !0,
        xmlName: "SignedExpiry",
        type: {
          name: "String"
        }
      },
      signedService: {
        serializedName: "SignedService",
        required: !0,
        xmlName: "SignedService",
        type: {
          name: "String"
        }
      },
      signedVersion: {
        serializedName: "SignedVersion",
        required: !0,
        xmlName: "SignedVersion",
        type: {
          name: "String"
        }
      },
      value: {
        serializedName: "Value",
        required: !0,
        xmlName: "Value",
        type: {
          name: "String"
        }
      }
    }
  }
}, oa = {
  serializedName: "FilterBlobSegment",
  xmlName: "EnumerationResults",
  type: {
    name: "Composite",
    className: "FilterBlobSegment",
    modelProperties: {
      serviceEndpoint: {
        serializedName: "ServiceEndpoint",
        required: !0,
        xmlName: "ServiceEndpoint",
        xmlIsAttribute: !0,
        type: {
          name: "String"
        }
      },
      where: {
        serializedName: "Where",
        required: !0,
        xmlName: "Where",
        type: {
          name: "String"
        }
      },
      blobs: {
        serializedName: "Blobs",
        required: !0,
        xmlName: "Blobs",
        xmlIsWrapped: !0,
        xmlElementName: "Blob",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "FilterBlobItem"
            }
          }
        }
      },
      continuationToken: {
        serializedName: "NextMarker",
        xmlName: "NextMarker",
        type: {
          name: "String"
        }
      }
    }
  }
}, Nu = {
  serializedName: "FilterBlobItem",
  xmlName: "Blob",
  type: {
    name: "Composite",
    className: "FilterBlobItem",
    modelProperties: {
      name: {
        serializedName: "Name",
        required: !0,
        xmlName: "Name",
        type: {
          name: "String"
        }
      },
      containerName: {
        serializedName: "ContainerName",
        required: !0,
        xmlName: "ContainerName",
        type: {
          name: "String"
        }
      },
      tags: {
        serializedName: "Tags",
        xmlName: "Tags",
        type: {
          name: "Composite",
          className: "BlobTags"
        }
      }
    }
  }
}, ma = {
  serializedName: "BlobTags",
  xmlName: "Tags",
  type: {
    name: "Composite",
    className: "BlobTags",
    modelProperties: {
      blobTagSet: {
        serializedName: "BlobTagSet",
        required: !0,
        xmlName: "TagSet",
        xmlIsWrapped: !0,
        xmlElementName: "Tag",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "BlobTag"
            }
          }
        }
      }
    }
  }
}, bu = {
  serializedName: "BlobTag",
  xmlName: "Tag",
  type: {
    name: "Composite",
    className: "BlobTag",
    modelProperties: {
      key: {
        serializedName: "Key",
        required: !0,
        xmlName: "Key",
        type: {
          name: "String"
        }
      },
      value: {
        serializedName: "Value",
        required: !0,
        xmlName: "Value",
        type: {
          name: "String"
        }
      }
    }
  }
}, Cu = {
  serializedName: "SignedIdentifier",
  xmlName: "SignedIdentifier",
  type: {
    name: "Composite",
    className: "SignedIdentifier",
    modelProperties: {
      id: {
        serializedName: "Id",
        required: !0,
        xmlName: "Id",
        type: {
          name: "String"
        }
      },
      accessPolicy: {
        serializedName: "AccessPolicy",
        xmlName: "AccessPolicy",
        type: {
          name: "Composite",
          className: "AccessPolicy"
        }
      }
    }
  }
}, Pu = {
  serializedName: "AccessPolicy",
  type: {
    name: "Composite",
    className: "AccessPolicy",
    modelProperties: {
      startsOn: {
        serializedName: "Start",
        xmlName: "Start",
        type: {
          name: "String"
        }
      },
      expiresOn: {
        serializedName: "Expiry",
        xmlName: "Expiry",
        type: {
          name: "String"
        }
      },
      permissions: {
        serializedName: "Permission",
        xmlName: "Permission",
        type: {
          name: "String"
        }
      }
    }
  }
}, ci = {
  serializedName: "ListBlobsFlatSegmentResponse",
  xmlName: "EnumerationResults",
  type: {
    name: "Composite",
    className: "ListBlobsFlatSegmentResponse",
    modelProperties: {
      serviceEndpoint: {
        serializedName: "ServiceEndpoint",
        required: !0,
        xmlName: "ServiceEndpoint",
        xmlIsAttribute: !0,
        type: {
          name: "String"
        }
      },
      containerName: {
        serializedName: "ContainerName",
        required: !0,
        xmlName: "ContainerName",
        xmlIsAttribute: !0,
        type: {
          name: "String"
        }
      },
      prefix: {
        serializedName: "Prefix",
        xmlName: "Prefix",
        type: {
          name: "String"
        }
      },
      marker: {
        serializedName: "Marker",
        xmlName: "Marker",
        type: {
          name: "String"
        }
      },
      maxPageSize: {
        serializedName: "MaxResults",
        xmlName: "MaxResults",
        type: {
          name: "Number"
        }
      },
      segment: {
        serializedName: "Segment",
        xmlName: "Blobs",
        type: {
          name: "Composite",
          className: "BlobFlatListSegment"
        }
      },
      continuationToken: {
        serializedName: "NextMarker",
        xmlName: "NextMarker",
        type: {
          name: "String"
        }
      }
    }
  }
}, vu = {
  serializedName: "BlobFlatListSegment",
  xmlName: "Blobs",
  type: {
    name: "Composite",
    className: "BlobFlatListSegment",
    modelProperties: {
      blobItems: {
        serializedName: "BlobItems",
        required: !0,
        xmlName: "BlobItems",
        xmlElementName: "Blob",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "BlobItemInternal"
            }
          }
        }
      }
    }
  }
}, zu = {
  serializedName: "BlobItemInternal",
  xmlName: "Blob",
  type: {
    name: "Composite",
    className: "BlobItemInternal",
    modelProperties: {
      name: {
        serializedName: "Name",
        xmlName: "Name",
        type: {
          name: "Composite",
          className: "BlobName"
        }
      },
      deleted: {
        serializedName: "Deleted",
        required: !0,
        xmlName: "Deleted",
        type: {
          name: "Boolean"
        }
      },
      snapshot: {
        serializedName: "Snapshot",
        required: !0,
        xmlName: "Snapshot",
        type: {
          name: "String"
        }
      },
      versionId: {
        serializedName: "VersionId",
        xmlName: "VersionId",
        type: {
          name: "String"
        }
      },
      isCurrentVersion: {
        serializedName: "IsCurrentVersion",
        xmlName: "IsCurrentVersion",
        type: {
          name: "Boolean"
        }
      },
      properties: {
        serializedName: "Properties",
        xmlName: "Properties",
        type: {
          name: "Composite",
          className: "BlobPropertiesInternal"
        }
      },
      metadata: {
        serializedName: "Metadata",
        xmlName: "Metadata",
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } }
        }
      },
      blobTags: {
        serializedName: "BlobTags",
        xmlName: "Tags",
        type: {
          name: "Composite",
          className: "BlobTags"
        }
      },
      objectReplicationMetadata: {
        serializedName: "ObjectReplicationMetadata",
        xmlName: "OrMetadata",
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } }
        }
      },
      hasVersionsOnly: {
        serializedName: "HasVersionsOnly",
        xmlName: "HasVersionsOnly",
        type: {
          name: "Boolean"
        }
      }
    }
  }
}, Su = {
  serializedName: "BlobName",
  type: {
    name: "Composite",
    className: "BlobName",
    modelProperties: {
      encoded: {
        serializedName: "Encoded",
        xmlName: "Encoded",
        xmlIsAttribute: !0,
        type: {
          name: "Boolean"
        }
      },
      content: {
        serializedName: "content",
        xmlName: "content",
        xmlIsMsText: !0,
        type: {
          name: "String"
        }
      }
    }
  }
}, Ru = {
  serializedName: "BlobPropertiesInternal",
  xmlName: "Properties",
  type: {
    name: "Composite",
    className: "BlobPropertiesInternal",
    modelProperties: {
      createdOn: {
        serializedName: "Creation-Time",
        xmlName: "Creation-Time",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      lastModified: {
        serializedName: "Last-Modified",
        required: !0,
        xmlName: "Last-Modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      etag: {
        serializedName: "Etag",
        required: !0,
        xmlName: "Etag",
        type: {
          name: "String"
        }
      },
      contentLength: {
        serializedName: "Content-Length",
        xmlName: "Content-Length",
        type: {
          name: "Number"
        }
      },
      contentType: {
        serializedName: "Content-Type",
        xmlName: "Content-Type",
        type: {
          name: "String"
        }
      },
      contentEncoding: {
        serializedName: "Content-Encoding",
        xmlName: "Content-Encoding",
        type: {
          name: "String"
        }
      },
      contentLanguage: {
        serializedName: "Content-Language",
        xmlName: "Content-Language",
        type: {
          name: "String"
        }
      },
      contentMD5: {
        serializedName: "Content-MD5",
        xmlName: "Content-MD5",
        type: {
          name: "ByteArray"
        }
      },
      contentDisposition: {
        serializedName: "Content-Disposition",
        xmlName: "Content-Disposition",
        type: {
          name: "String"
        }
      },
      cacheControl: {
        serializedName: "Cache-Control",
        xmlName: "Cache-Control",
        type: {
          name: "String"
        }
      },
      blobSequenceNumber: {
        serializedName: "x-ms-blob-sequence-number",
        xmlName: "x-ms-blob-sequence-number",
        type: {
          name: "Number"
        }
      },
      blobType: {
        serializedName: "BlobType",
        xmlName: "BlobType",
        type: {
          name: "Enum",
          allowedValues: ["BlockBlob", "PageBlob", "AppendBlob"]
        }
      },
      leaseStatus: {
        serializedName: "LeaseStatus",
        xmlName: "LeaseStatus",
        type: {
          name: "Enum",
          allowedValues: ["locked", "unlocked"]
        }
      },
      leaseState: {
        serializedName: "LeaseState",
        xmlName: "LeaseState",
        type: {
          name: "Enum",
          allowedValues: [
            "available",
            "leased",
            "expired",
            "breaking",
            "broken"
          ]
        }
      },
      leaseDuration: {
        serializedName: "LeaseDuration",
        xmlName: "LeaseDuration",
        type: {
          name: "Enum",
          allowedValues: ["infinite", "fixed"]
        }
      },
      copyId: {
        serializedName: "CopyId",
        xmlName: "CopyId",
        type: {
          name: "String"
        }
      },
      copyStatus: {
        serializedName: "CopyStatus",
        xmlName: "CopyStatus",
        type: {
          name: "Enum",
          allowedValues: ["pending", "success", "aborted", "failed"]
        }
      },
      copySource: {
        serializedName: "CopySource",
        xmlName: "CopySource",
        type: {
          name: "String"
        }
      },
      copyProgress: {
        serializedName: "CopyProgress",
        xmlName: "CopyProgress",
        type: {
          name: "String"
        }
      },
      copyCompletedOn: {
        serializedName: "CopyCompletionTime",
        xmlName: "CopyCompletionTime",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      copyStatusDescription: {
        serializedName: "CopyStatusDescription",
        xmlName: "CopyStatusDescription",
        type: {
          name: "String"
        }
      },
      serverEncrypted: {
        serializedName: "ServerEncrypted",
        xmlName: "ServerEncrypted",
        type: {
          name: "Boolean"
        }
      },
      incrementalCopy: {
        serializedName: "IncrementalCopy",
        xmlName: "IncrementalCopy",
        type: {
          name: "Boolean"
        }
      },
      destinationSnapshot: {
        serializedName: "DestinationSnapshot",
        xmlName: "DestinationSnapshot",
        type: {
          name: "String"
        }
      },
      deletedOn: {
        serializedName: "DeletedTime",
        xmlName: "DeletedTime",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      remainingRetentionDays: {
        serializedName: "RemainingRetentionDays",
        xmlName: "RemainingRetentionDays",
        type: {
          name: "Number"
        }
      },
      accessTier: {
        serializedName: "AccessTier",
        xmlName: "AccessTier",
        type: {
          name: "Enum",
          allowedValues: [
            "P4",
            "P6",
            "P10",
            "P15",
            "P20",
            "P30",
            "P40",
            "P50",
            "P60",
            "P70",
            "P80",
            "Hot",
            "Cool",
            "Archive",
            "Cold"
          ]
        }
      },
      accessTierInferred: {
        serializedName: "AccessTierInferred",
        xmlName: "AccessTierInferred",
        type: {
          name: "Boolean"
        }
      },
      archiveStatus: {
        serializedName: "ArchiveStatus",
        xmlName: "ArchiveStatus",
        type: {
          name: "Enum",
          allowedValues: [
            "rehydrate-pending-to-hot",
            "rehydrate-pending-to-cool",
            "rehydrate-pending-to-cold"
          ]
        }
      },
      customerProvidedKeySha256: {
        serializedName: "CustomerProvidedKeySha256",
        xmlName: "CustomerProvidedKeySha256",
        type: {
          name: "String"
        }
      },
      encryptionScope: {
        serializedName: "EncryptionScope",
        xmlName: "EncryptionScope",
        type: {
          name: "String"
        }
      },
      accessTierChangedOn: {
        serializedName: "AccessTierChangeTime",
        xmlName: "AccessTierChangeTime",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      tagCount: {
        serializedName: "TagCount",
        xmlName: "TagCount",
        type: {
          name: "Number"
        }
      },
      expiresOn: {
        serializedName: "Expiry-Time",
        xmlName: "Expiry-Time",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      isSealed: {
        serializedName: "Sealed",
        xmlName: "Sealed",
        type: {
          name: "Boolean"
        }
      },
      rehydratePriority: {
        serializedName: "RehydratePriority",
        xmlName: "RehydratePriority",
        type: {
          name: "Enum",
          allowedValues: ["High", "Standard"]
        }
      },
      lastAccessedOn: {
        serializedName: "LastAccessTime",
        xmlName: "LastAccessTime",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      immutabilityPolicyExpiresOn: {
        serializedName: "ImmutabilityPolicyUntilDate",
        xmlName: "ImmutabilityPolicyUntilDate",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      immutabilityPolicyMode: {
        serializedName: "ImmutabilityPolicyMode",
        xmlName: "ImmutabilityPolicyMode",
        type: {
          name: "Enum",
          allowedValues: ["Mutable", "Unlocked", "Locked"]
        }
      },
      legalHold: {
        serializedName: "LegalHold",
        xmlName: "LegalHold",
        type: {
          name: "Boolean"
        }
      }
    }
  }
}, di = {
  serializedName: "ListBlobsHierarchySegmentResponse",
  xmlName: "EnumerationResults",
  type: {
    name: "Composite",
    className: "ListBlobsHierarchySegmentResponse",
    modelProperties: {
      serviceEndpoint: {
        serializedName: "ServiceEndpoint",
        required: !0,
        xmlName: "ServiceEndpoint",
        xmlIsAttribute: !0,
        type: {
          name: "String"
        }
      },
      containerName: {
        serializedName: "ContainerName",
        required: !0,
        xmlName: "ContainerName",
        xmlIsAttribute: !0,
        type: {
          name: "String"
        }
      },
      prefix: {
        serializedName: "Prefix",
        xmlName: "Prefix",
        type: {
          name: "String"
        }
      },
      marker: {
        serializedName: "Marker",
        xmlName: "Marker",
        type: {
          name: "String"
        }
      },
      maxPageSize: {
        serializedName: "MaxResults",
        xmlName: "MaxResults",
        type: {
          name: "Number"
        }
      },
      delimiter: {
        serializedName: "Delimiter",
        xmlName: "Delimiter",
        type: {
          name: "String"
        }
      },
      segment: {
        serializedName: "Segment",
        xmlName: "Blobs",
        type: {
          name: "Composite",
          className: "BlobHierarchyListSegment"
        }
      },
      continuationToken: {
        serializedName: "NextMarker",
        xmlName: "NextMarker",
        type: {
          name: "String"
        }
      }
    }
  }
}, wu = {
  serializedName: "BlobHierarchyListSegment",
  xmlName: "Blobs",
  type: {
    name: "Composite",
    className: "BlobHierarchyListSegment",
    modelProperties: {
      blobPrefixes: {
        serializedName: "BlobPrefixes",
        xmlName: "BlobPrefixes",
        xmlElementName: "BlobPrefix",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "BlobPrefix"
            }
          }
        }
      },
      blobItems: {
        serializedName: "BlobItems",
        required: !0,
        xmlName: "BlobItems",
        xmlElementName: "Blob",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "BlobItemInternal"
            }
          }
        }
      }
    }
  }
}, Bu = {
  serializedName: "BlobPrefix",
  type: {
    name: "Composite",
    className: "BlobPrefix",
    modelProperties: {
      name: {
        serializedName: "Name",
        xmlName: "Name",
        type: {
          name: "Composite",
          className: "BlobName"
        }
      }
    }
  }
}, pi = {
  serializedName: "BlockLookupList",
  xmlName: "BlockList",
  type: {
    name: "Composite",
    className: "BlockLookupList",
    modelProperties: {
      committed: {
        serializedName: "Committed",
        xmlName: "Committed",
        xmlElementName: "Committed",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      },
      uncommitted: {
        serializedName: "Uncommitted",
        xmlName: "Uncommitted",
        xmlElementName: "Uncommitted",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      },
      latest: {
        serializedName: "Latest",
        xmlName: "Latest",
        xmlElementName: "Latest",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      }
    }
  }
}, ui = {
  serializedName: "BlockList",
  type: {
    name: "Composite",
    className: "BlockList",
    modelProperties: {
      committedBlocks: {
        serializedName: "CommittedBlocks",
        xmlName: "CommittedBlocks",
        xmlIsWrapped: !0,
        xmlElementName: "Block",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "Block"
            }
          }
        }
      },
      uncommittedBlocks: {
        serializedName: "UncommittedBlocks",
        xmlName: "UncommittedBlocks",
        xmlIsWrapped: !0,
        xmlElementName: "Block",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "Block"
            }
          }
        }
      }
    }
  }
}, Eu = {
  serializedName: "Block",
  type: {
    name: "Composite",
    className: "Block",
    modelProperties: {
      name: {
        serializedName: "Name",
        required: !0,
        xmlName: "Name",
        type: {
          name: "String"
        }
      },
      size: {
        serializedName: "Size",
        required: !0,
        xmlName: "Size",
        type: {
          name: "Number"
        }
      }
    }
  }
}, la = {
  serializedName: "PageList",
  type: {
    name: "Composite",
    className: "PageList",
    modelProperties: {
      pageRange: {
        serializedName: "PageRange",
        xmlName: "PageRange",
        xmlElementName: "PageRange",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "PageRange"
            }
          }
        }
      },
      clearRange: {
        serializedName: "ClearRange",
        xmlName: "ClearRange",
        xmlElementName: "ClearRange",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "ClearRange"
            }
          }
        }
      },
      continuationToken: {
        serializedName: "NextMarker",
        xmlName: "NextMarker",
        type: {
          name: "String"
        }
      }
    }
  }
}, Tu = {
  serializedName: "PageRange",
  xmlName: "PageRange",
  type: {
    name: "Composite",
    className: "PageRange",
    modelProperties: {
      start: {
        serializedName: "Start",
        required: !0,
        xmlName: "Start",
        type: {
          name: "Number"
        }
      },
      end: {
        serializedName: "End",
        required: !0,
        xmlName: "End",
        type: {
          name: "Number"
        }
      }
    }
  }
}, Mu = {
  serializedName: "ClearRange",
  xmlName: "ClearRange",
  type: {
    name: "Composite",
    className: "ClearRange",
    modelProperties: {
      start: {
        serializedName: "Start",
        required: !0,
        xmlName: "Start",
        type: {
          name: "Number"
        }
      },
      end: {
        serializedName: "End",
        required: !0,
        xmlName: "End",
        type: {
          name: "Number"
        }
      }
    }
  }
}, yi = {
  serializedName: "QueryRequest",
  xmlName: "QueryRequest",
  type: {
    name: "Composite",
    className: "QueryRequest",
    modelProperties: {
      queryType: {
        serializedName: "QueryType",
        required: !0,
        xmlName: "QueryType",
        type: {
          name: "String"
        }
      },
      expression: {
        serializedName: "Expression",
        required: !0,
        xmlName: "Expression",
        type: {
          name: "String"
        }
      },
      inputSerialization: {
        serializedName: "InputSerialization",
        xmlName: "InputSerialization",
        type: {
          name: "Composite",
          className: "QuerySerialization"
        }
      },
      outputSerialization: {
        serializedName: "OutputSerialization",
        xmlName: "OutputSerialization",
        type: {
          name: "Composite",
          className: "QuerySerialization"
        }
      }
    }
  }
}, Iu = {
  serializedName: "QuerySerialization",
  type: {
    name: "Composite",
    className: "QuerySerialization",
    modelProperties: {
      format: {
        serializedName: "Format",
        xmlName: "Format",
        type: {
          name: "Composite",
          className: "QueryFormat"
        }
      }
    }
  }
}, qu = {
  serializedName: "QueryFormat",
  type: {
    name: "Composite",
    className: "QueryFormat",
    modelProperties: {
      type: {
        serializedName: "Type",
        required: !0,
        xmlName: "Type",
        type: {
          name: "Enum",
          allowedValues: ["delimited", "json", "arrow", "parquet"]
        }
      },
      delimitedTextConfiguration: {
        serializedName: "DelimitedTextConfiguration",
        xmlName: "DelimitedTextConfiguration",
        type: {
          name: "Composite",
          className: "DelimitedTextConfiguration"
        }
      },
      jsonTextConfiguration: {
        serializedName: "JsonTextConfiguration",
        xmlName: "JsonTextConfiguration",
        type: {
          name: "Composite",
          className: "JsonTextConfiguration"
        }
      },
      arrowConfiguration: {
        serializedName: "ArrowConfiguration",
        xmlName: "ArrowConfiguration",
        type: {
          name: "Composite",
          className: "ArrowConfiguration"
        }
      },
      parquetTextConfiguration: {
        serializedName: "ParquetTextConfiguration",
        xmlName: "ParquetTextConfiguration",
        type: {
          name: "Dictionary",
          value: { type: { name: "any" } }
        }
      }
    }
  }
}, Ou = {
  serializedName: "DelimitedTextConfiguration",
  xmlName: "DelimitedTextConfiguration",
  type: {
    name: "Composite",
    className: "DelimitedTextConfiguration",
    modelProperties: {
      columnSeparator: {
        serializedName: "ColumnSeparator",
        xmlName: "ColumnSeparator",
        type: {
          name: "String"
        }
      },
      fieldQuote: {
        serializedName: "FieldQuote",
        xmlName: "FieldQuote",
        type: {
          name: "String"
        }
      },
      recordSeparator: {
        serializedName: "RecordSeparator",
        xmlName: "RecordSeparator",
        type: {
          name: "String"
        }
      },
      escapeChar: {
        serializedName: "EscapeChar",
        xmlName: "EscapeChar",
        type: {
          name: "String"
        }
      },
      headersPresent: {
        serializedName: "HeadersPresent",
        xmlName: "HasHeaders",
        type: {
          name: "Boolean"
        }
      }
    }
  }
}, _u = {
  serializedName: "JsonTextConfiguration",
  xmlName: "JsonTextConfiguration",
  type: {
    name: "Composite",
    className: "JsonTextConfiguration",
    modelProperties: {
      recordSeparator: {
        serializedName: "RecordSeparator",
        xmlName: "RecordSeparator",
        type: {
          name: "String"
        }
      }
    }
  }
}, Hu = {
  serializedName: "ArrowConfiguration",
  xmlName: "ArrowConfiguration",
  type: {
    name: "Composite",
    className: "ArrowConfiguration",
    modelProperties: {
      schema: {
        serializedName: "Schema",
        required: !0,
        xmlName: "Schema",
        xmlIsWrapped: !0,
        xmlElementName: "Field",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "ArrowField"
            }
          }
        }
      }
    }
  }
}, Du = {
  serializedName: "ArrowField",
  xmlName: "Field",
  type: {
    name: "Composite",
    className: "ArrowField",
    modelProperties: {
      type: {
        serializedName: "Type",
        required: !0,
        xmlName: "Type",
        type: {
          name: "String"
        }
      },
      name: {
        serializedName: "Name",
        xmlName: "Name",
        type: {
          name: "String"
        }
      },
      precision: {
        serializedName: "Precision",
        xmlName: "Precision",
        type: {
          name: "Number"
        }
      },
      scale: {
        serializedName: "Scale",
        xmlName: "Scale",
        type: {
          name: "Number"
        }
      }
    }
  }
}, fi = {
  serializedName: "Service_setPropertiesHeaders",
  type: {
    name: "Composite",
    className: "ServiceSetPropertiesHeaders",
    modelProperties: {
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, gi = {
  serializedName: "Service_setPropertiesExceptionHeaders",
  type: {
    name: "Composite",
    className: "ServiceSetPropertiesExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, hi = {
  serializedName: "Service_getPropertiesHeaders",
  type: {
    name: "Composite",
    className: "ServiceGetPropertiesHeaders",
    modelProperties: {
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, xi = {
  serializedName: "Service_getPropertiesExceptionHeaders",
  type: {
    name: "Composite",
    className: "ServiceGetPropertiesExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Ni = {
  serializedName: "Service_getStatisticsHeaders",
  type: {
    name: "Composite",
    className: "ServiceGetStatisticsHeaders",
    modelProperties: {
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, bi = {
  serializedName: "Service_getStatisticsExceptionHeaders",
  type: {
    name: "Composite",
    className: "ServiceGetStatisticsExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Ci = {
  serializedName: "Service_listContainersSegmentHeaders",
  type: {
    name: "Composite",
    className: "ServiceListContainersSegmentHeaders",
    modelProperties: {
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Pi = {
  serializedName: "Service_listContainersSegmentExceptionHeaders",
  type: {
    name: "Composite",
    className: "ServiceListContainersSegmentExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, vi = {
  serializedName: "Service_getUserDelegationKeyHeaders",
  type: {
    name: "Composite",
    className: "ServiceGetUserDelegationKeyHeaders",
    modelProperties: {
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, zi = {
  serializedName: "Service_getUserDelegationKeyExceptionHeaders",
  type: {
    name: "Composite",
    className: "ServiceGetUserDelegationKeyExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Si = {
  serializedName: "Service_getAccountInfoHeaders",
  type: {
    name: "Composite",
    className: "ServiceGetAccountInfoHeaders",
    modelProperties: {
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      skuName: {
        serializedName: "x-ms-sku-name",
        xmlName: "x-ms-sku-name",
        type: {
          name: "Enum",
          allowedValues: [
            "Standard_LRS",
            "Standard_GRS",
            "Standard_RAGRS",
            "Standard_ZRS",
            "Premium_LRS"
          ]
        }
      },
      accountKind: {
        serializedName: "x-ms-account-kind",
        xmlName: "x-ms-account-kind",
        type: {
          name: "Enum",
          allowedValues: [
            "Storage",
            "BlobStorage",
            "StorageV2",
            "FileStorage",
            "BlockBlobStorage"
          ]
        }
      },
      isHierarchicalNamespaceEnabled: {
        serializedName: "x-ms-is-hns-enabled",
        xmlName: "x-ms-is-hns-enabled",
        type: {
          name: "Boolean"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Ri = {
  serializedName: "Service_getAccountInfoExceptionHeaders",
  type: {
    name: "Composite",
    className: "ServiceGetAccountInfoExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, wi = {
  serializedName: "Service_submitBatchHeaders",
  type: {
    name: "Composite",
    className: "ServiceSubmitBatchHeaders",
    modelProperties: {
      contentType: {
        serializedName: "content-type",
        xmlName: "content-type",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Bi = {
  serializedName: "Service_submitBatchExceptionHeaders",
  type: {
    name: "Composite",
    className: "ServiceSubmitBatchExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Ei = {
  serializedName: "Service_filterBlobsHeaders",
  type: {
    name: "Composite",
    className: "ServiceFilterBlobsHeaders",
    modelProperties: {
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Ti = {
  serializedName: "Service_filterBlobsExceptionHeaders",
  type: {
    name: "Composite",
    className: "ServiceFilterBlobsExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Mi = {
  serializedName: "Container_createHeaders",
  type: {
    name: "Composite",
    className: "ContainerCreateHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Ii = {
  serializedName: "Container_createExceptionHeaders",
  type: {
    name: "Composite",
    className: "ContainerCreateExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, qi = {
  serializedName: "Container_getPropertiesHeaders",
  type: {
    name: "Composite",
    className: "ContainerGetPropertiesHeaders",
    modelProperties: {
      metadata: {
        serializedName: "x-ms-meta",
        headerCollectionPrefix: "x-ms-meta-",
        xmlName: "x-ms-meta",
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } }
        }
      },
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      leaseDuration: {
        serializedName: "x-ms-lease-duration",
        xmlName: "x-ms-lease-duration",
        type: {
          name: "Enum",
          allowedValues: ["infinite", "fixed"]
        }
      },
      leaseState: {
        serializedName: "x-ms-lease-state",
        xmlName: "x-ms-lease-state",
        type: {
          name: "Enum",
          allowedValues: [
            "available",
            "leased",
            "expired",
            "breaking",
            "broken"
          ]
        }
      },
      leaseStatus: {
        serializedName: "x-ms-lease-status",
        xmlName: "x-ms-lease-status",
        type: {
          name: "Enum",
          allowedValues: ["locked", "unlocked"]
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      blobPublicAccess: {
        serializedName: "x-ms-blob-public-access",
        xmlName: "x-ms-blob-public-access",
        type: {
          name: "Enum",
          allowedValues: ["container", "blob"]
        }
      },
      hasImmutabilityPolicy: {
        serializedName: "x-ms-has-immutability-policy",
        xmlName: "x-ms-has-immutability-policy",
        type: {
          name: "Boolean"
        }
      },
      hasLegalHold: {
        serializedName: "x-ms-has-legal-hold",
        xmlName: "x-ms-has-legal-hold",
        type: {
          name: "Boolean"
        }
      },
      defaultEncryptionScope: {
        serializedName: "x-ms-default-encryption-scope",
        xmlName: "x-ms-default-encryption-scope",
        type: {
          name: "String"
        }
      },
      denyEncryptionScopeOverride: {
        serializedName: "x-ms-deny-encryption-scope-override",
        xmlName: "x-ms-deny-encryption-scope-override",
        type: {
          name: "Boolean"
        }
      },
      isImmutableStorageWithVersioningEnabled: {
        serializedName: "x-ms-immutable-storage-with-versioning-enabled",
        xmlName: "x-ms-immutable-storage-with-versioning-enabled",
        type: {
          name: "Boolean"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Oi = {
  serializedName: "Container_getPropertiesExceptionHeaders",
  type: {
    name: "Composite",
    className: "ContainerGetPropertiesExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, _i = {
  serializedName: "Container_deleteHeaders",
  type: {
    name: "Composite",
    className: "ContainerDeleteHeaders",
    modelProperties: {
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Hi = {
  serializedName: "Container_deleteExceptionHeaders",
  type: {
    name: "Composite",
    className: "ContainerDeleteExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Di = {
  serializedName: "Container_setMetadataHeaders",
  type: {
    name: "Composite",
    className: "ContainerSetMetadataHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Li = {
  serializedName: "Container_setMetadataExceptionHeaders",
  type: {
    name: "Composite",
    className: "ContainerSetMetadataExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, ki = {
  serializedName: "Container_getAccessPolicyHeaders",
  type: {
    name: "Composite",
    className: "ContainerGetAccessPolicyHeaders",
    modelProperties: {
      blobPublicAccess: {
        serializedName: "x-ms-blob-public-access",
        xmlName: "x-ms-blob-public-access",
        type: {
          name: "Enum",
          allowedValues: ["container", "blob"]
        }
      },
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Ai = {
  serializedName: "Container_getAccessPolicyExceptionHeaders",
  type: {
    name: "Composite",
    className: "ContainerGetAccessPolicyExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Ui = {
  serializedName: "Container_setAccessPolicyHeaders",
  type: {
    name: "Composite",
    className: "ContainerSetAccessPolicyHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, $i = {
  serializedName: "Container_setAccessPolicyExceptionHeaders",
  type: {
    name: "Composite",
    className: "ContainerSetAccessPolicyExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, ji = {
  serializedName: "Container_restoreHeaders",
  type: {
    name: "Composite",
    className: "ContainerRestoreHeaders",
    modelProperties: {
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Fi = {
  serializedName: "Container_restoreExceptionHeaders",
  type: {
    name: "Composite",
    className: "ContainerRestoreExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Ki = {
  serializedName: "Container_renameHeaders",
  type: {
    name: "Composite",
    className: "ContainerRenameHeaders",
    modelProperties: {
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Gi = {
  serializedName: "Container_renameExceptionHeaders",
  type: {
    name: "Composite",
    className: "ContainerRenameExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Xi = {
  serializedName: "Container_submitBatchHeaders",
  type: {
    name: "Composite",
    className: "ContainerSubmitBatchHeaders",
    modelProperties: {
      contentType: {
        serializedName: "content-type",
        xmlName: "content-type",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      }
    }
  }
}, Wi = {
  serializedName: "Container_submitBatchExceptionHeaders",
  type: {
    name: "Composite",
    className: "ContainerSubmitBatchExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Qi = {
  serializedName: "Container_filterBlobsHeaders",
  type: {
    name: "Composite",
    className: "ContainerFilterBlobsHeaders",
    modelProperties: {
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      }
    }
  }
}, Ji = {
  serializedName: "Container_filterBlobsExceptionHeaders",
  type: {
    name: "Composite",
    className: "ContainerFilterBlobsExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Yi = {
  serializedName: "Container_acquireLeaseHeaders",
  type: {
    name: "Composite",
    className: "ContainerAcquireLeaseHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      leaseId: {
        serializedName: "x-ms-lease-id",
        xmlName: "x-ms-lease-id",
        type: {
          name: "String"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      }
    }
  }
}, Zi = {
  serializedName: "Container_acquireLeaseExceptionHeaders",
  type: {
    name: "Composite",
    className: "ContainerAcquireLeaseExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Vi = {
  serializedName: "Container_releaseLeaseHeaders",
  type: {
    name: "Composite",
    className: "ContainerReleaseLeaseHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      }
    }
  }
}, es = {
  serializedName: "Container_releaseLeaseExceptionHeaders",
  type: {
    name: "Composite",
    className: "ContainerReleaseLeaseExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, ts = {
  serializedName: "Container_renewLeaseHeaders",
  type: {
    name: "Composite",
    className: "ContainerRenewLeaseHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      leaseId: {
        serializedName: "x-ms-lease-id",
        xmlName: "x-ms-lease-id",
        type: {
          name: "String"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      }
    }
  }
}, rs = {
  serializedName: "Container_renewLeaseExceptionHeaders",
  type: {
    name: "Composite",
    className: "ContainerRenewLeaseExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, as = {
  serializedName: "Container_breakLeaseHeaders",
  type: {
    name: "Composite",
    className: "ContainerBreakLeaseHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      leaseTime: {
        serializedName: "x-ms-lease-time",
        xmlName: "x-ms-lease-time",
        type: {
          name: "Number"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      }
    }
  }
}, ns = {
  serializedName: "Container_breakLeaseExceptionHeaders",
  type: {
    name: "Composite",
    className: "ContainerBreakLeaseExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, is = {
  serializedName: "Container_changeLeaseHeaders",
  type: {
    name: "Composite",
    className: "ContainerChangeLeaseHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      leaseId: {
        serializedName: "x-ms-lease-id",
        xmlName: "x-ms-lease-id",
        type: {
          name: "String"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      }
    }
  }
}, ss = {
  serializedName: "Container_changeLeaseExceptionHeaders",
  type: {
    name: "Composite",
    className: "ContainerChangeLeaseExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, os = {
  serializedName: "Container_listBlobFlatSegmentHeaders",
  type: {
    name: "Composite",
    className: "ContainerListBlobFlatSegmentHeaders",
    modelProperties: {
      contentType: {
        serializedName: "content-type",
        xmlName: "content-type",
        type: {
          name: "String"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, ms = {
  serializedName: "Container_listBlobFlatSegmentExceptionHeaders",
  type: {
    name: "Composite",
    className: "ContainerListBlobFlatSegmentExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, ls = {
  serializedName: "Container_listBlobHierarchySegmentHeaders",
  type: {
    name: "Composite",
    className: "ContainerListBlobHierarchySegmentHeaders",
    modelProperties: {
      contentType: {
        serializedName: "content-type",
        xmlName: "content-type",
        type: {
          name: "String"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, cs = {
  serializedName: "Container_listBlobHierarchySegmentExceptionHeaders",
  type: {
    name: "Composite",
    className: "ContainerListBlobHierarchySegmentExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, ds = {
  serializedName: "Container_getAccountInfoHeaders",
  type: {
    name: "Composite",
    className: "ContainerGetAccountInfoHeaders",
    modelProperties: {
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      skuName: {
        serializedName: "x-ms-sku-name",
        xmlName: "x-ms-sku-name",
        type: {
          name: "Enum",
          allowedValues: [
            "Standard_LRS",
            "Standard_GRS",
            "Standard_RAGRS",
            "Standard_ZRS",
            "Premium_LRS"
          ]
        }
      },
      accountKind: {
        serializedName: "x-ms-account-kind",
        xmlName: "x-ms-account-kind",
        type: {
          name: "Enum",
          allowedValues: [
            "Storage",
            "BlobStorage",
            "StorageV2",
            "FileStorage",
            "BlockBlobStorage"
          ]
        }
      },
      isHierarchicalNamespaceEnabled: {
        serializedName: "x-ms-is-hns-enabled",
        xmlName: "x-ms-is-hns-enabled",
        type: {
          name: "Boolean"
        }
      }
    }
  }
}, ps = {
  serializedName: "Container_getAccountInfoExceptionHeaders",
  type: {
    name: "Composite",
    className: "ContainerGetAccountInfoExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Lr = {
  serializedName: "Blob_downloadHeaders",
  type: {
    name: "Composite",
    className: "BlobDownloadHeaders",
    modelProperties: {
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      createdOn: {
        serializedName: "x-ms-creation-time",
        xmlName: "x-ms-creation-time",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      metadata: {
        serializedName: "x-ms-meta",
        headerCollectionPrefix: "x-ms-meta-",
        xmlName: "x-ms-meta",
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } }
        }
      },
      objectReplicationPolicyId: {
        serializedName: "x-ms-or-policy-id",
        xmlName: "x-ms-or-policy-id",
        type: {
          name: "String"
        }
      },
      objectReplicationRules: {
        serializedName: "x-ms-or",
        headerCollectionPrefix: "x-ms-or-",
        xmlName: "x-ms-or",
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } }
        }
      },
      contentLength: {
        serializedName: "content-length",
        xmlName: "content-length",
        type: {
          name: "Number"
        }
      },
      contentType: {
        serializedName: "content-type",
        xmlName: "content-type",
        type: {
          name: "String"
        }
      },
      contentRange: {
        serializedName: "content-range",
        xmlName: "content-range",
        type: {
          name: "String"
        }
      },
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      contentMD5: {
        serializedName: "content-md5",
        xmlName: "content-md5",
        type: {
          name: "ByteArray"
        }
      },
      contentEncoding: {
        serializedName: "content-encoding",
        xmlName: "content-encoding",
        type: {
          name: "String"
        }
      },
      cacheControl: {
        serializedName: "cache-control",
        xmlName: "cache-control",
        type: {
          name: "String"
        }
      },
      contentDisposition: {
        serializedName: "content-disposition",
        xmlName: "content-disposition",
        type: {
          name: "String"
        }
      },
      contentLanguage: {
        serializedName: "content-language",
        xmlName: "content-language",
        type: {
          name: "String"
        }
      },
      blobSequenceNumber: {
        serializedName: "x-ms-blob-sequence-number",
        xmlName: "x-ms-blob-sequence-number",
        type: {
          name: "Number"
        }
      },
      blobType: {
        serializedName: "x-ms-blob-type",
        xmlName: "x-ms-blob-type",
        type: {
          name: "Enum",
          allowedValues: ["BlockBlob", "PageBlob", "AppendBlob"]
        }
      },
      copyCompletedOn: {
        serializedName: "x-ms-copy-completion-time",
        xmlName: "x-ms-copy-completion-time",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      copyStatusDescription: {
        serializedName: "x-ms-copy-status-description",
        xmlName: "x-ms-copy-status-description",
        type: {
          name: "String"
        }
      },
      copyId: {
        serializedName: "x-ms-copy-id",
        xmlName: "x-ms-copy-id",
        type: {
          name: "String"
        }
      },
      copyProgress: {
        serializedName: "x-ms-copy-progress",
        xmlName: "x-ms-copy-progress",
        type: {
          name: "String"
        }
      },
      copySource: {
        serializedName: "x-ms-copy-source",
        xmlName: "x-ms-copy-source",
        type: {
          name: "String"
        }
      },
      copyStatus: {
        serializedName: "x-ms-copy-status",
        xmlName: "x-ms-copy-status",
        type: {
          name: "Enum",
          allowedValues: ["pending", "success", "aborted", "failed"]
        }
      },
      leaseDuration: {
        serializedName: "x-ms-lease-duration",
        xmlName: "x-ms-lease-duration",
        type: {
          name: "Enum",
          allowedValues: ["infinite", "fixed"]
        }
      },
      leaseState: {
        serializedName: "x-ms-lease-state",
        xmlName: "x-ms-lease-state",
        type: {
          name: "Enum",
          allowedValues: [
            "available",
            "leased",
            "expired",
            "breaking",
            "broken"
          ]
        }
      },
      leaseStatus: {
        serializedName: "x-ms-lease-status",
        xmlName: "x-ms-lease-status",
        type: {
          name: "Enum",
          allowedValues: ["locked", "unlocked"]
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      versionId: {
        serializedName: "x-ms-version-id",
        xmlName: "x-ms-version-id",
        type: {
          name: "String"
        }
      },
      isCurrentVersion: {
        serializedName: "x-ms-is-current-version",
        xmlName: "x-ms-is-current-version",
        type: {
          name: "Boolean"
        }
      },
      acceptRanges: {
        serializedName: "accept-ranges",
        xmlName: "accept-ranges",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      blobCommittedBlockCount: {
        serializedName: "x-ms-blob-committed-block-count",
        xmlName: "x-ms-blob-committed-block-count",
        type: {
          name: "Number"
        }
      },
      isServerEncrypted: {
        serializedName: "x-ms-server-encrypted",
        xmlName: "x-ms-server-encrypted",
        type: {
          name: "Boolean"
        }
      },
      encryptionKeySha256: {
        serializedName: "x-ms-encryption-key-sha256",
        xmlName: "x-ms-encryption-key-sha256",
        type: {
          name: "String"
        }
      },
      encryptionScope: {
        serializedName: "x-ms-encryption-scope",
        xmlName: "x-ms-encryption-scope",
        type: {
          name: "String"
        }
      },
      blobContentMD5: {
        serializedName: "x-ms-blob-content-md5",
        xmlName: "x-ms-blob-content-md5",
        type: {
          name: "ByteArray"
        }
      },
      tagCount: {
        serializedName: "x-ms-tag-count",
        xmlName: "x-ms-tag-count",
        type: {
          name: "Number"
        }
      },
      isSealed: {
        serializedName: "x-ms-blob-sealed",
        xmlName: "x-ms-blob-sealed",
        type: {
          name: "Boolean"
        }
      },
      lastAccessed: {
        serializedName: "x-ms-last-access-time",
        xmlName: "x-ms-last-access-time",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      immutabilityPolicyExpiresOn: {
        serializedName: "x-ms-immutability-policy-until-date",
        xmlName: "x-ms-immutability-policy-until-date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      immutabilityPolicyMode: {
        serializedName: "x-ms-immutability-policy-mode",
        xmlName: "x-ms-immutability-policy-mode",
        type: {
          name: "Enum",
          allowedValues: ["Mutable", "Unlocked", "Locked"]
        }
      },
      legalHold: {
        serializedName: "x-ms-legal-hold",
        xmlName: "x-ms-legal-hold",
        type: {
          name: "Boolean"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      },
      contentCrc64: {
        serializedName: "x-ms-content-crc64",
        xmlName: "x-ms-content-crc64",
        type: {
          name: "ByteArray"
        }
      }
    }
  }
}, us = {
  serializedName: "Blob_downloadExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlobDownloadExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, ys = {
  serializedName: "Blob_getPropertiesHeaders",
  type: {
    name: "Composite",
    className: "BlobGetPropertiesHeaders",
    modelProperties: {
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      createdOn: {
        serializedName: "x-ms-creation-time",
        xmlName: "x-ms-creation-time",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      metadata: {
        serializedName: "x-ms-meta",
        headerCollectionPrefix: "x-ms-meta-",
        xmlName: "x-ms-meta",
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } }
        }
      },
      objectReplicationPolicyId: {
        serializedName: "x-ms-or-policy-id",
        xmlName: "x-ms-or-policy-id",
        type: {
          name: "String"
        }
      },
      objectReplicationRules: {
        serializedName: "x-ms-or",
        headerCollectionPrefix: "x-ms-or-",
        xmlName: "x-ms-or",
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } }
        }
      },
      blobType: {
        serializedName: "x-ms-blob-type",
        xmlName: "x-ms-blob-type",
        type: {
          name: "Enum",
          allowedValues: ["BlockBlob", "PageBlob", "AppendBlob"]
        }
      },
      copyCompletedOn: {
        serializedName: "x-ms-copy-completion-time",
        xmlName: "x-ms-copy-completion-time",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      copyStatusDescription: {
        serializedName: "x-ms-copy-status-description",
        xmlName: "x-ms-copy-status-description",
        type: {
          name: "String"
        }
      },
      copyId: {
        serializedName: "x-ms-copy-id",
        xmlName: "x-ms-copy-id",
        type: {
          name: "String"
        }
      },
      copyProgress: {
        serializedName: "x-ms-copy-progress",
        xmlName: "x-ms-copy-progress",
        type: {
          name: "String"
        }
      },
      copySource: {
        serializedName: "x-ms-copy-source",
        xmlName: "x-ms-copy-source",
        type: {
          name: "String"
        }
      },
      copyStatus: {
        serializedName: "x-ms-copy-status",
        xmlName: "x-ms-copy-status",
        type: {
          name: "Enum",
          allowedValues: ["pending", "success", "aborted", "failed"]
        }
      },
      isIncrementalCopy: {
        serializedName: "x-ms-incremental-copy",
        xmlName: "x-ms-incremental-copy",
        type: {
          name: "Boolean"
        }
      },
      destinationSnapshot: {
        serializedName: "x-ms-copy-destination-snapshot",
        xmlName: "x-ms-copy-destination-snapshot",
        type: {
          name: "String"
        }
      },
      leaseDuration: {
        serializedName: "x-ms-lease-duration",
        xmlName: "x-ms-lease-duration",
        type: {
          name: "Enum",
          allowedValues: ["infinite", "fixed"]
        }
      },
      leaseState: {
        serializedName: "x-ms-lease-state",
        xmlName: "x-ms-lease-state",
        type: {
          name: "Enum",
          allowedValues: [
            "available",
            "leased",
            "expired",
            "breaking",
            "broken"
          ]
        }
      },
      leaseStatus: {
        serializedName: "x-ms-lease-status",
        xmlName: "x-ms-lease-status",
        type: {
          name: "Enum",
          allowedValues: ["locked", "unlocked"]
        }
      },
      contentLength: {
        serializedName: "content-length",
        xmlName: "content-length",
        type: {
          name: "Number"
        }
      },
      contentType: {
        serializedName: "content-type",
        xmlName: "content-type",
        type: {
          name: "String"
        }
      },
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      contentMD5: {
        serializedName: "content-md5",
        xmlName: "content-md5",
        type: {
          name: "ByteArray"
        }
      },
      contentEncoding: {
        serializedName: "content-encoding",
        xmlName: "content-encoding",
        type: {
          name: "String"
        }
      },
      contentDisposition: {
        serializedName: "content-disposition",
        xmlName: "content-disposition",
        type: {
          name: "String"
        }
      },
      contentLanguage: {
        serializedName: "content-language",
        xmlName: "content-language",
        type: {
          name: "String"
        }
      },
      cacheControl: {
        serializedName: "cache-control",
        xmlName: "cache-control",
        type: {
          name: "String"
        }
      },
      blobSequenceNumber: {
        serializedName: "x-ms-blob-sequence-number",
        xmlName: "x-ms-blob-sequence-number",
        type: {
          name: "Number"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      acceptRanges: {
        serializedName: "accept-ranges",
        xmlName: "accept-ranges",
        type: {
          name: "String"
        }
      },
      blobCommittedBlockCount: {
        serializedName: "x-ms-blob-committed-block-count",
        xmlName: "x-ms-blob-committed-block-count",
        type: {
          name: "Number"
        }
      },
      isServerEncrypted: {
        serializedName: "x-ms-server-encrypted",
        xmlName: "x-ms-server-encrypted",
        type: {
          name: "Boolean"
        }
      },
      encryptionKeySha256: {
        serializedName: "x-ms-encryption-key-sha256",
        xmlName: "x-ms-encryption-key-sha256",
        type: {
          name: "String"
        }
      },
      encryptionScope: {
        serializedName: "x-ms-encryption-scope",
        xmlName: "x-ms-encryption-scope",
        type: {
          name: "String"
        }
      },
      accessTier: {
        serializedName: "x-ms-access-tier",
        xmlName: "x-ms-access-tier",
        type: {
          name: "String"
        }
      },
      accessTierInferred: {
        serializedName: "x-ms-access-tier-inferred",
        xmlName: "x-ms-access-tier-inferred",
        type: {
          name: "Boolean"
        }
      },
      archiveStatus: {
        serializedName: "x-ms-archive-status",
        xmlName: "x-ms-archive-status",
        type: {
          name: "String"
        }
      },
      accessTierChangedOn: {
        serializedName: "x-ms-access-tier-change-time",
        xmlName: "x-ms-access-tier-change-time",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      versionId: {
        serializedName: "x-ms-version-id",
        xmlName: "x-ms-version-id",
        type: {
          name: "String"
        }
      },
      isCurrentVersion: {
        serializedName: "x-ms-is-current-version",
        xmlName: "x-ms-is-current-version",
        type: {
          name: "Boolean"
        }
      },
      tagCount: {
        serializedName: "x-ms-tag-count",
        xmlName: "x-ms-tag-count",
        type: {
          name: "Number"
        }
      },
      expiresOn: {
        serializedName: "x-ms-expiry-time",
        xmlName: "x-ms-expiry-time",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      isSealed: {
        serializedName: "x-ms-blob-sealed",
        xmlName: "x-ms-blob-sealed",
        type: {
          name: "Boolean"
        }
      },
      rehydratePriority: {
        serializedName: "x-ms-rehydrate-priority",
        xmlName: "x-ms-rehydrate-priority",
        type: {
          name: "Enum",
          allowedValues: ["High", "Standard"]
        }
      },
      lastAccessed: {
        serializedName: "x-ms-last-access-time",
        xmlName: "x-ms-last-access-time",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      immutabilityPolicyExpiresOn: {
        serializedName: "x-ms-immutability-policy-until-date",
        xmlName: "x-ms-immutability-policy-until-date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      immutabilityPolicyMode: {
        serializedName: "x-ms-immutability-policy-mode",
        xmlName: "x-ms-immutability-policy-mode",
        type: {
          name: "Enum",
          allowedValues: ["Mutable", "Unlocked", "Locked"]
        }
      },
      legalHold: {
        serializedName: "x-ms-legal-hold",
        xmlName: "x-ms-legal-hold",
        type: {
          name: "Boolean"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, fs = {
  serializedName: "Blob_getPropertiesExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlobGetPropertiesExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, gs = {
  serializedName: "Blob_deleteHeaders",
  type: {
    name: "Composite",
    className: "BlobDeleteHeaders",
    modelProperties: {
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, hs = {
  serializedName: "Blob_deleteExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlobDeleteExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, xs = {
  serializedName: "Blob_undeleteHeaders",
  type: {
    name: "Composite",
    className: "BlobUndeleteHeaders",
    modelProperties: {
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Ns = {
  serializedName: "Blob_undeleteExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlobUndeleteExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, bs = {
  serializedName: "Blob_setExpiryHeaders",
  type: {
    name: "Composite",
    className: "BlobSetExpiryHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      }
    }
  }
}, Cs = {
  serializedName: "Blob_setExpiryExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlobSetExpiryExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Ps = {
  serializedName: "Blob_setHttpHeadersHeaders",
  type: {
    name: "Composite",
    className: "BlobSetHttpHeadersHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      blobSequenceNumber: {
        serializedName: "x-ms-blob-sequence-number",
        xmlName: "x-ms-blob-sequence-number",
        type: {
          name: "Number"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, vs = {
  serializedName: "Blob_setHttpHeadersExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlobSetHttpHeadersExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, zs = {
  serializedName: "Blob_setImmutabilityPolicyHeaders",
  type: {
    name: "Composite",
    className: "BlobSetImmutabilityPolicyHeaders",
    modelProperties: {
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      immutabilityPolicyExpiry: {
        serializedName: "x-ms-immutability-policy-until-date",
        xmlName: "x-ms-immutability-policy-until-date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      immutabilityPolicyMode: {
        serializedName: "x-ms-immutability-policy-mode",
        xmlName: "x-ms-immutability-policy-mode",
        type: {
          name: "Enum",
          allowedValues: ["Mutable", "Unlocked", "Locked"]
        }
      }
    }
  }
}, Ss = {
  serializedName: "Blob_setImmutabilityPolicyExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlobSetImmutabilityPolicyExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Rs = {
  serializedName: "Blob_deleteImmutabilityPolicyHeaders",
  type: {
    name: "Composite",
    className: "BlobDeleteImmutabilityPolicyHeaders",
    modelProperties: {
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      }
    }
  }
}, ws = {
  serializedName: "Blob_deleteImmutabilityPolicyExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlobDeleteImmutabilityPolicyExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Bs = {
  serializedName: "Blob_setLegalHoldHeaders",
  type: {
    name: "Composite",
    className: "BlobSetLegalHoldHeaders",
    modelProperties: {
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      legalHold: {
        serializedName: "x-ms-legal-hold",
        xmlName: "x-ms-legal-hold",
        type: {
          name: "Boolean"
        }
      }
    }
  }
}, Es = {
  serializedName: "Blob_setLegalHoldExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlobSetLegalHoldExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Ts = {
  serializedName: "Blob_setMetadataHeaders",
  type: {
    name: "Composite",
    className: "BlobSetMetadataHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      versionId: {
        serializedName: "x-ms-version-id",
        xmlName: "x-ms-version-id",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      isServerEncrypted: {
        serializedName: "x-ms-request-server-encrypted",
        xmlName: "x-ms-request-server-encrypted",
        type: {
          name: "Boolean"
        }
      },
      encryptionKeySha256: {
        serializedName: "x-ms-encryption-key-sha256",
        xmlName: "x-ms-encryption-key-sha256",
        type: {
          name: "String"
        }
      },
      encryptionScope: {
        serializedName: "x-ms-encryption-scope",
        xmlName: "x-ms-encryption-scope",
        type: {
          name: "String"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Ms = {
  serializedName: "Blob_setMetadataExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlobSetMetadataExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Is = {
  serializedName: "Blob_acquireLeaseHeaders",
  type: {
    name: "Composite",
    className: "BlobAcquireLeaseHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      leaseId: {
        serializedName: "x-ms-lease-id",
        xmlName: "x-ms-lease-id",
        type: {
          name: "String"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      }
    }
  }
}, qs = {
  serializedName: "Blob_acquireLeaseExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlobAcquireLeaseExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Os = {
  serializedName: "Blob_releaseLeaseHeaders",
  type: {
    name: "Composite",
    className: "BlobReleaseLeaseHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      }
    }
  }
}, _s = {
  serializedName: "Blob_releaseLeaseExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlobReleaseLeaseExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Hs = {
  serializedName: "Blob_renewLeaseHeaders",
  type: {
    name: "Composite",
    className: "BlobRenewLeaseHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      leaseId: {
        serializedName: "x-ms-lease-id",
        xmlName: "x-ms-lease-id",
        type: {
          name: "String"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      }
    }
  }
}, Ds = {
  serializedName: "Blob_renewLeaseExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlobRenewLeaseExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Ls = {
  serializedName: "Blob_changeLeaseHeaders",
  type: {
    name: "Composite",
    className: "BlobChangeLeaseHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      leaseId: {
        serializedName: "x-ms-lease-id",
        xmlName: "x-ms-lease-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      }
    }
  }
}, ks = {
  serializedName: "Blob_changeLeaseExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlobChangeLeaseExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, As = {
  serializedName: "Blob_breakLeaseHeaders",
  type: {
    name: "Composite",
    className: "BlobBreakLeaseHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      leaseTime: {
        serializedName: "x-ms-lease-time",
        xmlName: "x-ms-lease-time",
        type: {
          name: "Number"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      }
    }
  }
}, Us = {
  serializedName: "Blob_breakLeaseExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlobBreakLeaseExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, $s = {
  serializedName: "Blob_createSnapshotHeaders",
  type: {
    name: "Composite",
    className: "BlobCreateSnapshotHeaders",
    modelProperties: {
      snapshot: {
        serializedName: "x-ms-snapshot",
        xmlName: "x-ms-snapshot",
        type: {
          name: "String"
        }
      },
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      versionId: {
        serializedName: "x-ms-version-id",
        xmlName: "x-ms-version-id",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      isServerEncrypted: {
        serializedName: "x-ms-request-server-encrypted",
        xmlName: "x-ms-request-server-encrypted",
        type: {
          name: "Boolean"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, js = {
  serializedName: "Blob_createSnapshotExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlobCreateSnapshotExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Fs = {
  serializedName: "Blob_startCopyFromURLHeaders",
  type: {
    name: "Composite",
    className: "BlobStartCopyFromURLHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      versionId: {
        serializedName: "x-ms-version-id",
        xmlName: "x-ms-version-id",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      copyId: {
        serializedName: "x-ms-copy-id",
        xmlName: "x-ms-copy-id",
        type: {
          name: "String"
        }
      },
      copyStatus: {
        serializedName: "x-ms-copy-status",
        xmlName: "x-ms-copy-status",
        type: {
          name: "Enum",
          allowedValues: ["pending", "success", "aborted", "failed"]
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Ks = {
  serializedName: "Blob_startCopyFromURLExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlobStartCopyFromURLExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Gs = {
  serializedName: "Blob_copyFromURLHeaders",
  type: {
    name: "Composite",
    className: "BlobCopyFromURLHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      versionId: {
        serializedName: "x-ms-version-id",
        xmlName: "x-ms-version-id",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      copyId: {
        serializedName: "x-ms-copy-id",
        xmlName: "x-ms-copy-id",
        type: {
          name: "String"
        }
      },
      copyStatus: {
        defaultValue: "success",
        isConstant: !0,
        serializedName: "x-ms-copy-status",
        type: {
          name: "String"
        }
      },
      contentMD5: {
        serializedName: "content-md5",
        xmlName: "content-md5",
        type: {
          name: "ByteArray"
        }
      },
      xMsContentCrc64: {
        serializedName: "x-ms-content-crc64",
        xmlName: "x-ms-content-crc64",
        type: {
          name: "ByteArray"
        }
      },
      encryptionScope: {
        serializedName: "x-ms-encryption-scope",
        xmlName: "x-ms-encryption-scope",
        type: {
          name: "String"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Xs = {
  serializedName: "Blob_copyFromURLExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlobCopyFromURLExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Ws = {
  serializedName: "Blob_abortCopyFromURLHeaders",
  type: {
    name: "Composite",
    className: "BlobAbortCopyFromURLHeaders",
    modelProperties: {
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Qs = {
  serializedName: "Blob_abortCopyFromURLExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlobAbortCopyFromURLExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, kr = {
  serializedName: "Blob_setTierHeaders",
  type: {
    name: "Composite",
    className: "BlobSetTierHeaders",
    modelProperties: {
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Js = {
  serializedName: "Blob_setTierExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlobSetTierExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Ys = {
  serializedName: "Blob_getAccountInfoHeaders",
  type: {
    name: "Composite",
    className: "BlobGetAccountInfoHeaders",
    modelProperties: {
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      skuName: {
        serializedName: "x-ms-sku-name",
        xmlName: "x-ms-sku-name",
        type: {
          name: "Enum",
          allowedValues: [
            "Standard_LRS",
            "Standard_GRS",
            "Standard_RAGRS",
            "Standard_ZRS",
            "Premium_LRS"
          ]
        }
      },
      accountKind: {
        serializedName: "x-ms-account-kind",
        xmlName: "x-ms-account-kind",
        type: {
          name: "Enum",
          allowedValues: [
            "Storage",
            "BlobStorage",
            "StorageV2",
            "FileStorage",
            "BlockBlobStorage"
          ]
        }
      },
      isHierarchicalNamespaceEnabled: {
        serializedName: "x-ms-is-hns-enabled",
        xmlName: "x-ms-is-hns-enabled",
        type: {
          name: "Boolean"
        }
      }
    }
  }
}, Zs = {
  serializedName: "Blob_getAccountInfoExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlobGetAccountInfoExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Ar = {
  serializedName: "Blob_queryHeaders",
  type: {
    name: "Composite",
    className: "BlobQueryHeaders",
    modelProperties: {
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      metadata: {
        serializedName: "x-ms-meta",
        headerCollectionPrefix: "x-ms-meta-",
        xmlName: "x-ms-meta",
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } }
        }
      },
      contentLength: {
        serializedName: "content-length",
        xmlName: "content-length",
        type: {
          name: "Number"
        }
      },
      contentType: {
        serializedName: "content-type",
        xmlName: "content-type",
        type: {
          name: "String"
        }
      },
      contentRange: {
        serializedName: "content-range",
        xmlName: "content-range",
        type: {
          name: "String"
        }
      },
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      contentMD5: {
        serializedName: "content-md5",
        xmlName: "content-md5",
        type: {
          name: "ByteArray"
        }
      },
      contentEncoding: {
        serializedName: "content-encoding",
        xmlName: "content-encoding",
        type: {
          name: "String"
        }
      },
      cacheControl: {
        serializedName: "cache-control",
        xmlName: "cache-control",
        type: {
          name: "String"
        }
      },
      contentDisposition: {
        serializedName: "content-disposition",
        xmlName: "content-disposition",
        type: {
          name: "String"
        }
      },
      contentLanguage: {
        serializedName: "content-language",
        xmlName: "content-language",
        type: {
          name: "String"
        }
      },
      blobSequenceNumber: {
        serializedName: "x-ms-blob-sequence-number",
        xmlName: "x-ms-blob-sequence-number",
        type: {
          name: "Number"
        }
      },
      blobType: {
        serializedName: "x-ms-blob-type",
        xmlName: "x-ms-blob-type",
        type: {
          name: "Enum",
          allowedValues: ["BlockBlob", "PageBlob", "AppendBlob"]
        }
      },
      copyCompletionTime: {
        serializedName: "x-ms-copy-completion-time",
        xmlName: "x-ms-copy-completion-time",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      copyStatusDescription: {
        serializedName: "x-ms-copy-status-description",
        xmlName: "x-ms-copy-status-description",
        type: {
          name: "String"
        }
      },
      copyId: {
        serializedName: "x-ms-copy-id",
        xmlName: "x-ms-copy-id",
        type: {
          name: "String"
        }
      },
      copyProgress: {
        serializedName: "x-ms-copy-progress",
        xmlName: "x-ms-copy-progress",
        type: {
          name: "String"
        }
      },
      copySource: {
        serializedName: "x-ms-copy-source",
        xmlName: "x-ms-copy-source",
        type: {
          name: "String"
        }
      },
      copyStatus: {
        serializedName: "x-ms-copy-status",
        xmlName: "x-ms-copy-status",
        type: {
          name: "Enum",
          allowedValues: ["pending", "success", "aborted", "failed"]
        }
      },
      leaseDuration: {
        serializedName: "x-ms-lease-duration",
        xmlName: "x-ms-lease-duration",
        type: {
          name: "Enum",
          allowedValues: ["infinite", "fixed"]
        }
      },
      leaseState: {
        serializedName: "x-ms-lease-state",
        xmlName: "x-ms-lease-state",
        type: {
          name: "Enum",
          allowedValues: [
            "available",
            "leased",
            "expired",
            "breaking",
            "broken"
          ]
        }
      },
      leaseStatus: {
        serializedName: "x-ms-lease-status",
        xmlName: "x-ms-lease-status",
        type: {
          name: "Enum",
          allowedValues: ["locked", "unlocked"]
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      acceptRanges: {
        serializedName: "accept-ranges",
        xmlName: "accept-ranges",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      blobCommittedBlockCount: {
        serializedName: "x-ms-blob-committed-block-count",
        xmlName: "x-ms-blob-committed-block-count",
        type: {
          name: "Number"
        }
      },
      isServerEncrypted: {
        serializedName: "x-ms-server-encrypted",
        xmlName: "x-ms-server-encrypted",
        type: {
          name: "Boolean"
        }
      },
      encryptionKeySha256: {
        serializedName: "x-ms-encryption-key-sha256",
        xmlName: "x-ms-encryption-key-sha256",
        type: {
          name: "String"
        }
      },
      encryptionScope: {
        serializedName: "x-ms-encryption-scope",
        xmlName: "x-ms-encryption-scope",
        type: {
          name: "String"
        }
      },
      blobContentMD5: {
        serializedName: "x-ms-blob-content-md5",
        xmlName: "x-ms-blob-content-md5",
        type: {
          name: "ByteArray"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      },
      contentCrc64: {
        serializedName: "x-ms-content-crc64",
        xmlName: "x-ms-content-crc64",
        type: {
          name: "ByteArray"
        }
      }
    }
  }
}, Vs = {
  serializedName: "Blob_queryExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlobQueryExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, eo = {
  serializedName: "Blob_getTagsHeaders",
  type: {
    name: "Composite",
    className: "BlobGetTagsHeaders",
    modelProperties: {
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, to = {
  serializedName: "Blob_getTagsExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlobGetTagsExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, ro = {
  serializedName: "Blob_setTagsHeaders",
  type: {
    name: "Composite",
    className: "BlobSetTagsHeaders",
    modelProperties: {
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, ao = {
  serializedName: "Blob_setTagsExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlobSetTagsExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, no = {
  serializedName: "PageBlob_createHeaders",
  type: {
    name: "Composite",
    className: "PageBlobCreateHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      contentMD5: {
        serializedName: "content-md5",
        xmlName: "content-md5",
        type: {
          name: "ByteArray"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      versionId: {
        serializedName: "x-ms-version-id",
        xmlName: "x-ms-version-id",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      isServerEncrypted: {
        serializedName: "x-ms-request-server-encrypted",
        xmlName: "x-ms-request-server-encrypted",
        type: {
          name: "Boolean"
        }
      },
      encryptionKeySha256: {
        serializedName: "x-ms-encryption-key-sha256",
        xmlName: "x-ms-encryption-key-sha256",
        type: {
          name: "String"
        }
      },
      encryptionScope: {
        serializedName: "x-ms-encryption-scope",
        xmlName: "x-ms-encryption-scope",
        type: {
          name: "String"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, io = {
  serializedName: "PageBlob_createExceptionHeaders",
  type: {
    name: "Composite",
    className: "PageBlobCreateExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, so = {
  serializedName: "PageBlob_uploadPagesHeaders",
  type: {
    name: "Composite",
    className: "PageBlobUploadPagesHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      contentMD5: {
        serializedName: "content-md5",
        xmlName: "content-md5",
        type: {
          name: "ByteArray"
        }
      },
      xMsContentCrc64: {
        serializedName: "x-ms-content-crc64",
        xmlName: "x-ms-content-crc64",
        type: {
          name: "ByteArray"
        }
      },
      blobSequenceNumber: {
        serializedName: "x-ms-blob-sequence-number",
        xmlName: "x-ms-blob-sequence-number",
        type: {
          name: "Number"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      isServerEncrypted: {
        serializedName: "x-ms-request-server-encrypted",
        xmlName: "x-ms-request-server-encrypted",
        type: {
          name: "Boolean"
        }
      },
      encryptionKeySha256: {
        serializedName: "x-ms-encryption-key-sha256",
        xmlName: "x-ms-encryption-key-sha256",
        type: {
          name: "String"
        }
      },
      encryptionScope: {
        serializedName: "x-ms-encryption-scope",
        xmlName: "x-ms-encryption-scope",
        type: {
          name: "String"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, oo = {
  serializedName: "PageBlob_uploadPagesExceptionHeaders",
  type: {
    name: "Composite",
    className: "PageBlobUploadPagesExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, mo = {
  serializedName: "PageBlob_clearPagesHeaders",
  type: {
    name: "Composite",
    className: "PageBlobClearPagesHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      contentMD5: {
        serializedName: "content-md5",
        xmlName: "content-md5",
        type: {
          name: "ByteArray"
        }
      },
      xMsContentCrc64: {
        serializedName: "x-ms-content-crc64",
        xmlName: "x-ms-content-crc64",
        type: {
          name: "ByteArray"
        }
      },
      blobSequenceNumber: {
        serializedName: "x-ms-blob-sequence-number",
        xmlName: "x-ms-blob-sequence-number",
        type: {
          name: "Number"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, lo = {
  serializedName: "PageBlob_clearPagesExceptionHeaders",
  type: {
    name: "Composite",
    className: "PageBlobClearPagesExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, co = {
  serializedName: "PageBlob_uploadPagesFromURLHeaders",
  type: {
    name: "Composite",
    className: "PageBlobUploadPagesFromURLHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      contentMD5: {
        serializedName: "content-md5",
        xmlName: "content-md5",
        type: {
          name: "ByteArray"
        }
      },
      xMsContentCrc64: {
        serializedName: "x-ms-content-crc64",
        xmlName: "x-ms-content-crc64",
        type: {
          name: "ByteArray"
        }
      },
      blobSequenceNumber: {
        serializedName: "x-ms-blob-sequence-number",
        xmlName: "x-ms-blob-sequence-number",
        type: {
          name: "Number"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      isServerEncrypted: {
        serializedName: "x-ms-request-server-encrypted",
        xmlName: "x-ms-request-server-encrypted",
        type: {
          name: "Boolean"
        }
      },
      encryptionKeySha256: {
        serializedName: "x-ms-encryption-key-sha256",
        xmlName: "x-ms-encryption-key-sha256",
        type: {
          name: "String"
        }
      },
      encryptionScope: {
        serializedName: "x-ms-encryption-scope",
        xmlName: "x-ms-encryption-scope",
        type: {
          name: "String"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, po = {
  serializedName: "PageBlob_uploadPagesFromURLExceptionHeaders",
  type: {
    name: "Composite",
    className: "PageBlobUploadPagesFromURLExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, uo = {
  serializedName: "PageBlob_getPageRangesHeaders",
  type: {
    name: "Composite",
    className: "PageBlobGetPageRangesHeaders",
    modelProperties: {
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      blobContentLength: {
        serializedName: "x-ms-blob-content-length",
        xmlName: "x-ms-blob-content-length",
        type: {
          name: "Number"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, yo = {
  serializedName: "PageBlob_getPageRangesExceptionHeaders",
  type: {
    name: "Composite",
    className: "PageBlobGetPageRangesExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, fo = {
  serializedName: "PageBlob_getPageRangesDiffHeaders",
  type: {
    name: "Composite",
    className: "PageBlobGetPageRangesDiffHeaders",
    modelProperties: {
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      blobContentLength: {
        serializedName: "x-ms-blob-content-length",
        xmlName: "x-ms-blob-content-length",
        type: {
          name: "Number"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, go = {
  serializedName: "PageBlob_getPageRangesDiffExceptionHeaders",
  type: {
    name: "Composite",
    className: "PageBlobGetPageRangesDiffExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, ho = {
  serializedName: "PageBlob_resizeHeaders",
  type: {
    name: "Composite",
    className: "PageBlobResizeHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      blobSequenceNumber: {
        serializedName: "x-ms-blob-sequence-number",
        xmlName: "x-ms-blob-sequence-number",
        type: {
          name: "Number"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, xo = {
  serializedName: "PageBlob_resizeExceptionHeaders",
  type: {
    name: "Composite",
    className: "PageBlobResizeExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, No = {
  serializedName: "PageBlob_updateSequenceNumberHeaders",
  type: {
    name: "Composite",
    className: "PageBlobUpdateSequenceNumberHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      blobSequenceNumber: {
        serializedName: "x-ms-blob-sequence-number",
        xmlName: "x-ms-blob-sequence-number",
        type: {
          name: "Number"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, bo = {
  serializedName: "PageBlob_updateSequenceNumberExceptionHeaders",
  type: {
    name: "Composite",
    className: "PageBlobUpdateSequenceNumberExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Co = {
  serializedName: "PageBlob_copyIncrementalHeaders",
  type: {
    name: "Composite",
    className: "PageBlobCopyIncrementalHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      copyId: {
        serializedName: "x-ms-copy-id",
        xmlName: "x-ms-copy-id",
        type: {
          name: "String"
        }
      },
      copyStatus: {
        serializedName: "x-ms-copy-status",
        xmlName: "x-ms-copy-status",
        type: {
          name: "Enum",
          allowedValues: ["pending", "success", "aborted", "failed"]
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Po = {
  serializedName: "PageBlob_copyIncrementalExceptionHeaders",
  type: {
    name: "Composite",
    className: "PageBlobCopyIncrementalExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, vo = {
  serializedName: "AppendBlob_createHeaders",
  type: {
    name: "Composite",
    className: "AppendBlobCreateHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      contentMD5: {
        serializedName: "content-md5",
        xmlName: "content-md5",
        type: {
          name: "ByteArray"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      versionId: {
        serializedName: "x-ms-version-id",
        xmlName: "x-ms-version-id",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      isServerEncrypted: {
        serializedName: "x-ms-request-server-encrypted",
        xmlName: "x-ms-request-server-encrypted",
        type: {
          name: "Boolean"
        }
      },
      encryptionKeySha256: {
        serializedName: "x-ms-encryption-key-sha256",
        xmlName: "x-ms-encryption-key-sha256",
        type: {
          name: "String"
        }
      },
      encryptionScope: {
        serializedName: "x-ms-encryption-scope",
        xmlName: "x-ms-encryption-scope",
        type: {
          name: "String"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, zo = {
  serializedName: "AppendBlob_createExceptionHeaders",
  type: {
    name: "Composite",
    className: "AppendBlobCreateExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, So = {
  serializedName: "AppendBlob_appendBlockHeaders",
  type: {
    name: "Composite",
    className: "AppendBlobAppendBlockHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      contentMD5: {
        serializedName: "content-md5",
        xmlName: "content-md5",
        type: {
          name: "ByteArray"
        }
      },
      xMsContentCrc64: {
        serializedName: "x-ms-content-crc64",
        xmlName: "x-ms-content-crc64",
        type: {
          name: "ByteArray"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      blobAppendOffset: {
        serializedName: "x-ms-blob-append-offset",
        xmlName: "x-ms-blob-append-offset",
        type: {
          name: "String"
        }
      },
      blobCommittedBlockCount: {
        serializedName: "x-ms-blob-committed-block-count",
        xmlName: "x-ms-blob-committed-block-count",
        type: {
          name: "Number"
        }
      },
      isServerEncrypted: {
        serializedName: "x-ms-request-server-encrypted",
        xmlName: "x-ms-request-server-encrypted",
        type: {
          name: "Boolean"
        }
      },
      encryptionKeySha256: {
        serializedName: "x-ms-encryption-key-sha256",
        xmlName: "x-ms-encryption-key-sha256",
        type: {
          name: "String"
        }
      },
      encryptionScope: {
        serializedName: "x-ms-encryption-scope",
        xmlName: "x-ms-encryption-scope",
        type: {
          name: "String"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Ro = {
  serializedName: "AppendBlob_appendBlockExceptionHeaders",
  type: {
    name: "Composite",
    className: "AppendBlobAppendBlockExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, wo = {
  serializedName: "AppendBlob_appendBlockFromUrlHeaders",
  type: {
    name: "Composite",
    className: "AppendBlobAppendBlockFromUrlHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      contentMD5: {
        serializedName: "content-md5",
        xmlName: "content-md5",
        type: {
          name: "ByteArray"
        }
      },
      xMsContentCrc64: {
        serializedName: "x-ms-content-crc64",
        xmlName: "x-ms-content-crc64",
        type: {
          name: "ByteArray"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      blobAppendOffset: {
        serializedName: "x-ms-blob-append-offset",
        xmlName: "x-ms-blob-append-offset",
        type: {
          name: "String"
        }
      },
      blobCommittedBlockCount: {
        serializedName: "x-ms-blob-committed-block-count",
        xmlName: "x-ms-blob-committed-block-count",
        type: {
          name: "Number"
        }
      },
      encryptionKeySha256: {
        serializedName: "x-ms-encryption-key-sha256",
        xmlName: "x-ms-encryption-key-sha256",
        type: {
          name: "String"
        }
      },
      encryptionScope: {
        serializedName: "x-ms-encryption-scope",
        xmlName: "x-ms-encryption-scope",
        type: {
          name: "String"
        }
      },
      isServerEncrypted: {
        serializedName: "x-ms-request-server-encrypted",
        xmlName: "x-ms-request-server-encrypted",
        type: {
          name: "Boolean"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Bo = {
  serializedName: "AppendBlob_appendBlockFromUrlExceptionHeaders",
  type: {
    name: "Composite",
    className: "AppendBlobAppendBlockFromUrlExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Eo = {
  serializedName: "AppendBlob_sealHeaders",
  type: {
    name: "Composite",
    className: "AppendBlobSealHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      isSealed: {
        serializedName: "x-ms-blob-sealed",
        xmlName: "x-ms-blob-sealed",
        type: {
          name: "Boolean"
        }
      }
    }
  }
}, To = {
  serializedName: "AppendBlob_sealExceptionHeaders",
  type: {
    name: "Composite",
    className: "AppendBlobSealExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Mo = {
  serializedName: "BlockBlob_uploadHeaders",
  type: {
    name: "Composite",
    className: "BlockBlobUploadHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      contentMD5: {
        serializedName: "content-md5",
        xmlName: "content-md5",
        type: {
          name: "ByteArray"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      versionId: {
        serializedName: "x-ms-version-id",
        xmlName: "x-ms-version-id",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      isServerEncrypted: {
        serializedName: "x-ms-request-server-encrypted",
        xmlName: "x-ms-request-server-encrypted",
        type: {
          name: "Boolean"
        }
      },
      encryptionKeySha256: {
        serializedName: "x-ms-encryption-key-sha256",
        xmlName: "x-ms-encryption-key-sha256",
        type: {
          name: "String"
        }
      },
      encryptionScope: {
        serializedName: "x-ms-encryption-scope",
        xmlName: "x-ms-encryption-scope",
        type: {
          name: "String"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Io = {
  serializedName: "BlockBlob_uploadExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlockBlobUploadExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, qo = {
  serializedName: "BlockBlob_putBlobFromUrlHeaders",
  type: {
    name: "Composite",
    className: "BlockBlobPutBlobFromUrlHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      contentMD5: {
        serializedName: "content-md5",
        xmlName: "content-md5",
        type: {
          name: "ByteArray"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      versionId: {
        serializedName: "x-ms-version-id",
        xmlName: "x-ms-version-id",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      isServerEncrypted: {
        serializedName: "x-ms-request-server-encrypted",
        xmlName: "x-ms-request-server-encrypted",
        type: {
          name: "Boolean"
        }
      },
      encryptionKeySha256: {
        serializedName: "x-ms-encryption-key-sha256",
        xmlName: "x-ms-encryption-key-sha256",
        type: {
          name: "String"
        }
      },
      encryptionScope: {
        serializedName: "x-ms-encryption-scope",
        xmlName: "x-ms-encryption-scope",
        type: {
          name: "String"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Oo = {
  serializedName: "BlockBlob_putBlobFromUrlExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlockBlobPutBlobFromUrlExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, _o = {
  serializedName: "BlockBlob_stageBlockHeaders",
  type: {
    name: "Composite",
    className: "BlockBlobStageBlockHeaders",
    modelProperties: {
      contentMD5: {
        serializedName: "content-md5",
        xmlName: "content-md5",
        type: {
          name: "ByteArray"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      xMsContentCrc64: {
        serializedName: "x-ms-content-crc64",
        xmlName: "x-ms-content-crc64",
        type: {
          name: "ByteArray"
        }
      },
      isServerEncrypted: {
        serializedName: "x-ms-request-server-encrypted",
        xmlName: "x-ms-request-server-encrypted",
        type: {
          name: "Boolean"
        }
      },
      encryptionKeySha256: {
        serializedName: "x-ms-encryption-key-sha256",
        xmlName: "x-ms-encryption-key-sha256",
        type: {
          name: "String"
        }
      },
      encryptionScope: {
        serializedName: "x-ms-encryption-scope",
        xmlName: "x-ms-encryption-scope",
        type: {
          name: "String"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Ho = {
  serializedName: "BlockBlob_stageBlockExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlockBlobStageBlockExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Do = {
  serializedName: "BlockBlob_stageBlockFromURLHeaders",
  type: {
    name: "Composite",
    className: "BlockBlobStageBlockFromURLHeaders",
    modelProperties: {
      contentMD5: {
        serializedName: "content-md5",
        xmlName: "content-md5",
        type: {
          name: "ByteArray"
        }
      },
      xMsContentCrc64: {
        serializedName: "x-ms-content-crc64",
        xmlName: "x-ms-content-crc64",
        type: {
          name: "ByteArray"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      isServerEncrypted: {
        serializedName: "x-ms-request-server-encrypted",
        xmlName: "x-ms-request-server-encrypted",
        type: {
          name: "Boolean"
        }
      },
      encryptionKeySha256: {
        serializedName: "x-ms-encryption-key-sha256",
        xmlName: "x-ms-encryption-key-sha256",
        type: {
          name: "String"
        }
      },
      encryptionScope: {
        serializedName: "x-ms-encryption-scope",
        xmlName: "x-ms-encryption-scope",
        type: {
          name: "String"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Lo = {
  serializedName: "BlockBlob_stageBlockFromURLExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlockBlobStageBlockFromURLExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, ko = {
  serializedName: "BlockBlob_commitBlockListHeaders",
  type: {
    name: "Composite",
    className: "BlockBlobCommitBlockListHeaders",
    modelProperties: {
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      contentMD5: {
        serializedName: "content-md5",
        xmlName: "content-md5",
        type: {
          name: "ByteArray"
        }
      },
      xMsContentCrc64: {
        serializedName: "x-ms-content-crc64",
        xmlName: "x-ms-content-crc64",
        type: {
          name: "ByteArray"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      versionId: {
        serializedName: "x-ms-version-id",
        xmlName: "x-ms-version-id",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      isServerEncrypted: {
        serializedName: "x-ms-request-server-encrypted",
        xmlName: "x-ms-request-server-encrypted",
        type: {
          name: "Boolean"
        }
      },
      encryptionKeySha256: {
        serializedName: "x-ms-encryption-key-sha256",
        xmlName: "x-ms-encryption-key-sha256",
        type: {
          name: "String"
        }
      },
      encryptionScope: {
        serializedName: "x-ms-encryption-scope",
        xmlName: "x-ms-encryption-scope",
        type: {
          name: "String"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Ao = {
  serializedName: "BlockBlob_commitBlockListExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlockBlobCommitBlockListExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, Uo = {
  serializedName: "BlockBlob_getBlockListHeaders",
  type: {
    name: "Composite",
    className: "BlockBlobGetBlockListHeaders",
    modelProperties: {
      lastModified: {
        serializedName: "last-modified",
        xmlName: "last-modified",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      etag: {
        serializedName: "etag",
        xmlName: "etag",
        type: {
          name: "String"
        }
      },
      contentType: {
        serializedName: "content-type",
        xmlName: "content-type",
        type: {
          name: "String"
        }
      },
      blobContentLength: {
        serializedName: "x-ms-blob-content-length",
        xmlName: "x-ms-blob-content-length",
        type: {
          name: "Number"
        }
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String"
        }
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123"
        }
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, $o = {
  serializedName: "BlockBlob_getBlockListExceptionHeaders",
  type: {
    name: "Composite",
    className: "BlockBlobGetBlockListExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String"
        }
      }
    }
  }
}, rt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AccessPolicy: Pu,
  AppendBlobAppendBlockExceptionHeaders: Ro,
  AppendBlobAppendBlockFromUrlExceptionHeaders: Bo,
  AppendBlobAppendBlockFromUrlHeaders: wo,
  AppendBlobAppendBlockHeaders: So,
  AppendBlobCreateExceptionHeaders: zo,
  AppendBlobCreateHeaders: vo,
  AppendBlobSealExceptionHeaders: To,
  AppendBlobSealHeaders: Eo,
  ArrowConfiguration: Hu,
  ArrowField: Du,
  BlobAbortCopyFromURLExceptionHeaders: Qs,
  BlobAbortCopyFromURLHeaders: Ws,
  BlobAcquireLeaseExceptionHeaders: qs,
  BlobAcquireLeaseHeaders: Is,
  BlobBreakLeaseExceptionHeaders: Us,
  BlobBreakLeaseHeaders: As,
  BlobChangeLeaseExceptionHeaders: ks,
  BlobChangeLeaseHeaders: Ls,
  BlobCopyFromURLExceptionHeaders: Xs,
  BlobCopyFromURLHeaders: Gs,
  BlobCreateSnapshotExceptionHeaders: js,
  BlobCreateSnapshotHeaders: $s,
  BlobDeleteExceptionHeaders: hs,
  BlobDeleteHeaders: gs,
  BlobDeleteImmutabilityPolicyExceptionHeaders: ws,
  BlobDeleteImmutabilityPolicyHeaders: Rs,
  BlobDownloadExceptionHeaders: us,
  BlobDownloadHeaders: Lr,
  BlobFlatListSegment: vu,
  BlobGetAccountInfoExceptionHeaders: Zs,
  BlobGetAccountInfoHeaders: Ys,
  BlobGetPropertiesExceptionHeaders: fs,
  BlobGetPropertiesHeaders: ys,
  BlobGetTagsExceptionHeaders: to,
  BlobGetTagsHeaders: eo,
  BlobHierarchyListSegment: wu,
  BlobItemInternal: zu,
  BlobName: Su,
  BlobPrefix: Bu,
  BlobPropertiesInternal: Ru,
  BlobQueryExceptionHeaders: Vs,
  BlobQueryHeaders: Ar,
  BlobReleaseLeaseExceptionHeaders: _s,
  BlobReleaseLeaseHeaders: Os,
  BlobRenewLeaseExceptionHeaders: Ds,
  BlobRenewLeaseHeaders: Hs,
  BlobServiceProperties: sa,
  BlobServiceStatistics: si,
  BlobSetExpiryExceptionHeaders: Cs,
  BlobSetExpiryHeaders: bs,
  BlobSetHttpHeadersExceptionHeaders: vs,
  BlobSetHttpHeadersHeaders: Ps,
  BlobSetImmutabilityPolicyExceptionHeaders: Ss,
  BlobSetImmutabilityPolicyHeaders: zs,
  BlobSetLegalHoldExceptionHeaders: Es,
  BlobSetLegalHoldHeaders: Bs,
  BlobSetMetadataExceptionHeaders: Ms,
  BlobSetMetadataHeaders: Ts,
  BlobSetTagsExceptionHeaders: ao,
  BlobSetTagsHeaders: ro,
  BlobSetTierExceptionHeaders: Js,
  BlobSetTierHeaders: kr,
  BlobStartCopyFromURLExceptionHeaders: Ks,
  BlobStartCopyFromURLHeaders: Fs,
  BlobTag: bu,
  BlobTags: ma,
  BlobUndeleteExceptionHeaders: Ns,
  BlobUndeleteHeaders: xs,
  Block: Eu,
  BlockBlobCommitBlockListExceptionHeaders: Ao,
  BlockBlobCommitBlockListHeaders: ko,
  BlockBlobGetBlockListExceptionHeaders: $o,
  BlockBlobGetBlockListHeaders: Uo,
  BlockBlobPutBlobFromUrlExceptionHeaders: Oo,
  BlockBlobPutBlobFromUrlHeaders: qo,
  BlockBlobStageBlockExceptionHeaders: Ho,
  BlockBlobStageBlockFromURLExceptionHeaders: Lo,
  BlockBlobStageBlockFromURLHeaders: Do,
  BlockBlobStageBlockHeaders: _o,
  BlockBlobUploadExceptionHeaders: Io,
  BlockBlobUploadHeaders: Mo,
  BlockList: ui,
  BlockLookupList: pi,
  ClearRange: Mu,
  ContainerAcquireLeaseExceptionHeaders: Zi,
  ContainerAcquireLeaseHeaders: Yi,
  ContainerBreakLeaseExceptionHeaders: ns,
  ContainerBreakLeaseHeaders: as,
  ContainerChangeLeaseExceptionHeaders: ss,
  ContainerChangeLeaseHeaders: is,
  ContainerCreateExceptionHeaders: Ii,
  ContainerCreateHeaders: Mi,
  ContainerDeleteExceptionHeaders: Hi,
  ContainerDeleteHeaders: _i,
  ContainerFilterBlobsExceptionHeaders: Ji,
  ContainerFilterBlobsHeaders: Qi,
  ContainerGetAccessPolicyExceptionHeaders: Ai,
  ContainerGetAccessPolicyHeaders: ki,
  ContainerGetAccountInfoExceptionHeaders: ps,
  ContainerGetAccountInfoHeaders: ds,
  ContainerGetPropertiesExceptionHeaders: Oi,
  ContainerGetPropertiesHeaders: qi,
  ContainerItem: hu,
  ContainerListBlobFlatSegmentExceptionHeaders: ms,
  ContainerListBlobFlatSegmentHeaders: os,
  ContainerListBlobHierarchySegmentExceptionHeaders: cs,
  ContainerListBlobHierarchySegmentHeaders: ls,
  ContainerProperties: xu,
  ContainerReleaseLeaseExceptionHeaders: es,
  ContainerReleaseLeaseHeaders: Vi,
  ContainerRenameExceptionHeaders: Gi,
  ContainerRenameHeaders: Ki,
  ContainerRenewLeaseExceptionHeaders: rs,
  ContainerRenewLeaseHeaders: ts,
  ContainerRestoreExceptionHeaders: Fi,
  ContainerRestoreHeaders: ji,
  ContainerSetAccessPolicyExceptionHeaders: $i,
  ContainerSetAccessPolicyHeaders: Ui,
  ContainerSetMetadataExceptionHeaders: Li,
  ContainerSetMetadataHeaders: Di,
  ContainerSubmitBatchExceptionHeaders: Wi,
  ContainerSubmitBatchHeaders: Xi,
  CorsRule: yu,
  DelimitedTextConfiguration: Ou,
  FilterBlobItem: Nu,
  FilterBlobSegment: oa,
  GeoReplication: gu,
  JsonTextConfiguration: _u,
  KeyInfo: mi,
  ListBlobsFlatSegmentResponse: ci,
  ListBlobsHierarchySegmentResponse: di,
  ListContainersSegmentResponse: oi,
  Logging: du,
  Metrics: uu,
  PageBlobClearPagesExceptionHeaders: lo,
  PageBlobClearPagesHeaders: mo,
  PageBlobCopyIncrementalExceptionHeaders: Po,
  PageBlobCopyIncrementalHeaders: Co,
  PageBlobCreateExceptionHeaders: io,
  PageBlobCreateHeaders: no,
  PageBlobGetPageRangesDiffExceptionHeaders: go,
  PageBlobGetPageRangesDiffHeaders: fo,
  PageBlobGetPageRangesExceptionHeaders: yo,
  PageBlobGetPageRangesHeaders: uo,
  PageBlobResizeExceptionHeaders: xo,
  PageBlobResizeHeaders: ho,
  PageBlobUpdateSequenceNumberExceptionHeaders: bo,
  PageBlobUpdateSequenceNumberHeaders: No,
  PageBlobUploadPagesExceptionHeaders: oo,
  PageBlobUploadPagesFromURLExceptionHeaders: po,
  PageBlobUploadPagesFromURLHeaders: co,
  PageBlobUploadPagesHeaders: so,
  PageList: la,
  PageRange: Tu,
  QueryFormat: qu,
  QueryRequest: yi,
  QuerySerialization: Iu,
  RetentionPolicy: pu,
  ServiceFilterBlobsExceptionHeaders: Ti,
  ServiceFilterBlobsHeaders: Ei,
  ServiceGetAccountInfoExceptionHeaders: Ri,
  ServiceGetAccountInfoHeaders: Si,
  ServiceGetPropertiesExceptionHeaders: xi,
  ServiceGetPropertiesHeaders: hi,
  ServiceGetStatisticsExceptionHeaders: bi,
  ServiceGetStatisticsHeaders: Ni,
  ServiceGetUserDelegationKeyExceptionHeaders: zi,
  ServiceGetUserDelegationKeyHeaders: vi,
  ServiceListContainersSegmentExceptionHeaders: Pi,
  ServiceListContainersSegmentHeaders: Ci,
  ServiceSetPropertiesExceptionHeaders: gi,
  ServiceSetPropertiesHeaders: fi,
  ServiceSubmitBatchExceptionHeaders: Bi,
  ServiceSubmitBatchHeaders: wi,
  SignedIdentifier: Cu,
  StaticWebsite: fu,
  StorageError: b,
  UserDelegationKey: li
}, Symbol.toStringTag, { value: "Module" })), at = {
  parameterPath: ["options", "contentType"],
  mapper: {
    defaultValue: "application/xml",
    isConstant: !0,
    serializedName: "Content-Type",
    type: {
      name: "String"
    }
  }
}, Lu = {
  parameterPath: "blobServiceProperties",
  mapper: sa
}, Re = {
  parameterPath: "accept",
  mapper: {
    defaultValue: "application/xml",
    isConstant: !0,
    serializedName: "Accept",
    type: {
      name: "String"
    }
  }
}, P = {
  parameterPath: "url",
  mapper: {
    serializedName: "url",
    required: !0,
    xmlName: "url",
    type: {
      name: "String"
    }
  },
  skipEncoding: !0
}, or = {
  parameterPath: "restype",
  mapper: {
    defaultValue: "service",
    isConstant: !0,
    serializedName: "restype",
    type: {
      name: "String"
    }
  }
}, we = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "properties",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, v = {
  parameterPath: ["options", "timeoutInSeconds"],
  mapper: {
    constraints: {
      InclusiveMinimum: 0
    },
    serializedName: "timeout",
    xmlName: "timeout",
    type: {
      name: "Number"
    }
  }
}, z = {
  parameterPath: "version",
  mapper: {
    defaultValue: "2025-05-05",
    isConstant: !0,
    serializedName: "x-ms-version",
    type: {
      name: "String"
    }
  }
}, S = {
  parameterPath: ["options", "requestId"],
  mapper: {
    serializedName: "x-ms-client-request-id",
    xmlName: "x-ms-client-request-id",
    type: {
      name: "String"
    }
  }
}, B = {
  parameterPath: "accept",
  mapper: {
    defaultValue: "application/xml",
    isConstant: !0,
    serializedName: "Accept",
    type: {
      name: "String"
    }
  }
}, ku = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "stats",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, ca = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "list",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, da = {
  parameterPath: ["options", "prefix"],
  mapper: {
    serializedName: "prefix",
    xmlName: "prefix",
    type: {
      name: "String"
    }
  }
}, He = {
  parameterPath: ["options", "marker"],
  mapper: {
    serializedName: "marker",
    xmlName: "marker",
    type: {
      name: "String"
    }
  }
}, De = {
  parameterPath: ["options", "maxPageSize"],
  mapper: {
    constraints: {
      InclusiveMinimum: 1
    },
    serializedName: "maxresults",
    xmlName: "maxresults",
    type: {
      name: "Number"
    }
  }
}, Au = {
  parameterPath: ["options", "include"],
  mapper: {
    serializedName: "include",
    xmlName: "include",
    xmlElementName: "ListContainersIncludeType",
    type: {
      name: "Sequence",
      element: {
        type: {
          name: "Enum",
          allowedValues: ["metadata", "deleted", "system"]
        }
      }
    }
  },
  collectionFormat: "CSV"
}, Uu = {
  parameterPath: "keyInfo",
  mapper: mi
}, $u = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "userdelegationkey",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, pa = {
  parameterPath: "restype",
  mapper: {
    defaultValue: "account",
    isConstant: !0,
    serializedName: "restype",
    type: {
      name: "String"
    }
  }
}, jo = {
  parameterPath: "body",
  mapper: {
    serializedName: "body",
    required: !0,
    xmlName: "body",
    type: {
      name: "Stream"
    }
  }
}, Fo = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "batch",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, me = {
  parameterPath: "contentLength",
  mapper: {
    serializedName: "Content-Length",
    required: !0,
    xmlName: "Content-Length",
    type: {
      name: "Number"
    }
  }
}, Ko = {
  parameterPath: "multipartContentType",
  mapper: {
    serializedName: "Content-Type",
    required: !0,
    xmlName: "Content-Type",
    type: {
      name: "String"
    }
  }
}, Go = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "blobs",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, Xo = {
  parameterPath: ["options", "where"],
  mapper: {
    serializedName: "where",
    xmlName: "where",
    type: {
      name: "String"
    }
  }
}, re = {
  parameterPath: "restype",
  mapper: {
    defaultValue: "container",
    isConstant: !0,
    serializedName: "restype",
    type: {
      name: "String"
    }
  }
}, ue = {
  parameterPath: ["options", "metadata"],
  mapper: {
    serializedName: "x-ms-meta",
    xmlName: "x-ms-meta",
    headerCollectionPrefix: "x-ms-meta-",
    type: {
      name: "Dictionary",
      value: { type: { name: "String" } }
    }
  }
}, Wo = {
  parameterPath: ["options", "access"],
  mapper: {
    serializedName: "x-ms-blob-public-access",
    xmlName: "x-ms-blob-public-access",
    type: {
      name: "Enum",
      allowedValues: ["container", "blob"]
    }
  }
}, ju = {
  parameterPath: [
    "options",
    "containerEncryptionScope",
    "defaultEncryptionScope"
  ],
  mapper: {
    serializedName: "x-ms-default-encryption-scope",
    xmlName: "x-ms-default-encryption-scope",
    type: {
      name: "String"
    }
  }
}, Fu = {
  parameterPath: [
    "options",
    "containerEncryptionScope",
    "preventEncryptionScopeOverride"
  ],
  mapper: {
    serializedName: "x-ms-deny-encryption-scope-override",
    xmlName: "x-ms-deny-encryption-scope-override",
    type: {
      name: "Boolean"
    }
  }
}, D = {
  parameterPath: ["options", "leaseAccessConditions", "leaseId"],
  mapper: {
    serializedName: "x-ms-lease-id",
    xmlName: "x-ms-lease-id",
    type: {
      name: "String"
    }
  }
}, _ = {
  parameterPath: ["options", "modifiedAccessConditions", "ifModifiedSince"],
  mapper: {
    serializedName: "If-Modified-Since",
    xmlName: "If-Modified-Since",
    type: {
      name: "DateTimeRfc1123"
    }
  }
}, H = {
  parameterPath: ["options", "modifiedAccessConditions", "ifUnmodifiedSince"],
  mapper: {
    serializedName: "If-Unmodified-Since",
    xmlName: "If-Unmodified-Since",
    type: {
      name: "DateTimeRfc1123"
    }
  }
}, Qo = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "metadata",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, Jo = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "acl",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, Ku = {
  parameterPath: ["options", "containerAcl"],
  mapper: {
    serializedName: "containerAcl",
    xmlName: "SignedIdentifiers",
    xmlIsWrapped: !0,
    xmlElementName: "SignedIdentifier",
    type: {
      name: "Sequence",
      element: {
        type: {
          name: "Composite",
          className: "SignedIdentifier"
        }
      }
    }
  }
}, Yo = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "undelete",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, Gu = {
  parameterPath: ["options", "deletedContainerName"],
  mapper: {
    serializedName: "x-ms-deleted-container-name",
    xmlName: "x-ms-deleted-container-name",
    type: {
      name: "String"
    }
  }
}, Xu = {
  parameterPath: ["options", "deletedContainerVersion"],
  mapper: {
    serializedName: "x-ms-deleted-container-version",
    xmlName: "x-ms-deleted-container-version",
    type: {
      name: "String"
    }
  }
}, Wu = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "rename",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, Qu = {
  parameterPath: "sourceContainerName",
  mapper: {
    serializedName: "x-ms-source-container-name",
    required: !0,
    xmlName: "x-ms-source-container-name",
    type: {
      name: "String"
    }
  }
}, Ju = {
  parameterPath: ["options", "sourceLeaseId"],
  mapper: {
    serializedName: "x-ms-source-lease-id",
    xmlName: "x-ms-source-lease-id",
    type: {
      name: "String"
    }
  }
}, ge = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "lease",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, Zo = {
  parameterPath: "action",
  mapper: {
    defaultValue: "acquire",
    isConstant: !0,
    serializedName: "x-ms-lease-action",
    type: {
      name: "String"
    }
  }
}, Vo = {
  parameterPath: ["options", "duration"],
  mapper: {
    serializedName: "x-ms-lease-duration",
    xmlName: "x-ms-lease-duration",
    type: {
      name: "Number"
    }
  }
}, em = {
  parameterPath: ["options", "proposedLeaseId"],
  mapper: {
    serializedName: "x-ms-proposed-lease-id",
    xmlName: "x-ms-proposed-lease-id",
    type: {
      name: "String"
    }
  }
}, tm = {
  parameterPath: "action",
  mapper: {
    defaultValue: "release",
    isConstant: !0,
    serializedName: "x-ms-lease-action",
    type: {
      name: "String"
    }
  }
}, nt = {
  parameterPath: "leaseId",
  mapper: {
    serializedName: "x-ms-lease-id",
    required: !0,
    xmlName: "x-ms-lease-id",
    type: {
      name: "String"
    }
  }
}, rm = {
  parameterPath: "action",
  mapper: {
    defaultValue: "renew",
    isConstant: !0,
    serializedName: "x-ms-lease-action",
    type: {
      name: "String"
    }
  }
}, am = {
  parameterPath: "action",
  mapper: {
    defaultValue: "break",
    isConstant: !0,
    serializedName: "x-ms-lease-action",
    type: {
      name: "String"
    }
  }
}, nm = {
  parameterPath: ["options", "breakPeriod"],
  mapper: {
    serializedName: "x-ms-lease-break-period",
    xmlName: "x-ms-lease-break-period",
    type: {
      name: "Number"
    }
  }
}, im = {
  parameterPath: "action",
  mapper: {
    defaultValue: "change",
    isConstant: !0,
    serializedName: "x-ms-lease-action",
    type: {
      name: "String"
    }
  }
}, sm = {
  parameterPath: "proposedLeaseId",
  mapper: {
    serializedName: "x-ms-proposed-lease-id",
    required: !0,
    xmlName: "x-ms-proposed-lease-id",
    type: {
      name: "String"
    }
  }
}, om = {
  parameterPath: ["options", "include"],
  mapper: {
    serializedName: "include",
    xmlName: "include",
    xmlElementName: "ListBlobsIncludeItem",
    type: {
      name: "Sequence",
      element: {
        type: {
          name: "Enum",
          allowedValues: [
            "copy",
            "deleted",
            "metadata",
            "snapshots",
            "uncommittedblobs",
            "versions",
            "tags",
            "immutabilitypolicy",
            "legalhold",
            "deletedwithversions"
          ]
        }
      }
    }
  },
  collectionFormat: "CSV"
}, Yu = {
  parameterPath: "delimiter",
  mapper: {
    serializedName: "delimiter",
    required: !0,
    xmlName: "delimiter",
    type: {
      name: "String"
    }
  }
}, ce = {
  parameterPath: ["options", "snapshot"],
  mapper: {
    serializedName: "snapshot",
    xmlName: "snapshot",
    type: {
      name: "String"
    }
  }
}, Pe = {
  parameterPath: ["options", "versionId"],
  mapper: {
    serializedName: "versionid",
    xmlName: "versionid",
    type: {
      name: "String"
    }
  }
}, Ut = {
  parameterPath: ["options", "range"],
  mapper: {
    serializedName: "x-ms-range",
    xmlName: "x-ms-range",
    type: {
      name: "String"
    }
  }
}, Zu = {
  parameterPath: ["options", "rangeGetContentMD5"],
  mapper: {
    serializedName: "x-ms-range-get-content-md5",
    xmlName: "x-ms-range-get-content-md5",
    type: {
      name: "Boolean"
    }
  }
}, Vu = {
  parameterPath: ["options", "rangeGetContentCRC64"],
  mapper: {
    serializedName: "x-ms-range-get-content-crc64",
    xmlName: "x-ms-range-get-content-crc64",
    type: {
      name: "Boolean"
    }
  }
}, Y = {
  parameterPath: ["options", "cpkInfo", "encryptionKey"],
  mapper: {
    serializedName: "x-ms-encryption-key",
    xmlName: "x-ms-encryption-key",
    type: {
      name: "String"
    }
  }
}, Z = {
  parameterPath: ["options", "cpkInfo", "encryptionKeySha256"],
  mapper: {
    serializedName: "x-ms-encryption-key-sha256",
    xmlName: "x-ms-encryption-key-sha256",
    type: {
      name: "String"
    }
  }
}, V = {
  parameterPath: ["options", "cpkInfo", "encryptionAlgorithm"],
  mapper: {
    serializedName: "x-ms-encryption-algorithm",
    xmlName: "x-ms-encryption-algorithm",
    type: {
      name: "String"
    }
  }
}, A = {
  parameterPath: ["options", "modifiedAccessConditions", "ifMatch"],
  mapper: {
    serializedName: "If-Match",
    xmlName: "If-Match",
    type: {
      name: "String"
    }
  }
}, U = {
  parameterPath: ["options", "modifiedAccessConditions", "ifNoneMatch"],
  mapper: {
    serializedName: "If-None-Match",
    xmlName: "If-None-Match",
    type: {
      name: "String"
    }
  }
}, L = {
  parameterPath: ["options", "modifiedAccessConditions", "ifTags"],
  mapper: {
    serializedName: "x-ms-if-tags",
    xmlName: "x-ms-if-tags",
    type: {
      name: "String"
    }
  }
}, ey = {
  parameterPath: ["options", "deleteSnapshots"],
  mapper: {
    serializedName: "x-ms-delete-snapshots",
    xmlName: "x-ms-delete-snapshots",
    type: {
      name: "Enum",
      allowedValues: ["include", "only"]
    }
  }
}, ty = {
  parameterPath: ["options", "blobDeleteType"],
  mapper: {
    serializedName: "deletetype",
    xmlName: "deletetype",
    type: {
      name: "String"
    }
  }
}, ry = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "expiry",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, ay = {
  parameterPath: "expiryOptions",
  mapper: {
    serializedName: "x-ms-expiry-option",
    required: !0,
    xmlName: "x-ms-expiry-option",
    type: {
      name: "String"
    }
  }
}, ny = {
  parameterPath: ["options", "expiresOn"],
  mapper: {
    serializedName: "x-ms-expiry-time",
    xmlName: "x-ms-expiry-time",
    type: {
      name: "String"
    }
  }
}, it = {
  parameterPath: ["options", "blobHttpHeaders", "blobCacheControl"],
  mapper: {
    serializedName: "x-ms-blob-cache-control",
    xmlName: "x-ms-blob-cache-control",
    type: {
      name: "String"
    }
  }
}, st = {
  parameterPath: ["options", "blobHttpHeaders", "blobContentType"],
  mapper: {
    serializedName: "x-ms-blob-content-type",
    xmlName: "x-ms-blob-content-type",
    type: {
      name: "String"
    }
  }
}, ot = {
  parameterPath: ["options", "blobHttpHeaders", "blobContentMD5"],
  mapper: {
    serializedName: "x-ms-blob-content-md5",
    xmlName: "x-ms-blob-content-md5",
    type: {
      name: "ByteArray"
    }
  }
}, mt = {
  parameterPath: ["options", "blobHttpHeaders", "blobContentEncoding"],
  mapper: {
    serializedName: "x-ms-blob-content-encoding",
    xmlName: "x-ms-blob-content-encoding",
    type: {
      name: "String"
    }
  }
}, lt = {
  parameterPath: ["options", "blobHttpHeaders", "blobContentLanguage"],
  mapper: {
    serializedName: "x-ms-blob-content-language",
    xmlName: "x-ms-blob-content-language",
    type: {
      name: "String"
    }
  }
}, ct = {
  parameterPath: ["options", "blobHttpHeaders", "blobContentDisposition"],
  mapper: {
    serializedName: "x-ms-blob-content-disposition",
    xmlName: "x-ms-blob-content-disposition",
    type: {
      name: "String"
    }
  }
}, mm = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "immutabilityPolicies",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, Le = {
  parameterPath: ["options", "immutabilityPolicyExpiry"],
  mapper: {
    serializedName: "x-ms-immutability-policy-until-date",
    xmlName: "x-ms-immutability-policy-until-date",
    type: {
      name: "DateTimeRfc1123"
    }
  }
}, ke = {
  parameterPath: ["options", "immutabilityPolicyMode"],
  mapper: {
    serializedName: "x-ms-immutability-policy-mode",
    xmlName: "x-ms-immutability-policy-mode",
    type: {
      name: "Enum",
      allowedValues: ["Mutable", "Unlocked", "Locked"]
    }
  }
}, iy = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "legalhold",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, sy = {
  parameterPath: "legalHold",
  mapper: {
    serializedName: "x-ms-legal-hold",
    required: !0,
    xmlName: "x-ms-legal-hold",
    type: {
      name: "Boolean"
    }
  }
}, ae = {
  parameterPath: ["options", "encryptionScope"],
  mapper: {
    serializedName: "x-ms-encryption-scope",
    xmlName: "x-ms-encryption-scope",
    type: {
      name: "String"
    }
  }
}, oy = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "snapshot",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, dt = {
  parameterPath: ["options", "tier"],
  mapper: {
    serializedName: "x-ms-access-tier",
    xmlName: "x-ms-access-tier",
    type: {
      name: "Enum",
      allowedValues: [
        "P4",
        "P6",
        "P10",
        "P15",
        "P20",
        "P30",
        "P40",
        "P50",
        "P60",
        "P70",
        "P80",
        "Hot",
        "Cool",
        "Archive",
        "Cold"
      ]
    }
  }
}, lm = {
  parameterPath: ["options", "rehydratePriority"],
  mapper: {
    serializedName: "x-ms-rehydrate-priority",
    xmlName: "x-ms-rehydrate-priority",
    type: {
      name: "Enum",
      allowedValues: ["High", "Standard"]
    }
  }
}, pt = {
  parameterPath: [
    "options",
    "sourceModifiedAccessConditions",
    "sourceIfModifiedSince"
  ],
  mapper: {
    serializedName: "x-ms-source-if-modified-since",
    xmlName: "x-ms-source-if-modified-since",
    type: {
      name: "DateTimeRfc1123"
    }
  }
}, ut = {
  parameterPath: [
    "options",
    "sourceModifiedAccessConditions",
    "sourceIfUnmodifiedSince"
  ],
  mapper: {
    serializedName: "x-ms-source-if-unmodified-since",
    xmlName: "x-ms-source-if-unmodified-since",
    type: {
      name: "DateTimeRfc1123"
    }
  }
}, yt = {
  parameterPath: ["options", "sourceModifiedAccessConditions", "sourceIfMatch"],
  mapper: {
    serializedName: "x-ms-source-if-match",
    xmlName: "x-ms-source-if-match",
    type: {
      name: "String"
    }
  }
}, ft = {
  parameterPath: [
    "options",
    "sourceModifiedAccessConditions",
    "sourceIfNoneMatch"
  ],
  mapper: {
    serializedName: "x-ms-source-if-none-match",
    xmlName: "x-ms-source-if-none-match",
    type: {
      name: "String"
    }
  }
}, cm = {
  parameterPath: ["options", "sourceModifiedAccessConditions", "sourceIfTags"],
  mapper: {
    serializedName: "x-ms-source-if-tags",
    xmlName: "x-ms-source-if-tags",
    type: {
      name: "String"
    }
  }
}, mr = {
  parameterPath: "copySource",
  mapper: {
    serializedName: "x-ms-copy-source",
    required: !0,
    xmlName: "x-ms-copy-source",
    type: {
      name: "String"
    }
  }
}, Ae = {
  parameterPath: ["options", "blobTagsString"],
  mapper: {
    serializedName: "x-ms-tags",
    xmlName: "x-ms-tags",
    type: {
      name: "String"
    }
  }
}, my = {
  parameterPath: ["options", "sealBlob"],
  mapper: {
    serializedName: "x-ms-seal-blob",
    xmlName: "x-ms-seal-blob",
    type: {
      name: "Boolean"
    }
  }
}, gt = {
  parameterPath: ["options", "legalHold"],
  mapper: {
    serializedName: "x-ms-legal-hold",
    xmlName: "x-ms-legal-hold",
    type: {
      name: "Boolean"
    }
  }
}, ly = {
  parameterPath: "xMsRequiresSync",
  mapper: {
    defaultValue: "true",
    isConstant: !0,
    serializedName: "x-ms-requires-sync",
    type: {
      name: "String"
    }
  }
}, $t = {
  parameterPath: ["options", "sourceContentMD5"],
  mapper: {
    serializedName: "x-ms-source-content-md5",
    xmlName: "x-ms-source-content-md5",
    type: {
      name: "ByteArray"
    }
  }
}, jt = {
  parameterPath: ["options", "copySourceAuthorization"],
  mapper: {
    serializedName: "x-ms-copy-source-authorization",
    xmlName: "x-ms-copy-source-authorization",
    type: {
      name: "String"
    }
  }
}, dm = {
  parameterPath: ["options", "copySourceTags"],
  mapper: {
    serializedName: "x-ms-copy-source-tag-option",
    xmlName: "x-ms-copy-source-tag-option",
    type: {
      name: "Enum",
      allowedValues: ["REPLACE", "COPY"]
    }
  }
}, cy = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "copy",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, dy = {
  parameterPath: "copyActionAbortConstant",
  mapper: {
    defaultValue: "abort",
    isConstant: !0,
    serializedName: "x-ms-copy-action",
    type: {
      name: "String"
    }
  }
}, py = {
  parameterPath: "copyId",
  mapper: {
    serializedName: "copyid",
    required: !0,
    xmlName: "copyid",
    type: {
      name: "String"
    }
  }
}, uy = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "tier",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, yy = {
  parameterPath: "tier",
  mapper: {
    serializedName: "x-ms-access-tier",
    required: !0,
    xmlName: "x-ms-access-tier",
    type: {
      name: "Enum",
      allowedValues: [
        "P4",
        "P6",
        "P10",
        "P15",
        "P20",
        "P30",
        "P40",
        "P50",
        "P60",
        "P70",
        "P80",
        "Hot",
        "Cool",
        "Archive",
        "Cold"
      ]
    }
  }
}, fy = {
  parameterPath: ["options", "queryRequest"],
  mapper: yi
}, gy = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "query",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, pm = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "tags",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, hy = {
  parameterPath: ["options", "tags"],
  mapper: ma
}, Be = {
  parameterPath: ["options", "transactionalContentMD5"],
  mapper: {
    serializedName: "Content-MD5",
    xmlName: "Content-MD5",
    type: {
      name: "ByteArray"
    }
  }
}, ht = {
  parameterPath: ["options", "transactionalContentCrc64"],
  mapper: {
    serializedName: "x-ms-content-crc64",
    xmlName: "x-ms-content-crc64",
    type: {
      name: "ByteArray"
    }
  }
}, xy = {
  parameterPath: "blobType",
  mapper: {
    defaultValue: "PageBlob",
    isConstant: !0,
    serializedName: "x-ms-blob-type",
    type: {
      name: "String"
    }
  }
}, um = {
  parameterPath: "blobContentLength",
  mapper: {
    serializedName: "x-ms-blob-content-length",
    required: !0,
    xmlName: "x-ms-blob-content-length",
    type: {
      name: "Number"
    }
  }
}, ym = {
  parameterPath: ["options", "blobSequenceNumber"],
  mapper: {
    defaultValue: 0,
    serializedName: "x-ms-blob-sequence-number",
    xmlName: "x-ms-blob-sequence-number",
    type: {
      name: "Number"
    }
  }
}, lr = {
  parameterPath: ["options", "contentType"],
  mapper: {
    defaultValue: "application/octet-stream",
    isConstant: !0,
    serializedName: "Content-Type",
    type: {
      name: "String"
    }
  }
}, cr = {
  parameterPath: "body",
  mapper: {
    serializedName: "body",
    required: !0,
    xmlName: "body",
    type: {
      name: "Stream"
    }
  }
}, dr = {
  parameterPath: "accept",
  mapper: {
    defaultValue: "application/xml",
    isConstant: !0,
    serializedName: "Accept",
    type: {
      name: "String"
    }
  }
}, ua = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "page",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, fm = {
  parameterPath: "pageWrite",
  mapper: {
    defaultValue: "update",
    isConstant: !0,
    serializedName: "x-ms-page-write",
    type: {
      name: "String"
    }
  }
}, ya = {
  parameterPath: [
    "options",
    "sequenceNumberAccessConditions",
    "ifSequenceNumberLessThanOrEqualTo"
  ],
  mapper: {
    serializedName: "x-ms-if-sequence-number-le",
    xmlName: "x-ms-if-sequence-number-le",
    type: {
      name: "Number"
    }
  }
}, fa = {
  parameterPath: [
    "options",
    "sequenceNumberAccessConditions",
    "ifSequenceNumberLessThan"
  ],
  mapper: {
    serializedName: "x-ms-if-sequence-number-lt",
    xmlName: "x-ms-if-sequence-number-lt",
    type: {
      name: "Number"
    }
  }
}, ga = {
  parameterPath: [
    "options",
    "sequenceNumberAccessConditions",
    "ifSequenceNumberEqualTo"
  ],
  mapper: {
    serializedName: "x-ms-if-sequence-number-eq",
    xmlName: "x-ms-if-sequence-number-eq",
    type: {
      name: "Number"
    }
  }
}, Ny = {
  parameterPath: "pageWrite",
  mapper: {
    defaultValue: "clear",
    isConstant: !0,
    serializedName: "x-ms-page-write",
    type: {
      name: "String"
    }
  }
}, ha = {
  parameterPath: "sourceUrl",
  mapper: {
    serializedName: "x-ms-copy-source",
    required: !0,
    xmlName: "x-ms-copy-source",
    type: {
      name: "String"
    }
  }
}, by = {
  parameterPath: "sourceRange",
  mapper: {
    serializedName: "x-ms-source-range",
    required: !0,
    xmlName: "x-ms-source-range",
    type: {
      name: "String"
    }
  }
}, xa = {
  parameterPath: ["options", "sourceContentCrc64"],
  mapper: {
    serializedName: "x-ms-source-content-crc64",
    xmlName: "x-ms-source-content-crc64",
    type: {
      name: "ByteArray"
    }
  }
}, Cy = {
  parameterPath: "range",
  mapper: {
    serializedName: "x-ms-range",
    required: !0,
    xmlName: "x-ms-range",
    type: {
      name: "String"
    }
  }
}, gm = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "pagelist",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, Py = {
  parameterPath: ["options", "prevsnapshot"],
  mapper: {
    serializedName: "prevsnapshot",
    xmlName: "prevsnapshot",
    type: {
      name: "String"
    }
  }
}, vy = {
  parameterPath: ["options", "prevSnapshotUrl"],
  mapper: {
    serializedName: "x-ms-previous-snapshot-url",
    xmlName: "x-ms-previous-snapshot-url",
    type: {
      name: "String"
    }
  }
}, zy = {
  parameterPath: "sequenceNumberAction",
  mapper: {
    serializedName: "x-ms-sequence-number-action",
    required: !0,
    xmlName: "x-ms-sequence-number-action",
    type: {
      name: "Enum",
      allowedValues: ["max", "update", "increment"]
    }
  }
}, Sy = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "incrementalcopy",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, Ry = {
  parameterPath: "blobType",
  mapper: {
    defaultValue: "AppendBlob",
    isConstant: !0,
    serializedName: "x-ms-blob-type",
    type: {
      name: "String"
    }
  }
}, hm = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "appendblock",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, xm = {
  parameterPath: ["options", "appendPositionAccessConditions", "maxSize"],
  mapper: {
    serializedName: "x-ms-blob-condition-maxsize",
    xmlName: "x-ms-blob-condition-maxsize",
    type: {
      name: "Number"
    }
  }
}, Na = {
  parameterPath: [
    "options",
    "appendPositionAccessConditions",
    "appendPosition"
  ],
  mapper: {
    serializedName: "x-ms-blob-condition-appendpos",
    xmlName: "x-ms-blob-condition-appendpos",
    type: {
      name: "Number"
    }
  }
}, Nm = {
  parameterPath: ["options", "sourceRange"],
  mapper: {
    serializedName: "x-ms-source-range",
    xmlName: "x-ms-source-range",
    type: {
      name: "String"
    }
  }
}, wy = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "seal",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, bm = {
  parameterPath: "blobType",
  mapper: {
    defaultValue: "BlockBlob",
    isConstant: !0,
    serializedName: "x-ms-blob-type",
    type: {
      name: "String"
    }
  }
}, By = {
  parameterPath: ["options", "copySourceBlobProperties"],
  mapper: {
    serializedName: "x-ms-copy-source-blob-properties",
    xmlName: "x-ms-copy-source-blob-properties",
    type: {
      name: "Boolean"
    }
  }
}, Cm = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "block",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, Pm = {
  parameterPath: "blockId",
  mapper: {
    serializedName: "blockid",
    required: !0,
    xmlName: "blockid",
    type: {
      name: "String"
    }
  }
}, Ey = {
  parameterPath: "blocks",
  mapper: pi
}, vm = {
  parameterPath: "comp",
  mapper: {
    defaultValue: "blocklist",
    isConstant: !0,
    serializedName: "comp",
    type: {
      name: "String"
    }
  }
}, Ty = {
  parameterPath: "listType",
  mapper: {
    defaultValue: "committed",
    serializedName: "blocklisttype",
    required: !0,
    xmlName: "blocklisttype",
    type: {
      name: "Enum",
      allowedValues: ["committed", "uncommitted", "all"]
    }
  }
};
class My {
  /**
   * Initialize a new instance of the class Service class.
   * @param client Reference to the service client
   */
  constructor(e) {
    this.client = e;
  }
  /**
   * Sets properties for a storage account's Blob service endpoint, including properties for Storage
   * Analytics and CORS (Cross-Origin Resource Sharing) rules
   * @param blobServiceProperties The StorageService properties.
   * @param options The options parameters.
   */
  setProperties(e, t) {
    return this.client.sendOperationRequest({ blobServiceProperties: e, options: t }, Iy);
  }
  /**
   * gets the properties of a storage account's Blob service, including properties for Storage Analytics
   * and CORS (Cross-Origin Resource Sharing) rules.
   * @param options The options parameters.
   */
  getProperties(e) {
    return this.client.sendOperationRequest({ options: e }, qy);
  }
  /**
   * Retrieves statistics related to replication for the Blob service. It is only available on the
   * secondary location endpoint when read-access geo-redundant replication is enabled for the storage
   * account.
   * @param options The options parameters.
   */
  getStatistics(e) {
    return this.client.sendOperationRequest({ options: e }, Oy);
  }
  /**
   * The List Containers Segment operation returns a list of the containers under the specified account
   * @param options The options parameters.
   */
  listContainersSegment(e) {
    return this.client.sendOperationRequest({ options: e }, _y);
  }
  /**
   * Retrieves a user delegation key for the Blob service. This is only a valid operation when using
   * bearer token authentication.
   * @param keyInfo Key information
   * @param options The options parameters.
   */
  getUserDelegationKey(e, t) {
    return this.client.sendOperationRequest({ keyInfo: e, options: t }, Hy);
  }
  /**
   * Returns the sku name and account kind
   * @param options The options parameters.
   */
  getAccountInfo(e) {
    return this.client.sendOperationRequest({ options: e }, Dy);
  }
  /**
   * The Batch operation allows multiple API calls to be embedded into a single HTTP request.
   * @param contentLength The length of the request.
   * @param multipartContentType Required. The value of this header must be multipart/mixed with a batch
   *                             boundary. Example header value: multipart/mixed; boundary=batch_<GUID>
   * @param body Initial data
   * @param options The options parameters.
   */
  submitBatch(e, t, a, n) {
    return this.client.sendOperationRequest({ contentLength: e, multipartContentType: t, body: a, options: n }, Ly);
  }
  /**
   * The Filter Blobs operation enables callers to list blobs across all containers whose tags match a
   * given search expression.  Filter blobs searches across all containers within a storage account but
   * can be scoped within the expression to a single container.
   * @param options The options parameters.
   */
  filterBlobs(e) {
    return this.client.sendOperationRequest({ options: e }, ky);
  }
}
const Ee = Ve(
  rt,
  /* isXml */
  !0
), Iy = {
  path: "/",
  httpMethod: "PUT",
  responses: {
    202: {
      headersMapper: fi
    },
    default: {
      bodyMapper: b,
      headersMapper: gi
    }
  },
  requestBody: Lu,
  queryParameters: [
    or,
    we,
    v
  ],
  urlParameters: [P],
  headerParameters: [
    at,
    Re,
    z,
    S
  ],
  isXML: !0,
  contentType: "application/xml; charset=utf-8",
  mediaType: "xml",
  serializer: Ee
}, qy = {
  path: "/",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: sa,
      headersMapper: hi
    },
    default: {
      bodyMapper: b,
      headersMapper: xi
    }
  },
  queryParameters: [
    or,
    we,
    v
  ],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B
  ],
  isXML: !0,
  serializer: Ee
}, Oy = {
  path: "/",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: si,
      headersMapper: Ni
    },
    default: {
      bodyMapper: b,
      headersMapper: bi
    }
  },
  queryParameters: [
    or,
    v,
    ku
  ],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B
  ],
  isXML: !0,
  serializer: Ee
}, _y = {
  path: "/",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: oi,
      headersMapper: Ci
    },
    default: {
      bodyMapper: b,
      headersMapper: Pi
    }
  },
  queryParameters: [
    v,
    ca,
    da,
    He,
    De,
    Au
  ],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B
  ],
  isXML: !0,
  serializer: Ee
}, Hy = {
  path: "/",
  httpMethod: "POST",
  responses: {
    200: {
      bodyMapper: li,
      headersMapper: vi
    },
    default: {
      bodyMapper: b,
      headersMapper: zi
    }
  },
  requestBody: Uu,
  queryParameters: [
    or,
    v,
    $u
  ],
  urlParameters: [P],
  headerParameters: [
    at,
    Re,
    z,
    S
  ],
  isXML: !0,
  contentType: "application/xml; charset=utf-8",
  mediaType: "xml",
  serializer: Ee
}, Dy = {
  path: "/",
  httpMethod: "GET",
  responses: {
    200: {
      headersMapper: Si
    },
    default: {
      bodyMapper: b,
      headersMapper: Ri
    }
  },
  queryParameters: [
    we,
    v,
    pa
  ],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B
  ],
  isXML: !0,
  serializer: Ee
}, Ly = {
  path: "/",
  httpMethod: "POST",
  responses: {
    202: {
      bodyMapper: {
        type: { name: "Stream" },
        serializedName: "parsedResponse"
      },
      headersMapper: wi
    },
    default: {
      bodyMapper: b,
      headersMapper: Bi
    }
  },
  requestBody: jo,
  queryParameters: [v, Fo],
  urlParameters: [P],
  headerParameters: [
    Re,
    z,
    S,
    me,
    Ko
  ],
  isXML: !0,
  contentType: "application/xml; charset=utf-8",
  mediaType: "xml",
  serializer: Ee
}, ky = {
  path: "/",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: oa,
      headersMapper: Ei
    },
    default: {
      bodyMapper: b,
      headersMapper: Ti
    }
  },
  queryParameters: [
    v,
    He,
    De,
    Go,
    Xo
  ],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B
  ],
  isXML: !0,
  serializer: Ee
};
class Ay {
  /**
   * Initialize a new instance of the class Container class.
   * @param client Reference to the service client
   */
  constructor(e) {
    this.client = e;
  }
  /**
   * creates a new container under the specified account. If the container with the same name already
   * exists, the operation fails
   * @param options The options parameters.
   */
  create(e) {
    return this.client.sendOperationRequest({ options: e }, Uy);
  }
  /**
   * returns all user-defined metadata and system properties for the specified container. The data
   * returned does not include the container's list of blobs
   * @param options The options parameters.
   */
  getProperties(e) {
    return this.client.sendOperationRequest({ options: e }, $y);
  }
  /**
   * operation marks the specified container for deletion. The container and any blobs contained within
   * it are later deleted during garbage collection
   * @param options The options parameters.
   */
  delete(e) {
    return this.client.sendOperationRequest({ options: e }, jy);
  }
  /**
   * operation sets one or more user-defined name-value pairs for the specified container.
   * @param options The options parameters.
   */
  setMetadata(e) {
    return this.client.sendOperationRequest({ options: e }, Fy);
  }
  /**
   * gets the permissions for the specified container. The permissions indicate whether container data
   * may be accessed publicly.
   * @param options The options parameters.
   */
  getAccessPolicy(e) {
    return this.client.sendOperationRequest({ options: e }, Ky);
  }
  /**
   * sets the permissions for the specified container. The permissions indicate whether blobs in a
   * container may be accessed publicly.
   * @param options The options parameters.
   */
  setAccessPolicy(e) {
    return this.client.sendOperationRequest({ options: e }, Gy);
  }
  /**
   * Restores a previously-deleted container.
   * @param options The options parameters.
   */
  restore(e) {
    return this.client.sendOperationRequest({ options: e }, Xy);
  }
  /**
   * Renames an existing container.
   * @param sourceContainerName Required.  Specifies the name of the container to rename.
   * @param options The options parameters.
   */
  rename(e, t) {
    return this.client.sendOperationRequest({ sourceContainerName: e, options: t }, Wy);
  }
  /**
   * The Batch operation allows multiple API calls to be embedded into a single HTTP request.
   * @param contentLength The length of the request.
   * @param multipartContentType Required. The value of this header must be multipart/mixed with a batch
   *                             boundary. Example header value: multipart/mixed; boundary=batch_<GUID>
   * @param body Initial data
   * @param options The options parameters.
   */
  submitBatch(e, t, a, n) {
    return this.client.sendOperationRequest({ contentLength: e, multipartContentType: t, body: a, options: n }, Qy);
  }
  /**
   * The Filter Blobs operation enables callers to list blobs in a container whose tags match a given
   * search expression.  Filter blobs searches within the given container.
   * @param options The options parameters.
   */
  filterBlobs(e) {
    return this.client.sendOperationRequest({ options: e }, Jy);
  }
  /**
   * [Update] establishes and manages a lock on a container for delete operations. The lock duration can
   * be 15 to 60 seconds, or can be infinite
   * @param options The options parameters.
   */
  acquireLease(e) {
    return this.client.sendOperationRequest({ options: e }, Yy);
  }
  /**
   * [Update] establishes and manages a lock on a container for delete operations. The lock duration can
   * be 15 to 60 seconds, or can be infinite
   * @param leaseId Specifies the current lease ID on the resource.
   * @param options The options parameters.
   */
  releaseLease(e, t) {
    return this.client.sendOperationRequest({ leaseId: e, options: t }, Zy);
  }
  /**
   * [Update] establishes and manages a lock on a container for delete operations. The lock duration can
   * be 15 to 60 seconds, or can be infinite
   * @param leaseId Specifies the current lease ID on the resource.
   * @param options The options parameters.
   */
  renewLease(e, t) {
    return this.client.sendOperationRequest({ leaseId: e, options: t }, Vy);
  }
  /**
   * [Update] establishes and manages a lock on a container for delete operations. The lock duration can
   * be 15 to 60 seconds, or can be infinite
   * @param options The options parameters.
   */
  breakLease(e) {
    return this.client.sendOperationRequest({ options: e }, ef);
  }
  /**
   * [Update] establishes and manages a lock on a container for delete operations. The lock duration can
   * be 15 to 60 seconds, or can be infinite
   * @param leaseId Specifies the current lease ID on the resource.
   * @param proposedLeaseId Proposed lease ID, in a GUID string format. The Blob service returns 400
   *                        (Invalid request) if the proposed lease ID is not in the correct format. See Guid Constructor
   *                        (String) for a list of valid GUID string formats.
   * @param options The options parameters.
   */
  changeLease(e, t, a) {
    return this.client.sendOperationRequest({ leaseId: e, proposedLeaseId: t, options: a }, tf);
  }
  /**
   * [Update] The List Blobs operation returns a list of the blobs under the specified container
   * @param options The options parameters.
   */
  listBlobFlatSegment(e) {
    return this.client.sendOperationRequest({ options: e }, rf);
  }
  /**
   * [Update] The List Blobs operation returns a list of the blobs under the specified container
   * @param delimiter When the request includes this parameter, the operation returns a BlobPrefix
   *                  element in the response body that acts as a placeholder for all blobs whose names begin with the
   *                  same substring up to the appearance of the delimiter character. The delimiter may be a single
   *                  character or a string.
   * @param options The options parameters.
   */
  listBlobHierarchySegment(e, t) {
    return this.client.sendOperationRequest({ delimiter: e, options: t }, af);
  }
  /**
   * Returns the sku name and account kind
   * @param options The options parameters.
   */
  getAccountInfo(e) {
    return this.client.sendOperationRequest({ options: e }, nf);
  }
}
const ee = Ve(
  rt,
  /* isXml */
  !0
), Uy = {
  path: "/{containerName}",
  httpMethod: "PUT",
  responses: {
    201: {
      headersMapper: Mi
    },
    default: {
      bodyMapper: b,
      headersMapper: Ii
    }
  },
  queryParameters: [v, re],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B,
    ue,
    Wo,
    ju,
    Fu
  ],
  isXML: !0,
  serializer: ee
}, $y = {
  path: "/{containerName}",
  httpMethod: "GET",
  responses: {
    200: {
      headersMapper: qi
    },
    default: {
      bodyMapper: b,
      headersMapper: Oi
    }
  },
  queryParameters: [v, re],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B,
    D
  ],
  isXML: !0,
  serializer: ee
}, jy = {
  path: "/{containerName}",
  httpMethod: "DELETE",
  responses: {
    202: {
      headersMapper: _i
    },
    default: {
      bodyMapper: b,
      headersMapper: Hi
    }
  },
  queryParameters: [v, re],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B,
    D,
    _,
    H
  ],
  isXML: !0,
  serializer: ee
}, Fy = {
  path: "/{containerName}",
  httpMethod: "PUT",
  responses: {
    200: {
      headersMapper: Di
    },
    default: {
      bodyMapper: b,
      headersMapper: Li
    }
  },
  queryParameters: [
    v,
    re,
    Qo
  ],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B,
    ue,
    D,
    _
  ],
  isXML: !0,
  serializer: ee
}, Ky = {
  path: "/{containerName}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Sequence",
          element: {
            type: { name: "Composite", className: "SignedIdentifier" }
          }
        },
        serializedName: "SignedIdentifiers",
        xmlName: "SignedIdentifiers",
        xmlIsWrapped: !0,
        xmlElementName: "SignedIdentifier"
      },
      headersMapper: ki
    },
    default: {
      bodyMapper: b,
      headersMapper: Ai
    }
  },
  queryParameters: [
    v,
    re,
    Jo
  ],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B,
    D
  ],
  isXML: !0,
  serializer: ee
}, Gy = {
  path: "/{containerName}",
  httpMethod: "PUT",
  responses: {
    200: {
      headersMapper: Ui
    },
    default: {
      bodyMapper: b,
      headersMapper: $i
    }
  },
  requestBody: Ku,
  queryParameters: [
    v,
    re,
    Jo
  ],
  urlParameters: [P],
  headerParameters: [
    at,
    Re,
    z,
    S,
    Wo,
    D,
    _,
    H
  ],
  isXML: !0,
  contentType: "application/xml; charset=utf-8",
  mediaType: "xml",
  serializer: ee
}, Xy = {
  path: "/{containerName}",
  httpMethod: "PUT",
  responses: {
    201: {
      headersMapper: ji
    },
    default: {
      bodyMapper: b,
      headersMapper: Fi
    }
  },
  queryParameters: [
    v,
    re,
    Yo
  ],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B,
    Gu,
    Xu
  ],
  isXML: !0,
  serializer: ee
}, Wy = {
  path: "/{containerName}",
  httpMethod: "PUT",
  responses: {
    200: {
      headersMapper: Ki
    },
    default: {
      bodyMapper: b,
      headersMapper: Gi
    }
  },
  queryParameters: [
    v,
    re,
    Wu
  ],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B,
    Qu,
    Ju
  ],
  isXML: !0,
  serializer: ee
}, Qy = {
  path: "/{containerName}",
  httpMethod: "POST",
  responses: {
    202: {
      bodyMapper: {
        type: { name: "Stream" },
        serializedName: "parsedResponse"
      },
      headersMapper: Xi
    },
    default: {
      bodyMapper: b,
      headersMapper: Wi
    }
  },
  requestBody: jo,
  queryParameters: [
    v,
    Fo,
    re
  ],
  urlParameters: [P],
  headerParameters: [
    Re,
    z,
    S,
    me,
    Ko
  ],
  isXML: !0,
  contentType: "application/xml; charset=utf-8",
  mediaType: "xml",
  serializer: ee
}, Jy = {
  path: "/{containerName}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: oa,
      headersMapper: Qi
    },
    default: {
      bodyMapper: b,
      headersMapper: Ji
    }
  },
  queryParameters: [
    v,
    He,
    De,
    Go,
    Xo,
    re
  ],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B
  ],
  isXML: !0,
  serializer: ee
}, Yy = {
  path: "/{containerName}",
  httpMethod: "PUT",
  responses: {
    201: {
      headersMapper: Yi
    },
    default: {
      bodyMapper: b,
      headersMapper: Zi
    }
  },
  queryParameters: [
    v,
    re,
    ge
  ],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B,
    _,
    H,
    Zo,
    Vo,
    em
  ],
  isXML: !0,
  serializer: ee
}, Zy = {
  path: "/{containerName}",
  httpMethod: "PUT",
  responses: {
    200: {
      headersMapper: Vi
    },
    default: {
      bodyMapper: b,
      headersMapper: es
    }
  },
  queryParameters: [
    v,
    re,
    ge
  ],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B,
    _,
    H,
    tm,
    nt
  ],
  isXML: !0,
  serializer: ee
}, Vy = {
  path: "/{containerName}",
  httpMethod: "PUT",
  responses: {
    200: {
      headersMapper: ts
    },
    default: {
      bodyMapper: b,
      headersMapper: rs
    }
  },
  queryParameters: [
    v,
    re,
    ge
  ],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B,
    _,
    H,
    nt,
    rm
  ],
  isXML: !0,
  serializer: ee
}, ef = {
  path: "/{containerName}",
  httpMethod: "PUT",
  responses: {
    202: {
      headersMapper: as
    },
    default: {
      bodyMapper: b,
      headersMapper: ns
    }
  },
  queryParameters: [
    v,
    re,
    ge
  ],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B,
    _,
    H,
    am,
    nm
  ],
  isXML: !0,
  serializer: ee
}, tf = {
  path: "/{containerName}",
  httpMethod: "PUT",
  responses: {
    200: {
      headersMapper: is
    },
    default: {
      bodyMapper: b,
      headersMapper: ss
    }
  },
  queryParameters: [
    v,
    re,
    ge
  ],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B,
    _,
    H,
    nt,
    im,
    sm
  ],
  isXML: !0,
  serializer: ee
}, rf = {
  path: "/{containerName}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: ci,
      headersMapper: os
    },
    default: {
      bodyMapper: b,
      headersMapper: ms
    }
  },
  queryParameters: [
    v,
    ca,
    da,
    He,
    De,
    re,
    om
  ],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B
  ],
  isXML: !0,
  serializer: ee
}, af = {
  path: "/{containerName}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: di,
      headersMapper: ls
    },
    default: {
      bodyMapper: b,
      headersMapper: cs
    }
  },
  queryParameters: [
    v,
    ca,
    da,
    He,
    De,
    re,
    om,
    Yu
  ],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B
  ],
  isXML: !0,
  serializer: ee
}, nf = {
  path: "/{containerName}",
  httpMethod: "GET",
  responses: {
    200: {
      headersMapper: ds
    },
    default: {
      bodyMapper: b,
      headersMapper: ps
    }
  },
  queryParameters: [
    we,
    v,
    pa
  ],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B
  ],
  isXML: !0,
  serializer: ee
};
class sf {
  /**
   * Initialize a new instance of the class Blob class.
   * @param client Reference to the service client
   */
  constructor(e) {
    this.client = e;
  }
  /**
   * The Download operation reads or downloads a blob from the system, including its metadata and
   * properties. You can also call Download to read a snapshot.
   * @param options The options parameters.
   */
  download(e) {
    return this.client.sendOperationRequest({ options: e }, of);
  }
  /**
   * The Get Properties operation returns all user-defined metadata, standard HTTP properties, and system
   * properties for the blob. It does not return the content of the blob.
   * @param options The options parameters.
   */
  getProperties(e) {
    return this.client.sendOperationRequest({ options: e }, mf);
  }
  /**
   * If the storage account's soft delete feature is disabled then, when a blob is deleted, it is
   * permanently removed from the storage account. If the storage account's soft delete feature is
   * enabled, then, when a blob is deleted, it is marked for deletion and becomes inaccessible
   * immediately. However, the blob service retains the blob or snapshot for the number of days specified
   * by the DeleteRetentionPolicy section of [Storage service properties]
   * (Set-Blob-Service-Properties.md). After the specified number of days has passed, the blob's data is
   * permanently removed from the storage account. Note that you continue to be charged for the
   * soft-deleted blob's storage until it is permanently removed. Use the List Blobs API and specify the
   * "include=deleted" query parameter to discover which blobs and snapshots have been soft deleted. You
   * can then use the Undelete Blob API to restore a soft-deleted blob. All other operations on a
   * soft-deleted blob or snapshot causes the service to return an HTTP status code of 404
   * (ResourceNotFound).
   * @param options The options parameters.
   */
  delete(e) {
    return this.client.sendOperationRequest({ options: e }, lf);
  }
  /**
   * Undelete a blob that was previously soft deleted
   * @param options The options parameters.
   */
  undelete(e) {
    return this.client.sendOperationRequest({ options: e }, cf);
  }
  /**
   * Sets the time a blob will expire and be deleted.
   * @param expiryOptions Required. Indicates mode of the expiry time
   * @param options The options parameters.
   */
  setExpiry(e, t) {
    return this.client.sendOperationRequest({ expiryOptions: e, options: t }, df);
  }
  /**
   * The Set HTTP Headers operation sets system properties on the blob
   * @param options The options parameters.
   */
  setHttpHeaders(e) {
    return this.client.sendOperationRequest({ options: e }, pf);
  }
  /**
   * The Set Immutability Policy operation sets the immutability policy on the blob
   * @param options The options parameters.
   */
  setImmutabilityPolicy(e) {
    return this.client.sendOperationRequest({ options: e }, uf);
  }
  /**
   * The Delete Immutability Policy operation deletes the immutability policy on the blob
   * @param options The options parameters.
   */
  deleteImmutabilityPolicy(e) {
    return this.client.sendOperationRequest({ options: e }, yf);
  }
  /**
   * The Set Legal Hold operation sets a legal hold on the blob.
   * @param legalHold Specified if a legal hold should be set on the blob.
   * @param options The options parameters.
   */
  setLegalHold(e, t) {
    return this.client.sendOperationRequest({ legalHold: e, options: t }, ff);
  }
  /**
   * The Set Blob Metadata operation sets user-defined metadata for the specified blob as one or more
   * name-value pairs
   * @param options The options parameters.
   */
  setMetadata(e) {
    return this.client.sendOperationRequest({ options: e }, gf);
  }
  /**
   * [Update] The Lease Blob operation establishes and manages a lock on a blob for write and delete
   * operations
   * @param options The options parameters.
   */
  acquireLease(e) {
    return this.client.sendOperationRequest({ options: e }, hf);
  }
  /**
   * [Update] The Lease Blob operation establishes and manages a lock on a blob for write and delete
   * operations
   * @param leaseId Specifies the current lease ID on the resource.
   * @param options The options parameters.
   */
  releaseLease(e, t) {
    return this.client.sendOperationRequest({ leaseId: e, options: t }, xf);
  }
  /**
   * [Update] The Lease Blob operation establishes and manages a lock on a blob for write and delete
   * operations
   * @param leaseId Specifies the current lease ID on the resource.
   * @param options The options parameters.
   */
  renewLease(e, t) {
    return this.client.sendOperationRequest({ leaseId: e, options: t }, Nf);
  }
  /**
   * [Update] The Lease Blob operation establishes and manages a lock on a blob for write and delete
   * operations
   * @param leaseId Specifies the current lease ID on the resource.
   * @param proposedLeaseId Proposed lease ID, in a GUID string format. The Blob service returns 400
   *                        (Invalid request) if the proposed lease ID is not in the correct format. See Guid Constructor
   *                        (String) for a list of valid GUID string formats.
   * @param options The options parameters.
   */
  changeLease(e, t, a) {
    return this.client.sendOperationRequest({ leaseId: e, proposedLeaseId: t, options: a }, bf);
  }
  /**
   * [Update] The Lease Blob operation establishes and manages a lock on a blob for write and delete
   * operations
   * @param options The options parameters.
   */
  breakLease(e) {
    return this.client.sendOperationRequest({ options: e }, Cf);
  }
  /**
   * The Create Snapshot operation creates a read-only snapshot of a blob
   * @param options The options parameters.
   */
  createSnapshot(e) {
    return this.client.sendOperationRequest({ options: e }, Pf);
  }
  /**
   * The Start Copy From URL operation copies a blob or an internet resource to a new blob.
   * @param copySource Specifies the name of the source page blob snapshot. This value is a URL of up to
   *                   2 KB in length that specifies a page blob snapshot. The value should be URL-encoded as it would
   *                   appear in a request URI. The source blob must either be public or must be authenticated via a shared
   *                   access signature.
   * @param options The options parameters.
   */
  startCopyFromURL(e, t) {
    return this.client.sendOperationRequest({ copySource: e, options: t }, vf);
  }
  /**
   * The Copy From URL operation copies a blob or an internet resource to a new blob. It will not return
   * a response until the copy is complete.
   * @param copySource Specifies the name of the source page blob snapshot. This value is a URL of up to
   *                   2 KB in length that specifies a page blob snapshot. The value should be URL-encoded as it would
   *                   appear in a request URI. The source blob must either be public or must be authenticated via a shared
   *                   access signature.
   * @param options The options parameters.
   */
  copyFromURL(e, t) {
    return this.client.sendOperationRequest({ copySource: e, options: t }, zf);
  }
  /**
   * The Abort Copy From URL operation aborts a pending Copy From URL operation, and leaves a destination
   * blob with zero length and full metadata.
   * @param copyId The copy identifier provided in the x-ms-copy-id header of the original Copy Blob
   *               operation.
   * @param options The options parameters.
   */
  abortCopyFromURL(e, t) {
    return this.client.sendOperationRequest({ copyId: e, options: t }, Sf);
  }
  /**
   * The Set Tier operation sets the tier on a blob. The operation is allowed on a page blob in a premium
   * storage account and on a block blob in a blob storage account (locally redundant storage only). A
   * premium page blob's tier determines the allowed size, IOPS, and bandwidth of the blob. A block
   * blob's tier determines Hot/Cool/Archive storage type. This operation does not update the blob's
   * ETag.
   * @param tier Indicates the tier to be set on the blob.
   * @param options The options parameters.
   */
  setTier(e, t) {
    return this.client.sendOperationRequest({ tier: e, options: t }, Rf);
  }
  /**
   * Returns the sku name and account kind
   * @param options The options parameters.
   */
  getAccountInfo(e) {
    return this.client.sendOperationRequest({ options: e }, wf);
  }
  /**
   * The Query operation enables users to select/project on blob data by providing simple query
   * expressions.
   * @param options The options parameters.
   */
  query(e) {
    return this.client.sendOperationRequest({ options: e }, Bf);
  }
  /**
   * The Get Tags operation enables users to get the tags associated with a blob.
   * @param options The options parameters.
   */
  getTags(e) {
    return this.client.sendOperationRequest({ options: e }, Ef);
  }
  /**
   * The Set Tags operation enables users to set tags on a blob.
   * @param options The options parameters.
   */
  setTags(e) {
    return this.client.sendOperationRequest({ options: e }, Tf);
  }
}
const G = Ve(
  rt,
  /* isXml */
  !0
), of = {
  path: "/{containerName}/{blob}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: { name: "Stream" },
        serializedName: "parsedResponse"
      },
      headersMapper: Lr
    },
    206: {
      bodyMapper: {
        type: { name: "Stream" },
        serializedName: "parsedResponse"
      },
      headersMapper: Lr
    },
    default: {
      bodyMapper: b,
      headersMapper: us
    }
  },
  queryParameters: [
    v,
    ce,
    Pe
  ],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B,
    D,
    _,
    H,
    Ut,
    Zu,
    Vu,
    Y,
    Z,
    V,
    A,
    U,
    L
  ],
  isXML: !0,
  serializer: G
}, mf = {
  path: "/{containerName}/{blob}",
  httpMethod: "HEAD",
  responses: {
    200: {
      headersMapper: ys
    },
    default: {
      bodyMapper: b,
      headersMapper: fs
    }
  },
  queryParameters: [
    v,
    ce,
    Pe
  ],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B,
    D,
    _,
    H,
    Y,
    Z,
    V,
    A,
    U,
    L
  ],
  isXML: !0,
  serializer: G
}, lf = {
  path: "/{containerName}/{blob}",
  httpMethod: "DELETE",
  responses: {
    202: {
      headersMapper: gs
    },
    default: {
      bodyMapper: b,
      headersMapper: hs
    }
  },
  queryParameters: [
    v,
    ce,
    Pe,
    ty
  ],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B,
    D,
    _,
    H,
    A,
    U,
    L,
    ey
  ],
  isXML: !0,
  serializer: G
}, cf = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    200: {
      headersMapper: xs
    },
    default: {
      bodyMapper: b,
      headersMapper: Ns
    }
  },
  queryParameters: [v, Yo],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B
  ],
  isXML: !0,
  serializer: G
}, df = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    200: {
      headersMapper: bs
    },
    default: {
      bodyMapper: b,
      headersMapper: Cs
    }
  },
  queryParameters: [v, ry],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B,
    ay,
    ny
  ],
  isXML: !0,
  serializer: G
}, pf = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    200: {
      headersMapper: Ps
    },
    default: {
      bodyMapper: b,
      headersMapper: vs
    }
  },
  queryParameters: [we, v],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B,
    D,
    _,
    H,
    A,
    U,
    L,
    it,
    st,
    ot,
    mt,
    lt,
    ct
  ],
  isXML: !0,
  serializer: G
}, uf = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    200: {
      headersMapper: zs
    },
    default: {
      bodyMapper: b,
      headersMapper: Ss
    }
  },
  queryParameters: [
    v,
    ce,
    Pe,
    mm
  ],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B,
    H,
    Le,
    ke
  ],
  isXML: !0,
  serializer: G
}, yf = {
  path: "/{containerName}/{blob}",
  httpMethod: "DELETE",
  responses: {
    200: {
      headersMapper: Rs
    },
    default: {
      bodyMapper: b,
      headersMapper: ws
    }
  },
  queryParameters: [
    v,
    ce,
    Pe,
    mm
  ],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B
  ],
  isXML: !0,
  serializer: G
}, ff = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    200: {
      headersMapper: Bs
    },
    default: {
      bodyMapper: b,
      headersMapper: Es
    }
  },
  queryParameters: [
    v,
    ce,
    Pe,
    iy
  ],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B,
    sy
  ],
  isXML: !0,
  serializer: G
}, gf = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    200: {
      headersMapper: Ts
    },
    default: {
      bodyMapper: b,
      headersMapper: Ms
    }
  },
  queryParameters: [v, Qo],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B,
    ue,
    D,
    _,
    H,
    Y,
    Z,
    V,
    A,
    U,
    L,
    ae
  ],
  isXML: !0,
  serializer: G
}, hf = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    201: {
      headersMapper: Is
    },
    default: {
      bodyMapper: b,
      headersMapper: qs
    }
  },
  queryParameters: [v, ge],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B,
    _,
    H,
    Zo,
    Vo,
    em,
    A,
    U,
    L
  ],
  isXML: !0,
  serializer: G
}, xf = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    200: {
      headersMapper: Os
    },
    default: {
      bodyMapper: b,
      headersMapper: _s
    }
  },
  queryParameters: [v, ge],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B,
    _,
    H,
    tm,
    nt,
    A,
    U,
    L
  ],
  isXML: !0,
  serializer: G
}, Nf = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    200: {
      headersMapper: Hs
    },
    default: {
      bodyMapper: b,
      headersMapper: Ds
    }
  },
  queryParameters: [v, ge],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B,
    _,
    H,
    nt,
    rm,
    A,
    U,
    L
  ],
  isXML: !0,
  serializer: G
}, bf = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    200: {
      headersMapper: Ls
    },
    default: {
      bodyMapper: b,
      headersMapper: ks
    }
  },
  queryParameters: [v, ge],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B,
    _,
    H,
    nt,
    im,
    sm,
    A,
    U,
    L
  ],
  isXML: !0,
  serializer: G
}, Cf = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    202: {
      headersMapper: As
    },
    default: {
      bodyMapper: b,
      headersMapper: Us
    }
  },
  queryParameters: [v, ge],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B,
    _,
    H,
    am,
    nm,
    A,
    U,
    L
  ],
  isXML: !0,
  serializer: G
}, Pf = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    201: {
      headersMapper: $s
    },
    default: {
      bodyMapper: b,
      headersMapper: js
    }
  },
  queryParameters: [v, oy],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B,
    ue,
    D,
    _,
    H,
    Y,
    Z,
    V,
    A,
    U,
    L,
    ae
  ],
  isXML: !0,
  serializer: G
}, vf = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    202: {
      headersMapper: Fs
    },
    default: {
      bodyMapper: b,
      headersMapper: Ks
    }
  },
  queryParameters: [v],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B,
    ue,
    D,
    _,
    H,
    A,
    U,
    L,
    Le,
    ke,
    dt,
    lm,
    pt,
    ut,
    yt,
    ft,
    cm,
    mr,
    Ae,
    my,
    gt
  ],
  isXML: !0,
  serializer: G
}, zf = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    202: {
      headersMapper: Gs
    },
    default: {
      bodyMapper: b,
      headersMapper: Xs
    }
  },
  queryParameters: [v],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B,
    ue,
    D,
    _,
    H,
    A,
    U,
    L,
    Le,
    ke,
    ae,
    dt,
    pt,
    ut,
    yt,
    ft,
    mr,
    Ae,
    gt,
    ly,
    $t,
    jt,
    dm
  ],
  isXML: !0,
  serializer: G
}, Sf = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    204: {
      headersMapper: Ws
    },
    default: {
      bodyMapper: b,
      headersMapper: Qs
    }
  },
  queryParameters: [
    v,
    cy,
    py
  ],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B,
    D,
    dy
  ],
  isXML: !0,
  serializer: G
}, Rf = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    200: {
      headersMapper: kr
    },
    202: {
      headersMapper: kr
    },
    default: {
      bodyMapper: b,
      headersMapper: Js
    }
  },
  queryParameters: [
    v,
    ce,
    Pe,
    uy
  ],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B,
    D,
    L,
    lm,
    yy
  ],
  isXML: !0,
  serializer: G
}, wf = {
  path: "/{containerName}/{blob}",
  httpMethod: "GET",
  responses: {
    200: {
      headersMapper: Ys
    },
    default: {
      bodyMapper: b,
      headersMapper: Zs
    }
  },
  queryParameters: [
    we,
    v,
    pa
  ],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B
  ],
  isXML: !0,
  serializer: G
}, Bf = {
  path: "/{containerName}/{blob}",
  httpMethod: "POST",
  responses: {
    200: {
      bodyMapper: {
        type: { name: "Stream" },
        serializedName: "parsedResponse"
      },
      headersMapper: Ar
    },
    206: {
      bodyMapper: {
        type: { name: "Stream" },
        serializedName: "parsedResponse"
      },
      headersMapper: Ar
    },
    default: {
      bodyMapper: b,
      headersMapper: Vs
    }
  },
  requestBody: fy,
  queryParameters: [
    v,
    ce,
    gy
  ],
  urlParameters: [P],
  headerParameters: [
    at,
    Re,
    z,
    S,
    D,
    _,
    H,
    Y,
    Z,
    V,
    A,
    U,
    L
  ],
  isXML: !0,
  contentType: "application/xml; charset=utf-8",
  mediaType: "xml",
  serializer: G
}, Ef = {
  path: "/{containerName}/{blob}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: ma,
      headersMapper: eo
    },
    default: {
      bodyMapper: b,
      headersMapper: to
    }
  },
  queryParameters: [
    v,
    ce,
    Pe,
    pm
  ],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B,
    D,
    L
  ],
  isXML: !0,
  serializer: G
}, Tf = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    204: {
      headersMapper: ro
    },
    default: {
      bodyMapper: b,
      headersMapper: ao
    }
  },
  requestBody: hy,
  queryParameters: [
    v,
    Pe,
    pm
  ],
  urlParameters: [P],
  headerParameters: [
    at,
    Re,
    z,
    S,
    D,
    L,
    Be,
    ht
  ],
  isXML: !0,
  contentType: "application/xml; charset=utf-8",
  mediaType: "xml",
  serializer: G
};
class Mf {
  /**
   * Initialize a new instance of the class PageBlob class.
   * @param client Reference to the service client
   */
  constructor(e) {
    this.client = e;
  }
  /**
   * The Create operation creates a new page blob.
   * @param contentLength The length of the request.
   * @param blobContentLength This header specifies the maximum size for the page blob, up to 1 TB. The
   *                          page blob size must be aligned to a 512-byte boundary.
   * @param options The options parameters.
   */
  create(e, t, a) {
    return this.client.sendOperationRequest({ contentLength: e, blobContentLength: t, options: a }, If);
  }
  /**
   * The Upload Pages operation writes a range of pages to a page blob
   * @param contentLength The length of the request.
   * @param body Initial data
   * @param options The options parameters.
   */
  uploadPages(e, t, a) {
    return this.client.sendOperationRequest({ contentLength: e, body: t, options: a }, qf);
  }
  /**
   * The Clear Pages operation clears a set of pages from a page blob
   * @param contentLength The length of the request.
   * @param options The options parameters.
   */
  clearPages(e, t) {
    return this.client.sendOperationRequest({ contentLength: e, options: t }, Of);
  }
  /**
   * The Upload Pages operation writes a range of pages to a page blob where the contents are read from a
   * URL
   * @param sourceUrl Specify a URL to the copy source.
   * @param sourceRange Bytes of source data in the specified range. The length of this range should
   *                    match the ContentLength header and x-ms-range/Range destination range header.
   * @param contentLength The length of the request.
   * @param range The range of bytes to which the source range would be written. The range should be 512
   *              aligned and range-end is required.
   * @param options The options parameters.
   */
  uploadPagesFromURL(e, t, a, n, i) {
    return this.client.sendOperationRequest({ sourceUrl: e, sourceRange: t, contentLength: a, range: n, options: i }, _f);
  }
  /**
   * The Get Page Ranges operation returns the list of valid page ranges for a page blob or snapshot of a
   * page blob
   * @param options The options parameters.
   */
  getPageRanges(e) {
    return this.client.sendOperationRequest({ options: e }, Hf);
  }
  /**
   * The Get Page Ranges Diff operation returns the list of valid page ranges for a page blob that were
   * changed between target blob and previous snapshot.
   * @param options The options parameters.
   */
  getPageRangesDiff(e) {
    return this.client.sendOperationRequest({ options: e }, Df);
  }
  /**
   * Resize the Blob
   * @param blobContentLength This header specifies the maximum size for the page blob, up to 1 TB. The
   *                          page blob size must be aligned to a 512-byte boundary.
   * @param options The options parameters.
   */
  resize(e, t) {
    return this.client.sendOperationRequest({ blobContentLength: e, options: t }, Lf);
  }
  /**
   * Update the sequence number of the blob
   * @param sequenceNumberAction Required if the x-ms-blob-sequence-number header is set for the request.
   *                             This property applies to page blobs only. This property indicates how the service should modify the
   *                             blob's sequence number
   * @param options The options parameters.
   */
  updateSequenceNumber(e, t) {
    return this.client.sendOperationRequest({ sequenceNumberAction: e, options: t }, kf);
  }
  /**
   * The Copy Incremental operation copies a snapshot of the source page blob to a destination page blob.
   * The snapshot is copied such that only the differential changes between the previously copied
   * snapshot are transferred to the destination. The copied snapshots are complete copies of the
   * original snapshot and can be read or copied from as usual. This API is supported since REST version
   * 2016-05-31.
   * @param copySource Specifies the name of the source page blob snapshot. This value is a URL of up to
   *                   2 KB in length that specifies a page blob snapshot. The value should be URL-encoded as it would
   *                   appear in a request URI. The source blob must either be public or must be authenticated via a shared
   *                   access signature.
   * @param options The options parameters.
   */
  copyIncremental(e, t) {
    return this.client.sendOperationRequest({ copySource: e, options: t }, Af);
  }
}
const ve = Ve(
  rt,
  /* isXml */
  !0
), If = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    201: {
      headersMapper: no
    },
    default: {
      bodyMapper: b,
      headersMapper: io
    }
  },
  queryParameters: [v],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B,
    me,
    ue,
    D,
    _,
    H,
    Y,
    Z,
    V,
    A,
    U,
    L,
    it,
    st,
    ot,
    mt,
    lt,
    ct,
    Le,
    ke,
    ae,
    dt,
    Ae,
    gt,
    xy,
    um,
    ym
  ],
  isXML: !0,
  serializer: ve
}, qf = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    201: {
      headersMapper: so
    },
    default: {
      bodyMapper: b,
      headersMapper: oo
    }
  },
  requestBody: cr,
  queryParameters: [v, ua],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    me,
    D,
    _,
    H,
    Ut,
    Y,
    Z,
    V,
    A,
    U,
    L,
    ae,
    Be,
    ht,
    lr,
    dr,
    fm,
    ya,
    fa,
    ga
  ],
  isXML: !0,
  contentType: "application/xml; charset=utf-8",
  mediaType: "binary",
  serializer: ve
}, Of = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    201: {
      headersMapper: mo
    },
    default: {
      bodyMapper: b,
      headersMapper: lo
    }
  },
  queryParameters: [v, ua],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B,
    me,
    D,
    _,
    H,
    Ut,
    Y,
    Z,
    V,
    A,
    U,
    L,
    ae,
    ya,
    fa,
    ga,
    Ny
  ],
  isXML: !0,
  serializer: ve
}, _f = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    201: {
      headersMapper: co
    },
    default: {
      bodyMapper: b,
      headersMapper: po
    }
  },
  queryParameters: [v, ua],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B,
    me,
    D,
    _,
    H,
    Y,
    Z,
    V,
    A,
    U,
    L,
    ae,
    pt,
    ut,
    yt,
    ft,
    $t,
    jt,
    fm,
    ya,
    fa,
    ga,
    ha,
    by,
    xa,
    Cy
  ],
  isXML: !0,
  serializer: ve
}, Hf = {
  path: "/{containerName}/{blob}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: la,
      headersMapper: uo
    },
    default: {
      bodyMapper: b,
      headersMapper: yo
    }
  },
  queryParameters: [
    v,
    He,
    De,
    ce,
    gm
  ],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B,
    D,
    _,
    H,
    Ut,
    A,
    U,
    L
  ],
  isXML: !0,
  serializer: ve
}, Df = {
  path: "/{containerName}/{blob}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: la,
      headersMapper: fo
    },
    default: {
      bodyMapper: b,
      headersMapper: go
    }
  },
  queryParameters: [
    v,
    He,
    De,
    ce,
    gm,
    Py
  ],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B,
    D,
    _,
    H,
    Ut,
    A,
    U,
    L,
    vy
  ],
  isXML: !0,
  serializer: ve
}, Lf = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    200: {
      headersMapper: ho
    },
    default: {
      bodyMapper: b,
      headersMapper: xo
    }
  },
  queryParameters: [we, v],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B,
    D,
    _,
    H,
    Y,
    Z,
    V,
    A,
    U,
    L,
    ae,
    um
  ],
  isXML: !0,
  serializer: ve
}, kf = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    200: {
      headersMapper: No
    },
    default: {
      bodyMapper: b,
      headersMapper: bo
    }
  },
  queryParameters: [we, v],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B,
    D,
    _,
    H,
    A,
    U,
    L,
    ym,
    zy
  ],
  isXML: !0,
  serializer: ve
}, Af = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    202: {
      headersMapper: Co
    },
    default: {
      bodyMapper: b,
      headersMapper: Po
    }
  },
  queryParameters: [v, Sy],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B,
    _,
    H,
    A,
    U,
    L,
    mr
  ],
  isXML: !0,
  serializer: ve
};
class Uf {
  /**
   * Initialize a new instance of the class AppendBlob class.
   * @param client Reference to the service client
   */
  constructor(e) {
    this.client = e;
  }
  /**
   * The Create Append Blob operation creates a new append blob.
   * @param contentLength The length of the request.
   * @param options The options parameters.
   */
  create(e, t) {
    return this.client.sendOperationRequest({ contentLength: e, options: t }, $f);
  }
  /**
   * The Append Block operation commits a new block of data to the end of an existing append blob. The
   * Append Block operation is permitted only if the blob was created with x-ms-blob-type set to
   * AppendBlob. Append Block is supported only on version 2015-02-21 version or later.
   * @param contentLength The length of the request.
   * @param body Initial data
   * @param options The options parameters.
   */
  appendBlock(e, t, a) {
    return this.client.sendOperationRequest({ contentLength: e, body: t, options: a }, jf);
  }
  /**
   * The Append Block operation commits a new block of data to the end of an existing append blob where
   * the contents are read from a source url. The Append Block operation is permitted only if the blob
   * was created with x-ms-blob-type set to AppendBlob. Append Block is supported only on version
   * 2015-02-21 version or later.
   * @param sourceUrl Specify a URL to the copy source.
   * @param contentLength The length of the request.
   * @param options The options parameters.
   */
  appendBlockFromUrl(e, t, a) {
    return this.client.sendOperationRequest({ sourceUrl: e, contentLength: t, options: a }, Ff);
  }
  /**
   * The Seal operation seals the Append Blob to make it read-only. Seal is supported only on version
   * 2019-12-12 version or later.
   * @param options The options parameters.
   */
  seal(e) {
    return this.client.sendOperationRequest({ options: e }, Kf);
  }
}
const pr = Ve(
  rt,
  /* isXml */
  !0
), $f = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    201: {
      headersMapper: vo
    },
    default: {
      bodyMapper: b,
      headersMapper: zo
    }
  },
  queryParameters: [v],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B,
    me,
    ue,
    D,
    _,
    H,
    Y,
    Z,
    V,
    A,
    U,
    L,
    it,
    st,
    ot,
    mt,
    lt,
    ct,
    Le,
    ke,
    ae,
    Ae,
    gt,
    Ry
  ],
  isXML: !0,
  serializer: pr
}, jf = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    201: {
      headersMapper: So
    },
    default: {
      bodyMapper: b,
      headersMapper: Ro
    }
  },
  requestBody: cr,
  queryParameters: [v, hm],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    me,
    D,
    _,
    H,
    Y,
    Z,
    V,
    A,
    U,
    L,
    ae,
    Be,
    ht,
    lr,
    dr,
    xm,
    Na
  ],
  isXML: !0,
  contentType: "application/xml; charset=utf-8",
  mediaType: "binary",
  serializer: pr
}, Ff = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    201: {
      headersMapper: wo
    },
    default: {
      bodyMapper: b,
      headersMapper: Bo
    }
  },
  queryParameters: [v, hm],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B,
    me,
    D,
    _,
    H,
    Y,
    Z,
    V,
    A,
    U,
    L,
    ae,
    pt,
    ut,
    yt,
    ft,
    $t,
    jt,
    Be,
    ha,
    xa,
    xm,
    Na,
    Nm
  ],
  isXML: !0,
  serializer: pr
}, Kf = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    200: {
      headersMapper: Eo
    },
    default: {
      bodyMapper: b,
      headersMapper: To
    }
  },
  queryParameters: [v, wy],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B,
    D,
    _,
    H,
    A,
    U,
    Na
  ],
  isXML: !0,
  serializer: pr
};
class Gf {
  /**
   * Initialize a new instance of the class BlockBlob class.
   * @param client Reference to the service client
   */
  constructor(e) {
    this.client = e;
  }
  /**
   * The Upload Block Blob operation updates the content of an existing block blob. Updating an existing
   * block blob overwrites any existing metadata on the blob. Partial updates are not supported with Put
   * Blob; the content of the existing blob is overwritten with the content of the new blob. To perform a
   * partial update of the content of a block blob, use the Put Block List operation.
   * @param contentLength The length of the request.
   * @param body Initial data
   * @param options The options parameters.
   */
  upload(e, t, a) {
    return this.client.sendOperationRequest({ contentLength: e, body: t, options: a }, Xf);
  }
  /**
   * The Put Blob from URL operation creates a new Block Blob where the contents of the blob are read
   * from a given URL.  This API is supported beginning with the 2020-04-08 version. Partial updates are
   * not supported with Put Blob from URL; the content of an existing blob is overwritten with the
   * content of the new blob.  To perform partial updates to a block blob’s contents using a source URL,
   * use the Put Block from URL API in conjunction with Put Block List.
   * @param contentLength The length of the request.
   * @param copySource Specifies the name of the source page blob snapshot. This value is a URL of up to
   *                   2 KB in length that specifies a page blob snapshot. The value should be URL-encoded as it would
   *                   appear in a request URI. The source blob must either be public or must be authenticated via a shared
   *                   access signature.
   * @param options The options parameters.
   */
  putBlobFromUrl(e, t, a) {
    return this.client.sendOperationRequest({ contentLength: e, copySource: t, options: a }, Wf);
  }
  /**
   * The Stage Block operation creates a new block to be committed as part of a blob
   * @param blockId A valid Base64 string value that identifies the block. Prior to encoding, the string
   *                must be less than or equal to 64 bytes in size. For a given blob, the length of the value specified
   *                for the blockid parameter must be the same size for each block.
   * @param contentLength The length of the request.
   * @param body Initial data
   * @param options The options parameters.
   */
  stageBlock(e, t, a, n) {
    return this.client.sendOperationRequest({ blockId: e, contentLength: t, body: a, options: n }, Qf);
  }
  /**
   * The Stage Block operation creates a new block to be committed as part of a blob where the contents
   * are read from a URL.
   * @param blockId A valid Base64 string value that identifies the block. Prior to encoding, the string
   *                must be less than or equal to 64 bytes in size. For a given blob, the length of the value specified
   *                for the blockid parameter must be the same size for each block.
   * @param contentLength The length of the request.
   * @param sourceUrl Specify a URL to the copy source.
   * @param options The options parameters.
   */
  stageBlockFromURL(e, t, a, n) {
    return this.client.sendOperationRequest({ blockId: e, contentLength: t, sourceUrl: a, options: n }, Jf);
  }
  /**
   * The Commit Block List operation writes a blob by specifying the list of block IDs that make up the
   * blob. In order to be written as part of a blob, a block must have been successfully written to the
   * server in a prior Put Block operation. You can call Put Block List to update a blob by uploading
   * only those blocks that have changed, then committing the new and existing blocks together. You can
   * do this by specifying whether to commit a block from the committed block list or from the
   * uncommitted block list, or to commit the most recently uploaded version of the block, whichever list
   * it may belong to.
   * @param blocks Blob Blocks.
   * @param options The options parameters.
   */
  commitBlockList(e, t) {
    return this.client.sendOperationRequest({ blocks: e, options: t }, Yf);
  }
  /**
   * The Get Block List operation retrieves the list of blocks that have been uploaded as part of a block
   * blob
   * @param listType Specifies whether to return the list of committed blocks, the list of uncommitted
   *                 blocks, or both lists together.
   * @param options The options parameters.
   */
  getBlockList(e, t) {
    return this.client.sendOperationRequest({ listType: e, options: t }, Zf);
  }
}
const xt = Ve(
  rt,
  /* isXml */
  !0
), Xf = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    201: {
      headersMapper: Mo
    },
    default: {
      bodyMapper: b,
      headersMapper: Io
    }
  },
  requestBody: cr,
  queryParameters: [v],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    me,
    ue,
    D,
    _,
    H,
    Y,
    Z,
    V,
    A,
    U,
    L,
    it,
    st,
    ot,
    mt,
    lt,
    ct,
    Le,
    ke,
    ae,
    dt,
    Ae,
    gt,
    Be,
    ht,
    lr,
    dr,
    bm
  ],
  isXML: !0,
  contentType: "application/xml; charset=utf-8",
  mediaType: "binary",
  serializer: xt
}, Wf = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    201: {
      headersMapper: qo
    },
    default: {
      bodyMapper: b,
      headersMapper: Oo
    }
  },
  queryParameters: [v],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B,
    me,
    ue,
    D,
    _,
    H,
    Y,
    Z,
    V,
    A,
    U,
    L,
    it,
    st,
    ot,
    mt,
    lt,
    ct,
    ae,
    dt,
    pt,
    ut,
    yt,
    ft,
    cm,
    mr,
    Ae,
    $t,
    jt,
    dm,
    Be,
    bm,
    By
  ],
  isXML: !0,
  serializer: xt
}, Qf = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    201: {
      headersMapper: _o
    },
    default: {
      bodyMapper: b,
      headersMapper: Ho
    }
  },
  requestBody: cr,
  queryParameters: [
    v,
    Cm,
    Pm
  ],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    me,
    D,
    Y,
    Z,
    V,
    ae,
    Be,
    ht,
    lr,
    dr
  ],
  isXML: !0,
  contentType: "application/xml; charset=utf-8",
  mediaType: "binary",
  serializer: xt
}, Jf = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    201: {
      headersMapper: Do
    },
    default: {
      bodyMapper: b,
      headersMapper: Lo
    }
  },
  queryParameters: [
    v,
    Cm,
    Pm
  ],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B,
    me,
    D,
    Y,
    Z,
    V,
    ae,
    pt,
    ut,
    yt,
    ft,
    $t,
    jt,
    ha,
    xa,
    Nm
  ],
  isXML: !0,
  serializer: xt
}, Yf = {
  path: "/{containerName}/{blob}",
  httpMethod: "PUT",
  responses: {
    201: {
      headersMapper: ko
    },
    default: {
      bodyMapper: b,
      headersMapper: Ao
    }
  },
  requestBody: Ey,
  queryParameters: [v, vm],
  urlParameters: [P],
  headerParameters: [
    at,
    Re,
    z,
    S,
    ue,
    D,
    _,
    H,
    Y,
    Z,
    V,
    A,
    U,
    L,
    it,
    st,
    ot,
    mt,
    lt,
    ct,
    Le,
    ke,
    ae,
    dt,
    Ae,
    gt,
    Be,
    ht
  ],
  isXML: !0,
  contentType: "application/xml; charset=utf-8",
  mediaType: "xml",
  serializer: xt
}, Zf = {
  path: "/{containerName}/{blob}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: ui,
      headersMapper: Uo
    },
    default: {
      bodyMapper: b,
      headersMapper: $o
    }
  },
  queryParameters: [
    v,
    ce,
    vm,
    Ty
  ],
  urlParameters: [P],
  headerParameters: [
    z,
    S,
    B,
    D,
    L
  ],
  isXML: !0,
  serializer: xt
};
let Vf = class extends op {
  /**
   * Initializes a new instance of the StorageClient class.
   * @param url The URL of the service account, container, or blob that is the target of the desired
   *            operation.
   * @param options The parameter options
   */
  constructor(e, t) {
    var a, n;
    if (e === void 0)
      throw new Error("'url' cannot be null");
    t || (t = {});
    const i = {
      requestContentType: "application/json; charset=utf-8"
    }, s = "azsdk-js-azure-storage-blob/12.27.0", o = t.userAgentOptions && t.userAgentOptions.userAgentPrefix ? `${t.userAgentOptions.userAgentPrefix} ${s}` : `${s}`, l = Object.assign(Object.assign(Object.assign({}, i), t), { userAgentOptions: {
      userAgentPrefix: o
    }, endpoint: (n = (a = t.endpoint) !== null && a !== void 0 ? a : t.baseUri) !== null && n !== void 0 ? n : "{url}" });
    super(l), this.url = e, this.version = t.version || "2025-05-05", this.service = new My(this), this.container = new Ay(this), this.blob = new sf(this), this.pageBlob = new Mf(this), this.appendBlob = new Uf(this), this.blockBlob = new Gf(this);
  }
};
class zm extends Vf {
  async sendOperationRequest(e, t) {
    const a = Object.assign({}, t);
    return (a.path === "/{containerName}" || a.path === "/{containerName}/{blob}") && (a.path = ""), super.sendOperationRequest(e, a);
  }
}
class ba {
  /**
   * Creates an instance of StorageClient.
   * @param url - url to resource
   * @param pipeline - request policy pipeline.
   */
  constructor(e, t) {
    this.url = Ep(e), this.accountName = ei(e), this.pipeline = t, this.storageClientContext = new zm(this.url, ai(t)), this.isHttps = Vn(Ip(this.url) || "", "https"), this.credential = ni(t);
    const a = this.storageClientContext;
    a.requestContentType = void 0;
  }
}
const x = vn({
  packageName: "@azure/storage-blob",
  packageVersion: Gn,
  namespace: "Microsoft.Storage"
});
class Ne {
  constructor() {
    this.read = !1, this.add = !1, this.create = !1, this.write = !1, this.delete = !1, this.deleteVersion = !1, this.tag = !1, this.move = !1, this.execute = !1, this.setImmutabilityPolicy = !1, this.permanentDelete = !1;
  }
  /**
   * Creates a {@link BlobSASPermissions} from the specified permissions string. This method will throw an
   * Error if it encounters a character that does not correspond to a valid permission.
   *
   * @param permissions -
   */
  static parse(e) {
    const t = new Ne();
    for (const a of e)
      switch (a) {
        case "r":
          t.read = !0;
          break;
        case "a":
          t.add = !0;
          break;
        case "c":
          t.create = !0;
          break;
        case "w":
          t.write = !0;
          break;
        case "d":
          t.delete = !0;
          break;
        case "x":
          t.deleteVersion = !0;
          break;
        case "t":
          t.tag = !0;
          break;
        case "m":
          t.move = !0;
          break;
        case "e":
          t.execute = !0;
          break;
        case "i":
          t.setImmutabilityPolicy = !0;
          break;
        case "y":
          t.permanentDelete = !0;
          break;
        default:
          throw new RangeError(`Invalid permission: ${a}`);
      }
    return t;
  }
  /**
   * Creates a {@link BlobSASPermissions} from a raw object which contains same keys as it
   * and boolean values for them.
   *
   * @param permissionLike -
   */
  static from(e) {
    const t = new Ne();
    return e.read && (t.read = !0), e.add && (t.add = !0), e.create && (t.create = !0), e.write && (t.write = !0), e.delete && (t.delete = !0), e.deleteVersion && (t.deleteVersion = !0), e.tag && (t.tag = !0), e.move && (t.move = !0), e.execute && (t.execute = !0), e.setImmutabilityPolicy && (t.setImmutabilityPolicy = !0), e.permanentDelete && (t.permanentDelete = !0), t;
  }
  /**
   * Converts the given permissions to a string. Using this method will guarantee the permissions are in an
   * order accepted by the service.
   *
   * @returns A string which represents the BlobSASPermissions
   */
  toString() {
    const e = [];
    return this.read && e.push("r"), this.add && e.push("a"), this.create && e.push("c"), this.write && e.push("w"), this.delete && e.push("d"), this.deleteVersion && e.push("x"), this.tag && e.push("t"), this.move && e.push("m"), this.execute && e.push("e"), this.setImmutabilityPolicy && e.push("i"), this.permanentDelete && e.push("y"), e.join("");
  }
}
class be {
  constructor() {
    this.read = !1, this.add = !1, this.create = !1, this.write = !1, this.delete = !1, this.deleteVersion = !1, this.list = !1, this.tag = !1, this.move = !1, this.execute = !1, this.setImmutabilityPolicy = !1, this.permanentDelete = !1, this.filterByTags = !1;
  }
  /**
   * Creates an {@link ContainerSASPermissions} from the specified permissions string. This method will throw an
   * Error if it encounters a character that does not correspond to a valid permission.
   *
   * @param permissions -
   */
  static parse(e) {
    const t = new be();
    for (const a of e)
      switch (a) {
        case "r":
          t.read = !0;
          break;
        case "a":
          t.add = !0;
          break;
        case "c":
          t.create = !0;
          break;
        case "w":
          t.write = !0;
          break;
        case "d":
          t.delete = !0;
          break;
        case "l":
          t.list = !0;
          break;
        case "t":
          t.tag = !0;
          break;
        case "x":
          t.deleteVersion = !0;
          break;
        case "m":
          t.move = !0;
          break;
        case "e":
          t.execute = !0;
          break;
        case "i":
          t.setImmutabilityPolicy = !0;
          break;
        case "y":
          t.permanentDelete = !0;
          break;
        case "f":
          t.filterByTags = !0;
          break;
        default:
          throw new RangeError(`Invalid permission ${a}`);
      }
    return t;
  }
  /**
   * Creates a {@link ContainerSASPermissions} from a raw object which contains same keys as it
   * and boolean values for them.
   *
   * @param permissionLike -
   */
  static from(e) {
    const t = new be();
    return e.read && (t.read = !0), e.add && (t.add = !0), e.create && (t.create = !0), e.write && (t.write = !0), e.delete && (t.delete = !0), e.list && (t.list = !0), e.deleteVersion && (t.deleteVersion = !0), e.tag && (t.tag = !0), e.move && (t.move = !0), e.execute && (t.execute = !0), e.setImmutabilityPolicy && (t.setImmutabilityPolicy = !0), e.permanentDelete && (t.permanentDelete = !0), e.filterByTags && (t.filterByTags = !0), t;
  }
  /**
   * Converts the given permissions to a string. Using this method will guarantee the permissions are in an
   * order accepted by the service.
   *
   * The order of the characters should be as specified here to ensure correctness.
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/constructing-a-service-sas
   *
   */
  toString() {
    const e = [];
    return this.read && e.push("r"), this.add && e.push("a"), this.create && e.push("c"), this.write && e.push("w"), this.delete && e.push("d"), this.deleteVersion && e.push("x"), this.list && e.push("l"), this.tag && e.push("t"), this.move && e.push("m"), this.execute && e.push("e"), this.setImmutabilityPolicy && e.push("i"), this.permanentDelete && e.push("y"), this.filterByTags && e.push("f"), e.join("");
  }
}
class eg {
}
function Ce(r) {
  return r.end ? `${r.start}-${r.end}` : r.start;
}
var Ja;
(function(r) {
  r.Https = "https", r.HttpsAndHttp = "https,http";
})(Ja || (Ja = {}));
class Ue {
  /**
   * Optional. IP range allowed for this SAS.
   *
   * @readonly
   */
  get ipRange() {
    if (this.ipRangeInner)
      return {
        end: this.ipRangeInner.end,
        start: this.ipRangeInner.start
      };
  }
  constructor(e, t, a, n, i, s, o, l, m, c, d, p, y, u, h, R, M, T, $, f) {
    this.version = e, this.signature = t, a !== void 0 && typeof a != "string" ? (this.permissions = a.permissions, this.services = a.services, this.resourceTypes = a.resourceTypes, this.protocol = a.protocol, this.startsOn = a.startsOn, this.expiresOn = a.expiresOn, this.ipRangeInner = a.ipRange, this.identifier = a.identifier, this.encryptionScope = a.encryptionScope, this.resource = a.resource, this.cacheControl = a.cacheControl, this.contentDisposition = a.contentDisposition, this.contentEncoding = a.contentEncoding, this.contentLanguage = a.contentLanguage, this.contentType = a.contentType, a.userDelegationKey && (this.signedOid = a.userDelegationKey.signedObjectId, this.signedTenantId = a.userDelegationKey.signedTenantId, this.signedStartsOn = a.userDelegationKey.signedStartsOn, this.signedExpiresOn = a.userDelegationKey.signedExpiresOn, this.signedService = a.userDelegationKey.signedService, this.signedVersion = a.userDelegationKey.signedVersion, this.preauthorizedAgentObjectId = a.preauthorizedAgentObjectId, this.correlationId = a.correlationId)) : (this.services = n, this.resourceTypes = i, this.expiresOn = l, this.permissions = a, this.protocol = s, this.startsOn = o, this.ipRangeInner = m, this.encryptionScope = f, this.identifier = c, this.resource = d, this.cacheControl = p, this.contentDisposition = y, this.contentEncoding = u, this.contentLanguage = h, this.contentType = R, M && (this.signedOid = M.signedObjectId, this.signedTenantId = M.signedTenantId, this.signedStartsOn = M.signedStartsOn, this.signedExpiresOn = M.signedExpiresOn, this.signedService = M.signedService, this.signedVersion = M.signedVersion, this.preauthorizedAgentObjectId = T, this.correlationId = $));
  }
  /**
   * Encodes all SAS query parameters into a string that can be appended to a URL.
   *
   */
  toString() {
    const e = [
      "sv",
      "ss",
      "srt",
      "spr",
      "st",
      "se",
      "sip",
      "si",
      "ses",
      "skoid",
      // Signed object ID
      "sktid",
      // Signed tenant ID
      "skt",
      // Signed key start time
      "ske",
      // Signed key expiry time
      "sks",
      // Signed key service
      "skv",
      // Signed key version
      "sr",
      "sp",
      "sig",
      "rscc",
      "rscd",
      "rsce",
      "rscl",
      "rsct",
      "saoid",
      "scid"
    ], t = [];
    for (const a of e)
      switch (a) {
        case "sv":
          this.tryAppendQueryParameter(t, a, this.version);
          break;
        case "ss":
          this.tryAppendQueryParameter(t, a, this.services);
          break;
        case "srt":
          this.tryAppendQueryParameter(t, a, this.resourceTypes);
          break;
        case "spr":
          this.tryAppendQueryParameter(t, a, this.protocol);
          break;
        case "st":
          this.tryAppendQueryParameter(t, a, this.startsOn ? k(this.startsOn, !1) : void 0);
          break;
        case "se":
          this.tryAppendQueryParameter(t, a, this.expiresOn ? k(this.expiresOn, !1) : void 0);
          break;
        case "sip":
          this.tryAppendQueryParameter(t, a, this.ipRange ? Ce(this.ipRange) : void 0);
          break;
        case "si":
          this.tryAppendQueryParameter(t, a, this.identifier);
          break;
        case "ses":
          this.tryAppendQueryParameter(t, a, this.encryptionScope);
          break;
        case "skoid":
          this.tryAppendQueryParameter(t, a, this.signedOid);
          break;
        case "sktid":
          this.tryAppendQueryParameter(t, a, this.signedTenantId);
          break;
        case "skt":
          this.tryAppendQueryParameter(t, a, this.signedStartsOn ? k(this.signedStartsOn, !1) : void 0);
          break;
        case "ske":
          this.tryAppendQueryParameter(t, a, this.signedExpiresOn ? k(this.signedExpiresOn, !1) : void 0);
          break;
        case "sks":
          this.tryAppendQueryParameter(t, a, this.signedService);
          break;
        case "skv":
          this.tryAppendQueryParameter(t, a, this.signedVersion);
          break;
        case "sr":
          this.tryAppendQueryParameter(t, a, this.resource);
          break;
        case "sp":
          this.tryAppendQueryParameter(t, a, this.permissions);
          break;
        case "sig":
          this.tryAppendQueryParameter(t, a, this.signature);
          break;
        case "rscc":
          this.tryAppendQueryParameter(t, a, this.cacheControl);
          break;
        case "rscd":
          this.tryAppendQueryParameter(t, a, this.contentDisposition);
          break;
        case "rsce":
          this.tryAppendQueryParameter(t, a, this.contentEncoding);
          break;
        case "rscl":
          this.tryAppendQueryParameter(t, a, this.contentLanguage);
          break;
        case "rsct":
          this.tryAppendQueryParameter(t, a, this.contentType);
          break;
        case "saoid":
          this.tryAppendQueryParameter(t, a, this.preauthorizedAgentObjectId);
          break;
        case "scid":
          this.tryAppendQueryParameter(t, a, this.correlationId);
          break;
      }
    return t.join("&");
  }
  /**
   * A private helper method used to filter and append query key/value pairs into an array.
   *
   * @param queries -
   * @param key -
   * @param value -
   */
  tryAppendQueryParameter(e, t, a) {
    a && (t = encodeURIComponent(t), a = encodeURIComponent(a), t.length > 0 && a.length > 0 && e.push(`${t}=${a}`));
  }
}
function rr(r, e, t) {
  return Lt(r, e, t).sasQueryParameters;
}
function Lt(r, e, t) {
  const a = r.version ? r.version : na, n = e instanceof K ? e : void 0;
  let i;
  if (n === void 0 && t !== void 0 && (i = new eg(t, e)), n === void 0 && i === void 0)
    throw TypeError("Invalid sharedKeyCredential, userDelegationKey or accountName.");
  if (a >= "2020-12-06")
    return n !== void 0 ? ag(r, n) : sg(r, i);
  if (a >= "2018-11-09")
    return n !== void 0 ? rg(r, n) : a >= "2020-02-10" ? ig(r, i) : ng(r, i);
  if (a >= "2015-04-05") {
    if (n !== void 0)
      return tg(r, n);
    throw new RangeError("'version' must be >= '2018-11-09' when generating user delegation SAS using user delegation key.");
  }
  throw new RangeError("'version' must be >= '2015-04-05'.");
}
function tg(r, e) {
  if (r = bt(r), !r.identifier && !(r.permissions && r.expiresOn))
    throw new RangeError("Must provide 'permissions' and 'expiresOn' for Blob SAS generation when 'identifier' is not provided.");
  let t = "c";
  r.blobName && (t = "b");
  let a;
  r.permissions && (r.blobName ? a = Ne.parse(r.permissions.toString()).toString() : a = be.parse(r.permissions.toString()).toString());
  const n = [
    a || "",
    r.startsOn ? k(r.startsOn, !1) : "",
    r.expiresOn ? k(r.expiresOn, !1) : "",
    Nt(e.accountName, r.containerName, r.blobName),
    r.identifier,
    r.ipRange ? Ce(r.ipRange) : "",
    r.protocol ? r.protocol : "",
    r.version,
    r.cacheControl ? r.cacheControl : "",
    r.contentDisposition ? r.contentDisposition : "",
    r.contentEncoding ? r.contentEncoding : "",
    r.contentLanguage ? r.contentLanguage : "",
    r.contentType ? r.contentType : ""
  ].join(`
`), i = e.computeHMACSHA256(n);
  return {
    sasQueryParameters: new Ue(r.version, i, a, void 0, void 0, r.protocol, r.startsOn, r.expiresOn, r.ipRange, r.identifier, t, r.cacheControl, r.contentDisposition, r.contentEncoding, r.contentLanguage, r.contentType),
    stringToSign: n
  };
}
function rg(r, e) {
  if (r = bt(r), !r.identifier && !(r.permissions && r.expiresOn))
    throw new RangeError("Must provide 'permissions' and 'expiresOn' for Blob SAS generation when 'identifier' is not provided.");
  let t = "c", a = r.snapshotTime;
  r.blobName && (t = "b", r.snapshotTime ? t = "bs" : r.versionId && (t = "bv", a = r.versionId));
  let n;
  r.permissions && (r.blobName ? n = Ne.parse(r.permissions.toString()).toString() : n = be.parse(r.permissions.toString()).toString());
  const i = [
    n || "",
    r.startsOn ? k(r.startsOn, !1) : "",
    r.expiresOn ? k(r.expiresOn, !1) : "",
    Nt(e.accountName, r.containerName, r.blobName),
    r.identifier,
    r.ipRange ? Ce(r.ipRange) : "",
    r.protocol ? r.protocol : "",
    r.version,
    t,
    a,
    r.cacheControl ? r.cacheControl : "",
    r.contentDisposition ? r.contentDisposition : "",
    r.contentEncoding ? r.contentEncoding : "",
    r.contentLanguage ? r.contentLanguage : "",
    r.contentType ? r.contentType : ""
  ].join(`
`), s = e.computeHMACSHA256(i);
  return {
    sasQueryParameters: new Ue(r.version, s, n, void 0, void 0, r.protocol, r.startsOn, r.expiresOn, r.ipRange, r.identifier, t, r.cacheControl, r.contentDisposition, r.contentEncoding, r.contentLanguage, r.contentType),
    stringToSign: i
  };
}
function ag(r, e) {
  if (r = bt(r), !r.identifier && !(r.permissions && r.expiresOn))
    throw new RangeError("Must provide 'permissions' and 'expiresOn' for Blob SAS generation when 'identifier' is not provided.");
  let t = "c", a = r.snapshotTime;
  r.blobName && (t = "b", r.snapshotTime ? t = "bs" : r.versionId && (t = "bv", a = r.versionId));
  let n;
  r.permissions && (r.blobName ? n = Ne.parse(r.permissions.toString()).toString() : n = be.parse(r.permissions.toString()).toString());
  const i = [
    n || "",
    r.startsOn ? k(r.startsOn, !1) : "",
    r.expiresOn ? k(r.expiresOn, !1) : "",
    Nt(e.accountName, r.containerName, r.blobName),
    r.identifier,
    r.ipRange ? Ce(r.ipRange) : "",
    r.protocol ? r.protocol : "",
    r.version,
    t,
    a,
    r.encryptionScope,
    r.cacheControl ? r.cacheControl : "",
    r.contentDisposition ? r.contentDisposition : "",
    r.contentEncoding ? r.contentEncoding : "",
    r.contentLanguage ? r.contentLanguage : "",
    r.contentType ? r.contentType : ""
  ].join(`
`), s = e.computeHMACSHA256(i);
  return {
    sasQueryParameters: new Ue(r.version, s, n, void 0, void 0, r.protocol, r.startsOn, r.expiresOn, r.ipRange, r.identifier, t, r.cacheControl, r.contentDisposition, r.contentEncoding, r.contentLanguage, r.contentType, void 0, void 0, void 0, r.encryptionScope),
    stringToSign: i
  };
}
function ng(r, e) {
  if (r = bt(r), !r.permissions || !r.expiresOn)
    throw new RangeError("Must provide 'permissions' and 'expiresOn' for Blob SAS generation when generating user delegation SAS.");
  let t = "c", a = r.snapshotTime;
  r.blobName && (t = "b", r.snapshotTime ? t = "bs" : r.versionId && (t = "bv", a = r.versionId));
  let n;
  r.permissions && (r.blobName ? n = Ne.parse(r.permissions.toString()).toString() : n = be.parse(r.permissions.toString()).toString());
  const i = [
    n || "",
    r.startsOn ? k(r.startsOn, !1) : "",
    r.expiresOn ? k(r.expiresOn, !1) : "",
    Nt(e.accountName, r.containerName, r.blobName),
    e.userDelegationKey.signedObjectId,
    e.userDelegationKey.signedTenantId,
    e.userDelegationKey.signedStartsOn ? k(e.userDelegationKey.signedStartsOn, !1) : "",
    e.userDelegationKey.signedExpiresOn ? k(e.userDelegationKey.signedExpiresOn, !1) : "",
    e.userDelegationKey.signedService,
    e.userDelegationKey.signedVersion,
    r.ipRange ? Ce(r.ipRange) : "",
    r.protocol ? r.protocol : "",
    r.version,
    t,
    a,
    r.cacheControl,
    r.contentDisposition,
    r.contentEncoding,
    r.contentLanguage,
    r.contentType
  ].join(`
`), s = e.computeHMACSHA256(i);
  return {
    sasQueryParameters: new Ue(r.version, s, n, void 0, void 0, r.protocol, r.startsOn, r.expiresOn, r.ipRange, r.identifier, t, r.cacheControl, r.contentDisposition, r.contentEncoding, r.contentLanguage, r.contentType, e.userDelegationKey),
    stringToSign: i
  };
}
function ig(r, e) {
  if (r = bt(r), !r.permissions || !r.expiresOn)
    throw new RangeError("Must provide 'permissions' and 'expiresOn' for Blob SAS generation when generating user delegation SAS.");
  let t = "c", a = r.snapshotTime;
  r.blobName && (t = "b", r.snapshotTime ? t = "bs" : r.versionId && (t = "bv", a = r.versionId));
  let n;
  r.permissions && (r.blobName ? n = Ne.parse(r.permissions.toString()).toString() : n = be.parse(r.permissions.toString()).toString());
  const i = [
    n || "",
    r.startsOn ? k(r.startsOn, !1) : "",
    r.expiresOn ? k(r.expiresOn, !1) : "",
    Nt(e.accountName, r.containerName, r.blobName),
    e.userDelegationKey.signedObjectId,
    e.userDelegationKey.signedTenantId,
    e.userDelegationKey.signedStartsOn ? k(e.userDelegationKey.signedStartsOn, !1) : "",
    e.userDelegationKey.signedExpiresOn ? k(e.userDelegationKey.signedExpiresOn, !1) : "",
    e.userDelegationKey.signedService,
    e.userDelegationKey.signedVersion,
    r.preauthorizedAgentObjectId,
    void 0,
    // agentObjectId
    r.correlationId,
    r.ipRange ? Ce(r.ipRange) : "",
    r.protocol ? r.protocol : "",
    r.version,
    t,
    a,
    r.cacheControl,
    r.contentDisposition,
    r.contentEncoding,
    r.contentLanguage,
    r.contentType
  ].join(`
`), s = e.computeHMACSHA256(i);
  return {
    sasQueryParameters: new Ue(r.version, s, n, void 0, void 0, r.protocol, r.startsOn, r.expiresOn, r.ipRange, r.identifier, t, r.cacheControl, r.contentDisposition, r.contentEncoding, r.contentLanguage, r.contentType, e.userDelegationKey, r.preauthorizedAgentObjectId, r.correlationId),
    stringToSign: i
  };
}
function sg(r, e) {
  if (r = bt(r), !r.permissions || !r.expiresOn)
    throw new RangeError("Must provide 'permissions' and 'expiresOn' for Blob SAS generation when generating user delegation SAS.");
  let t = "c", a = r.snapshotTime;
  r.blobName && (t = "b", r.snapshotTime ? t = "bs" : r.versionId && (t = "bv", a = r.versionId));
  let n;
  r.permissions && (r.blobName ? n = Ne.parse(r.permissions.toString()).toString() : n = be.parse(r.permissions.toString()).toString());
  const i = [
    n || "",
    r.startsOn ? k(r.startsOn, !1) : "",
    r.expiresOn ? k(r.expiresOn, !1) : "",
    Nt(e.accountName, r.containerName, r.blobName),
    e.userDelegationKey.signedObjectId,
    e.userDelegationKey.signedTenantId,
    e.userDelegationKey.signedStartsOn ? k(e.userDelegationKey.signedStartsOn, !1) : "",
    e.userDelegationKey.signedExpiresOn ? k(e.userDelegationKey.signedExpiresOn, !1) : "",
    e.userDelegationKey.signedService,
    e.userDelegationKey.signedVersion,
    r.preauthorizedAgentObjectId,
    void 0,
    // agentObjectId
    r.correlationId,
    r.ipRange ? Ce(r.ipRange) : "",
    r.protocol ? r.protocol : "",
    r.version,
    t,
    a,
    r.encryptionScope,
    r.cacheControl,
    r.contentDisposition,
    r.contentEncoding,
    r.contentLanguage,
    r.contentType
  ].join(`
`), s = e.computeHMACSHA256(i);
  return {
    sasQueryParameters: new Ue(r.version, s, n, void 0, void 0, r.protocol, r.startsOn, r.expiresOn, r.ipRange, r.identifier, t, r.cacheControl, r.contentDisposition, r.contentEncoding, r.contentLanguage, r.contentType, e.userDelegationKey, r.preauthorizedAgentObjectId, r.correlationId, r.encryptionScope),
    stringToSign: i
  };
}
function Nt(r, e, t) {
  const a = [`/blob/${r}/${e}`];
  return t && a.push(`/${t}`), a.join("");
}
function bt(r) {
  const e = r.version ? r.version : na;
  if (r.snapshotTime && e < "2018-11-09")
    throw RangeError("'version' must be >= '2018-11-09' when providing 'snapshotTime'.");
  if (r.blobName === void 0 && r.snapshotTime)
    throw RangeError("Must provide 'blobName' when providing 'snapshotTime'.");
  if (r.versionId && e < "2019-10-10")
    throw RangeError("'version' must be >= '2019-10-10' when providing 'versionId'.");
  if (r.blobName === void 0 && r.versionId)
    throw RangeError("Must provide 'blobName' when providing 'versionId'.");
  if (r.permissions && r.permissions.setImmutabilityPolicy && e < "2020-08-04")
    throw RangeError("'version' must be >= '2020-08-04' when provided 'i' permission.");
  if (r.permissions && r.permissions.deleteVersion && e < "2019-10-10")
    throw RangeError("'version' must be >= '2019-10-10' when providing 'x' permission.");
  if (r.permissions && r.permissions.permanentDelete && e < "2019-10-10")
    throw RangeError("'version' must be >= '2019-10-10' when providing 'y' permission.");
  if (r.permissions && r.permissions.tag && e < "2019-12-12")
    throw RangeError("'version' must be >= '2019-12-12' when providing 't' permission.");
  if (e < "2020-02-10" && r.permissions && (r.permissions.move || r.permissions.execute))
    throw RangeError("'version' must be >= '2020-02-10' when providing the 'm' or 'e' permission.");
  if (e < "2021-04-10" && r.permissions && r.permissions.filterByTags)
    throw RangeError("'version' must be >= '2021-04-10' when providing the 'f' permission.");
  if (e < "2020-02-10" && (r.preauthorizedAgentObjectId || r.correlationId))
    throw RangeError("'version' must be >= '2020-02-10' when providing 'preauthorizedAgentObjectId' or 'correlationId'.");
  if (r.encryptionScope && e < "2020-12-06")
    throw RangeError("'version' must be >= '2020-12-06' when provided 'encryptionScope' in SAS.");
  return r.version = e, r;
}
class Sm {
  /**
   * Gets the lease Id.
   *
   * @readonly
   */
  get leaseId() {
    return this._leaseId;
  }
  /**
   * Gets the url.
   *
   * @readonly
   */
  get url() {
    return this._url;
  }
  /**
   * Creates an instance of BlobLeaseClient.
   * @param client - The client to make the lease operation requests.
   * @param leaseId - Initial proposed lease id.
   */
  constructor(e, t) {
    const a = e.storageClientContext;
    this._url = e.url, e.name === void 0 ? (this._isContainer = !0, this._containerOrBlobOperation = a.container) : (this._isContainer = !1, this._containerOrBlobOperation = a.blob), t || (t = Vt()), this._leaseId = t;
  }
  /**
   * Establishes and manages a lock on a container for delete operations, or on a blob
   * for write and delete operations.
   * The lock duration can be 15 to 60 seconds, or can be infinite.
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/lease-container
   * and
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/lease-blob
   *
   * @param duration - Must be between 15 to 60 seconds, or infinite (-1)
   * @param options - option to configure lease management operations.
   * @returns Response data for acquire lease operation.
   */
  async acquireLease(e, t = {}) {
    var a, n, i, s, o;
    if (this._isContainer && (!((a = t.conditions) === null || a === void 0) && a.ifMatch && ((n = t.conditions) === null || n === void 0 ? void 0 : n.ifMatch) !== ye || !((i = t.conditions) === null || i === void 0) && i.ifNoneMatch && ((s = t.conditions) === null || s === void 0 ? void 0 : s.ifNoneMatch) !== ye || !((o = t.conditions) === null || o === void 0) && o.tagConditions))
      throw new RangeError("The IfMatch, IfNoneMatch and tags access conditions are ignored by the service. Values other than undefined or their default values are not acceptable.");
    return x.withSpan("BlobLeaseClient-acquireLease", t, async (l) => {
      var m;
      return C(await this._containerOrBlobOperation.acquireLease({
        abortSignal: t.abortSignal,
        duration: e,
        modifiedAccessConditions: Object.assign(Object.assign({}, t.conditions), { ifTags: (m = t.conditions) === null || m === void 0 ? void 0 : m.tagConditions }),
        proposedLeaseId: this._leaseId,
        tracingOptions: l.tracingOptions
      }));
    });
  }
  /**
   * To change the ID of the lease.
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/lease-container
   * and
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/lease-blob
   *
   * @param proposedLeaseId - the proposed new lease Id.
   * @param options - option to configure lease management operations.
   * @returns Response data for change lease operation.
   */
  async changeLease(e, t = {}) {
    var a, n, i, s, o;
    if (this._isContainer && (!((a = t.conditions) === null || a === void 0) && a.ifMatch && ((n = t.conditions) === null || n === void 0 ? void 0 : n.ifMatch) !== ye || !((i = t.conditions) === null || i === void 0) && i.ifNoneMatch && ((s = t.conditions) === null || s === void 0 ? void 0 : s.ifNoneMatch) !== ye || !((o = t.conditions) === null || o === void 0) && o.tagConditions))
      throw new RangeError("The IfMatch, IfNoneMatch and tags access conditions are ignored by the service. Values other than undefined or their default values are not acceptable.");
    return x.withSpan("BlobLeaseClient-changeLease", t, async (l) => {
      var m;
      const c = C(await this._containerOrBlobOperation.changeLease(this._leaseId, e, {
        abortSignal: t.abortSignal,
        modifiedAccessConditions: Object.assign(Object.assign({}, t.conditions), { ifTags: (m = t.conditions) === null || m === void 0 ? void 0 : m.tagConditions }),
        tracingOptions: l.tracingOptions
      }));
      return this._leaseId = e, c;
    });
  }
  /**
   * To free the lease if it is no longer needed so that another client may
   * immediately acquire a lease against the container or the blob.
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/lease-container
   * and
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/lease-blob
   *
   * @param options - option to configure lease management operations.
   * @returns Response data for release lease operation.
   */
  async releaseLease(e = {}) {
    var t, a, n, i, s;
    if (this._isContainer && (!((t = e.conditions) === null || t === void 0) && t.ifMatch && ((a = e.conditions) === null || a === void 0 ? void 0 : a.ifMatch) !== ye || !((n = e.conditions) === null || n === void 0) && n.ifNoneMatch && ((i = e.conditions) === null || i === void 0 ? void 0 : i.ifNoneMatch) !== ye || !((s = e.conditions) === null || s === void 0) && s.tagConditions))
      throw new RangeError("The IfMatch, IfNoneMatch and tags access conditions are ignored by the service. Values other than undefined or their default values are not acceptable.");
    return x.withSpan("BlobLeaseClient-releaseLease", e, async (o) => {
      var l;
      return C(await this._containerOrBlobOperation.releaseLease(this._leaseId, {
        abortSignal: e.abortSignal,
        modifiedAccessConditions: Object.assign(Object.assign({}, e.conditions), { ifTags: (l = e.conditions) === null || l === void 0 ? void 0 : l.tagConditions }),
        tracingOptions: o.tracingOptions
      }));
    });
  }
  /**
   * To renew the lease.
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/lease-container
   * and
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/lease-blob
   *
   * @param options - Optional option to configure lease management operations.
   * @returns Response data for renew lease operation.
   */
  async renewLease(e = {}) {
    var t, a, n, i, s;
    if (this._isContainer && (!((t = e.conditions) === null || t === void 0) && t.ifMatch && ((a = e.conditions) === null || a === void 0 ? void 0 : a.ifMatch) !== ye || !((n = e.conditions) === null || n === void 0) && n.ifNoneMatch && ((i = e.conditions) === null || i === void 0 ? void 0 : i.ifNoneMatch) !== ye || !((s = e.conditions) === null || s === void 0) && s.tagConditions))
      throw new RangeError("The IfMatch, IfNoneMatch and tags access conditions are ignored by the service. Values other than undefined or their default values are not acceptable.");
    return x.withSpan("BlobLeaseClient-renewLease", e, async (o) => {
      var l;
      return this._containerOrBlobOperation.renewLease(this._leaseId, {
        abortSignal: e.abortSignal,
        modifiedAccessConditions: Object.assign(Object.assign({}, e.conditions), { ifTags: (l = e.conditions) === null || l === void 0 ? void 0 : l.tagConditions }),
        tracingOptions: o.tracingOptions
      });
    });
  }
  /**
   * To end the lease but ensure that another client cannot acquire a new lease
   * until the current lease period has expired.
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/lease-container
   * and
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/lease-blob
   *
   * @param breakPeriod - Break period
   * @param options - Optional options to configure lease management operations.
   * @returns Response data for break lease operation.
   */
  async breakLease(e, t = {}) {
    var a, n, i, s, o;
    if (this._isContainer && (!((a = t.conditions) === null || a === void 0) && a.ifMatch && ((n = t.conditions) === null || n === void 0 ? void 0 : n.ifMatch) !== ye || !((i = t.conditions) === null || i === void 0) && i.ifNoneMatch && ((s = t.conditions) === null || s === void 0 ? void 0 : s.ifNoneMatch) !== ye || !((o = t.conditions) === null || o === void 0) && o.tagConditions))
      throw new RangeError("The IfMatch, IfNoneMatch and tags access conditions are ignored by the service. Values other than undefined or their default values are not acceptable.");
    return x.withSpan("BlobLeaseClient-breakLease", t, async (l) => {
      var m;
      const c = {
        abortSignal: t.abortSignal,
        breakPeriod: e,
        modifiedAccessConditions: Object.assign(Object.assign({}, t.conditions), { ifTags: (m = t.conditions) === null || m === void 0 ? void 0 : m.tagConditions }),
        tracingOptions: l.tracingOptions
      };
      return C(await this._containerOrBlobOperation.breakLease(c));
    });
  }
}
const og = 1;
class mg {
  /**
   * Indicates that the service supports
   * requests for partial file content.
   *
   * @readonly
   */
  get acceptRanges() {
    return this.originalResponse.acceptRanges;
  }
  /**
   * Returns if it was previously specified
   * for the file.
   *
   * @readonly
   */
  get cacheControl() {
    return this.originalResponse.cacheControl;
  }
  /**
   * Returns the value that was specified
   * for the 'x-ms-content-disposition' header and specifies how to process the
   * response.
   *
   * @readonly
   */
  get contentDisposition() {
    return this.originalResponse.contentDisposition;
  }
  /**
   * Returns the value that was specified
   * for the Content-Encoding request header.
   *
   * @readonly
   */
  get contentEncoding() {
    return this.originalResponse.contentEncoding;
  }
  /**
   * Returns the value that was specified
   * for the Content-Language request header.
   *
   * @readonly
   */
  get contentLanguage() {
    return this.originalResponse.contentLanguage;
  }
  /**
   * The current sequence number for a
   * page blob. This header is not returned for block blobs or append blobs.
   *
   * @readonly
   */
  get blobSequenceNumber() {
    return this.originalResponse.blobSequenceNumber;
  }
  /**
   * The blob's type. Possible values include:
   * 'BlockBlob', 'PageBlob', 'AppendBlob'.
   *
   * @readonly
   */
  get blobType() {
    return this.originalResponse.blobType;
  }
  /**
   * The number of bytes present in the
   * response body.
   *
   * @readonly
   */
  get contentLength() {
    return this.originalResponse.contentLength;
  }
  /**
   * If the file has an MD5 hash and the
   * request is to read the full file, this response header is returned so that
   * the client can check for message content integrity. If the request is to
   * read a specified range and the 'x-ms-range-get-content-md5' is set to
   * true, then the request returns an MD5 hash for the range, as long as the
   * range size is less than or equal to 4 MB. If neither of these sets of
   * conditions is true, then no value is returned for the 'Content-MD5'
   * header.
   *
   * @readonly
   */
  get contentMD5() {
    return this.originalResponse.contentMD5;
  }
  /**
   * Indicates the range of bytes returned if
   * the client requested a subset of the file by setting the Range request
   * header.
   *
   * @readonly
   */
  get contentRange() {
    return this.originalResponse.contentRange;
  }
  /**
   * The content type specified for the file.
   * The default content type is 'application/octet-stream'
   *
   * @readonly
   */
  get contentType() {
    return this.originalResponse.contentType;
  }
  /**
   * Conclusion time of the last attempted
   * Copy File operation where this file was the destination file. This value
   * can specify the time of a completed, aborted, or failed copy attempt.
   *
   * @readonly
   */
  get copyCompletedOn() {
  }
  /**
   * String identifier for the last attempted Copy
   * File operation where this file was the destination file.
   *
   * @readonly
   */
  get copyId() {
    return this.originalResponse.copyId;
  }
  /**
   * Contains the number of bytes copied and
   * the total bytes in the source in the last attempted Copy File operation
   * where this file was the destination file. Can show between 0 and
   * Content-Length bytes copied.
   *
   * @readonly
   */
  get copyProgress() {
    return this.originalResponse.copyProgress;
  }
  /**
   * URL up to 2KB in length that specifies the
   * source file used in the last attempted Copy File operation where this file
   * was the destination file.
   *
   * @readonly
   */
  get copySource() {
    return this.originalResponse.copySource;
  }
  /**
   * State of the copy operation
   * identified by 'x-ms-copy-id'. Possible values include: 'pending',
   * 'success', 'aborted', 'failed'
   *
   * @readonly
   */
  get copyStatus() {
    return this.originalResponse.copyStatus;
  }
  /**
   * Only appears when
   * x-ms-copy-status is failed or pending. Describes cause of fatal or
   * non-fatal copy operation failure.
   *
   * @readonly
   */
  get copyStatusDescription() {
    return this.originalResponse.copyStatusDescription;
  }
  /**
   * When a blob is leased,
   * specifies whether the lease is of infinite or fixed duration. Possible
   * values include: 'infinite', 'fixed'.
   *
   * @readonly
   */
  get leaseDuration() {
    return this.originalResponse.leaseDuration;
  }
  /**
   * Lease state of the blob. Possible
   * values include: 'available', 'leased', 'expired', 'breaking', 'broken'.
   *
   * @readonly
   */
  get leaseState() {
    return this.originalResponse.leaseState;
  }
  /**
   * The current lease status of the
   * blob. Possible values include: 'locked', 'unlocked'.
   *
   * @readonly
   */
  get leaseStatus() {
    return this.originalResponse.leaseStatus;
  }
  /**
   * A UTC date/time value generated by the service that
   * indicates the time at which the response was initiated.
   *
   * @readonly
   */
  get date() {
    return this.originalResponse.date;
  }
  /**
   * The number of committed blocks
   * present in the blob. This header is returned only for append blobs.
   *
   * @readonly
   */
  get blobCommittedBlockCount() {
    return this.originalResponse.blobCommittedBlockCount;
  }
  /**
   * The ETag contains a value that you can use to
   * perform operations conditionally, in quotes.
   *
   * @readonly
   */
  get etag() {
    return this.originalResponse.etag;
  }
  /**
   * The error code.
   *
   * @readonly
   */
  get errorCode() {
    return this.originalResponse.errorCode;
  }
  /**
   * The value of this header is set to
   * true if the file data and application metadata are completely encrypted
   * using the specified algorithm. Otherwise, the value is set to false (when
   * the file is unencrypted, or if only parts of the file/application metadata
   * are encrypted).
   *
   * @readonly
   */
  get isServerEncrypted() {
    return this.originalResponse.isServerEncrypted;
  }
  /**
   * If the blob has a MD5 hash, and if
   * request contains range header (Range or x-ms-range), this response header
   * is returned with the value of the whole blob's MD5 value. This value may
   * or may not be equal to the value returned in Content-MD5 header, with the
   * latter calculated from the requested range.
   *
   * @readonly
   */
  get blobContentMD5() {
    return this.originalResponse.blobContentMD5;
  }
  /**
   * Returns the date and time the file was last
   * modified. Any operation that modifies the file or its properties updates
   * the last modified time.
   *
   * @readonly
   */
  get lastModified() {
    return this.originalResponse.lastModified;
  }
  /**
   * A name-value pair
   * to associate with a file storage object.
   *
   * @readonly
   */
  get metadata() {
    return this.originalResponse.metadata;
  }
  /**
   * This header uniquely identifies the request
   * that was made and can be used for troubleshooting the request.
   *
   * @readonly
   */
  get requestId() {
    return this.originalResponse.requestId;
  }
  /**
   * If a client request id header is sent in the request, this header will be present in the
   * response with the same value.
   *
   * @readonly
   */
  get clientRequestId() {
    return this.originalResponse.clientRequestId;
  }
  /**
   * Indicates the version of the File service used
   * to execute the request.
   *
   * @readonly
   */
  get version() {
    return this.originalResponse.version;
  }
  /**
   * The SHA-256 hash of the encryption key used to encrypt the blob. This value is only returned
   * when the blob was encrypted with a customer-provided key.
   *
   * @readonly
   */
  get encryptionKeySha256() {
    return this.originalResponse.encryptionKeySha256;
  }
  /**
   * If the request is to read a specified range and the x-ms-range-get-content-crc64 is set to
   * true, then the request returns a crc64 for the range, as long as the range size is less than
   * or equal to 4 MB. If both x-ms-range-get-content-crc64 & x-ms-range-get-content-md5 is
   * specified in the same request, it will fail with 400(Bad Request)
   */
  get contentCrc64() {
    return this.originalResponse.contentCrc64;
  }
  /**
   * The response body as a browser Blob.
   * Always undefined in node.js.
   *
   * @readonly
   */
  get blobBody() {
    throw Error("Quick query in browser is not supported yet.");
  }
  /**
   * The response body as a node.js Readable stream.
   * Always undefined in the browser.
   *
   * @readonly
   */
  get readableStreamBody() {
  }
  /**
   * The HTTP response.
   */
  get _response() {
    return this.originalResponse._response;
  }
  /**
   * Creates an instance of BlobQueryResponse.
   *
   * @param originalResponse -
   * @param options -
   */
  constructor(e, t = {}) {
    this.originalResponse = e;
  }
}
var Ur;
(function(r) {
  r.Hot = "Hot", r.Cool = "Cool", r.Cold = "Cold", r.Archive = "Archive";
})(Ur || (Ur = {}));
var Ya;
(function(r) {
  r.P4 = "P4", r.P6 = "P6", r.P10 = "P10", r.P15 = "P15", r.P20 = "P20", r.P30 = "P30", r.P40 = "P40", r.P50 = "P50", r.P60 = "P60", r.P70 = "P70", r.P80 = "P80";
})(Ya || (Ya = {}));
function Oe(r) {
  if (r !== void 0)
    return r;
}
function J(r, e) {
  if (r && !e)
    throw new RangeError("Customer-provided encryption key must be used over HTTPS.");
  r && !r.encryptionAlgorithm && (r.encryptionAlgorithm = Pp);
}
var Za;
(function(r) {
  r.StorageOAuthScopes = "https://storage.azure.com/.default", r.DiskComputeOAuthScopes = "https://disk.compute.azure.com/.default";
})(Za || (Za = {}));
function wr(r) {
  const e = (r._response.parsedBody.pageRange || []).map((a) => ({
    offset: a.start,
    count: a.end - a.start
  })), t = (r._response.parsedBody.clearRange || []).map((a) => ({
    offset: a.start,
    count: a.end - a.start
  }));
  return Object.assign(Object.assign({}, r), {
    pageRange: e,
    clearRange: t,
    _response: Object.assign(Object.assign({}, r._response), { parsedBody: {
      pageRange: e,
      clearRange: t
    } })
  });
}
class Ca extends Error {
  constructor(e) {
    super(e), this.name = "PollerStoppedError", Object.setPrototypeOf(this, Ca.prototype);
  }
}
class Pa extends Error {
  constructor(e) {
    super(e), this.name = "PollerCancelledError", Object.setPrototypeOf(this, Pa.prototype);
  }
}
class lg {
  /**
   * A poller needs to be initialized by passing in at least the basic properties of the `PollOperation<TState, TResult>`.
   *
   * When writing an implementation of a Poller, this implementation needs to deal with the initialization
   * of any custom state beyond the basic definition of the poller. The basic poller assumes that the poller's
   * operation has already been defined, at least its basic properties. The code below shows how to approach
   * the definition of the constructor of a new custom poller.
   *
   * ```ts
   * export class MyPoller extends Poller<MyOperationState, string> {
   *   constructor({
   *     // Anything you might need outside of the basics
   *   }) {
   *     let state: MyOperationState = {
   *       privateProperty: private,
   *       publicProperty: public,
   *     };
   *
   *     const operation = {
   *       state,
   *       update,
   *       cancel,
   *       toString
   *     }
   *
   *     // Sending the operation to the parent's constructor.
   *     super(operation);
   *
   *     // You can assign more local properties here.
   *   }
   * }
   * ```
   *
   * Inside of this constructor, a new promise is created. This will be used to
   * tell the user when the poller finishes (see `pollUntilDone()`). The promise's
   * resolve and reject methods are also used internally to control when to resolve
   * or reject anyone waiting for the poller to finish.
   *
   * The constructor of a custom implementation of a poller is where any serialized version of
   * a previous poller's operation should be deserialized into the operation sent to the
   * base constructor. For example:
   *
   * ```ts
   * export class MyPoller extends Poller<MyOperationState, string> {
   *   constructor(
   *     baseOperation: string | undefined
   *   ) {
   *     let state: MyOperationState = {};
   *     if (baseOperation) {
   *       state = {
   *         ...JSON.parse(baseOperation).state,
   *         ...state
   *       };
   *     }
   *     const operation = {
   *       state,
   *       // ...
   *     }
   *     super(operation);
   *   }
   * }
   * ```
   *
   * @param operation - Must contain the basic properties of `PollOperation<State, TResult>`.
   */
  constructor(e) {
    this.resolveOnUnsuccessful = !1, this.stopped = !0, this.pollProgressCallbacks = [], this.operation = e, this.promise = new Promise((t, a) => {
      this.resolve = t, this.reject = a;
    }), this.promise.catch(() => {
    });
  }
  /**
   * Starts a loop that will break only if the poller is done
   * or if the poller is stopped.
   */
  async startPolling(e = {}) {
    for (this.stopped && (this.stopped = !1); !this.isStopped() && !this.isDone(); )
      await this.poll(e), await this.delay();
  }
  /**
   * pollOnce does one polling, by calling to the update method of the underlying
   * poll operation to make any relevant change effective.
   *
   * It only optionally receives an object with an abortSignal property, from \@azure/abort-controller's AbortSignalLike.
   *
   * @param options - Optional properties passed to the operation's update method.
   */
  async pollOnce(e = {}) {
    this.isDone() || (this.operation = await this.operation.update({
      abortSignal: e.abortSignal,
      fireProgress: this.fireProgress.bind(this)
    })), this.processUpdatedState();
  }
  /**
   * fireProgress calls the functions passed in via onProgress the method of the poller.
   *
   * It loops over all of the callbacks received from onProgress, and executes them, sending them
   * the current operation state.
   *
   * @param state - The current operation state.
   */
  fireProgress(e) {
    for (const t of this.pollProgressCallbacks)
      t(e);
  }
  /**
   * Invokes the underlying operation's cancel method.
   */
  async cancelOnce(e = {}) {
    this.operation = await this.operation.cancel(e);
  }
  /**
   * Returns a promise that will resolve once a single polling request finishes.
   * It does this by calling the update method of the Poller's operation.
   *
   * It only optionally receives an object with an abortSignal property, from \@azure/abort-controller's AbortSignalLike.
   *
   * @param options - Optional properties passed to the operation's update method.
   */
  poll(e = {}) {
    if (!this.pollOncePromise) {
      this.pollOncePromise = this.pollOnce(e);
      const t = () => {
        this.pollOncePromise = void 0;
      };
      this.pollOncePromise.then(t, t).catch(this.reject);
    }
    return this.pollOncePromise;
  }
  processUpdatedState() {
    if (this.operation.state.error && (this.stopped = !0, !this.resolveOnUnsuccessful))
      throw this.reject(this.operation.state.error), this.operation.state.error;
    if (this.operation.state.isCancelled && (this.stopped = !0, !this.resolveOnUnsuccessful)) {
      const e = new Pa("Operation was canceled");
      throw this.reject(e), e;
    }
    this.isDone() && this.resolve && this.resolve(this.getResult());
  }
  /**
   * Returns a promise that will resolve once the underlying operation is completed.
   */
  async pollUntilDone(e = {}) {
    return this.stopped && this.startPolling(e).catch(this.reject), this.processUpdatedState(), this.promise;
  }
  /**
   * Invokes the provided callback after each polling is completed,
   * sending the current state of the poller's operation.
   *
   * It returns a method that can be used to stop receiving updates on the given callback function.
   */
  onProgress(e) {
    return this.pollProgressCallbacks.push(e), () => {
      this.pollProgressCallbacks = this.pollProgressCallbacks.filter((t) => t !== e);
    };
  }
  /**
   * Returns true if the poller has finished polling.
   */
  isDone() {
    const e = this.operation.state;
    return !!(e.isCompleted || e.isCancelled || e.error);
  }
  /**
   * Stops the poller from continuing to poll.
   */
  stopPolling() {
    this.stopped || (this.stopped = !0, this.reject && this.reject(new Ca("This poller is already stopped")));
  }
  /**
   * Returns true if the poller is stopped.
   */
  isStopped() {
    return this.stopped;
  }
  /**
   * Attempts to cancel the underlying operation.
   *
   * It only optionally receives an object with an abortSignal property, from \@azure/abort-controller's AbortSignalLike.
   *
   * If it's called again before it finishes, it will throw an error.
   *
   * @param options - Optional properties passed to the operation's update method.
   */
  cancelOperation(e = {}) {
    if (!this.cancelPromise)
      this.cancelPromise = this.cancelOnce(e);
    else if (e.abortSignal)
      throw new Error("A cancel request is currently pending");
    return this.cancelPromise;
  }
  /**
   * Returns the state of the operation.
   *
   * Even though TState will be the same type inside any of the methods of any extension of the Poller class,
   * implementations of the pollers can customize what's shared with the public by writing their own
   * version of the `getOperationState` method, and by defining two types, one representing the internal state of the poller
   * and a public type representing a safe to share subset of the properties of the internal state.
   * Their definition of getOperationState can then return their public type.
   *
   * Example:
   *
   * ```ts
   * // Let's say we have our poller's operation state defined as:
   * interface MyOperationState extends PollOperationState<ResultType> {
   *   privateProperty?: string;
   *   publicProperty?: string;
   * }
   *
   * // To allow us to have a true separation of public and private state, we have to define another interface:
   * interface PublicState extends PollOperationState<ResultType> {
   *   publicProperty?: string;
   * }
   *
   * // Then, we define our Poller as follows:
   * export class MyPoller extends Poller<MyOperationState, ResultType> {
   *   // ... More content is needed here ...
   *
   *   public getOperationState(): PublicState {
   *     const state: PublicState = this.operation.state;
   *     return {
   *       // Properties from PollOperationState<TResult>
   *       isStarted: state.isStarted,
   *       isCompleted: state.isCompleted,
   *       isCancelled: state.isCancelled,
   *       error: state.error,
   *       result: state.result,
   *
   *       // The only other property needed by PublicState.
   *       publicProperty: state.publicProperty
   *     }
   *   }
   * }
   * ```
   *
   * You can see this in the tests of this repository, go to the file:
   * `../test/utils/testPoller.ts`
   * and look for the getOperationState implementation.
   */
  getOperationState() {
    return this.operation.state;
  }
  /**
   * Returns the result value of the operation,
   * regardless of the state of the poller.
   * It can return undefined or an incomplete form of the final TResult value
   * depending on the implementation.
   */
  getResult() {
    return this.operation.state.result;
  }
  /**
   * Returns a serialized version of the poller's operation
   * by invoking the operation's toString method.
   */
  toString() {
    return this.operation.toString();
  }
}
class cg extends lg {
  constructor(e) {
    const { blobClient: t, copySource: a, intervalInMs: n = 15e3, onProgress: i, resumeFrom: s, startCopyFromURLOptions: o } = e;
    let l;
    s && (l = JSON.parse(s).state);
    const m = Et(Object.assign(Object.assign({}, l), {
      blobClient: t,
      copySource: a,
      startCopyFromURLOptions: o
    }));
    super(m), typeof i == "function" && this.onProgress(i), this.intervalInMs = n;
  }
  delay() {
    return Nn(this.intervalInMs);
  }
}
const dg = async function(e = {}) {
  const t = this.state, { copyId: a } = t;
  return t.isCompleted ? Et(t) : a ? (await t.blobClient.abortCopyFromURL(a, {
    abortSignal: e.abortSignal
  }), t.isCancelled = !0, Et(t)) : (t.isCancelled = !0, Et(t));
}, pg = async function(e = {}) {
  const t = this.state, { blobClient: a, copySource: n, startCopyFromURLOptions: i } = t;
  if (t.isStarted) {
    if (!t.isCompleted)
      try {
        const s = await t.blobClient.getProperties({ abortSignal: e.abortSignal }), { copyStatus: o, copyProgress: l } = s, m = t.copyProgress;
        l && (t.copyProgress = l), o === "pending" && l !== m && typeof e.fireProgress == "function" ? e.fireProgress(t) : o === "success" ? (t.result = s, t.isCompleted = !0) : o === "failed" && (t.error = new Error(`Blob copy failed with reason: "${s.copyStatusDescription || "unknown"}"`), t.isCompleted = !0);
      } catch (s) {
        t.error = s, t.isCompleted = !0;
      }
  } else {
    t.isStarted = !0;
    const s = await a.startCopyFromURL(n, i);
    t.copyId = s.copyId, s.copyStatus === "success" && (t.result = s, t.isCompleted = !0);
  }
  return Et(t);
}, ug = function() {
  return JSON.stringify({ state: this.state }, (e, t) => {
    if (e !== "blobClient")
      return t;
  });
};
function Et(r) {
  return {
    state: Object.assign({}, r),
    cancel: dg,
    toString: ug,
    update: pg
  };
}
function se(r) {
  if (r.offset < 0)
    throw new RangeError("Range.offset cannot be smaller than 0.");
  if (r.count && r.count <= 0)
    throw new RangeError("Range.count must be larger than 0. Leave it undefined if you want a range from offset to the end.");
  return r.count ? `bytes=${r.offset}-${r.offset + r.count - 1}` : `bytes=${r.offset}-`;
}
var Qt = { exports: {} }, Va;
function yg() {
  if (Va) return Qt.exports;
  Va = 1;
  var r = typeof Reflect == "object" ? Reflect : null, e = r && typeof r.apply == "function" ? r.apply : function(g, N, w) {
    return Function.prototype.apply.call(g, N, w);
  }, t;
  r && typeof r.ownKeys == "function" ? t = r.ownKeys : Object.getOwnPropertySymbols ? t = function(g) {
    return Object.getOwnPropertyNames(g).concat(Object.getOwnPropertySymbols(g));
  } : t = function(g) {
    return Object.getOwnPropertyNames(g);
  };
  function a(f) {
    console && console.warn && console.warn(f);
  }
  var n = Number.isNaN || function(g) {
    return g !== g;
  };
  function i() {
    i.init.call(this);
  }
  Qt.exports = i, Qt.exports.once = M, i.EventEmitter = i, i.prototype._events = void 0, i.prototype._eventsCount = 0, i.prototype._maxListeners = void 0;
  var s = 10;
  function o(f) {
    if (typeof f != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof f);
  }
  Object.defineProperty(i, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return s;
    },
    set: function(f) {
      if (typeof f != "number" || f < 0 || n(f))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + f + ".");
      s = f;
    }
  }), i.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, i.prototype.setMaxListeners = function(g) {
    if (typeof g != "number" || g < 0 || n(g))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + g + ".");
    return this._maxListeners = g, this;
  };
  function l(f) {
    return f._maxListeners === void 0 ? i.defaultMaxListeners : f._maxListeners;
  }
  i.prototype.getMaxListeners = function() {
    return l(this);
  }, i.prototype.emit = function(g) {
    for (var N = [], w = 1; w < arguments.length; w++) N.push(arguments[w]);
    var E = g === "error", q = this._events;
    if (q !== void 0)
      E = E && q.error === void 0;
    else if (!E)
      return !1;
    if (E) {
      var O;
      if (N.length > 0 && (O = N[0]), O instanceof Error)
        throw O;
      var ie = new Error("Unhandled error." + (O ? " (" + O.message + ")" : ""));
      throw ie.context = O, ie;
    }
    var Ct = q[g];
    if (Ct === void 0)
      return !1;
    if (typeof Ct == "function")
      e(Ct, this, N);
    else
      for (var za = Ct.length, Em = u(Ct, za), w = 0; w < za; ++w)
        e(Em[w], this, N);
    return !0;
  };
  function m(f, g, N, w) {
    var E, q, O;
    if (o(N), q = f._events, q === void 0 ? (q = f._events = /* @__PURE__ */ Object.create(null), f._eventsCount = 0) : (q.newListener !== void 0 && (f.emit(
      "newListener",
      g,
      N.listener ? N.listener : N
    ), q = f._events), O = q[g]), O === void 0)
      O = q[g] = N, ++f._eventsCount;
    else if (typeof O == "function" ? O = q[g] = w ? [N, O] : [O, N] : w ? O.unshift(N) : O.push(N), E = l(f), E > 0 && O.length > E && !O.warned) {
      O.warned = !0;
      var ie = new Error("Possible EventEmitter memory leak detected. " + O.length + " " + String(g) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      ie.name = "MaxListenersExceededWarning", ie.emitter = f, ie.type = g, ie.count = O.length, a(ie);
    }
    return f;
  }
  i.prototype.addListener = function(g, N) {
    return m(this, g, N, !1);
  }, i.prototype.on = i.prototype.addListener, i.prototype.prependListener = function(g, N) {
    return m(this, g, N, !0);
  };
  function c() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function d(f, g, N) {
    var w = { fired: !1, wrapFn: void 0, target: f, type: g, listener: N }, E = c.bind(w);
    return E.listener = N, w.wrapFn = E, E;
  }
  i.prototype.once = function(g, N) {
    return o(N), this.on(g, d(this, g, N)), this;
  }, i.prototype.prependOnceListener = function(g, N) {
    return o(N), this.prependListener(g, d(this, g, N)), this;
  }, i.prototype.removeListener = function(g, N) {
    var w, E, q, O, ie;
    if (o(N), E = this._events, E === void 0)
      return this;
    if (w = E[g], w === void 0)
      return this;
    if (w === N || w.listener === N)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete E[g], E.removeListener && this.emit("removeListener", g, w.listener || N));
    else if (typeof w != "function") {
      for (q = -1, O = w.length - 1; O >= 0; O--)
        if (w[O] === N || w[O].listener === N) {
          ie = w[O].listener, q = O;
          break;
        }
      if (q < 0)
        return this;
      q === 0 ? w.shift() : h(w, q), w.length === 1 && (E[g] = w[0]), E.removeListener !== void 0 && this.emit("removeListener", g, ie || N);
    }
    return this;
  }, i.prototype.off = i.prototype.removeListener, i.prototype.removeAllListeners = function(g) {
    var N, w, E;
    if (w = this._events, w === void 0)
      return this;
    if (w.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : w[g] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete w[g]), this;
    if (arguments.length === 0) {
      var q = Object.keys(w), O;
      for (E = 0; E < q.length; ++E)
        O = q[E], O !== "removeListener" && this.removeAllListeners(O);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (N = w[g], typeof N == "function")
      this.removeListener(g, N);
    else if (N !== void 0)
      for (E = N.length - 1; E >= 0; E--)
        this.removeListener(g, N[E]);
    return this;
  };
  function p(f, g, N) {
    var w = f._events;
    if (w === void 0)
      return [];
    var E = w[g];
    return E === void 0 ? [] : typeof E == "function" ? N ? [E.listener || E] : [E] : N ? R(E) : u(E, E.length);
  }
  i.prototype.listeners = function(g) {
    return p(this, g, !0);
  }, i.prototype.rawListeners = function(g) {
    return p(this, g, !1);
  }, i.listenerCount = function(f, g) {
    return typeof f.listenerCount == "function" ? f.listenerCount(g) : y.call(f, g);
  }, i.prototype.listenerCount = y;
  function y(f) {
    var g = this._events;
    if (g !== void 0) {
      var N = g[f];
      if (typeof N == "function")
        return 1;
      if (N !== void 0)
        return N.length;
    }
    return 0;
  }
  i.prototype.eventNames = function() {
    return this._eventsCount > 0 ? t(this._events) : [];
  };
  function u(f, g) {
    for (var N = new Array(g), w = 0; w < g; ++w)
      N[w] = f[w];
    return N;
  }
  function h(f, g) {
    for (; g + 1 < f.length; g++)
      f[g] = f[g + 1];
    f.pop();
  }
  function R(f) {
    for (var g = new Array(f.length), N = 0; N < g.length; ++N)
      g[N] = f[N].listener || f[N];
    return g;
  }
  function M(f, g) {
    return new Promise(function(N, w) {
      function E(O) {
        f.removeListener(g, q), w(O);
      }
      function q() {
        typeof f.removeListener == "function" && f.removeListener("error", E), N([].slice.call(arguments));
      }
      $(f, g, q, { once: !0 }), g !== "error" && T(f, E, { once: !0 });
    });
  }
  function T(f, g, N) {
    typeof f.on == "function" && $(f, "error", g, N);
  }
  function $(f, g, N, w) {
    if (typeof f.on == "function")
      w.once ? f.once(g, N) : f.on(g, N);
    else if (typeof f.addEventListener == "function")
      f.addEventListener(g, function E(q) {
        w.once && f.removeEventListener(g, E), N(q);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof f);
  }
  return Qt.exports;
}
var fg = yg(), Tt;
(function(r) {
  r[r.Good = 0] = "Good", r[r.Error = 1] = "Error";
})(Tt || (Tt = {}));
class Rm {
  /**
   * Creates an instance of Batch.
   * @param concurrency -
   */
  constructor(e = 5) {
    if (this.actives = 0, this.completed = 0, this.offset = 0, this.operations = [], this.state = Tt.Good, e < 1)
      throw new RangeError("concurrency must be larger than 0");
    this.concurrency = e, this.emitter = new fg.EventEmitter();
  }
  /**
   * Add a operation into queue.
   *
   * @param operation -
   */
  addOperation(e) {
    this.operations.push(async () => {
      try {
        this.actives++, await e(), this.actives--, this.completed++, this.parallelExecute();
      } catch (t) {
        this.emitter.emit("error", t);
      }
    });
  }
  /**
   * Start execute operations in the queue.
   *
   */
  async do() {
    return this.operations.length === 0 ? Promise.resolve() : (this.parallelExecute(), new Promise((e, t) => {
      this.emitter.on("finish", e), this.emitter.on("error", (a) => {
        this.state = Tt.Error, t(a);
      });
    }));
  }
  /**
   * Get next operation to be executed. Return null when reaching ends.
   *
   */
  nextOperation() {
    return this.offset < this.operations.length ? this.operations[this.offset++] : null;
  }
  /**
   * Start execute operations. One one the most important difference between
   * this method with do() is that do() wraps as an sync method.
   *
   */
  parallelExecute() {
    if (this.state !== Tt.Error) {
      if (this.completed >= this.operations.length) {
        this.emitter.emit("finish");
        return;
      }
      for (; this.actives < this.concurrency; ) {
        const e = this.nextOperation();
        if (e)
          e();
        else
          return;
      }
    }
  }
}
class gg {
}
async function hg(r) {
  const e = new FileReader();
  return new Promise((t, a) => {
    e.onloadend = (n) => {
      t(n.target.result);
    }, e.onerror = a, e.readAsText(r);
  });
}
const xg = function() {
}, Ng = function() {
};
class pe extends ba {
  /**
   * The name of the blob.
   */
  get name() {
    return this._name;
  }
  /**
   * The name of the storage container the blob is associated with.
   */
  get containerName() {
    return this._containerName;
  }
  constructor(e, t, a, n) {
    n = n || {};
    let i, s;
    if (_e(t))
      s = e, i = t;
    else if (W && t instanceof K || t instanceof F || le(t))
      s = e, n = a, i = j(t, n);
    else if (!t && typeof t != "string")
      s = e, a && typeof a != "string" && (n = a), i = j(new F(), n);
    else if (t && typeof t == "string" && a && typeof a == "string") {
      const o = t, l = a, m = tt(e);
      if (m.kind === "AccountConnString")
        if (W) {
          const c = new K(m.accountName, m.accountKey);
          s = X(X(m.url, encodeURIComponent(o)), encodeURIComponent(l)), n.proxyOptions || (n.proxyOptions = Ze(m.proxyUri)), i = j(c, n);
        } else
          throw new Error("Account connection string is only supported in Node.js environment");
      else if (m.kind === "SASConnString")
        s = X(X(m.url, encodeURIComponent(o)), encodeURIComponent(l)) + "?" + m.accountSas, i = j(new F(), n);
      else
        throw new Error("Connection string must be either an Account connection string or a SAS connection string");
    } else
      throw new Error("Expecting non-empty strings for containerName and blobName parameters");
    super(s, i), { blobName: this._name, containerName: this._containerName } = this.getBlobAndContainerNamesFromUrl(), this.blobContext = this.storageClientContext.blob, this._snapshot = Ga(this.url, de.Parameters.SNAPSHOT), this._versionId = Ga(this.url, de.Parameters.VERSIONID);
  }
  /**
   * Creates a new BlobClient object identical to the source but with the specified snapshot timestamp.
   * Provide "" will remove the snapshot and return a Client to the base blob.
   *
   * @param snapshot - The snapshot timestamp.
   * @returns A new BlobClient object identical to the source but with the specified snapshot timestamp
   */
  withSnapshot(e) {
    return new pe(xe(this.url, de.Parameters.SNAPSHOT, e.length === 0 ? void 0 : e), this.pipeline);
  }
  /**
   * Creates a new BlobClient object pointing to a version of this blob.
   * Provide "" will remove the versionId and return a Client to the base blob.
   *
   * @param versionId - The versionId.
   * @returns A new BlobClient object pointing to the version of this blob.
   */
  withVersion(e) {
    return new pe(xe(this.url, de.Parameters.VERSIONID, e.length === 0 ? void 0 : e), this.pipeline);
  }
  /**
   * Creates a AppendBlobClient object.
   *
   */
  getAppendBlobClient() {
    return new ur(this.url, this.pipeline);
  }
  /**
   * Creates a BlockBlobClient object.
   *
   */
  getBlockBlobClient() {
    return new yr(this.url, this.pipeline);
  }
  /**
   * Creates a PageBlobClient object.
   *
   */
  getPageBlobClient() {
    return new fr(this.url, this.pipeline);
  }
  /**
   * Reads or downloads a blob from the system, including its metadata and properties.
   * You can also call Get Blob to read a snapshot.
   *
   * * In Node.js, data returns in a Readable stream readableStreamBody
   * * In browsers, data returns in a promise blobBody
   *
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/get-blob
   *
   * @param offset - From which position of the blob to download, greater than or equal to 0
   * @param count - How much data to be downloaded, greater than 0. Will download to the end when undefined
   * @param options - Optional options to Blob Download operation.
   *
   *
   * Example usage (Node.js):
   *
   * ```js
   * // Download and convert a blob to a string
   * const downloadBlockBlobResponse = await blobClient.download();
   * const downloaded = await streamToBuffer(downloadBlockBlobResponse.readableStreamBody);
   * console.log("Downloaded blob content:", downloaded.toString());
   *
   * async function streamToBuffer(readableStream) {
   *   return new Promise((resolve, reject) => {
   *     const chunks = [];
   *     readableStream.on("data", (data) => {
   *       chunks.push(typeof data === "string" ? Buffer.from(data) : data);
   *     });
   *     readableStream.on("end", () => {
   *       resolve(Buffer.concat(chunks));
   *     });
   *     readableStream.on("error", reject);
   *   });
   * }
   * ```
   *
   * Example usage (browser):
   *
   * ```js
   * // Download and convert a blob to a string
   * const downloadBlockBlobResponse = await blobClient.download();
   * const downloaded = await blobToString(await downloadBlockBlobResponse.blobBody);
   * console.log(
   *   "Downloaded blob content",
   *   downloaded
   * );
   *
   * async function blobToString(blob: Blob): Promise<string> {
   *   const fileReader = new FileReader();
   *   return new Promise<string>((resolve, reject) => {
   *     fileReader.onloadend = (ev: any) => {
   *       resolve(ev.target!.result);
   *     };
   *     fileReader.onerror = reject;
   *     fileReader.readAsText(blob);
   *   });
   * }
   * ```
   */
  async download(e = 0, t, a = {}) {
    return a.conditions = a.conditions || {}, a.conditions = a.conditions || {}, J(a.customerProvidedKey, this.isHttps), x.withSpan("BlobClient-download", a, async (n) => {
      var i;
      const s = C(await this.blobContext.download({
        abortSignal: a.abortSignal,
        leaseAccessConditions: a.conditions,
        modifiedAccessConditions: Object.assign(Object.assign({}, a.conditions), { ifTags: (i = a.conditions) === null || i === void 0 ? void 0 : i.tagConditions }),
        requestOptions: {
          onDownloadProgress: W ? void 0 : a.onProgress
          // for Node.js, progress is reported by RetriableReadableStream
        },
        range: e === 0 && !t ? void 0 : se({ offset: e, count: t }),
        rangeGetContentMD5: a.rangeGetContentMD5,
        rangeGetContentCRC64: a.rangeGetContentCrc64,
        snapshot: a.snapshot,
        cpkInfo: a.customerProvidedKey,
        tracingOptions: n.tracingOptions
      })), o = Object.assign(Object.assign({}, s), { _response: s._response, objectReplicationDestinationPolicyId: s.objectReplicationPolicyId, objectReplicationSourceProperties: tr(s.objectReplicationRules) });
      if (!W)
        return o;
      if ((a.maxRetryRequests === void 0 || a.maxRetryRequests < 0) && (a.maxRetryRequests = bp), s.contentLength === void 0)
        throw new RangeError("File download response doesn't contain valid content length header");
      if (!s.etag)
        throw new RangeError("File download response doesn't contain valid etag header");
      return new og(o, async (l) => {
        var m;
        const c = {
          leaseAccessConditions: a.conditions,
          modifiedAccessConditions: {
            ifMatch: a.conditions.ifMatch || s.etag,
            ifModifiedSince: a.conditions.ifModifiedSince,
            ifNoneMatch: a.conditions.ifNoneMatch,
            ifUnmodifiedSince: a.conditions.ifUnmodifiedSince,
            ifTags: (m = a.conditions) === null || m === void 0 ? void 0 : m.tagConditions
          },
          range: se({
            count: e + s.contentLength - l,
            offset: l
          }),
          rangeGetContentMD5: a.rangeGetContentMD5,
          rangeGetContentCRC64: a.rangeGetContentCrc64,
          snapshot: a.snapshot,
          cpkInfo: a.customerProvidedKey
        };
        return (await this.blobContext.download(Object.assign({ abortSignal: a.abortSignal }, c))).readableStreamBody;
      }, e, s.contentLength, {
        maxRetryRequests: a.maxRetryRequests,
        onProgress: a.onProgress
      });
    });
  }
  /**
   * Returns true if the Azure blob resource represented by this client exists; false otherwise.
   *
   * NOTE: use this function with care since an existing blob might be deleted by other clients or
   * applications. Vice versa new blobs might be added by other clients or applications after this
   * function completes.
   *
   * @param options - options to Exists operation.
   */
  async exists(e = {}) {
    return x.withSpan("BlobClient-exists", e, async (t) => {
      try {
        return J(e.customerProvidedKey, this.isHttps), await this.getProperties({
          abortSignal: e.abortSignal,
          customerProvidedKey: e.customerProvidedKey,
          conditions: e.conditions,
          tracingOptions: t.tracingOptions
        }), !0;
      } catch (a) {
        if (a.statusCode === 404)
          return !1;
        if (a.statusCode === 409 && (a.details.errorCode === Rp || a.details.errorCode === wp))
          return !0;
        throw a;
      }
    });
  }
  /**
   * Returns all user-defined metadata, standard HTTP properties, and system properties
   * for the blob. It does not return the content of the blob.
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/get-blob-properties
   *
   * WARNING: The `metadata` object returned in the response will have its keys in lowercase, even if
   * they originally contained uppercase characters. This differs from the metadata keys returned by
   * the methods of {@link ContainerClient} that list blobs using the `includeMetadata` option, which
   * will retain their original casing.
   *
   * @param options - Optional options to Get Properties operation.
   */
  async getProperties(e = {}) {
    return e.conditions = e.conditions || {}, J(e.customerProvidedKey, this.isHttps), x.withSpan("BlobClient-getProperties", e, async (t) => {
      var a;
      const n = C(await this.blobContext.getProperties({
        abortSignal: e.abortSignal,
        leaseAccessConditions: e.conditions,
        modifiedAccessConditions: Object.assign(Object.assign({}, e.conditions), { ifTags: (a = e.conditions) === null || a === void 0 ? void 0 : a.tagConditions }),
        cpkInfo: e.customerProvidedKey,
        tracingOptions: t.tracingOptions
      }));
      return Object.assign(Object.assign({}, n), { _response: n._response, objectReplicationDestinationPolicyId: n.objectReplicationPolicyId, objectReplicationSourceProperties: tr(n.objectReplicationRules) });
    });
  }
  /**
   * Marks the specified blob or snapshot for deletion. The blob is later deleted
   * during garbage collection. Note that in order to delete a blob, you must delete
   * all of its snapshots. You can delete both at the same time with the Delete
   * Blob operation.
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/delete-blob
   *
   * @param options - Optional options to Blob Delete operation.
   */
  async delete(e = {}) {
    return e.conditions = e.conditions || {}, x.withSpan("BlobClient-delete", e, async (t) => {
      var a;
      return C(await this.blobContext.delete({
        abortSignal: e.abortSignal,
        deleteSnapshots: e.deleteSnapshots,
        leaseAccessConditions: e.conditions,
        modifiedAccessConditions: Object.assign(Object.assign({}, e.conditions), { ifTags: (a = e.conditions) === null || a === void 0 ? void 0 : a.tagConditions }),
        tracingOptions: t.tracingOptions
      }));
    });
  }
  /**
   * Marks the specified blob or snapshot for deletion if it exists. The blob is later deleted
   * during garbage collection. Note that in order to delete a blob, you must delete
   * all of its snapshots. You can delete both at the same time with the Delete
   * Blob operation.
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/delete-blob
   *
   * @param options - Optional options to Blob Delete operation.
   */
  async deleteIfExists(e = {}) {
    return x.withSpan("BlobClient-deleteIfExists", e, async (t) => {
      var a, n;
      try {
        const i = C(await this.delete(t));
        return Object.assign(Object.assign({ succeeded: !0 }, i), { _response: i._response });
      } catch (i) {
        if (((a = i.details) === null || a === void 0 ? void 0 : a.errorCode) === "BlobNotFound")
          return Object.assign(Object.assign({ succeeded: !1 }, (n = i.response) === null || n === void 0 ? void 0 : n.parsedHeaders), { _response: i.response });
        throw i;
      }
    });
  }
  /**
   * Restores the contents and metadata of soft deleted blob and any associated
   * soft deleted snapshots. Undelete Blob is supported only on version 2017-07-29
   * or later.
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/undelete-blob
   *
   * @param options - Optional options to Blob Undelete operation.
   */
  async undelete(e = {}) {
    return x.withSpan("BlobClient-undelete", e, async (t) => C(await this.blobContext.undelete({
      abortSignal: e.abortSignal,
      tracingOptions: t.tracingOptions
    })));
  }
  /**
   * Sets system properties on the blob.
   *
   * If no value provided, or no value provided for the specified blob HTTP headers,
   * these blob HTTP headers without a value will be cleared.
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/set-blob-properties
   *
   * @param blobHTTPHeaders - If no value provided, or no value provided for
   *                                                   the specified blob HTTP headers, these blob HTTP
   *                                                   headers without a value will be cleared.
   *                                                   A common header to set is `blobContentType`
   *                                                   enabling the browser to provide functionality
   *                                                   based on file type.
   * @param options - Optional options to Blob Set HTTP Headers operation.
   */
  async setHTTPHeaders(e, t = {}) {
    return t.conditions = t.conditions || {}, J(t.customerProvidedKey, this.isHttps), x.withSpan("BlobClient-setHTTPHeaders", t, async (a) => {
      var n;
      return C(await this.blobContext.setHttpHeaders({
        abortSignal: t.abortSignal,
        blobHttpHeaders: e,
        leaseAccessConditions: t.conditions,
        modifiedAccessConditions: Object.assign(Object.assign({}, t.conditions), { ifTags: (n = t.conditions) === null || n === void 0 ? void 0 : n.tagConditions }),
        // cpkInfo: options.customerProvidedKey, // CPK is not included in Swagger, should change this back when this issue is fixed in Swagger.
        tracingOptions: a.tracingOptions
      }));
    });
  }
  /**
   * Sets user-defined metadata for the specified blob as one or more name-value pairs.
   *
   * If no option provided, or no metadata defined in the parameter, the blob
   * metadata will be removed.
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/set-blob-metadata
   *
   * @param metadata - Replace existing metadata with this value.
   *                               If no value provided the existing metadata will be removed.
   * @param options - Optional options to Set Metadata operation.
   */
  async setMetadata(e, t = {}) {
    return t.conditions = t.conditions || {}, J(t.customerProvidedKey, this.isHttps), x.withSpan("BlobClient-setMetadata", t, async (a) => {
      var n;
      return C(await this.blobContext.setMetadata({
        abortSignal: t.abortSignal,
        leaseAccessConditions: t.conditions,
        metadata: e,
        modifiedAccessConditions: Object.assign(Object.assign({}, t.conditions), { ifTags: (n = t.conditions) === null || n === void 0 ? void 0 : n.tagConditions }),
        cpkInfo: t.customerProvidedKey,
        encryptionScope: t.encryptionScope,
        tracingOptions: a.tracingOptions
      }));
    });
  }
  /**
   * Sets tags on the underlying blob.
   * A blob can have up to 10 tags. Tag keys must be between 1 and 128 characters.  Tag values must be between 0 and 256 characters.
   * Valid tag key and value characters include lower and upper case letters, digits (0-9),
   * space (' '), plus ('+'), minus ('-'), period ('.'), foward slash ('/'), colon (':'), equals ('='), and underscore ('_').
   *
   * @param tags -
   * @param options -
   */
  async setTags(e, t = {}) {
    return x.withSpan("BlobClient-setTags", t, async (a) => {
      var n;
      return C(await this.blobContext.setTags({
        abortSignal: t.abortSignal,
        leaseAccessConditions: t.conditions,
        modifiedAccessConditions: Object.assign(Object.assign({}, t.conditions), { ifTags: (n = t.conditions) === null || n === void 0 ? void 0 : n.tagConditions }),
        tracingOptions: a.tracingOptions,
        tags: Hp(e)
      }));
    });
  }
  /**
   * Gets the tags associated with the underlying blob.
   *
   * @param options -
   */
  async getTags(e = {}) {
    return x.withSpan("BlobClient-getTags", e, async (t) => {
      var a;
      const n = C(await this.blobContext.getTags({
        abortSignal: e.abortSignal,
        leaseAccessConditions: e.conditions,
        modifiedAccessConditions: Object.assign(Object.assign({}, e.conditions), { ifTags: (a = e.conditions) === null || a === void 0 ? void 0 : a.tagConditions }),
        tracingOptions: t.tracingOptions
      }));
      return Object.assign(Object.assign({}, n), { _response: n._response, tags: Bt({ blobTagSet: n.blobTagSet }) || {} });
    });
  }
  /**
   * Get a {@link BlobLeaseClient} that manages leases on the blob.
   *
   * @param proposeLeaseId - Initial proposed lease Id.
   * @returns A new BlobLeaseClient object for managing leases on the blob.
   */
  getBlobLeaseClient(e) {
    return new Sm(this, e);
  }
  /**
   * Creates a read-only snapshot of a blob.
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/snapshot-blob
   *
   * @param options - Optional options to the Blob Create Snapshot operation.
   */
  async createSnapshot(e = {}) {
    return e.conditions = e.conditions || {}, J(e.customerProvidedKey, this.isHttps), x.withSpan("BlobClient-createSnapshot", e, async (t) => {
      var a;
      return C(await this.blobContext.createSnapshot({
        abortSignal: e.abortSignal,
        leaseAccessConditions: e.conditions,
        metadata: e.metadata,
        modifiedAccessConditions: Object.assign(Object.assign({}, e.conditions), { ifTags: (a = e.conditions) === null || a === void 0 ? void 0 : a.tagConditions }),
        cpkInfo: e.customerProvidedKey,
        encryptionScope: e.encryptionScope,
        tracingOptions: t.tracingOptions
      }));
    });
  }
  /**
   * Asynchronously copies a blob to a destination within the storage account.
   * This method returns a long running operation poller that allows you to wait
   * indefinitely until the copy is completed.
   * You can also cancel a copy before it is completed by calling `cancelOperation` on the poller.
   * Note that the onProgress callback will not be invoked if the operation completes in the first
   * request, and attempting to cancel a completed copy will result in an error being thrown.
   *
   * In version 2012-02-12 and later, the source for a Copy Blob operation can be
   * a committed blob in any Azure storage account.
   * Beginning with version 2015-02-21, the source for a Copy Blob operation can be
   * an Azure file in any Azure storage account.
   * Only storage accounts created on or after June 7th, 2012 allow the Copy Blob
   * operation to copy from another storage account.
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/copy-blob
   *
   * Example using automatic polling:
   *
   * ```js
   * const copyPoller = await blobClient.beginCopyFromURL('url');
   * const result = await copyPoller.pollUntilDone();
   * ```
   *
   * Example using manual polling:
   *
   * ```js
   * const copyPoller = await blobClient.beginCopyFromURL('url');
   * while (!poller.isDone()) {
   *    await poller.poll();
   * }
   * const result = copyPoller.getResult();
   * ```
   *
   * Example using progress updates:
   *
   * ```js
   * const copyPoller = await blobClient.beginCopyFromURL('url', {
   *   onProgress(state) {
   *     console.log(`Progress: ${state.copyProgress}`);
   *   }
   * });
   * const result = await copyPoller.pollUntilDone();
   * ```
   *
   * Example using a changing polling interval (default 15 seconds):
   *
   * ```js
   * const copyPoller = await blobClient.beginCopyFromURL('url', {
   *   intervalInMs: 1000 // poll blob every 1 second for copy progress
   * });
   * const result = await copyPoller.pollUntilDone();
   * ```
   *
   * Example using copy cancellation:
   *
   * ```js
   * const copyPoller = await blobClient.beginCopyFromURL('url');
   * // cancel operation after starting it.
   * try {
   *   await copyPoller.cancelOperation();
   *   // calls to get the result now throw PollerCancelledError
   *   await copyPoller.getResult();
   * } catch (err) {
   *   if (err.name === 'PollerCancelledError') {
   *     console.log('The copy was cancelled.');
   *   }
   * }
   * ```
   *
   * @param copySource - url to the source Azure Blob/File.
   * @param options - Optional options to the Blob Start Copy From URL operation.
   */
  async beginCopyFromURL(e, t = {}) {
    const a = {
      abortCopyFromURL: (...i) => this.abortCopyFromURL(...i),
      getProperties: (...i) => this.getProperties(...i),
      startCopyFromURL: (...i) => this.startCopyFromURL(...i)
    }, n = new cg({
      blobClient: a,
      copySource: e,
      intervalInMs: t.intervalInMs,
      onProgress: t.onProgress,
      resumeFrom: t.resumeFrom,
      startCopyFromURLOptions: t
    });
    return await n.poll(), n;
  }
  /**
   * Aborts a pending asynchronous Copy Blob operation, and leaves a destination blob with zero
   * length and full metadata. Version 2012-02-12 and newer.
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/abort-copy-blob
   *
   * @param copyId - Id of the Copy From URL operation.
   * @param options - Optional options to the Blob Abort Copy From URL operation.
   */
  async abortCopyFromURL(e, t = {}) {
    return x.withSpan("BlobClient-abortCopyFromURL", t, async (a) => C(await this.blobContext.abortCopyFromURL(e, {
      abortSignal: t.abortSignal,
      leaseAccessConditions: t.conditions,
      tracingOptions: a.tracingOptions
    })));
  }
  /**
   * The synchronous Copy From URL operation copies a blob or an internet resource to a new blob. It will not
   * return a response until the copy is complete.
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/copy-blob-from-url
   *
   * @param copySource - The source URL to copy from, Shared Access Signature(SAS) maybe needed for authentication
   * @param options -
   */
  async syncCopyFromURL(e, t = {}) {
    return t.conditions = t.conditions || {}, t.sourceConditions = t.sourceConditions || {}, x.withSpan("BlobClient-syncCopyFromURL", t, async (a) => {
      var n, i, s, o, l, m, c;
      return C(await this.blobContext.copyFromURL(e, {
        abortSignal: t.abortSignal,
        metadata: t.metadata,
        leaseAccessConditions: t.conditions,
        modifiedAccessConditions: Object.assign(Object.assign({}, t.conditions), { ifTags: (n = t.conditions) === null || n === void 0 ? void 0 : n.tagConditions }),
        sourceModifiedAccessConditions: {
          sourceIfMatch: (i = t.sourceConditions) === null || i === void 0 ? void 0 : i.ifMatch,
          sourceIfModifiedSince: (s = t.sourceConditions) === null || s === void 0 ? void 0 : s.ifModifiedSince,
          sourceIfNoneMatch: (o = t.sourceConditions) === null || o === void 0 ? void 0 : o.ifNoneMatch,
          sourceIfUnmodifiedSince: (l = t.sourceConditions) === null || l === void 0 ? void 0 : l.ifUnmodifiedSince
        },
        sourceContentMD5: t.sourceContentMD5,
        copySourceAuthorization: _t(t.sourceAuthorization),
        tier: Oe(t.tier),
        blobTagsString: qe(t.tags),
        immutabilityPolicyExpiry: (m = t.immutabilityPolicy) === null || m === void 0 ? void 0 : m.expiriesOn,
        immutabilityPolicyMode: (c = t.immutabilityPolicy) === null || c === void 0 ? void 0 : c.policyMode,
        legalHold: t.legalHold,
        encryptionScope: t.encryptionScope,
        copySourceTags: t.copySourceTags,
        tracingOptions: a.tracingOptions
      }));
    });
  }
  /**
   * Sets the tier on a blob. The operation is allowed on a page blob in a premium
   * storage account and on a block blob in a blob storage account (locally redundant
   * storage only). A premium page blob's tier determines the allowed size, IOPS,
   * and bandwidth of the blob. A block blob's tier determines Hot/Cool/Archive
   * storage type. This operation does not update the blob's ETag.
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/set-blob-tier
   *
   * @param tier - The tier to be set on the blob. Valid values are Hot, Cool, or Archive.
   * @param options - Optional options to the Blob Set Tier operation.
   */
  async setAccessTier(e, t = {}) {
    return x.withSpan("BlobClient-setAccessTier", t, async (a) => {
      var n;
      return C(await this.blobContext.setTier(Oe(e), {
        abortSignal: t.abortSignal,
        leaseAccessConditions: t.conditions,
        modifiedAccessConditions: Object.assign(Object.assign({}, t.conditions), { ifTags: (n = t.conditions) === null || n === void 0 ? void 0 : n.tagConditions }),
        rehydratePriority: t.rehydratePriority,
        tracingOptions: a.tracingOptions
      }));
    });
  }
  async downloadToBuffer(e, t, a, n = {}) {
    var i;
    let s, o = 0, l = 0, m = n;
    e instanceof Buffer ? (s = e, o = t || 0, l = typeof a == "number" ? a : 0) : (o = typeof e == "number" ? e : 0, l = typeof t == "number" ? t : 0, m = a || {});
    let c = (i = m.blockSize) !== null && i !== void 0 ? i : 0;
    if (c < 0)
      throw new RangeError("blockSize option must be >= 0");
    if (c === 0 && (c = Dr), o < 0)
      throw new RangeError("offset option must be >= 0");
    if (l && l <= 0)
      throw new RangeError("count option must be greater than 0");
    return m.conditions || (m.conditions = {}), x.withSpan("BlobClient-downloadToBuffer", m, async (d) => {
      if (!l) {
        const u = await this.getProperties(Object.assign(Object.assign({}, m), { tracingOptions: d.tracingOptions }));
        if (l = u.contentLength - o, l < 0)
          throw new RangeError(`offset ${o} shouldn't be larger than blob size ${u.contentLength}`);
      }
      if (!s)
        try {
          s = Buffer.alloc(l);
        } catch (u) {
          throw new Error(`Unable to allocate the buffer of size: ${l}(in bytes). Please try passing your own buffer to the "downloadToBuffer" method or try using other methods like "download" or "downloadToFile".	 ${u.message}`);
        }
      if (s.length < l)
        throw new RangeError(`The buffer's size should be equal to or larger than the request count of bytes: ${l}`);
      let p = 0;
      const y = new Rm(m.concurrency);
      for (let u = o; u < o + l; u = u + c)
        y.addOperation(async () => {
          let h = o + l;
          u + c < h && (h = u + c), (await this.download(u, h - u, {
            abortSignal: m.abortSignal,
            conditions: m.conditions,
            maxRetryRequests: m.maxRetryRequestsPerBlock,
            customerProvidedKey: m.customerProvidedKey,
            tracingOptions: d.tracingOptions
          })).readableStreamBody, await void 0, p += h - u, m.onProgress && m.onProgress({ loadedBytes: p });
        });
      return await y.do(), s;
    });
  }
  /**
   * ONLY AVAILABLE IN NODE.JS RUNTIME.
   *
   * Downloads an Azure Blob to a local file.
   * Fails if the the given file path already exits.
   * Offset and count are optional, pass 0 and undefined respectively to download the entire blob.
   *
   * @param filePath -
   * @param offset - From which position of the block blob to download.
   * @param count - How much data to be downloaded. Will download to the end when passing undefined.
   * @param options - Options to Blob download options.
   * @returns The response data for blob download operation,
   *                                                 but with readableStreamBody set to undefined since its
   *                                                 content is already read and written into a local file
   *                                                 at the specified path.
   */
  async downloadToFile(e, t = 0, a, n = {}) {
    return x.withSpan("BlobClient-downloadToFile", n, async (i) => {
      const s = await this.download(t, a, Object.assign(Object.assign({}, n), { tracingOptions: i.tracingOptions }));
      return s.readableStreamBody && await (s.readableStreamBody, void 0), s.blobDownloadStream = void 0, s;
    });
  }
  getBlobAndContainerNamesFromUrl() {
    let e, t;
    try {
      const a = new URL(this.url);
      if (a.host.split(".")[1] === "blob") {
        const n = a.pathname.match("/([^/]*)(/(.*))?");
        e = n[1], t = n[3];
      } else if (ia(a)) {
        const n = a.pathname.match("/([^/]*)/([^/]*)(/(.*))?");
        e = n[2], t = n[4];
      } else {
        const n = a.pathname.match("/([^/]*)(/(.*))?");
        e = n[1], t = n[3];
      }
      if (e = decodeURIComponent(e), t = decodeURIComponent(t), t = t.replace(/\\/g, "/"), !e)
        throw new Error("Provided containerName is invalid.");
      return { blobName: t, containerName: e };
    } catch {
      throw new Error("Unable to extract blobName and containerName with provided information.");
    }
  }
  /**
   * Asynchronously copies a blob to a destination within the storage account.
   * In version 2012-02-12 and later, the source for a Copy Blob operation can be
   * a committed blob in any Azure storage account.
   * Beginning with version 2015-02-21, the source for a Copy Blob operation can be
   * an Azure file in any Azure storage account.
   * Only storage accounts created on or after June 7th, 2012 allow the Copy Blob
   * operation to copy from another storage account.
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/copy-blob
   *
   * @param copySource - url to the source Azure Blob/File.
   * @param options - Optional options to the Blob Start Copy From URL operation.
   */
  async startCopyFromURL(e, t = {}) {
    return x.withSpan("BlobClient-startCopyFromURL", t, async (a) => {
      var n, i, s;
      return t.conditions = t.conditions || {}, t.sourceConditions = t.sourceConditions || {}, C(await this.blobContext.startCopyFromURL(e, {
        abortSignal: t.abortSignal,
        leaseAccessConditions: t.conditions,
        metadata: t.metadata,
        modifiedAccessConditions: Object.assign(Object.assign({}, t.conditions), { ifTags: (n = t.conditions) === null || n === void 0 ? void 0 : n.tagConditions }),
        sourceModifiedAccessConditions: {
          sourceIfMatch: t.sourceConditions.ifMatch,
          sourceIfModifiedSince: t.sourceConditions.ifModifiedSince,
          sourceIfNoneMatch: t.sourceConditions.ifNoneMatch,
          sourceIfUnmodifiedSince: t.sourceConditions.ifUnmodifiedSince,
          sourceIfTags: t.sourceConditions.tagConditions
        },
        immutabilityPolicyExpiry: (i = t.immutabilityPolicy) === null || i === void 0 ? void 0 : i.expiriesOn,
        immutabilityPolicyMode: (s = t.immutabilityPolicy) === null || s === void 0 ? void 0 : s.policyMode,
        legalHold: t.legalHold,
        rehydratePriority: t.rehydratePriority,
        tier: Oe(t.tier),
        blobTagsString: qe(t.tags),
        sealBlob: t.sealBlob,
        tracingOptions: a.tracingOptions
      }));
    });
  }
  /**
   * Only available for BlobClient constructed with a shared key credential.
   *
   * Generates a Blob Service Shared Access Signature (SAS) URI based on the client properties
   * and parameters passed in. The SAS is signed by the shared key credential of the client.
   *
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/constructing-a-service-sas
   *
   * @param options - Optional parameters.
   * @returns The SAS URI consisting of the URI to the resource represented by this client, followed by the generated SAS token.
   */
  generateSasUrl(e) {
    return new Promise((t) => {
      if (!(this.credential instanceof K))
        throw new RangeError("Can only generate the SAS when the client is initialized with a shared key credential");
      const a = rr(Object.assign({ containerName: this._containerName, blobName: this._name, snapshotTime: this._snapshot, versionId: this._versionId }, e), this.credential).toString();
      t(Ot(this.url, a));
    });
  }
  /**
   * Only available for BlobClient constructed with a shared key credential.
   *
   * Generates string to sign for a Blob Service Shared Access Signature (SAS) URI based on
   * the client properties and parameters passed in. The SAS is signed by the shared key credential of the client.
   *
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/constructing-a-service-sas
   *
   * @param options - Optional parameters.
   * @returns The SAS URI consisting of the URI to the resource represented by this client, followed by the generated SAS token.
   */
  /* eslint-disable-next-line @azure/azure-sdk/ts-naming-options*/
  generateSasStringToSign(e) {
    if (!(this.credential instanceof K))
      throw new RangeError("Can only generate the SAS when the client is initialized with a shared key credential");
    return Lt(Object.assign({ containerName: this._containerName, blobName: this._name, snapshotTime: this._snapshot, versionId: this._versionId }, e), this.credential).stringToSign;
  }
  /**
   *
   * Generates a Blob Service Shared Access Signature (SAS) URI based on
   * the client properties and parameters passed in. The SAS is signed by the input user delegation key.
   *
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/constructing-a-service-sas
   *
   * @param options - Optional parameters.
   * @param userDelegationKey -  Return value of `blobServiceClient.getUserDelegationKey()`
   * @returns The SAS URI consisting of the URI to the resource represented by this client, followed by the generated SAS token.
   */
  generateUserDelegationSasUrl(e, t) {
    return new Promise((a) => {
      const n = rr(Object.assign({ containerName: this._containerName, blobName: this._name, snapshotTime: this._snapshot, versionId: this._versionId }, e), t, this.accountName).toString();
      a(Ot(this.url, n));
    });
  }
  /**
   * Only available for BlobClient constructed with a shared key credential.
   *
   * Generates string to sign for a Blob Service Shared Access Signature (SAS) URI based on
   * the client properties and parameters passed in. The SAS is signed by the input user delegation key.
   *
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/constructing-a-service-sas
   *
   * @param options - Optional parameters.
   * @param userDelegationKey -  Return value of `blobServiceClient.getUserDelegationKey()`
   * @returns The SAS URI consisting of the URI to the resource represented by this client, followed by the generated SAS token.
   */
  generateUserDelegationSasStringToSign(e, t) {
    return Lt(Object.assign({ containerName: this._containerName, blobName: this._name, snapshotTime: this._snapshot, versionId: this._versionId }, e), t, this.accountName).stringToSign;
  }
  /**
   * Delete the immutablility policy on the blob.
   *
   * @param options - Optional options to delete immutability policy on the blob.
   */
  async deleteImmutabilityPolicy(e = {}) {
    return x.withSpan("BlobClient-deleteImmutabilityPolicy", e, async (t) => C(await this.blobContext.deleteImmutabilityPolicy({
      tracingOptions: t.tracingOptions
    })));
  }
  /**
   * Set immutability policy on the blob.
   *
   * @param options - Optional options to set immutability policy on the blob.
   */
  async setImmutabilityPolicy(e, t = {}) {
    return x.withSpan("BlobClient-setImmutabilityPolicy", t, async (a) => C(await this.blobContext.setImmutabilityPolicy({
      immutabilityPolicyExpiry: e.expiriesOn,
      immutabilityPolicyMode: e.policyMode,
      tracingOptions: a.tracingOptions
    })));
  }
  /**
   * Set legal hold on the blob.
   *
   * @param options - Optional options to set legal hold on the blob.
   */
  async setLegalHold(e, t = {}) {
    return x.withSpan("BlobClient-setLegalHold", t, async (a) => C(await this.blobContext.setLegalHold(e, {
      tracingOptions: a.tracingOptions
    })));
  }
  /**
   * The Get Account Information operation returns the sku name and account kind
   * for the specified account.
   * The Get Account Information operation is available on service versions beginning
   * with version 2018-03-28.
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/get-account-information
   *
   * @param options - Options to the Service Get Account Info operation.
   * @returns Response data for the Service Get Account Info operation.
   */
  async getAccountInfo(e = {}) {
    return x.withSpan("BlobClient-getAccountInfo", e, async (t) => C(await this.blobContext.getAccountInfo({
      abortSignal: e.abortSignal,
      tracingOptions: t.tracingOptions
    })));
  }
}
class ur extends pe {
  constructor(e, t, a, n) {
    let i, s;
    if (n = n || {}, _e(t))
      s = e, i = t;
    else if (W && t instanceof K || t instanceof F || le(t))
      s = e, n = a, i = j(t, n);
    else if (!t && typeof t != "string")
      s = e, i = j(new F(), n);
    else if (t && typeof t == "string" && a && typeof a == "string") {
      const o = t, l = a, m = tt(e);
      if (m.kind === "AccountConnString")
        if (W) {
          const c = new K(m.accountName, m.accountKey);
          s = X(X(m.url, encodeURIComponent(o)), encodeURIComponent(l)), n.proxyOptions || (n.proxyOptions = Ze(m.proxyUri)), i = j(c, n);
        } else
          throw new Error("Account connection string is only supported in Node.js environment");
      else if (m.kind === "SASConnString")
        s = X(X(m.url, encodeURIComponent(o)), encodeURIComponent(l)) + "?" + m.accountSas, i = j(new F(), n);
      else
        throw new Error("Connection string must be either an Account connection string or a SAS connection string");
    } else
      throw new Error("Expecting non-empty strings for containerName and blobName parameters");
    super(s, i), this.appendBlobContext = this.storageClientContext.appendBlob;
  }
  /**
   * Creates a new AppendBlobClient object identical to the source but with the
   * specified snapshot timestamp.
   * Provide "" will remove the snapshot and return a Client to the base blob.
   *
   * @param snapshot - The snapshot timestamp.
   * @returns A new AppendBlobClient object identical to the source but with the specified snapshot timestamp.
   */
  withSnapshot(e) {
    return new ur(xe(this.url, de.Parameters.SNAPSHOT, e.length === 0 ? void 0 : e), this.pipeline);
  }
  /**
   * Creates a 0-length append blob. Call AppendBlock to append data to an append blob.
   * @see https://learn.microsoft.com/rest/api/storageservices/put-blob
   *
   * @param options - Options to the Append Block Create operation.
   *
   *
   * Example usage:
   *
   * ```js
   * const appendBlobClient = containerClient.getAppendBlobClient("<blob name>");
   * await appendBlobClient.create();
   * ```
   */
  async create(e = {}) {
    return e.conditions = e.conditions || {}, J(e.customerProvidedKey, this.isHttps), x.withSpan("AppendBlobClient-create", e, async (t) => {
      var a, n, i;
      return C(await this.appendBlobContext.create(0, {
        abortSignal: e.abortSignal,
        blobHttpHeaders: e.blobHTTPHeaders,
        leaseAccessConditions: e.conditions,
        metadata: e.metadata,
        modifiedAccessConditions: Object.assign(Object.assign({}, e.conditions), { ifTags: (a = e.conditions) === null || a === void 0 ? void 0 : a.tagConditions }),
        cpkInfo: e.customerProvidedKey,
        encryptionScope: e.encryptionScope,
        immutabilityPolicyExpiry: (n = e.immutabilityPolicy) === null || n === void 0 ? void 0 : n.expiriesOn,
        immutabilityPolicyMode: (i = e.immutabilityPolicy) === null || i === void 0 ? void 0 : i.policyMode,
        legalHold: e.legalHold,
        blobTagsString: qe(e.tags),
        tracingOptions: t.tracingOptions
      }));
    });
  }
  /**
   * Creates a 0-length append blob. Call AppendBlock to append data to an append blob.
   * If the blob with the same name already exists, the content of the existing blob will remain unchanged.
   * @see https://learn.microsoft.com/rest/api/storageservices/put-blob
   *
   * @param options -
   */
  async createIfNotExists(e = {}) {
    const t = { ifNoneMatch: Wn };
    return x.withSpan("AppendBlobClient-createIfNotExists", e, async (a) => {
      var n, i;
      try {
        const s = C(await this.create(Object.assign(Object.assign({}, a), { conditions: t })));
        return Object.assign(Object.assign({ succeeded: !0 }, s), { _response: s._response });
      } catch (s) {
        if (((n = s.details) === null || n === void 0 ? void 0 : n.errorCode) === "BlobAlreadyExists")
          return Object.assign(Object.assign({ succeeded: !1 }, (i = s.response) === null || i === void 0 ? void 0 : i.parsedHeaders), { _response: s.response });
        throw s;
      }
    });
  }
  /**
   * Seals the append blob, making it read only.
   *
   * @param options -
   */
  async seal(e = {}) {
    return e.conditions = e.conditions || {}, x.withSpan("AppendBlobClient-seal", e, async (t) => {
      var a;
      return C(await this.appendBlobContext.seal({
        abortSignal: e.abortSignal,
        appendPositionAccessConditions: e.conditions,
        leaseAccessConditions: e.conditions,
        modifiedAccessConditions: Object.assign(Object.assign({}, e.conditions), { ifTags: (a = e.conditions) === null || a === void 0 ? void 0 : a.tagConditions }),
        tracingOptions: t.tracingOptions
      }));
    });
  }
  /**
   * Commits a new block of data to the end of the existing append blob.
   * @see https://learn.microsoft.com/rest/api/storageservices/append-block
   *
   * @param body - Data to be appended.
   * @param contentLength - Length of the body in bytes.
   * @param options - Options to the Append Block operation.
   *
   *
   * Example usage:
   *
   * ```js
   * const content = "Hello World!";
   *
   * // Create a new append blob and append data to the blob.
   * const newAppendBlobClient = containerClient.getAppendBlobClient("<blob name>");
   * await newAppendBlobClient.create();
   * await newAppendBlobClient.appendBlock(content, content.length);
   *
   * // Append data to an existing append blob.
   * const existingAppendBlobClient = containerClient.getAppendBlobClient("<blob name>");
   * await existingAppendBlobClient.appendBlock(content, content.length);
   * ```
   */
  async appendBlock(e, t, a = {}) {
    return a.conditions = a.conditions || {}, J(a.customerProvidedKey, this.isHttps), x.withSpan("AppendBlobClient-appendBlock", a, async (n) => {
      var i;
      return C(await this.appendBlobContext.appendBlock(t, e, {
        abortSignal: a.abortSignal,
        appendPositionAccessConditions: a.conditions,
        leaseAccessConditions: a.conditions,
        modifiedAccessConditions: Object.assign(Object.assign({}, a.conditions), { ifTags: (i = a.conditions) === null || i === void 0 ? void 0 : i.tagConditions }),
        requestOptions: {
          onUploadProgress: a.onProgress
        },
        transactionalContentMD5: a.transactionalContentMD5,
        transactionalContentCrc64: a.transactionalContentCrc64,
        cpkInfo: a.customerProvidedKey,
        encryptionScope: a.encryptionScope,
        tracingOptions: n.tracingOptions
      }));
    });
  }
  /**
   * The Append Block operation commits a new block of data to the end of an existing append blob
   * where the contents are read from a source url.
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/append-block-from-url
   *
   * @param sourceURL -
   *                 The url to the blob that will be the source of the copy. A source blob in the same storage account can
   *                 be authenticated via Shared Key. However, if the source is a blob in another account, the source blob
   *                 must either be public or must be authenticated via a shared access signature. If the source blob is
   *                 public, no authentication is required to perform the operation.
   * @param sourceOffset - Offset in source to be appended
   * @param count - Number of bytes to be appended as a block
   * @param options -
   */
  async appendBlockFromURL(e, t, a, n = {}) {
    return n.conditions = n.conditions || {}, n.sourceConditions = n.sourceConditions || {}, J(n.customerProvidedKey, this.isHttps), x.withSpan("AppendBlobClient-appendBlockFromURL", n, async (i) => {
      var s, o, l, m, c;
      return C(await this.appendBlobContext.appendBlockFromUrl(e, 0, {
        abortSignal: n.abortSignal,
        sourceRange: se({ offset: t, count: a }),
        sourceContentMD5: n.sourceContentMD5,
        sourceContentCrc64: n.sourceContentCrc64,
        leaseAccessConditions: n.conditions,
        appendPositionAccessConditions: n.conditions,
        modifiedAccessConditions: Object.assign(Object.assign({}, n.conditions), { ifTags: (s = n.conditions) === null || s === void 0 ? void 0 : s.tagConditions }),
        sourceModifiedAccessConditions: {
          sourceIfMatch: (o = n.sourceConditions) === null || o === void 0 ? void 0 : o.ifMatch,
          sourceIfModifiedSince: (l = n.sourceConditions) === null || l === void 0 ? void 0 : l.ifModifiedSince,
          sourceIfNoneMatch: (m = n.sourceConditions) === null || m === void 0 ? void 0 : m.ifNoneMatch,
          sourceIfUnmodifiedSince: (c = n.sourceConditions) === null || c === void 0 ? void 0 : c.ifUnmodifiedSince
        },
        copySourceAuthorization: _t(n.sourceAuthorization),
        cpkInfo: n.customerProvidedKey,
        encryptionScope: n.encryptionScope,
        tracingOptions: i.tracingOptions
      }));
    });
  }
}
class yr extends pe {
  constructor(e, t, a, n) {
    let i, s;
    if (n = n || {}, _e(t))
      s = e, i = t;
    else if (W && t instanceof K || t instanceof F || le(t))
      s = e, n = a, i = j(t, n);
    else if (!t && typeof t != "string")
      s = e, a && typeof a != "string" && (n = a), i = j(new F(), n);
    else if (t && typeof t == "string" && a && typeof a == "string") {
      const o = t, l = a, m = tt(e);
      if (m.kind === "AccountConnString")
        if (W) {
          const c = new K(m.accountName, m.accountKey);
          s = X(X(m.url, encodeURIComponent(o)), encodeURIComponent(l)), n.proxyOptions || (n.proxyOptions = Ze(m.proxyUri)), i = j(c, n);
        } else
          throw new Error("Account connection string is only supported in Node.js environment");
      else if (m.kind === "SASConnString")
        s = X(X(m.url, encodeURIComponent(o)), encodeURIComponent(l)) + "?" + m.accountSas, i = j(new F(), n);
      else
        throw new Error("Connection string must be either an Account connection string or a SAS connection string");
    } else
      throw new Error("Expecting non-empty strings for containerName and blobName parameters");
    super(s, i), this.blockBlobContext = this.storageClientContext.blockBlob, this._blobContext = this.storageClientContext.blob;
  }
  /**
   * Creates a new BlockBlobClient object identical to the source but with the
   * specified snapshot timestamp.
   * Provide "" will remove the snapshot and return a URL to the base blob.
   *
   * @param snapshot - The snapshot timestamp.
   * @returns A new BlockBlobClient object identical to the source but with the specified snapshot timestamp.
   */
  withSnapshot(e) {
    return new yr(xe(this.url, de.Parameters.SNAPSHOT, e.length === 0 ? void 0 : e), this.pipeline);
  }
  /**
   * ONLY AVAILABLE IN NODE.JS RUNTIME.
   *
   * Quick query for a JSON or CSV formatted blob.
   *
   * Example usage (Node.js):
   *
   * ```js
   * // Query and convert a blob to a string
   * const queryBlockBlobResponse = await blockBlobClient.query("select * from BlobStorage");
   * const downloaded = (await streamToBuffer(queryBlockBlobResponse.readableStreamBody)).toString();
   * console.log("Query blob content:", downloaded);
   *
   * async function streamToBuffer(readableStream) {
   *   return new Promise((resolve, reject) => {
   *     const chunks = [];
   *     readableStream.on("data", (data) => {
   *       chunks.push(typeof data === "string" ? Buffer.from(data) : data);
   *     });
   *     readableStream.on("end", () => {
   *       resolve(Buffer.concat(chunks));
   *     });
   *     readableStream.on("error", reject);
   *   });
   * }
   * ```
   *
   * @param query -
   * @param options -
   */
  async query(e, t = {}) {
    if (J(t.customerProvidedKey, this.isHttps), !W)
      throw new Error("This operation currently is only supported in Node.js.");
    return x.withSpan("BlockBlobClient-query", t, async (a) => {
      var n;
      const i = C(await this._blobContext.query({
        abortSignal: t.abortSignal,
        queryRequest: {
          queryType: "SQL",
          expression: e,
          inputSerialization: Wa(t.inputTextConfiguration),
          outputSerialization: Wa(t.outputTextConfiguration)
        },
        leaseAccessConditions: t.conditions,
        modifiedAccessConditions: Object.assign(Object.assign({}, t.conditions), { ifTags: (n = t.conditions) === null || n === void 0 ? void 0 : n.tagConditions }),
        cpkInfo: t.customerProvidedKey,
        tracingOptions: a.tracingOptions
      }));
      return new mg(i, {
        abortSignal: t.abortSignal,
        onProgress: t.onProgress,
        onError: t.onError
      });
    });
  }
  /**
   * Creates a new block blob, or updates the content of an existing block blob.
   * Updating an existing block blob overwrites any existing metadata on the blob.
   * Partial updates are not supported; the content of the existing blob is
   * overwritten with the new content. To perform a partial update of a block blob's,
   * use {@link stageBlock} and {@link commitBlockList}.
   *
   * This is a non-parallel uploading method, please use {@link uploadFile},
   * {@link uploadStream} or {@link uploadBrowserData} for better performance
   * with concurrency uploading.
   *
   * @see https://learn.microsoft.com/rest/api/storageservices/put-blob
   *
   * @param body - Blob, string, ArrayBuffer, ArrayBufferView or a function
   *                               which returns a new Readable stream whose offset is from data source beginning.
   * @param contentLength - Length of body in bytes. Use Buffer.byteLength() to calculate body length for a
   *                               string including non non-Base64/Hex-encoded characters.
   * @param options - Options to the Block Blob Upload operation.
   * @returns Response data for the Block Blob Upload operation.
   *
   * Example usage:
   *
   * ```js
   * const content = "Hello world!";
   * const uploadBlobResponse = await blockBlobClient.upload(content, content.length);
   * ```
   */
  async upload(e, t, a = {}) {
    return a.conditions = a.conditions || {}, J(a.customerProvidedKey, this.isHttps), x.withSpan("BlockBlobClient-upload", a, async (n) => {
      var i, s, o;
      return C(await this.blockBlobContext.upload(t, e, {
        abortSignal: a.abortSignal,
        blobHttpHeaders: a.blobHTTPHeaders,
        leaseAccessConditions: a.conditions,
        metadata: a.metadata,
        modifiedAccessConditions: Object.assign(Object.assign({}, a.conditions), { ifTags: (i = a.conditions) === null || i === void 0 ? void 0 : i.tagConditions }),
        requestOptions: {
          onUploadProgress: a.onProgress
        },
        cpkInfo: a.customerProvidedKey,
        encryptionScope: a.encryptionScope,
        immutabilityPolicyExpiry: (s = a.immutabilityPolicy) === null || s === void 0 ? void 0 : s.expiriesOn,
        immutabilityPolicyMode: (o = a.immutabilityPolicy) === null || o === void 0 ? void 0 : o.policyMode,
        legalHold: a.legalHold,
        tier: Oe(a.tier),
        blobTagsString: qe(a.tags),
        tracingOptions: n.tracingOptions
      }));
    });
  }
  /**
   * Creates a new Block Blob where the contents of the blob are read from a given URL.
   * This API is supported beginning with the 2020-04-08 version. Partial updates
   * are not supported with Put Blob from URL; the content of an existing blob is overwritten with
   * the content of the new blob.  To perform partial updates to a block blob’s contents using a
   * source URL, use {@link stageBlockFromURL} and {@link commitBlockList}.
   *
   * @param sourceURL - Specifies the URL of the blob. The value
   *                           may be a URL of up to 2 KB in length that specifies a blob.
   *                           The value should be URL-encoded as it would appear
   *                           in a request URI. The source blob must either be public
   *                           or must be authenticated via a shared access signature.
   *                           If the source blob is public, no authentication is required
   *                           to perform the operation. Here are some examples of source object URLs:
   *                           - https://myaccount.blob.core.windows.net/mycontainer/myblob
   *                           - https://myaccount.blob.core.windows.net/mycontainer/myblob?snapshot=<DateTime>
   * @param options - Optional parameters.
   */
  async syncUploadFromURL(e, t = {}) {
    return t.conditions = t.conditions || {}, J(t.customerProvidedKey, this.isHttps), x.withSpan("BlockBlobClient-syncUploadFromURL", t, async (a) => {
      var n, i, s, o, l, m;
      return C(await this.blockBlobContext.putBlobFromUrl(0, e, Object.assign(Object.assign({}, t), { blobHttpHeaders: t.blobHTTPHeaders, leaseAccessConditions: t.conditions, modifiedAccessConditions: Object.assign(Object.assign({}, t.conditions), { ifTags: (n = t.conditions) === null || n === void 0 ? void 0 : n.tagConditions }), sourceModifiedAccessConditions: {
        sourceIfMatch: (i = t.sourceConditions) === null || i === void 0 ? void 0 : i.ifMatch,
        sourceIfModifiedSince: (s = t.sourceConditions) === null || s === void 0 ? void 0 : s.ifModifiedSince,
        sourceIfNoneMatch: (o = t.sourceConditions) === null || o === void 0 ? void 0 : o.ifNoneMatch,
        sourceIfUnmodifiedSince: (l = t.sourceConditions) === null || l === void 0 ? void 0 : l.ifUnmodifiedSince,
        sourceIfTags: (m = t.sourceConditions) === null || m === void 0 ? void 0 : m.tagConditions
      }, cpkInfo: t.customerProvidedKey, copySourceAuthorization: _t(t.sourceAuthorization), tier: Oe(t.tier), blobTagsString: qe(t.tags), copySourceTags: t.copySourceTags, tracingOptions: a.tracingOptions })));
    });
  }
  /**
   * Uploads the specified block to the block blob's "staging area" to be later
   * committed by a call to commitBlockList.
   * @see https://learn.microsoft.com/rest/api/storageservices/put-block
   *
   * @param blockId - A 64-byte value that is base64-encoded
   * @param body - Data to upload to the staging area.
   * @param contentLength - Number of bytes to upload.
   * @param options - Options to the Block Blob Stage Block operation.
   * @returns Response data for the Block Blob Stage Block operation.
   */
  async stageBlock(e, t, a, n = {}) {
    return J(n.customerProvidedKey, this.isHttps), x.withSpan("BlockBlobClient-stageBlock", n, async (i) => C(await this.blockBlobContext.stageBlock(e, a, t, {
      abortSignal: n.abortSignal,
      leaseAccessConditions: n.conditions,
      requestOptions: {
        onUploadProgress: n.onProgress
      },
      transactionalContentMD5: n.transactionalContentMD5,
      transactionalContentCrc64: n.transactionalContentCrc64,
      cpkInfo: n.customerProvidedKey,
      encryptionScope: n.encryptionScope,
      tracingOptions: i.tracingOptions
    })));
  }
  /**
   * The Stage Block From URL operation creates a new block to be committed as part
   * of a blob where the contents are read from a URL.
   * This API is available starting in version 2018-03-28.
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/put-block-from-url
   *
   * @param blockId - A 64-byte value that is base64-encoded
   * @param sourceURL - Specifies the URL of the blob. The value
   *                           may be a URL of up to 2 KB in length that specifies a blob.
   *                           The value should be URL-encoded as it would appear
   *                           in a request URI. The source blob must either be public
   *                           or must be authenticated via a shared access signature.
   *                           If the source blob is public, no authentication is required
   *                           to perform the operation. Here are some examples of source object URLs:
   *                           - https://myaccount.blob.core.windows.net/mycontainer/myblob
   *                           - https://myaccount.blob.core.windows.net/mycontainer/myblob?snapshot=<DateTime>
   * @param offset - From which position of the blob to download, greater than or equal to 0
   * @param count - How much data to be downloaded, greater than 0. Will download to the end when undefined
   * @param options - Options to the Block Blob Stage Block From URL operation.
   * @returns Response data for the Block Blob Stage Block From URL operation.
   */
  async stageBlockFromURL(e, t, a = 0, n, i = {}) {
    return J(i.customerProvidedKey, this.isHttps), x.withSpan("BlockBlobClient-stageBlockFromURL", i, async (s) => C(await this.blockBlobContext.stageBlockFromURL(e, 0, t, {
      abortSignal: i.abortSignal,
      leaseAccessConditions: i.conditions,
      sourceContentMD5: i.sourceContentMD5,
      sourceContentCrc64: i.sourceContentCrc64,
      sourceRange: a === 0 && !n ? void 0 : se({ offset: a, count: n }),
      cpkInfo: i.customerProvidedKey,
      encryptionScope: i.encryptionScope,
      copySourceAuthorization: _t(i.sourceAuthorization),
      tracingOptions: s.tracingOptions
    })));
  }
  /**
   * Writes a blob by specifying the list of block IDs that make up the blob.
   * In order to be written as part of a blob, a block must have been successfully written
   * to the server in a prior {@link stageBlock} operation. You can call {@link commitBlockList} to
   * update a blob by uploading only those blocks that have changed, then committing the new and existing
   * blocks together. Any blocks not specified in the block list and permanently deleted.
   * @see https://learn.microsoft.com/rest/api/storageservices/put-block-list
   *
   * @param blocks -  Array of 64-byte value that is base64-encoded
   * @param options - Options to the Block Blob Commit Block List operation.
   * @returns Response data for the Block Blob Commit Block List operation.
   */
  async commitBlockList(e, t = {}) {
    return t.conditions = t.conditions || {}, J(t.customerProvidedKey, this.isHttps), x.withSpan("BlockBlobClient-commitBlockList", t, async (a) => {
      var n, i, s;
      return C(await this.blockBlobContext.commitBlockList({ latest: e }, {
        abortSignal: t.abortSignal,
        blobHttpHeaders: t.blobHTTPHeaders,
        leaseAccessConditions: t.conditions,
        metadata: t.metadata,
        modifiedAccessConditions: Object.assign(Object.assign({}, t.conditions), { ifTags: (n = t.conditions) === null || n === void 0 ? void 0 : n.tagConditions }),
        cpkInfo: t.customerProvidedKey,
        encryptionScope: t.encryptionScope,
        immutabilityPolicyExpiry: (i = t.immutabilityPolicy) === null || i === void 0 ? void 0 : i.expiriesOn,
        immutabilityPolicyMode: (s = t.immutabilityPolicy) === null || s === void 0 ? void 0 : s.policyMode,
        legalHold: t.legalHold,
        tier: Oe(t.tier),
        blobTagsString: qe(t.tags),
        tracingOptions: a.tracingOptions
      }));
    });
  }
  /**
   * Returns the list of blocks that have been uploaded as part of a block blob
   * using the specified block list filter.
   * @see https://learn.microsoft.com/rest/api/storageservices/get-block-list
   *
   * @param listType - Specifies whether to return the list of committed blocks,
   *                                        the list of uncommitted blocks, or both lists together.
   * @param options - Options to the Block Blob Get Block List operation.
   * @returns Response data for the Block Blob Get Block List operation.
   */
  async getBlockList(e, t = {}) {
    return x.withSpan("BlockBlobClient-getBlockList", t, async (a) => {
      var n;
      const i = C(await this.blockBlobContext.getBlockList(e, {
        abortSignal: t.abortSignal,
        leaseAccessConditions: t.conditions,
        modifiedAccessConditions: Object.assign(Object.assign({}, t.conditions), { ifTags: (n = t.conditions) === null || n === void 0 ? void 0 : n.tagConditions }),
        tracingOptions: a.tracingOptions
      }));
      return i.committedBlocks || (i.committedBlocks = []), i.uncommittedBlocks || (i.uncommittedBlocks = []), i;
    });
  }
  // High level functions
  /**
   * Uploads a Buffer(Node.js)/Blob(browsers)/ArrayBuffer/ArrayBufferView object to a BlockBlob.
   *
   * When data length is no more than the specifiled {@link BlockBlobParallelUploadOptions.maxSingleShotSize} (default is
   * {@link BLOCK_BLOB_MAX_UPLOAD_BLOB_BYTES}), this method will use 1 {@link upload} call to finish the upload.
   * Otherwise, this method will call {@link stageBlock} to upload blocks, and finally call {@link commitBlockList}
   * to commit the block list.
   *
   * A common {@link BlockBlobParallelUploadOptions.blobHTTPHeaders} option to set is
   * `blobContentType`, enabling the browser to provide
   * functionality based on file type.
   *
   * @param data - Buffer(Node.js), Blob, ArrayBuffer or ArrayBufferView
   * @param options -
   */
  async uploadData(e, t = {}) {
    return x.withSpan("BlockBlobClient-uploadData", t, async (a) => {
      if (W) {
        let n;
        return e instanceof Buffer ? n = e : e instanceof ArrayBuffer ? n = Buffer.from(e) : (e = e, n = Buffer.from(e.buffer, e.byteOffset, e.byteLength)), this.uploadSeekableInternal((i, s) => n.slice(i, i + s), n.byteLength, a);
      } else {
        const n = new Blob([e]);
        return this.uploadSeekableInternal((i, s) => n.slice(i, i + s), n.size, a);
      }
    });
  }
  /**
   * ONLY AVAILABLE IN BROWSERS.
   *
   * Uploads a browser Blob/File/ArrayBuffer/ArrayBufferView object to block blob.
   *
   * When buffer length lesser than or equal to 256MB, this method will use 1 upload call to finish the upload.
   * Otherwise, this method will call {@link stageBlock} to upload blocks, and finally call
   * {@link commitBlockList} to commit the block list.
   *
   * A common {@link BlockBlobParallelUploadOptions.blobHTTPHeaders} option to set is
   * `blobContentType`, enabling the browser to provide
   * functionality based on file type.
   *
   * @deprecated Use {@link uploadData} instead.
   *
   * @param browserData - Blob, File, ArrayBuffer or ArrayBufferView
   * @param options - Options to upload browser data.
   * @returns Response data for the Blob Upload operation.
   */
  async uploadBrowserData(e, t = {}) {
    return x.withSpan("BlockBlobClient-uploadBrowserData", t, async (a) => {
      const n = new Blob([e]);
      return this.uploadSeekableInternal((i, s) => n.slice(i, i + s), n.size, a);
    });
  }
  /**
   *
   * Uploads data to block blob. Requires a bodyFactory as the data source,
   * which need to return a {@link HttpRequestBody} object with the offset and size provided.
   *
   * When data length is no more than the specified {@link BlockBlobParallelUploadOptions.maxSingleShotSize} (default is
   * {@link BLOCK_BLOB_MAX_UPLOAD_BLOB_BYTES}), this method will use 1 {@link upload} call to finish the upload.
   * Otherwise, this method will call {@link stageBlock} to upload blocks, and finally call {@link commitBlockList}
   * to commit the block list.
   *
   * @param bodyFactory -
   * @param size - size of the data to upload.
   * @param options - Options to Upload to Block Blob operation.
   * @returns Response data for the Blob Upload operation.
   */
  async uploadSeekableInternal(e, t, a = {}) {
    var n, i;
    let s = (n = a.blockSize) !== null && n !== void 0 ? n : 0;
    if (s < 0 || s > Sr)
      throw new RangeError(`blockSize option must be >= 0 and <= ${Sr}`);
    const o = (i = a.maxSingleShotSize) !== null && i !== void 0 ? i : zr;
    if (o < 0 || o > zr)
      throw new RangeError(`maxSingleShotSize option must be >= 0 and <= ${zr}`);
    if (s === 0) {
      if (t > Sr * Xt)
        throw new RangeError(`${t} is too larger to upload to a block blob.`);
      t > o && (s = Math.ceil(t / Xt), s < Dr && (s = Dr));
    }
    return a.blobHTTPHeaders || (a.blobHTTPHeaders = {}), a.conditions || (a.conditions = {}), x.withSpan("BlockBlobClient-uploadSeekableInternal", a, async (l) => {
      if (t <= o)
        return C(await this.upload(e(0, t), t, l));
      const m = Math.floor((t - 1) / s) + 1;
      if (m > Xt)
        throw new RangeError(`The buffer's size is too big or the BlockSize is too small;the number of blocks must be <= ${Xt}`);
      const c = [], d = Vt();
      let p = 0;
      const y = new Rm(a.concurrency);
      for (let u = 0; u < m; u++)
        y.addOperation(async () => {
          const h = Xa(d, u), R = s * u, T = (u === m - 1 ? t : R + s) - R;
          c.push(h), await this.stageBlock(h, e(R, T), T, {
            abortSignal: a.abortSignal,
            conditions: a.conditions,
            encryptionScope: a.encryptionScope,
            tracingOptions: l.tracingOptions
          }), p += T, a.onProgress && a.onProgress({
            loadedBytes: p
          });
        });
      return await y.do(), this.commitBlockList(c, l);
    });
  }
  /**
   * ONLY AVAILABLE IN NODE.JS RUNTIME.
   *
   * Uploads a local file in blocks to a block blob.
   *
   * When file size lesser than or equal to 256MB, this method will use 1 upload call to finish the upload.
   * Otherwise, this method will call stageBlock to upload blocks, and finally call commitBlockList
   * to commit the block list.
   *
   * @param filePath - Full path of local file
   * @param options - Options to Upload to Block Blob operation.
   * @returns Response data for the Blob Upload operation.
   */
  async uploadFile(e, t = {}) {
    return x.withSpan("BlockBlobClient-uploadFile", t, async (a) => {
      const n = (await xg()).size;
      return this.uploadSeekableInternal((i, s) => () => Ng(), n, Object.assign(Object.assign({}, t), { tracingOptions: a.tracingOptions }));
    });
  }
  /**
   * ONLY AVAILABLE IN NODE.JS RUNTIME.
   *
   * Uploads a Node.js Readable stream into block blob.
   *
   * PERFORMANCE IMPROVEMENT TIPS:
   * * Input stream highWaterMark is better to set a same value with bufferSize
   *    parameter, which will avoid Buffer.concat() operations.
   *
   * @param stream - Node.js Readable stream
   * @param bufferSize - Size of every buffer allocated, also the block size in the uploaded block blob. Default value is 8MB
   * @param maxConcurrency -  Max concurrency indicates the max number of buffers that can be allocated,
   *                                 positive correlation with max uploading concurrency. Default value is 5
   * @param options - Options to Upload Stream to Block Blob operation.
   * @returns Response data for the Blob Upload operation.
   */
  async uploadStream(e, t = Np, a = 5, n = {}) {
    return n.blobHTTPHeaders || (n.blobHTTPHeaders = {}), n.conditions || (n.conditions = {}), x.withSpan("BlockBlobClient-uploadStream", n, async (i) => {
      let s = 0;
      const o = Vt();
      let l = 0;
      const m = [];
      return await new gg(
        e,
        t,
        a,
        async (d, p) => {
          const y = Xa(o, s);
          m.push(y), s++, await this.stageBlock(y, d, p, {
            customerProvidedKey: n.customerProvidedKey,
            conditions: n.conditions,
            encryptionScope: n.encryptionScope,
            tracingOptions: i.tracingOptions
          }), l += p, n.onProgress && n.onProgress({ loadedBytes: l });
        },
        // concurrency should set a smaller value than maxConcurrency, which is helpful to
        // reduce the possibility when a outgoing handler waits for stream data, in
        // this situation, outgoing handlers are blocked.
        // Outgoing queue shouldn't be empty.
        Math.ceil(a / 4 * 3)
      ).do(), C(await this.commitBlockList(m, Object.assign(Object.assign({}, n), { tracingOptions: i.tracingOptions })));
    });
  }
}
class fr extends pe {
  constructor(e, t, a, n) {
    let i, s;
    if (n = n || {}, _e(t))
      s = e, i = t;
    else if (W && t instanceof K || t instanceof F || le(t))
      s = e, n = a, i = j(t, n);
    else if (!t && typeof t != "string")
      s = e, i = j(new F(), n);
    else if (t && typeof t == "string" && a && typeof a == "string") {
      const o = t, l = a, m = tt(e);
      if (m.kind === "AccountConnString")
        if (W) {
          const c = new K(m.accountName, m.accountKey);
          s = X(X(m.url, encodeURIComponent(o)), encodeURIComponent(l)), n.proxyOptions || (n.proxyOptions = Ze(m.proxyUri)), i = j(c, n);
        } else
          throw new Error("Account connection string is only supported in Node.js environment");
      else if (m.kind === "SASConnString")
        s = X(X(m.url, encodeURIComponent(o)), encodeURIComponent(l)) + "?" + m.accountSas, i = j(new F(), n);
      else
        throw new Error("Connection string must be either an Account connection string or a SAS connection string");
    } else
      throw new Error("Expecting non-empty strings for containerName and blobName parameters");
    super(s, i), this.pageBlobContext = this.storageClientContext.pageBlob;
  }
  /**
   * Creates a new PageBlobClient object identical to the source but with the
   * specified snapshot timestamp.
   * Provide "" will remove the snapshot and return a Client to the base blob.
   *
   * @param snapshot - The snapshot timestamp.
   * @returns A new PageBlobClient object identical to the source but with the specified snapshot timestamp.
   */
  withSnapshot(e) {
    return new fr(xe(this.url, de.Parameters.SNAPSHOT, e.length === 0 ? void 0 : e), this.pipeline);
  }
  /**
   * Creates a page blob of the specified length. Call uploadPages to upload data
   * data to a page blob.
   * @see https://learn.microsoft.com/rest/api/storageservices/put-blob
   *
   * @param size - size of the page blob.
   * @param options - Options to the Page Blob Create operation.
   * @returns Response data for the Page Blob Create operation.
   */
  async create(e, t = {}) {
    return t.conditions = t.conditions || {}, J(t.customerProvidedKey, this.isHttps), x.withSpan("PageBlobClient-create", t, async (a) => {
      var n, i, s;
      return C(await this.pageBlobContext.create(0, e, {
        abortSignal: t.abortSignal,
        blobHttpHeaders: t.blobHTTPHeaders,
        blobSequenceNumber: t.blobSequenceNumber,
        leaseAccessConditions: t.conditions,
        metadata: t.metadata,
        modifiedAccessConditions: Object.assign(Object.assign({}, t.conditions), { ifTags: (n = t.conditions) === null || n === void 0 ? void 0 : n.tagConditions }),
        cpkInfo: t.customerProvidedKey,
        encryptionScope: t.encryptionScope,
        immutabilityPolicyExpiry: (i = t.immutabilityPolicy) === null || i === void 0 ? void 0 : i.expiriesOn,
        immutabilityPolicyMode: (s = t.immutabilityPolicy) === null || s === void 0 ? void 0 : s.policyMode,
        legalHold: t.legalHold,
        tier: Oe(t.tier),
        blobTagsString: qe(t.tags),
        tracingOptions: a.tracingOptions
      }));
    });
  }
  /**
   * Creates a page blob of the specified length. Call uploadPages to upload data
   * data to a page blob. If the blob with the same name already exists, the content
   * of the existing blob will remain unchanged.
   * @see https://learn.microsoft.com/rest/api/storageservices/put-blob
   *
   * @param size - size of the page blob.
   * @param options -
   */
  async createIfNotExists(e, t = {}) {
    return x.withSpan("PageBlobClient-createIfNotExists", t, async (a) => {
      var n, i;
      try {
        const s = { ifNoneMatch: Wn }, o = C(await this.create(e, Object.assign(Object.assign({}, t), { conditions: s, tracingOptions: a.tracingOptions })));
        return Object.assign(Object.assign({ succeeded: !0 }, o), { _response: o._response });
      } catch (s) {
        if (((n = s.details) === null || n === void 0 ? void 0 : n.errorCode) === "BlobAlreadyExists")
          return Object.assign(Object.assign({ succeeded: !1 }, (i = s.response) === null || i === void 0 ? void 0 : i.parsedHeaders), { _response: s.response });
        throw s;
      }
    });
  }
  /**
   * Writes 1 or more pages to the page blob. The start and end offsets must be a multiple of 512.
   * @see https://learn.microsoft.com/rest/api/storageservices/put-page
   *
   * @param body - Data to upload
   * @param offset - Offset of destination page blob
   * @param count - Content length of the body, also number of bytes to be uploaded
   * @param options - Options to the Page Blob Upload Pages operation.
   * @returns Response data for the Page Blob Upload Pages operation.
   */
  async uploadPages(e, t, a, n = {}) {
    return n.conditions = n.conditions || {}, J(n.customerProvidedKey, this.isHttps), x.withSpan("PageBlobClient-uploadPages", n, async (i) => {
      var s;
      return C(await this.pageBlobContext.uploadPages(a, e, {
        abortSignal: n.abortSignal,
        leaseAccessConditions: n.conditions,
        modifiedAccessConditions: Object.assign(Object.assign({}, n.conditions), { ifTags: (s = n.conditions) === null || s === void 0 ? void 0 : s.tagConditions }),
        requestOptions: {
          onUploadProgress: n.onProgress
        },
        range: se({ offset: t, count: a }),
        sequenceNumberAccessConditions: n.conditions,
        transactionalContentMD5: n.transactionalContentMD5,
        transactionalContentCrc64: n.transactionalContentCrc64,
        cpkInfo: n.customerProvidedKey,
        encryptionScope: n.encryptionScope,
        tracingOptions: i.tracingOptions
      }));
    });
  }
  /**
   * The Upload Pages operation writes a range of pages to a page blob where the
   * contents are read from a URL.
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/put-page-from-url
   *
   * @param sourceURL - Specify a URL to the copy source, Shared Access Signature(SAS) maybe needed for authentication
   * @param sourceOffset - The source offset to copy from. Pass 0 to copy from the beginning of source page blob
   * @param destOffset - Offset of destination page blob
   * @param count - Number of bytes to be uploaded from source page blob
   * @param options -
   */
  async uploadPagesFromURL(e, t, a, n, i = {}) {
    return i.conditions = i.conditions || {}, i.sourceConditions = i.sourceConditions || {}, J(i.customerProvidedKey, this.isHttps), x.withSpan("PageBlobClient-uploadPagesFromURL", i, async (s) => {
      var o, l, m, c, d;
      return C(await this.pageBlobContext.uploadPagesFromURL(e, se({ offset: t, count: n }), 0, se({ offset: a, count: n }), {
        abortSignal: i.abortSignal,
        sourceContentMD5: i.sourceContentMD5,
        sourceContentCrc64: i.sourceContentCrc64,
        leaseAccessConditions: i.conditions,
        sequenceNumberAccessConditions: i.conditions,
        modifiedAccessConditions: Object.assign(Object.assign({}, i.conditions), { ifTags: (o = i.conditions) === null || o === void 0 ? void 0 : o.tagConditions }),
        sourceModifiedAccessConditions: {
          sourceIfMatch: (l = i.sourceConditions) === null || l === void 0 ? void 0 : l.ifMatch,
          sourceIfModifiedSince: (m = i.sourceConditions) === null || m === void 0 ? void 0 : m.ifModifiedSince,
          sourceIfNoneMatch: (c = i.sourceConditions) === null || c === void 0 ? void 0 : c.ifNoneMatch,
          sourceIfUnmodifiedSince: (d = i.sourceConditions) === null || d === void 0 ? void 0 : d.ifUnmodifiedSince
        },
        cpkInfo: i.customerProvidedKey,
        encryptionScope: i.encryptionScope,
        copySourceAuthorization: _t(i.sourceAuthorization),
        tracingOptions: s.tracingOptions
      }));
    });
  }
  /**
   * Frees the specified pages from the page blob.
   * @see https://learn.microsoft.com/rest/api/storageservices/put-page
   *
   * @param offset - Starting byte position of the pages to clear.
   * @param count - Number of bytes to clear.
   * @param options - Options to the Page Blob Clear Pages operation.
   * @returns Response data for the Page Blob Clear Pages operation.
   */
  async clearPages(e = 0, t, a = {}) {
    return a.conditions = a.conditions || {}, x.withSpan("PageBlobClient-clearPages", a, async (n) => {
      var i;
      return C(await this.pageBlobContext.clearPages(0, {
        abortSignal: a.abortSignal,
        leaseAccessConditions: a.conditions,
        modifiedAccessConditions: Object.assign(Object.assign({}, a.conditions), { ifTags: (i = a.conditions) === null || i === void 0 ? void 0 : i.tagConditions }),
        range: se({ offset: e, count: t }),
        sequenceNumberAccessConditions: a.conditions,
        cpkInfo: a.customerProvidedKey,
        encryptionScope: a.encryptionScope,
        tracingOptions: n.tracingOptions
      }));
    });
  }
  /**
   * Returns the list of valid page ranges for a page blob or snapshot of a page blob.
   * @see https://learn.microsoft.com/rest/api/storageservices/get-page-ranges
   *
   * @param offset - Starting byte position of the page ranges.
   * @param count - Number of bytes to get.
   * @param options - Options to the Page Blob Get Ranges operation.
   * @returns Response data for the Page Blob Get Ranges operation.
   */
  async getPageRanges(e = 0, t, a = {}) {
    return a.conditions = a.conditions || {}, x.withSpan("PageBlobClient-getPageRanges", a, async (n) => {
      var i;
      const s = C(await this.pageBlobContext.getPageRanges({
        abortSignal: a.abortSignal,
        leaseAccessConditions: a.conditions,
        modifiedAccessConditions: Object.assign(Object.assign({}, a.conditions), { ifTags: (i = a.conditions) === null || i === void 0 ? void 0 : i.tagConditions }),
        range: se({ offset: e, count: t }),
        tracingOptions: n.tracingOptions
      }));
      return wr(s);
    });
  }
  /**
   * getPageRangesSegment returns a single segment of page ranges starting from the
   * specified Marker. Use an empty Marker to start enumeration from the beginning.
   * After getting a segment, process it, and then call getPageRangesSegment again
   * (passing the the previously-returned Marker) to get the next segment.
   * @see https://learn.microsoft.com/rest/api/storageservices/get-page-ranges
   *
   * @param offset - Starting byte position of the page ranges.
   * @param count - Number of bytes to get.
   * @param marker - A string value that identifies the portion of the list to be returned with the next list operation.
   * @param options - Options to PageBlob Get Page Ranges Segment operation.
   */
  async listPageRangesSegment(e = 0, t, a, n = {}) {
    return x.withSpan("PageBlobClient-getPageRangesSegment", n, async (i) => {
      var s;
      return C(await this.pageBlobContext.getPageRanges({
        abortSignal: n.abortSignal,
        leaseAccessConditions: n.conditions,
        modifiedAccessConditions: Object.assign(Object.assign({}, n.conditions), { ifTags: (s = n.conditions) === null || s === void 0 ? void 0 : s.tagConditions }),
        range: se({ offset: e, count: t }),
        marker: a,
        maxPageSize: n.maxPageSize,
        tracingOptions: i.tracingOptions
      }));
    });
  }
  /**
   * Returns an AsyncIterableIterator for {@link PageBlobGetPageRangesResponseModel}
   *
   * @param offset - Starting byte position of the page ranges.
   * @param count - Number of bytes to get.
   * @param marker - A string value that identifies the portion of
   *                          the get of page ranges to be returned with the next getting operation. The
   *                          operation returns the ContinuationToken value within the response body if the
   *                          getting operation did not return all page ranges remaining within the current page.
   *                          The ContinuationToken value can be used as the value for
   *                          the marker parameter in a subsequent call to request the next page of get
   *                          items. The marker value is opaque to the client.
   * @param options - Options to List Page Ranges operation.
   */
  listPageRangeItemSegments() {
    return ne(this, arguments, function* (t = 0, a, n, i = {}) {
      let s;
      if (n || n === void 0)
        do
          s = yield I(this.listPageRangesSegment(t, a, n, i)), n = s.continuationToken, yield yield I(yield I(s));
        while (n);
    });
  }
  /**
   * Returns an AsyncIterableIterator of {@link PageRangeInfo} objects
   *
   * @param offset - Starting byte position of the page ranges.
   * @param count - Number of bytes to get.
   * @param options - Options to List Page Ranges operation.
   */
  listPageRangeItems() {
    return ne(this, arguments, function* (t = 0, a, n = {}) {
      var i, s, o, l;
      let m;
      try {
        for (var c = !0, d = oe(this.listPageRangeItemSegments(t, a, m, n)), p; p = yield I(d.next()), i = p.done, !i; c = !0)
          l = p.value, c = !1, yield I(yield* We(oe(Qa(l))));
      } catch (y) {
        s = { error: y };
      } finally {
        try {
          !c && !i && (o = d.return) && (yield I(o.call(d)));
        } finally {
          if (s) throw s.error;
        }
      }
    });
  }
  /**
   * Returns an async iterable iterator to list of page ranges for a page blob.
   * @see https://learn.microsoft.com/rest/api/storageservices/get-page-ranges
   *
   *  .byPage() returns an async iterable iterator to list of page ranges for a page blob.
   *
   * Example using `for await` syntax:
   *
   * ```js
   * // Get the pageBlobClient before you run these snippets,
   * // Can be obtained from `blobServiceClient.getContainerClient("<your-container-name>").getPageBlobClient("<your-blob-name>");`
   * let i = 1;
   * for await (const pageRange of pageBlobClient.listPageRanges()) {
   *   console.log(`Page range ${i++}: ${pageRange.start} - ${pageRange.end}`);
   * }
   * ```
   *
   * Example using `iter.next()`:
   *
   * ```js
   * let i = 1;
   * let iter = pageBlobClient.listPageRanges();
   * let pageRangeItem = await iter.next();
   * while (!pageRangeItem.done) {
   *   console.log(`Page range ${i++}: ${pageRangeItem.value.start} - ${pageRangeItem.value.end}, IsClear: ${pageRangeItem.value.isClear}`);
   *   pageRangeItem = await iter.next();
   * }
   * ```
   *
   * Example using `byPage()`:
   *
   * ```js
   * // passing optional maxPageSize in the page settings
   * let i = 1;
   * for await (const response of pageBlobClient.listPageRanges().byPage({ maxPageSize: 20 })) {
   *   for (const pageRange of response) {
   *     console.log(`Page range ${i++}: ${pageRange.start} - ${pageRange.end}`);
   *   }
   * }
   * ```
   *
   * Example using paging with a marker:
   *
   * ```js
   * let i = 1;
   * let iterator = pageBlobClient.listPageRanges().byPage({ maxPageSize: 2 });
   * let response = (await iterator.next()).value;
   *
   * // Prints 2 page ranges
   * for (const pageRange of response) {
   *   console.log(`Page range ${i++}: ${pageRange.start} - ${pageRange.end}`);
   * }
   *
   * // Gets next marker
   * let marker = response.continuationToken;
   *
   * // Passing next marker as continuationToken
   *
   * iterator = pageBlobClient.listPageRanges().byPage({ continuationToken: marker, maxPageSize: 10 });
   * response = (await iterator.next()).value;
   *
   * // Prints 10 page ranges
   * for (const blob of response) {
   *   console.log(`Page range ${i++}: ${pageRange.start} - ${pageRange.end}`);
   * }
   * ```
   * @param offset - Starting byte position of the page ranges.
   * @param count - Number of bytes to get.
   * @param options - Options to the Page Blob Get Ranges operation.
   * @returns An asyncIterableIterator that supports paging.
   */
  listPageRanges(e = 0, t, a = {}) {
    a.conditions = a.conditions || {};
    const n = this.listPageRangeItems(e, t, a);
    return {
      /**
       * The next method, part of the iteration protocol
       */
      next() {
        return n.next();
      },
      /**
       * The connection to the async iterator, part of the iteration protocol
       */
      [Symbol.asyncIterator]() {
        return this;
      },
      /**
       * Return an AsyncIterableIterator that works a page at a time
       */
      byPage: (i = {}) => this.listPageRangeItemSegments(e, t, i.continuationToken, Object.assign({ maxPageSize: i.maxPageSize }, a))
    };
  }
  /**
   * Gets the collection of page ranges that differ between a specified snapshot and this page blob.
   * @see https://learn.microsoft.com/rest/api/storageservices/get-page-ranges
   *
   * @param offset - Starting byte position of the page blob
   * @param count - Number of bytes to get ranges diff.
   * @param prevSnapshot - Timestamp of snapshot to retrieve the difference.
   * @param options - Options to the Page Blob Get Page Ranges Diff operation.
   * @returns Response data for the Page Blob Get Page Range Diff operation.
   */
  async getPageRangesDiff(e, t, a, n = {}) {
    return n.conditions = n.conditions || {}, x.withSpan("PageBlobClient-getPageRangesDiff", n, async (i) => {
      var s;
      const o = C(await this.pageBlobContext.getPageRangesDiff({
        abortSignal: n.abortSignal,
        leaseAccessConditions: n.conditions,
        modifiedAccessConditions: Object.assign(Object.assign({}, n.conditions), { ifTags: (s = n.conditions) === null || s === void 0 ? void 0 : s.tagConditions }),
        prevsnapshot: a,
        range: se({ offset: e, count: t }),
        tracingOptions: i.tracingOptions
      }));
      return wr(o);
    });
  }
  /**
   * getPageRangesDiffSegment returns a single segment of page ranges starting from the
   * specified Marker for difference between previous snapshot and the target page blob.
   * Use an empty Marker to start enumeration from the beginning.
   * After getting a segment, process it, and then call getPageRangesDiffSegment again
   * (passing the the previously-returned Marker) to get the next segment.
   * @see https://learn.microsoft.com/rest/api/storageservices/get-page-ranges
   *
   * @param offset - Starting byte position of the page ranges.
   * @param count - Number of bytes to get.
   * @param prevSnapshotOrUrl - Timestamp of snapshot to retrieve the difference or URL of snapshot to retrieve the difference.
   * @param marker - A string value that identifies the portion of the get to be returned with the next get operation.
   * @param options - Options to the Page Blob Get Page Ranges Diff operation.
   */
  async listPageRangesDiffSegment(e, t, a, n, i = {}) {
    return x.withSpan("PageBlobClient-getPageRangesDiffSegment", i, async (s) => {
      var o;
      return C(await this.pageBlobContext.getPageRangesDiff({
        abortSignal: i == null ? void 0 : i.abortSignal,
        leaseAccessConditions: i == null ? void 0 : i.conditions,
        modifiedAccessConditions: Object.assign(Object.assign({}, i == null ? void 0 : i.conditions), { ifTags: (o = i == null ? void 0 : i.conditions) === null || o === void 0 ? void 0 : o.tagConditions }),
        prevsnapshot: a,
        range: se({
          offset: e,
          count: t
        }),
        marker: n,
        maxPageSize: i == null ? void 0 : i.maxPageSize,
        tracingOptions: s.tracingOptions
      }));
    });
  }
  /**
   * Returns an AsyncIterableIterator for {@link PageBlobGetPageRangesDiffResponseModel}
   *
   *
   * @param offset - Starting byte position of the page ranges.
   * @param count - Number of bytes to get.
   * @param prevSnapshotOrUrl - Timestamp of snapshot to retrieve the difference or URL of snapshot to retrieve the difference.
   * @param marker - A string value that identifies the portion of
   *                          the get of page ranges to be returned with the next getting operation. The
   *                          operation returns the ContinuationToken value within the response body if the
   *                          getting operation did not return all page ranges remaining within the current page.
   *                          The ContinuationToken value can be used as the value for
   *                          the marker parameter in a subsequent call to request the next page of get
   *                          items. The marker value is opaque to the client.
   * @param options - Options to the Page Blob Get Page Ranges Diff operation.
   */
  listPageRangeDiffItemSegments(e, t, a, n, i) {
    return ne(this, arguments, function* () {
      let o;
      if (n || n === void 0)
        do
          o = yield I(this.listPageRangesDiffSegment(e, t, a, n, i)), n = o.continuationToken, yield yield I(yield I(o));
        while (n);
    });
  }
  /**
   * Returns an AsyncIterableIterator of {@link PageRangeInfo} objects
   *
   * @param offset - Starting byte position of the page ranges.
   * @param count - Number of bytes to get.
   * @param prevSnapshotOrUrl - Timestamp of snapshot to retrieve the difference or URL of snapshot to retrieve the difference.
   * @param options - Options to the Page Blob Get Page Ranges Diff operation.
   */
  listPageRangeDiffItems(e, t, a, n) {
    return ne(this, arguments, function* () {
      var s, o, l, m;
      let c;
      try {
        for (var d = !0, p = oe(this.listPageRangeDiffItemSegments(e, t, a, c, n)), y; y = yield I(p.next()), s = y.done, !s; d = !0)
          m = y.value, d = !1, yield I(yield* We(oe(Qa(m))));
      } catch (u) {
        o = { error: u };
      } finally {
        try {
          !d && !s && (l = p.return) && (yield I(l.call(p)));
        } finally {
          if (o) throw o.error;
        }
      }
    });
  }
  /**
   * Returns an async iterable iterator to list of page ranges that differ between a specified snapshot and this page blob.
   * @see https://learn.microsoft.com/rest/api/storageservices/get-page-ranges
   *
   *  .byPage() returns an async iterable iterator to list of page ranges that differ between a specified snapshot and this page blob.
   *
   * Example using `for await` syntax:
   *
   * ```js
   * // Get the pageBlobClient before you run these snippets,
   * // Can be obtained from `blobServiceClient.getContainerClient("<your-container-name>").getPageBlobClient("<your-blob-name>");`
   * let i = 1;
   * for await (const pageRange of pageBlobClient.listPageRangesDiff()) {
   *   console.log(`Page range ${i++}: ${pageRange.start} - ${pageRange.end}`);
   * }
   * ```
   *
   * Example using `iter.next()`:
   *
   * ```js
   * let i = 1;
   * let iter = pageBlobClient.listPageRangesDiff();
   * let pageRangeItem = await iter.next();
   * while (!pageRangeItem.done) {
   *   console.log(`Page range ${i++}: ${pageRangeItem.value.start} - ${pageRangeItem.value.end}, IsClear: ${pageRangeItem.value.isClear}`);
   *   pageRangeItem = await iter.next();
   * }
   * ```
   *
   * Example using `byPage()`:
   *
   * ```js
   * // passing optional maxPageSize in the page settings
   * let i = 1;
   * for await (const response of pageBlobClient.listPageRangesDiff().byPage({ maxPageSize: 20 })) {
   *   for (const pageRange of response) {
   *     console.log(`Page range ${i++}: ${pageRange.start} - ${pageRange.end}`);
   *   }
   * }
   * ```
   *
   * Example using paging with a marker:
   *
   * ```js
   * let i = 1;
   * let iterator = pageBlobClient.listPageRangesDiff().byPage({ maxPageSize: 2 });
   * let response = (await iterator.next()).value;
   *
   * // Prints 2 page ranges
   * for (const pageRange of response) {
   *   console.log(`Page range ${i++}: ${pageRange.start} - ${pageRange.end}`);
   * }
   *
   * // Gets next marker
   * let marker = response.continuationToken;
   *
   * // Passing next marker as continuationToken
   *
   * iterator = pageBlobClient.listPageRangesDiff().byPage({ continuationToken: marker, maxPageSize: 10 });
   * response = (await iterator.next()).value;
   *
   * // Prints 10 page ranges
   * for (const blob of response) {
   *   console.log(`Page range ${i++}: ${pageRange.start} - ${pageRange.end}`);
   * }
   * ```
   * @param offset - Starting byte position of the page ranges.
   * @param count - Number of bytes to get.
   * @param prevSnapshot - Timestamp of snapshot to retrieve the difference.
   * @param options - Options to the Page Blob Get Ranges operation.
   * @returns An asyncIterableIterator that supports paging.
   */
  listPageRangesDiff(e, t, a, n = {}) {
    n.conditions = n.conditions || {};
    const i = this.listPageRangeDiffItems(e, t, a, Object.assign({}, n));
    return {
      /**
       * The next method, part of the iteration protocol
       */
      next() {
        return i.next();
      },
      /**
       * The connection to the async iterator, part of the iteration protocol
       */
      [Symbol.asyncIterator]() {
        return this;
      },
      /**
       * Return an AsyncIterableIterator that works a page at a time
       */
      byPage: (s = {}) => this.listPageRangeDiffItemSegments(e, t, a, s.continuationToken, Object.assign({ maxPageSize: s.maxPageSize }, n))
    };
  }
  /**
   * Gets the collection of page ranges that differ between a specified snapshot and this page blob for managed disks.
   * @see https://learn.microsoft.com/rest/api/storageservices/get-page-ranges
   *
   * @param offset - Starting byte position of the page blob
   * @param count - Number of bytes to get ranges diff.
   * @param prevSnapshotUrl - URL of snapshot to retrieve the difference.
   * @param options - Options to the Page Blob Get Page Ranges Diff operation.
   * @returns Response data for the Page Blob Get Page Range Diff operation.
   */
  async getPageRangesDiffForManagedDisks(e, t, a, n = {}) {
    return n.conditions = n.conditions || {}, x.withSpan("PageBlobClient-GetPageRangesDiffForManagedDisks", n, async (i) => {
      var s;
      const o = C(await this.pageBlobContext.getPageRangesDiff({
        abortSignal: n.abortSignal,
        leaseAccessConditions: n.conditions,
        modifiedAccessConditions: Object.assign(Object.assign({}, n.conditions), { ifTags: (s = n.conditions) === null || s === void 0 ? void 0 : s.tagConditions }),
        prevSnapshotUrl: a,
        range: se({ offset: e, count: t }),
        tracingOptions: i.tracingOptions
      }));
      return wr(o);
    });
  }
  /**
   * Resizes the page blob to the specified size (which must be a multiple of 512).
   * @see https://learn.microsoft.com/rest/api/storageservices/set-blob-properties
   *
   * @param size - Target size
   * @param options - Options to the Page Blob Resize operation.
   * @returns Response data for the Page Blob Resize operation.
   */
  async resize(e, t = {}) {
    return t.conditions = t.conditions || {}, x.withSpan("PageBlobClient-resize", t, async (a) => {
      var n;
      return C(await this.pageBlobContext.resize(e, {
        abortSignal: t.abortSignal,
        leaseAccessConditions: t.conditions,
        modifiedAccessConditions: Object.assign(Object.assign({}, t.conditions), { ifTags: (n = t.conditions) === null || n === void 0 ? void 0 : n.tagConditions }),
        encryptionScope: t.encryptionScope,
        tracingOptions: a.tracingOptions
      }));
    });
  }
  /**
   * Sets a page blob's sequence number.
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/set-blob-properties
   *
   * @param sequenceNumberAction - Indicates how the service should modify the blob's sequence number.
   * @param sequenceNumber - Required if sequenceNumberAction is max or update
   * @param options - Options to the Page Blob Update Sequence Number operation.
   * @returns Response data for the Page Blob Update Sequence Number operation.
   */
  async updateSequenceNumber(e, t, a = {}) {
    return a.conditions = a.conditions || {}, x.withSpan("PageBlobClient-updateSequenceNumber", a, async (n) => {
      var i;
      return C(await this.pageBlobContext.updateSequenceNumber(e, {
        abortSignal: a.abortSignal,
        blobSequenceNumber: t,
        leaseAccessConditions: a.conditions,
        modifiedAccessConditions: Object.assign(Object.assign({}, a.conditions), { ifTags: (i = a.conditions) === null || i === void 0 ? void 0 : i.tagConditions }),
        tracingOptions: n.tracingOptions
      }));
    });
  }
  /**
   * Begins an operation to start an incremental copy from one page blob's snapshot to this page blob.
   * The snapshot is copied such that only the differential changes between the previously
   * copied snapshot are transferred to the destination.
   * The copied snapshots are complete copies of the original snapshot and can be read or copied from as usual.
   * @see https://learn.microsoft.com/rest/api/storageservices/incremental-copy-blob
   * @see https://learn.microsoft.com/en-us/azure/virtual-machines/windows/incremental-snapshots
   *
   * @param copySource - Specifies the name of the source page blob snapshot. For example,
   *                            https://myaccount.blob.core.windows.net/mycontainer/myblob?snapshot=<DateTime>
   * @param options - Options to the Page Blob Copy Incremental operation.
   * @returns Response data for the Page Blob Copy Incremental operation.
   */
  async startCopyIncremental(e, t = {}) {
    return x.withSpan("PageBlobClient-startCopyIncremental", t, async (a) => {
      var n;
      return C(await this.pageBlobContext.copyIncremental(e, {
        abortSignal: t.abortSignal,
        modifiedAccessConditions: Object.assign(Object.assign({}, t.conditions), { ifTags: (n = t.conditions) === null || n === void 0 ? void 0 : n.tagConditions }),
        tracingOptions: a.tracingOptions
      }));
    });
  }
}
async function bg(r) {
  const e = await r.blobBody;
  return hg(e);
}
function Cg(r) {
  return new Blob([r]).size;
}
const Jt = ": ", en = " ", tn = -1;
class Pg {
  constructor(e, t) {
    if (!e || !e.contentType)
      throw new RangeError("batchResponse is malformed or doesn't contain valid content-type.");
    if (!t || t.size === 0)
      throw new RangeError("Invalid state: subRequests is not provided or size is 0.");
    this.batchResponse = e, this.subRequests = t, this.responseBatchBoundary = this.batchResponse.contentType.split("=")[1], this.perResponsePrefix = `--${this.responseBatchBoundary}${he}`, this.batchResponseEnding = `--${this.responseBatchBoundary}--`;
  }
  // For example of response, please refer to https://learn.microsoft.com/en-us/rest/api/storageservices/blob-batch#response
  async parseBatchResponse() {
    if (this.batchResponse._response.status !== Cp.HTTP_ACCEPTED)
      throw new Error(`Invalid state: batch request failed with status: '${this.batchResponse._response.status}'.`);
    const t = (await bg(this.batchResponse)).split(this.batchResponseEnding)[0].split(this.perResponsePrefix).slice(1), a = t.length;
    if (a !== this.subRequests.size && a !== 1)
      throw new Error("Invalid state: sub responses' count is not equal to sub requests' count.");
    const n = new Array(a);
    let i = 0, s = 0;
    for (let o = 0; o < a; o++) {
      const l = t[o], m = {};
      m.headers = ta(ir());
      const c = l.split(`${he}`);
      let d = !1, p = !1, y = !1, u = tn;
      for (const h of c) {
        if (!d) {
          if (h.startsWith(fe.CONTENT_ID) && (u = parseInt(h.split(Jt)[1])), h.startsWith(Qn)) {
            d = !0;
            const R = h.split(en);
            m.status = parseInt(R[1]), m.statusMessage = R.slice(2).join(en);
          }
          continue;
        }
        if (h.trim() === "") {
          p || (p = !0);
          continue;
        }
        if (p)
          m.bodyAsText || (m.bodyAsText = ""), m.bodyAsText += h;
        else {
          if (h.indexOf(Jt) === -1)
            throw new Error(`Invalid state: find non-empty line '${h}' without HTTP header delimiter '${Jt}'.`);
          const R = h.split(Jt);
          m.headers.set(R[0], R[1]), R[0] === fe.X_MS_ERROR_CODE && (m.errorCode = R[1], y = !0);
        }
      }
      u !== tn && Number.isInteger(u) && u >= 0 && u < this.subRequests.size && n[u] === void 0 ? (m._request = this.subRequests.get(u), n[u] = m) : Q.error(`subResponses[${o}] is dropped as the Content-ID is not found or invalid, Content-ID: ${u}`), y ? s++ : i++;
    }
    return {
      subResponses: n,
      subResponsesSucceededCount: i,
      subResponsesFailedCount: s
    };
  }
}
var Fe;
(function(r) {
  r[r.LOCKED = 0] = "LOCKED", r[r.UNLOCKED = 1] = "UNLOCKED";
})(Fe || (Fe = {}));
class ar {
  /**
   * Lock for a specific key. If the lock has been acquired by another customer, then
   * will wait until getting the lock.
   *
   * @param key - lock key
   */
  static async lock(e) {
    return new Promise((t) => {
      this.keys[e] === void 0 || this.keys[e] === Fe.UNLOCKED ? (this.keys[e] = Fe.LOCKED, t()) : this.onUnlockEvent(e, () => {
        this.keys[e] = Fe.LOCKED, t();
      });
    });
  }
  /**
   * Unlock a key.
   *
   * @param key -
   */
  static async unlock(e) {
    return new Promise((t) => {
      this.keys[e] === Fe.LOCKED && this.emitUnlockEvent(e), delete this.keys[e], t();
    });
  }
  static onUnlockEvent(e, t) {
    this.listeners[e] === void 0 ? this.listeners[e] = [t] : this.listeners[e].push(t);
  }
  static emitUnlockEvent(e) {
    if (this.listeners[e] !== void 0 && this.listeners[e].length > 0) {
      const t = this.listeners[e].shift();
      setImmediate(() => {
        t.call(this);
      });
    }
  }
}
ar.keys = {};
ar.listeners = {};
class Br {
  constructor() {
    this.batch = "batch", this.batchRequest = new vg();
  }
  /**
   * Get the value of Content-Type for a batch request.
   * The value must be multipart/mixed with a batch boundary.
   * Example: multipart/mixed; boundary=batch_a81786c8-e301-4e42-a729-a32ca24ae252
   */
  getMultiPartContentType() {
    return this.batchRequest.getMultipartContentType();
  }
  /**
   * Get assembled HTTP request body for sub requests.
   */
  getHttpRequestBody() {
    return this.batchRequest.getHttpRequestBody();
  }
  /**
   * Get sub requests that are added into the batch request.
   */
  getSubRequests() {
    return this.batchRequest.getSubRequests();
  }
  async addSubRequestInternal(e, t) {
    await ar.lock(this.batch);
    try {
      this.batchRequest.preAddSubRequest(e), await t(), this.batchRequest.postAddSubRequest(e);
    } finally {
      await ar.unlock(this.batch);
    }
  }
  setBatchType(e) {
    if (this.batchType || (this.batchType = e), this.batchType !== e)
      throw new RangeError(`BlobBatch only supports one operation type per batch and it already is being used for ${this.batchType} operations.`);
  }
  async deleteBlob(e, t, a) {
    let n, i;
    if (typeof e == "string" && (W && t instanceof K || t instanceof F || le(t)))
      n = e, i = t;
    else if (e instanceof pe)
      n = e.url, i = e.credential, a = t;
    else
      throw new RangeError("Invalid arguments. Either url and credential, or BlobClient need be provided.");
    return a || (a = {}), x.withSpan("BatchDeleteRequest-addSubRequest", a, async (s) => {
      this.setBatchType("delete"), await this.addSubRequestInternal({
        url: n,
        credential: i
      }, async () => {
        await new pe(n, this.batchRequest.createPipeline(i)).delete(s);
      });
    });
  }
  async setBlobAccessTier(e, t, a, n) {
    let i, s, o;
    if (typeof e == "string" && (W && t instanceof K || t instanceof F || le(t)))
      i = e, s = t, o = a;
    else if (e instanceof pe)
      i = e.url, s = e.credential, o = t, n = a;
    else
      throw new RangeError("Invalid arguments. Either url and credential, or BlobClient need be provided.");
    return n || (n = {}), x.withSpan("BatchSetTierRequest-addSubRequest", n, async (l) => {
      this.setBatchType("setAccessTier"), await this.addSubRequestInternal({
        url: i,
        credential: s
      }, async () => {
        await new pe(i, this.batchRequest.createPipeline(s)).setAccessTier(o, l);
      });
    });
  }
}
class vg {
  constructor() {
    this.operationCount = 0, this.body = "";
    const e = Vt();
    this.boundary = `batch_${e}`, this.subRequestPrefix = `--${this.boundary}${he}${fe.CONTENT_TYPE}: application/http${he}${fe.CONTENT_TRANSFER_ENCODING}: binary`, this.multipartContentType = `multipart/mixed; boundary=${this.boundary}`, this.batchRequestEnding = `--${this.boundary}--`, this.subRequests = /* @__PURE__ */ new Map();
  }
  /**
   * Create pipeline to assemble sub requests. The idea here is to use existing
   * credential and serialization/deserialization components, with additional policies to
   * filter unnecessary headers, assemble sub requests into request's body
   * and intercept request from going to wire.
   * @param credential -  Such as AnonymousCredential, StorageSharedKeyCredential or any credential from the `@azure/identity` package to authenticate requests to the service. You can also provide an object that implements the TokenCredential interface. If not specified, AnonymousCredential is used.
   */
  createPipeline(e) {
    const t = gn();
    t.addPolicy(_n({
      stringifyXML: Kn
    }), { phase: "Serialize" }), t.addPolicy(Sg()), t.addPolicy(zg(this), { afterPhase: "Sign" }), le(e) ? t.addPolicy(Vr({
      credential: e,
      scopes: Xn,
      challengeCallbacks: { authorizeRequestOnChallenge: Ln }
    }), { phase: "Sign" }) : e instanceof K && t.addPolicy(ti({
      accountName: e.accountName,
      accountKey: e.accountKey
    }), { phase: "Sign" });
    const a = new ri([]);
    return a._credential = e, a._corePipeline = t, a;
  }
  appendSubRequestToBody(e) {
    this.body += [
      this.subRequestPrefix,
      // sub request constant prefix
      `${fe.CONTENT_ID}: ${this.operationCount}`,
      // sub request's content ID
      "",
      // empty line after sub request's content ID
      `${e.method.toString()} ${qp(e.url)} ${Qn}${he}`
      // sub request start line with method
    ].join(he);
    for (const [t, a] of e.headers)
      this.body += `${t}: ${a}${he}`;
    this.body += he;
  }
  preAddSubRequest(e) {
    if (this.operationCount >= Ka)
      throw new RangeError(`Cannot exceed ${Ka} sub requests in a single batch`);
    const t = Yn(e.url);
    if (!t || t === "")
      throw new RangeError(`Invalid url for sub request: '${e.url}'`);
  }
  postAddSubRequest(e) {
    this.subRequests.set(this.operationCount, e), this.operationCount++;
  }
  // Return the http request body with assembling the ending line to the sub request body.
  getHttpRequestBody() {
    return `${this.body}${this.batchRequestEnding}${he}`;
  }
  getMultipartContentType() {
    return this.multipartContentType;
  }
  getSubRequests() {
    return this.subRequests;
  }
}
function zg(r) {
  return {
    name: "batchRequestAssemblePolicy",
    async sendRequest(e) {
      return r.appendSubRequestToBody(e), {
        request: e,
        status: 200,
        headers: ir()
      };
    }
  };
}
function Sg() {
  return {
    name: "batchHeaderFilterPolicy",
    async sendRequest(r, e) {
      let t = "";
      for (const [a] of r.headers)
        Vn(a, fe.X_MS_VERSION) && (t = a);
      return t !== "" && r.headers.delete(t), e(r);
    }
  };
}
class wm {
  constructor(e, t, a) {
    let n;
    _e(t) ? n = t : t ? n = j(t, a) : n = j(new F(), a);
    const i = new zm(e, ai(n)), s = Yn(e);
    s && s !== "/" ? this.serviceOrContainerContext = i.container : this.serviceOrContainerContext = i.service;
  }
  /**
   * Creates a {@link BlobBatch}.
   * A BlobBatch represents an aggregated set of operations on blobs.
   */
  createBatch() {
    return new Br();
  }
  async deleteBlobs(e, t, a) {
    const n = new Br();
    for (const i of e)
      typeof i == "string" ? await n.deleteBlob(i, t, a) : await n.deleteBlob(i, t);
    return this.submitBatch(n);
  }
  async setBlobsAccessTier(e, t, a, n) {
    const i = new Br();
    for (const s of e)
      typeof s == "string" ? await i.setBlobAccessTier(s, t, a, n) : await i.setBlobAccessTier(s, t, a);
    return this.submitBatch(i);
  }
  /**
   * Submit batch request which consists of multiple subrequests.
   *
   * Get `blobBatchClient` and other details before running the snippets.
   * `blobServiceClient.getBlobBatchClient()` gives the `blobBatchClient`
   *
   * Example usage:
   *
   * ```js
   * let batchRequest = new BlobBatch();
   * await batchRequest.deleteBlob(urlInString0, credential0);
   * await batchRequest.deleteBlob(urlInString1, credential1, {
   *  deleteSnapshots: "include"
   * });
   * const batchResp = await blobBatchClient.submitBatch(batchRequest);
   * console.log(batchResp.subResponsesSucceededCount);
   * ```
   *
   * Example using a lease:
   *
   * ```js
   * let batchRequest = new BlobBatch();
   * await batchRequest.setBlobAccessTier(blockBlobClient0, "Cool");
   * await batchRequest.setBlobAccessTier(blockBlobClient1, "Cool", {
   *  conditions: { leaseId: leaseId }
   * });
   * const batchResp = await blobBatchClient.submitBatch(batchRequest);
   * console.log(batchResp.subResponsesSucceededCount);
   * ```
   *
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/blob-batch
   *
   * @param batchRequest - A set of Delete or SetTier operations.
   * @param options -
   */
  async submitBatch(e, t = {}) {
    if (!e || e.getSubRequests().size === 0)
      throw new RangeError("Batch request should contain one or more sub requests.");
    return x.withSpan("BlobBatchClient-submitBatch", t, async (a) => {
      const n = e.getHttpRequestBody(), i = C(await this.serviceOrContainerContext.submitBatch(Cg(n), e.getMultiPartContentType(), n, Object.assign({}, a))), o = await new Pg(i, e.getSubRequests()).parseBatchResponse();
      return {
        _response: i._response,
        contentType: i.contentType,
        errorCode: i.errorCode,
        requestId: i.requestId,
        clientRequestId: i.clientRequestId,
        version: i.version,
        subResponses: o.subResponses,
        subResponsesSucceededCount: o.subResponsesSucceededCount,
        subResponsesFailedCount: o.subResponsesFailedCount
      };
    });
  }
}
class Rg extends ba {
  /**
   * The name of the container.
   */
  get containerName() {
    return this._containerName;
  }
  constructor(e, t, a) {
    let n, i;
    if (a = a || {}, _e(t))
      i = e, n = t;
    else if (W && t instanceof K || t instanceof F || le(t))
      i = e, n = j(t, a);
    else if (!t && typeof t != "string")
      i = e, n = j(new F(), a);
    else if (t && typeof t == "string") {
      const s = t, o = tt(e);
      if (o.kind === "AccountConnString")
        if (W) {
          const l = new K(o.accountName, o.accountKey);
          i = X(o.url, encodeURIComponent(s)), a.proxyOptions || (a.proxyOptions = Ze(o.proxyUri)), n = j(l, a);
        } else
          throw new Error("Account connection string is only supported in Node.js environment");
      else if (o.kind === "SASConnString")
        i = X(o.url, encodeURIComponent(s)) + "?" + o.accountSas, n = j(new F(), a);
      else
        throw new Error("Connection string must be either an Account connection string or a SAS connection string");
    } else
      throw new Error("Expecting non-empty strings for containerName parameter");
    super(i, n), this._containerName = this.getContainerNameFromUrl(), this.containerContext = this.storageClientContext.container;
  }
  /**
   * Creates a new container under the specified account. If the container with
   * the same name already exists, the operation fails.
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/create-container
   * Naming rules: @see https://learn.microsoft.com/rest/api/storageservices/naming-and-referencing-containers--blobs--and-metadata
   *
   * @param options - Options to Container Create operation.
   *
   *
   * Example usage:
   *
   * ```js
   * const containerClient = blobServiceClient.getContainerClient("<container name>");
   * const createContainerResponse = await containerClient.create();
   * console.log("Container was created successfully", createContainerResponse.requestId);
   * ```
   */
  async create(e = {}) {
    return x.withSpan("ContainerClient-create", e, async (t) => C(await this.containerContext.create(t)));
  }
  /**
   * Creates a new container under the specified account. If the container with
   * the same name already exists, it is not changed.
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/create-container
   * Naming rules: @see https://learn.microsoft.com/rest/api/storageservices/naming-and-referencing-containers--blobs--and-metadata
   *
   * @param options -
   */
  async createIfNotExists(e = {}) {
    return x.withSpan("ContainerClient-createIfNotExists", e, async (t) => {
      var a, n;
      try {
        const i = await this.create(t);
        return Object.assign(Object.assign({ succeeded: !0 }, i), { _response: i._response });
      } catch (i) {
        if (((a = i.details) === null || a === void 0 ? void 0 : a.errorCode) === "ContainerAlreadyExists")
          return Object.assign(Object.assign({ succeeded: !1 }, (n = i.response) === null || n === void 0 ? void 0 : n.parsedHeaders), { _response: i.response });
        throw i;
      }
    });
  }
  /**
   * Returns true if the Azure container resource represented by this client exists; false otherwise.
   *
   * NOTE: use this function with care since an existing container might be deleted by other clients or
   * applications. Vice versa new containers with the same name might be added by other clients or
   * applications after this function completes.
   *
   * @param options -
   */
  async exists(e = {}) {
    return x.withSpan("ContainerClient-exists", e, async (t) => {
      try {
        return await this.getProperties({
          abortSignal: e.abortSignal,
          tracingOptions: t.tracingOptions
        }), !0;
      } catch (a) {
        if (a.statusCode === 404)
          return !1;
        throw a;
      }
    });
  }
  /**
   * Creates a {@link BlobClient}
   *
   * @param blobName - A blob name
   * @returns A new BlobClient object for the given blob name.
   */
  getBlobClient(e) {
    return new pe(X(this.url, Wt(e)), this.pipeline);
  }
  /**
   * Creates an {@link AppendBlobClient}
   *
   * @param blobName - An append blob name
   */
  getAppendBlobClient(e) {
    return new ur(X(this.url, Wt(e)), this.pipeline);
  }
  /**
   * Creates a {@link BlockBlobClient}
   *
   * @param blobName - A block blob name
   *
   *
   * Example usage:
   *
   * ```js
   * const content = "Hello world!";
   *
   * const blockBlobClient = containerClient.getBlockBlobClient("<blob name>");
   * const uploadBlobResponse = await blockBlobClient.upload(content, content.length);
   * ```
   */
  getBlockBlobClient(e) {
    return new yr(X(this.url, Wt(e)), this.pipeline);
  }
  /**
   * Creates a {@link PageBlobClient}
   *
   * @param blobName - A page blob name
   */
  getPageBlobClient(e) {
    return new fr(X(this.url, Wt(e)), this.pipeline);
  }
  /**
   * Returns all user-defined metadata and system properties for the specified
   * container. The data returned does not include the container's list of blobs.
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/get-container-properties
   *
   * WARNING: The `metadata` object returned in the response will have its keys in lowercase, even if
   * they originally contained uppercase characters. This differs from the metadata keys returned by
   * the `listContainers` method of {@link BlobServiceClient} using the `includeMetadata` option, which
   * will retain their original casing.
   *
   * @param options - Options to Container Get Properties operation.
   */
  async getProperties(e = {}) {
    return e.conditions || (e.conditions = {}), x.withSpan("ContainerClient-getProperties", e, async (t) => C(await this.containerContext.getProperties(Object.assign(Object.assign({ abortSignal: e.abortSignal }, e.conditions), { tracingOptions: t.tracingOptions }))));
  }
  /**
   * Marks the specified container for deletion. The container and any blobs
   * contained within it are later deleted during garbage collection.
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/delete-container
   *
   * @param options - Options to Container Delete operation.
   */
  async delete(e = {}) {
    return e.conditions || (e.conditions = {}), x.withSpan("ContainerClient-delete", e, async (t) => C(await this.containerContext.delete({
      abortSignal: e.abortSignal,
      leaseAccessConditions: e.conditions,
      modifiedAccessConditions: e.conditions,
      tracingOptions: t.tracingOptions
    })));
  }
  /**
   * Marks the specified container for deletion if it exists. The container and any blobs
   * contained within it are later deleted during garbage collection.
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/delete-container
   *
   * @param options - Options to Container Delete operation.
   */
  async deleteIfExists(e = {}) {
    return x.withSpan("ContainerClient-deleteIfExists", e, async (t) => {
      var a, n;
      try {
        const i = await this.delete(t);
        return Object.assign(Object.assign({ succeeded: !0 }, i), { _response: i._response });
      } catch (i) {
        if (((a = i.details) === null || a === void 0 ? void 0 : a.errorCode) === "ContainerNotFound")
          return Object.assign(Object.assign({ succeeded: !1 }, (n = i.response) === null || n === void 0 ? void 0 : n.parsedHeaders), { _response: i.response });
        throw i;
      }
    });
  }
  /**
   * Sets one or more user-defined name-value pairs for the specified container.
   *
   * If no option provided, or no metadata defined in the parameter, the container
   * metadata will be removed.
   *
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/set-container-metadata
   *
   * @param metadata - Replace existing metadata with this value.
   *                            If no value provided the existing metadata will be removed.
   * @param options - Options to Container Set Metadata operation.
   */
  async setMetadata(e, t = {}) {
    if (t.conditions || (t.conditions = {}), t.conditions.ifUnmodifiedSince)
      throw new RangeError("the IfUnmodifiedSince must have their default values because they are ignored by the blob service");
    return x.withSpan("ContainerClient-setMetadata", t, async (a) => C(await this.containerContext.setMetadata({
      abortSignal: t.abortSignal,
      leaseAccessConditions: t.conditions,
      metadata: e,
      modifiedAccessConditions: t.conditions,
      tracingOptions: a.tracingOptions
    })));
  }
  /**
   * Gets the permissions for the specified container. The permissions indicate
   * whether container data may be accessed publicly.
   *
   * WARNING: JavaScript Date will potentially lose precision when parsing startsOn and expiresOn strings.
   * For example, new Date("2018-12-31T03:44:23.8827891Z").toISOString() will get "2018-12-31T03:44:23.882Z".
   *
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/get-container-acl
   *
   * @param options - Options to Container Get Access Policy operation.
   */
  async getAccessPolicy(e = {}) {
    return e.conditions || (e.conditions = {}), x.withSpan("ContainerClient-getAccessPolicy", e, async (t) => {
      const a = C(await this.containerContext.getAccessPolicy({
        abortSignal: e.abortSignal,
        leaseAccessConditions: e.conditions,
        tracingOptions: t.tracingOptions
      })), n = {
        _response: a._response,
        blobPublicAccess: a.blobPublicAccess,
        date: a.date,
        etag: a.etag,
        errorCode: a.errorCode,
        lastModified: a.lastModified,
        requestId: a.requestId,
        clientRequestId: a.clientRequestId,
        signedIdentifiers: [],
        version: a.version
      };
      for (const i of a) {
        let s;
        i.accessPolicy && (s = {
          permissions: i.accessPolicy.permissions
        }, i.accessPolicy.expiresOn && (s.expiresOn = new Date(i.accessPolicy.expiresOn)), i.accessPolicy.startsOn && (s.startsOn = new Date(i.accessPolicy.startsOn))), n.signedIdentifiers.push({
          accessPolicy: s,
          id: i.id
        });
      }
      return n;
    });
  }
  /**
   * Sets the permissions for the specified container. The permissions indicate
   * whether blobs in a container may be accessed publicly.
   *
   * When you set permissions for a container, the existing permissions are replaced.
   * If no access or containerAcl provided, the existing container ACL will be
   * removed.
   *
   * When you establish a stored access policy on a container, it may take up to 30 seconds to take effect.
   * During this interval, a shared access signature that is associated with the stored access policy will
   * fail with status code 403 (Forbidden), until the access policy becomes active.
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/set-container-acl
   *
   * @param access - The level of public access to data in the container.
   * @param containerAcl - Array of elements each having a unique Id and details of the access policy.
   * @param options - Options to Container Set Access Policy operation.
   */
  async setAccessPolicy(e, t, a = {}) {
    return a.conditions = a.conditions || {}, x.withSpan("ContainerClient-setAccessPolicy", a, async (n) => {
      const i = [];
      for (const s of t || [])
        i.push({
          accessPolicy: {
            expiresOn: s.accessPolicy.expiresOn ? k(s.accessPolicy.expiresOn) : "",
            permissions: s.accessPolicy.permissions,
            startsOn: s.accessPolicy.startsOn ? k(s.accessPolicy.startsOn) : ""
          },
          id: s.id
        });
      return C(await this.containerContext.setAccessPolicy({
        abortSignal: a.abortSignal,
        access: e,
        containerAcl: i,
        leaseAccessConditions: a.conditions,
        modifiedAccessConditions: a.conditions,
        tracingOptions: n.tracingOptions
      }));
    });
  }
  /**
   * Get a {@link BlobLeaseClient} that manages leases on the container.
   *
   * @param proposeLeaseId - Initial proposed lease Id.
   * @returns A new BlobLeaseClient object for managing leases on the container.
   */
  getBlobLeaseClient(e) {
    return new Sm(this, e);
  }
  /**
   * Creates a new block blob, or updates the content of an existing block blob.
   *
   * Updating an existing block blob overwrites any existing metadata on the blob.
   * Partial updates are not supported; the content of the existing blob is
   * overwritten with the new content. To perform a partial update of a block blob's,
   * use {@link BlockBlobClient.stageBlock} and {@link BlockBlobClient.commitBlockList}.
   *
   * This is a non-parallel uploading method, please use {@link BlockBlobClient.uploadFile},
   * {@link BlockBlobClient.uploadStream} or {@link BlockBlobClient.uploadBrowserData} for better
   * performance with concurrency uploading.
   *
   * @see https://learn.microsoft.com/rest/api/storageservices/put-blob
   *
   * @param blobName - Name of the block blob to create or update.
   * @param body - Blob, string, ArrayBuffer, ArrayBufferView or a function
   *                               which returns a new Readable stream whose offset is from data source beginning.
   * @param contentLength - Length of body in bytes. Use Buffer.byteLength() to calculate body length for a
   *                               string including non non-Base64/Hex-encoded characters.
   * @param options - Options to configure the Block Blob Upload operation.
   * @returns Block Blob upload response data and the corresponding BlockBlobClient instance.
   */
  async uploadBlockBlob(e, t, a, n = {}) {
    return x.withSpan("ContainerClient-uploadBlockBlob", n, async (i) => {
      const s = this.getBlockBlobClient(e), o = await s.upload(t, a, i);
      return {
        blockBlobClient: s,
        response: o
      };
    });
  }
  /**
   * Marks the specified blob or snapshot for deletion. The blob is later deleted
   * during garbage collection. Note that in order to delete a blob, you must delete
   * all of its snapshots. You can delete both at the same time with the Delete
   * Blob operation.
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/delete-blob
   *
   * @param blobName -
   * @param options - Options to Blob Delete operation.
   * @returns Block blob deletion response data.
   */
  async deleteBlob(e, t = {}) {
    return x.withSpan("ContainerClient-deleteBlob", t, async (a) => {
      let n = this.getBlobClient(e);
      return t.versionId && (n = n.withVersion(t.versionId)), n.delete(a);
    });
  }
  /**
   * listBlobFlatSegment returns a single segment of blobs starting from the
   * specified Marker. Use an empty Marker to start enumeration from the beginning.
   * After getting a segment, process it, and then call listBlobsFlatSegment again
   * (passing the the previously-returned Marker) to get the next segment.
   * @see https://learn.microsoft.com/rest/api/storageservices/list-blobs
   *
   * @param marker - A string value that identifies the portion of the list to be returned with the next list operation.
   * @param options - Options to Container List Blob Flat Segment operation.
   */
  async listBlobFlatSegment(e, t = {}) {
    return x.withSpan("ContainerClient-listBlobFlatSegment", t, async (a) => {
      const n = C(await this.containerContext.listBlobFlatSegment(Object.assign(Object.assign({ marker: e }, t), { tracingOptions: a.tracingOptions })));
      return Object.assign(Object.assign({}, n), { _response: Object.assign(Object.assign({}, n._response), { parsedBody: Dp(n._response.parsedBody) }), segment: Object.assign(Object.assign({}, n.segment), { blobItems: n.segment.blobItems.map((s) => Object.assign(Object.assign({}, s), { name: Ge(s.name), tags: Bt(s.blobTags), objectReplicationSourceProperties: tr(s.objectReplicationMetadata) })) }) });
    });
  }
  /**
   * listBlobHierarchySegment returns a single segment of blobs starting from
   * the specified Marker. Use an empty Marker to start enumeration from the
   * beginning. After getting a segment, process it, and then call listBlobsHierarchicalSegment
   * again (passing the the previously-returned Marker) to get the next segment.
   * @see https://learn.microsoft.com/rest/api/storageservices/list-blobs
   *
   * @param delimiter - The character or string used to define the virtual hierarchy
   * @param marker - A string value that identifies the portion of the list to be returned with the next list operation.
   * @param options - Options to Container List Blob Hierarchy Segment operation.
   */
  async listBlobHierarchySegment(e, t, a = {}) {
    return x.withSpan("ContainerClient-listBlobHierarchySegment", a, async (n) => {
      var i;
      const s = C(await this.containerContext.listBlobHierarchySegment(e, Object.assign(Object.assign({ marker: t }, a), { tracingOptions: n.tracingOptions })));
      return Object.assign(Object.assign({}, s), { _response: Object.assign(Object.assign({}, s._response), { parsedBody: Lp(s._response.parsedBody) }), segment: Object.assign(Object.assign({}, s.segment), { blobItems: s.segment.blobItems.map((l) => Object.assign(Object.assign({}, l), { name: Ge(l.name), tags: Bt(l.blobTags), objectReplicationSourceProperties: tr(l.objectReplicationMetadata) })), blobPrefixes: (i = s.segment.blobPrefixes) === null || i === void 0 ? void 0 : i.map((l) => Object.assign(Object.assign({}, l), { name: Ge(l.name) })) }) });
    });
  }
  /**
   * Returns an AsyncIterableIterator for ContainerListBlobFlatSegmentResponse
   *
   * @param marker - A string value that identifies the portion of
   *                          the list of blobs to be returned with the next listing operation. The
   *                          operation returns the ContinuationToken value within the response body if the
   *                          listing operation did not return all blobs remaining to be listed
   *                          with the current page. The ContinuationToken value can be used as the value for
   *                          the marker parameter in a subsequent call to request the next page of list
   *                          items. The marker value is opaque to the client.
   * @param options - Options to list blobs operation.
   */
  listSegments(e) {
    return ne(this, arguments, function* (a, n = {}) {
      let i;
      if (a || a === void 0)
        do
          i = yield I(this.listBlobFlatSegment(a, n)), a = i.continuationToken, yield yield I(yield I(i));
        while (a);
    });
  }
  /**
   * Returns an AsyncIterableIterator of {@link BlobItem} objects
   *
   * @param options - Options to list blobs operation.
   */
  listItems() {
    return ne(this, arguments, function* (t = {}) {
      var a, n, i, s;
      let o;
      try {
        for (var l = !0, m = oe(this.listSegments(o, t)), c; c = yield I(m.next()), a = c.done, !a; l = !0)
          s = c.value, l = !1, yield I(yield* We(oe(s.segment.blobItems)));
      } catch (d) {
        n = { error: d };
      } finally {
        try {
          !l && !a && (i = m.return) && (yield I(i.call(m)));
        } finally {
          if (n) throw n.error;
        }
      }
    });
  }
  /**
   * Returns an async iterable iterator to list all the blobs
   * under the specified account.
   *
   * .byPage() returns an async iterable iterator to list the blobs in pages.
   *
   * Example using `for await` syntax:
   *
   * ```js
   * // Get the containerClient before you run these snippets,
   * // Can be obtained from `blobServiceClient.getContainerClient("<your-container-name>");`
   * let i = 1;
   * for await (const blob of containerClient.listBlobsFlat()) {
   *   console.log(`Blob ${i++}: ${blob.name}`);
   * }
   * ```
   *
   * Example using `iter.next()`:
   *
   * ```js
   * let i = 1;
   * let iter = containerClient.listBlobsFlat();
   * let blobItem = await iter.next();
   * while (!blobItem.done) {
   *   console.log(`Blob ${i++}: ${blobItem.value.name}`);
   *   blobItem = await iter.next();
   * }
   * ```
   *
   * Example using `byPage()`:
   *
   * ```js
   * // passing optional maxPageSize in the page settings
   * let i = 1;
   * for await (const response of containerClient.listBlobsFlat().byPage({ maxPageSize: 20 })) {
   *   for (const blob of response.segment.blobItems) {
   *     console.log(`Blob ${i++}: ${blob.name}`);
   *   }
   * }
   * ```
   *
   * Example using paging with a marker:
   *
   * ```js
   * let i = 1;
   * let iterator = containerClient.listBlobsFlat().byPage({ maxPageSize: 2 });
   * let response = (await iterator.next()).value;
   *
   * // Prints 2 blob names
   * for (const blob of response.segment.blobItems) {
   *   console.log(`Blob ${i++}: ${blob.name}`);
   * }
   *
   * // Gets next marker
   * let marker = response.continuationToken;
   *
   * // Passing next marker as continuationToken
   *
   * iterator = containerClient.listBlobsFlat().byPage({ continuationToken: marker, maxPageSize: 10 });
   * response = (await iterator.next()).value;
   *
   * // Prints 10 blob names
   * for (const blob of response.segment.blobItems) {
   *   console.log(`Blob ${i++}: ${blob.name}`);
   * }
   * ```
   *
   * @param options - Options to list blobs.
   * @returns An asyncIterableIterator that supports paging.
   */
  listBlobsFlat(e = {}) {
    const t = [];
    e.includeCopy && t.push("copy"), e.includeDeleted && t.push("deleted"), e.includeMetadata && t.push("metadata"), e.includeSnapshots && t.push("snapshots"), e.includeVersions && t.push("versions"), e.includeUncommitedBlobs && t.push("uncommittedblobs"), e.includeTags && t.push("tags"), e.includeDeletedWithVersions && t.push("deletedwithversions"), e.includeImmutabilityPolicy && t.push("immutabilitypolicy"), e.includeLegalHold && t.push("legalhold"), e.prefix === "" && (e.prefix = void 0);
    const a = Object.assign(Object.assign({}, e), t.length > 0 ? { include: t } : {}), n = this.listItems(a);
    return {
      /**
       * The next method, part of the iteration protocol
       */
      next() {
        return n.next();
      },
      /**
       * The connection to the async iterator, part of the iteration protocol
       */
      [Symbol.asyncIterator]() {
        return this;
      },
      /**
       * Return an AsyncIterableIterator that works a page at a time
       */
      byPage: (i = {}) => this.listSegments(i.continuationToken, Object.assign({ maxPageSize: i.maxPageSize }, a))
    };
  }
  /**
   * Returns an AsyncIterableIterator for ContainerListBlobHierarchySegmentResponse
   *
   * @param delimiter - The character or string used to define the virtual hierarchy
   * @param marker - A string value that identifies the portion of
   *                          the list of blobs to be returned with the next listing operation. The
   *                          operation returns the ContinuationToken value within the response body if the
   *                          listing operation did not return all blobs remaining to be listed
   *                          with the current page. The ContinuationToken value can be used as the value for
   *                          the marker parameter in a subsequent call to request the next page of list
   *                          items. The marker value is opaque to the client.
   * @param options - Options to list blobs operation.
   */
  listHierarchySegments(e, t) {
    return ne(this, arguments, function* (n, i, s = {}) {
      let o;
      if (i || i === void 0)
        do
          o = yield I(this.listBlobHierarchySegment(n, i, s)), i = o.continuationToken, yield yield I(yield I(o));
        while (i);
    });
  }
  /**
   * Returns an AsyncIterableIterator for {@link BlobPrefix} and {@link BlobItem} objects.
   *
   * @param delimiter - The character or string used to define the virtual hierarchy
   * @param options - Options to list blobs operation.
   */
  listItemsByHierarchy(e) {
    return ne(this, arguments, function* (a, n = {}) {
      var i, s, o, l;
      let m;
      try {
        for (var c = !0, d = oe(this.listHierarchySegments(a, m, n)), p; p = yield I(d.next()), i = p.done, !i; c = !0) {
          l = p.value, c = !1;
          const u = l.segment;
          if (u.blobPrefixes)
            for (const h of u.blobPrefixes)
              yield yield I(Object.assign({ kind: "prefix" }, h));
          for (const h of u.blobItems)
            yield yield I(Object.assign({ kind: "blob" }, h));
        }
      } catch (y) {
        s = { error: y };
      } finally {
        try {
          !c && !i && (o = d.return) && (yield I(o.call(d)));
        } finally {
          if (s) throw s.error;
        }
      }
    });
  }
  /**
   * Returns an async iterable iterator to list all the blobs by hierarchy.
   * under the specified account.
   *
   * .byPage() returns an async iterable iterator to list the blobs by hierarchy in pages.
   *
   * Example using `for await` syntax:
   *
   * ```js
   * for await (const item of containerClient.listBlobsByHierarchy("/")) {
   *   if (item.kind === "prefix") {
   *     console.log(`\tBlobPrefix: ${item.name}`);
   *   } else {
   *     console.log(`\tBlobItem: name - ${item.name}`);
   *   }
   * }
   * ```
   *
   * Example using `iter.next()`:
   *
   * ```js
   * let iter = containerClient.listBlobsByHierarchy("/", { prefix: "prefix1/" });
   * let entity = await iter.next();
   * while (!entity.done) {
   *   let item = entity.value;
   *   if (item.kind === "prefix") {
   *     console.log(`\tBlobPrefix: ${item.name}`);
   *   } else {
   *     console.log(`\tBlobItem: name - ${item.name}`);
   *   }
   *   entity = await iter.next();
   * }
   * ```
   *
   * Example using `byPage()`:
   *
   * ```js
   * console.log("Listing blobs by hierarchy by page");
   * for await (const response of containerClient.listBlobsByHierarchy("/").byPage()) {
   *   const segment = response.segment;
   *   if (segment.blobPrefixes) {
   *     for (const prefix of segment.blobPrefixes) {
   *       console.log(`\tBlobPrefix: ${prefix.name}`);
   *     }
   *   }
   *   for (const blob of response.segment.blobItems) {
   *     console.log(`\tBlobItem: name - ${blob.name}`);
   *   }
   * }
   * ```
   *
   * Example using paging with a max page size:
   *
   * ```js
   * console.log("Listing blobs by hierarchy by page, specifying a prefix and a max page size");
   *
   * let i = 1;
   * for await (const response of containerClient
   *   .listBlobsByHierarchy("/", { prefix: "prefix2/sub1/" })
   *   .byPage({ maxPageSize: 2 })) {
   *   console.log(`Page ${i++}`);
   *   const segment = response.segment;
   *
   *   if (segment.blobPrefixes) {
   *     for (const prefix of segment.blobPrefixes) {
   *       console.log(`\tBlobPrefix: ${prefix.name}`);
   *     }
   *   }
   *
   *   for (const blob of response.segment.blobItems) {
   *     console.log(`\tBlobItem: name - ${blob.name}`);
   *   }
   * }
   * ```
   *
   * @param delimiter - The character or string used to define the virtual hierarchy
   * @param options - Options to list blobs operation.
   */
  listBlobsByHierarchy(e, t = {}) {
    if (e === "")
      throw new RangeError("delimiter should contain one or more characters");
    const a = [];
    t.includeCopy && a.push("copy"), t.includeDeleted && a.push("deleted"), t.includeMetadata && a.push("metadata"), t.includeSnapshots && a.push("snapshots"), t.includeVersions && a.push("versions"), t.includeUncommitedBlobs && a.push("uncommittedblobs"), t.includeTags && a.push("tags"), t.includeDeletedWithVersions && a.push("deletedwithversions"), t.includeImmutabilityPolicy && a.push("immutabilitypolicy"), t.includeLegalHold && a.push("legalhold"), t.prefix === "" && (t.prefix = void 0);
    const n = Object.assign(Object.assign({}, t), a.length > 0 ? { include: a } : {}), i = this.listItemsByHierarchy(e, n);
    return {
      /**
       * The next method, part of the iteration protocol
       */
      async next() {
        return i.next();
      },
      /**
       * The connection to the async iterator, part of the iteration protocol
       */
      [Symbol.asyncIterator]() {
        return this;
      },
      /**
       * Return an AsyncIterableIterator that works a page at a time
       */
      byPage: (s = {}) => this.listHierarchySegments(e, s.continuationToken, Object.assign({ maxPageSize: s.maxPageSize }, n))
    };
  }
  /**
   * The Filter Blobs operation enables callers to list blobs in the container whose tags
   * match a given search expression.
   *
   * @param tagFilterSqlExpression - The where parameter enables the caller to query blobs whose tags match a given expression.
   *                                        The given expression must evaluate to true for a blob to be returned in the results.
   *                                        The[OData - ABNF] filter syntax rule defines the formal grammar for the value of the where query parameter;
   *                                        however, only a subset of the OData filter syntax is supported in the Blob service.
   * @param marker - A string value that identifies the portion of
   *                          the list of blobs to be returned with the next listing operation. The
   *                          operation returns the continuationToken value within the response body if the
   *                          listing operation did not return all blobs remaining to be listed
   *                          with the current page. The continuationToken value can be used as the value for
   *                          the marker parameter in a subsequent call to request the next page of list
   *                          items. The marker value is opaque to the client.
   * @param options - Options to find blobs by tags.
   */
  async findBlobsByTagsSegment(e, t, a = {}) {
    return x.withSpan("ContainerClient-findBlobsByTagsSegment", a, async (n) => {
      const i = C(await this.containerContext.filterBlobs({
        abortSignal: a.abortSignal,
        where: e,
        marker: t,
        maxPageSize: a.maxPageSize,
        tracingOptions: n.tracingOptions
      }));
      return Object.assign(Object.assign({}, i), { _response: i._response, blobs: i.blobs.map((o) => {
        var l;
        let m = "";
        return ((l = o.tags) === null || l === void 0 ? void 0 : l.blobTagSet.length) === 1 && (m = o.tags.blobTagSet[0].value), Object.assign(Object.assign({}, o), { tags: Bt(o.tags), tagValue: m });
      }) });
    });
  }
  /**
   * Returns an AsyncIterableIterator for ContainerFindBlobsByTagsSegmentResponse.
   *
   * @param tagFilterSqlExpression -  The where parameter enables the caller to query blobs whose tags match a given expression.
   *                                         The given expression must evaluate to true for a blob to be returned in the results.
   *                                         The[OData - ABNF] filter syntax rule defines the formal grammar for the value of the where query parameter;
   *                                         however, only a subset of the OData filter syntax is supported in the Blob service.
   * @param marker - A string value that identifies the portion of
   *                          the list of blobs to be returned with the next listing operation. The
   *                          operation returns the continuationToken value within the response body if the
   *                          listing operation did not return all blobs remaining to be listed
   *                          with the current page. The continuationToken value can be used as the value for
   *                          the marker parameter in a subsequent call to request the next page of list
   *                          items. The marker value is opaque to the client.
   * @param options - Options to find blobs by tags.
   */
  findBlobsByTagsSegments(e, t) {
    return ne(this, arguments, function* (n, i, s = {}) {
      let o;
      if (i || i === void 0)
        do
          o = yield I(this.findBlobsByTagsSegment(n, i, s)), o.blobs = o.blobs || [], i = o.continuationToken, yield yield I(o);
        while (i);
    });
  }
  /**
   * Returns an AsyncIterableIterator for blobs.
   *
   * @param tagFilterSqlExpression -  The where parameter enables the caller to query blobs whose tags match a given expression.
   *                                         The given expression must evaluate to true for a blob to be returned in the results.
   *                                         The[OData - ABNF] filter syntax rule defines the formal grammar for the value of the where query parameter;
   *                                         however, only a subset of the OData filter syntax is supported in the Blob service.
   * @param options - Options to findBlobsByTagsItems.
   */
  findBlobsByTagsItems(e) {
    return ne(this, arguments, function* (a, n = {}) {
      var i, s, o, l;
      let m;
      try {
        for (var c = !0, d = oe(this.findBlobsByTagsSegments(a, m, n)), p; p = yield I(d.next()), i = p.done, !i; c = !0)
          l = p.value, c = !1, yield I(yield* We(oe(l.blobs)));
      } catch (y) {
        s = { error: y };
      } finally {
        try {
          !c && !i && (o = d.return) && (yield I(o.call(d)));
        } finally {
          if (s) throw s.error;
        }
      }
    });
  }
  /**
   * Returns an async iterable iterator to find all blobs with specified tag
   * under the specified container.
   *
   * .byPage() returns an async iterable iterator to list the blobs in pages.
   *
   * Example using `for await` syntax:
   *
   * ```js
   * let i = 1;
   * for await (const blob of containerClient.findBlobsByTags("tagkey='tagvalue'")) {
   *   console.log(`Blob ${i++}: ${blob.name}`);
   * }
   * ```
   *
   * Example using `iter.next()`:
   *
   * ```js
   * let i = 1;
   * const iter = containerClient.findBlobsByTags("tagkey='tagvalue'");
   * let blobItem = await iter.next();
   * while (!blobItem.done) {
   *   console.log(`Blob ${i++}: ${blobItem.value.name}`);
   *   blobItem = await iter.next();
   * }
   * ```
   *
   * Example using `byPage()`:
   *
   * ```js
   * // passing optional maxPageSize in the page settings
   * let i = 1;
   * for await (const response of containerClient.findBlobsByTags("tagkey='tagvalue'").byPage({ maxPageSize: 20 })) {
   *   if (response.blobs) {
   *     for (const blob of response.blobs) {
   *       console.log(`Blob ${i++}: ${blob.name}`);
   *     }
   *   }
   * }
   * ```
   *
   * Example using paging with a marker:
   *
   * ```js
   * let i = 1;
   * let iterator = containerClient.findBlobsByTags("tagkey='tagvalue'").byPage({ maxPageSize: 2 });
   * let response = (await iterator.next()).value;
   *
   * // Prints 2 blob names
   * if (response.blobs) {
   *   for (const blob of response.blobs) {
   *     console.log(`Blob ${i++}: ${blob.name}`);
   *   }
   * }
   *
   * // Gets next marker
   * let marker = response.continuationToken;
   * // Passing next marker as continuationToken
   * iterator = containerClient
   *   .findBlobsByTags("tagkey='tagvalue'")
   *   .byPage({ continuationToken: marker, maxPageSize: 10 });
   * response = (await iterator.next()).value;
   *
   * // Prints blob names
   * if (response.blobs) {
   *   for (const blob of response.blobs) {
   *      console.log(`Blob ${i++}: ${blob.name}`);
   *   }
   * }
   * ```
   *
   * @param tagFilterSqlExpression -  The where parameter enables the caller to query blobs whose tags match a given expression.
   *                                         The given expression must evaluate to true for a blob to be returned in the results.
   *                                         The[OData - ABNF] filter syntax rule defines the formal grammar for the value of the where query parameter;
   *                                         however, only a subset of the OData filter syntax is supported in the Blob service.
   * @param options - Options to find blobs by tags.
   */
  findBlobsByTags(e, t = {}) {
    const a = Object.assign({}, t), n = this.findBlobsByTagsItems(e, a);
    return {
      /**
       * The next method, part of the iteration protocol
       */
      next() {
        return n.next();
      },
      /**
       * The connection to the async iterator, part of the iteration protocol
       */
      [Symbol.asyncIterator]() {
        return this;
      },
      /**
       * Return an AsyncIterableIterator that works a page at a time
       */
      byPage: (i = {}) => this.findBlobsByTagsSegments(e, i.continuationToken, Object.assign({ maxPageSize: i.maxPageSize }, a))
    };
  }
  /**
   * The Get Account Information operation returns the sku name and account kind
   * for the specified account.
   * The Get Account Information operation is available on service versions beginning
   * with version 2018-03-28.
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/get-account-information
   *
   * @param options - Options to the Service Get Account Info operation.
   * @returns Response data for the Service Get Account Info operation.
   */
  async getAccountInfo(e = {}) {
    return x.withSpan("ContainerClient-getAccountInfo", e, async (t) => C(await this.containerContext.getAccountInfo({
      abortSignal: e.abortSignal,
      tracingOptions: t.tracingOptions
    })));
  }
  getContainerNameFromUrl() {
    let e;
    try {
      const t = new URL(this.url);
      if (t.hostname.split(".")[1] === "blob" ? e = t.pathname.split("/")[1] : ia(t) ? e = t.pathname.split("/")[2] : e = t.pathname.split("/")[1], e = decodeURIComponent(e), !e)
        throw new Error("Provided containerName is invalid.");
      return e;
    } catch {
      throw new Error("Unable to extract containerName with provided information.");
    }
  }
  /**
   * Only available for ContainerClient constructed with a shared key credential.
   *
   * Generates a Blob Container Service Shared Access Signature (SAS) URI based on the client properties
   * and parameters passed in. The SAS is signed by the shared key credential of the client.
   *
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/constructing-a-service-sas
   *
   * @param options - Optional parameters.
   * @returns The SAS URI consisting of the URI to the resource represented by this client, followed by the generated SAS token.
   */
  generateSasUrl(e) {
    return new Promise((t) => {
      if (!(this.credential instanceof K))
        throw new RangeError("Can only generate the SAS when the client is initialized with a shared key credential");
      const a = rr(Object.assign({ containerName: this._containerName }, e), this.credential).toString();
      t(Ot(this.url, a));
    });
  }
  /**
   * Only available for ContainerClient constructed with a shared key credential.
   *
   * Generates string to sign for a Blob Container Service Shared Access Signature (SAS) URI
   * based on the client properties and parameters passed in. The SAS is signed by the shared key credential of the client.
   *
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/constructing-a-service-sas
   *
   * @param options - Optional parameters.
   * @returns The SAS URI consisting of the URI to the resource represented by this client, followed by the generated SAS token.
   */
  /* eslint-disable-next-line @azure/azure-sdk/ts-naming-options*/
  generateSasStringToSign(e) {
    if (!(this.credential instanceof K))
      throw new RangeError("Can only generate the SAS when the client is initialized with a shared key credential");
    return Lt(Object.assign({ containerName: this._containerName }, e), this.credential).stringToSign;
  }
  /**
   * Generates a Blob Container Service Shared Access Signature (SAS) URI based on the client properties
   * and parameters passed in. The SAS is signed by the input user delegation key.
   *
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/constructing-a-service-sas
   *
   * @param options - Optional parameters.
   * @param userDelegationKey -  Return value of `blobServiceClient.getUserDelegationKey()`
   * @returns The SAS URI consisting of the URI to the resource represented by this client, followed by the generated SAS token.
   */
  generateUserDelegationSasUrl(e, t) {
    return new Promise((a) => {
      const n = rr(Object.assign({ containerName: this._containerName }, e), t, this.accountName).toString();
      a(Ot(this.url, n));
    });
  }
  /**
   * Generates string to sign for a Blob Container Service Shared Access Signature (SAS) URI
   * based on the client properties and parameters passed in. The SAS is signed by the input user delegation key.
   *
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/constructing-a-service-sas
   *
   * @param options - Optional parameters.
   * @param userDelegationKey -  Return value of `blobServiceClient.getUserDelegationKey()`
   * @returns The SAS URI consisting of the URI to the resource represented by this client, followed by the generated SAS token.
   */
  generateUserDelegationSasStringToSign(e, t) {
    return Lt(Object.assign({ containerName: this._containerName }, e), t, this.accountName).stringToSign;
  }
  /**
   * Creates a BlobBatchClient object to conduct batch operations.
   *
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/blob-batch
   *
   * @returns A new BlobBatchClient object for this container.
   */
  getBlobBatchClient() {
    return new wm(this.url, this.pipeline);
  }
}
class Je {
  constructor() {
    this.read = !1, this.write = !1, this.delete = !1, this.deleteVersion = !1, this.list = !1, this.add = !1, this.create = !1, this.update = !1, this.process = !1, this.tag = !1, this.filter = !1, this.setImmutabilityPolicy = !1, this.permanentDelete = !1;
  }
  /**
   * Parse initializes the AccountSASPermissions fields from a string.
   *
   * @param permissions -
   */
  static parse(e) {
    const t = new Je();
    for (const a of e)
      switch (a) {
        case "r":
          t.read = !0;
          break;
        case "w":
          t.write = !0;
          break;
        case "d":
          t.delete = !0;
          break;
        case "x":
          t.deleteVersion = !0;
          break;
        case "l":
          t.list = !0;
          break;
        case "a":
          t.add = !0;
          break;
        case "c":
          t.create = !0;
          break;
        case "u":
          t.update = !0;
          break;
        case "p":
          t.process = !0;
          break;
        case "t":
          t.tag = !0;
          break;
        case "f":
          t.filter = !0;
          break;
        case "i":
          t.setImmutabilityPolicy = !0;
          break;
        case "y":
          t.permanentDelete = !0;
          break;
        default:
          throw new RangeError(`Invalid permission character: ${a}`);
      }
    return t;
  }
  /**
   * Creates a {@link AccountSASPermissions} from a raw object which contains same keys as it
   * and boolean values for them.
   *
   * @param permissionLike -
   */
  static from(e) {
    const t = new Je();
    return e.read && (t.read = !0), e.write && (t.write = !0), e.delete && (t.delete = !0), e.deleteVersion && (t.deleteVersion = !0), e.filter && (t.filter = !0), e.tag && (t.tag = !0), e.list && (t.list = !0), e.add && (t.add = !0), e.create && (t.create = !0), e.update && (t.update = !0), e.process && (t.process = !0), e.setImmutabilityPolicy && (t.setImmutabilityPolicy = !0), e.permanentDelete && (t.permanentDelete = !0), t;
  }
  /**
   * Produces the SAS permissions string for an Azure Storage account.
   * Call this method to set AccountSASSignatureValues Permissions field.
   *
   * Using this method will guarantee the resource types are in
   * an order accepted by the service.
   *
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/constructing-an-account-sas
   *
   */
  toString() {
    const e = [];
    return this.read && e.push("r"), this.write && e.push("w"), this.delete && e.push("d"), this.deleteVersion && e.push("x"), this.filter && e.push("f"), this.tag && e.push("t"), this.list && e.push("l"), this.add && e.push("a"), this.create && e.push("c"), this.update && e.push("u"), this.process && e.push("p"), this.setImmutabilityPolicy && e.push("i"), this.permanentDelete && e.push("y"), e.join("");
  }
}
class va {
  constructor() {
    this.service = !1, this.container = !1, this.object = !1;
  }
  /**
   * Creates an {@link AccountSASResourceTypes} from the specified resource types string. This method will throw an
   * Error if it encounters a character that does not correspond to a valid resource type.
   *
   * @param resourceTypes -
   */
  static parse(e) {
    const t = new va();
    for (const a of e)
      switch (a) {
        case "s":
          t.service = !0;
          break;
        case "c":
          t.container = !0;
          break;
        case "o":
          t.object = !0;
          break;
        default:
          throw new RangeError(`Invalid resource type: ${a}`);
      }
    return t;
  }
  /**
   * Converts the given resource types to a string.
   *
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/constructing-an-account-sas
   *
   */
  toString() {
    const e = [];
    return this.service && e.push("s"), this.container && e.push("c"), this.object && e.push("o"), e.join("");
  }
}
class kt {
  constructor() {
    this.blob = !1, this.file = !1, this.queue = !1, this.table = !1;
  }
  /**
   * Creates an {@link AccountSASServices} from the specified services string. This method will throw an
   * Error if it encounters a character that does not correspond to a valid service.
   *
   * @param services -
   */
  static parse(e) {
    const t = new kt();
    for (const a of e)
      switch (a) {
        case "b":
          t.blob = !0;
          break;
        case "f":
          t.file = !0;
          break;
        case "q":
          t.queue = !0;
          break;
        case "t":
          t.table = !0;
          break;
        default:
          throw new RangeError(`Invalid service character: ${a}`);
      }
    return t;
  }
  /**
   * Converts the given services to a string.
   *
   */
  toString() {
    const e = [];
    return this.blob && e.push("b"), this.table && e.push("t"), this.queue && e.push("q"), this.file && e.push("f"), e.join("");
  }
}
function wg(r, e) {
  return Bm(r, e).sasQueryParameters;
}
function Bm(r, e) {
  const t = r.version ? r.version : na;
  if (r.permissions && r.permissions.setImmutabilityPolicy && t < "2020-08-04")
    throw RangeError("'version' must be >= '2020-08-04' when provided 'i' permission.");
  if (r.permissions && r.permissions.deleteVersion && t < "2019-10-10")
    throw RangeError("'version' must be >= '2019-10-10' when provided 'x' permission.");
  if (r.permissions && r.permissions.permanentDelete && t < "2019-10-10")
    throw RangeError("'version' must be >= '2019-10-10' when provided 'y' permission.");
  if (r.permissions && r.permissions.tag && t < "2019-12-12")
    throw RangeError("'version' must be >= '2019-12-12' when provided 't' permission.");
  if (r.permissions && r.permissions.filter && t < "2019-12-12")
    throw RangeError("'version' must be >= '2019-12-12' when provided 'f' permission.");
  if (r.encryptionScope && t < "2020-12-06")
    throw RangeError("'version' must be >= '2020-12-06' when provided 'encryptionScope' in SAS.");
  const a = Je.parse(r.permissions.toString()), n = kt.parse(r.services).toString(), i = va.parse(r.resourceTypes).toString();
  let s;
  t >= "2020-12-06" ? s = [
    e.accountName,
    a,
    n,
    i,
    r.startsOn ? k(r.startsOn, !1) : "",
    k(r.expiresOn, !1),
    r.ipRange ? Ce(r.ipRange) : "",
    r.protocol ? r.protocol : "",
    t,
    r.encryptionScope ? r.encryptionScope : "",
    ""
    // Account SAS requires an additional newline character
  ].join(`
`) : s = [
    e.accountName,
    a,
    n,
    i,
    r.startsOn ? k(r.startsOn, !1) : "",
    k(r.expiresOn, !1),
    r.ipRange ? Ce(r.ipRange) : "",
    r.protocol ? r.protocol : "",
    t,
    ""
    // Account SAS requires an additional newline character
  ].join(`
`);
  const o = e.computeHMACSHA256(s);
  return {
    sasQueryParameters: new Ue(t, o, a.toString(), n, i, r.protocol, r.startsOn, r.expiresOn, r.ipRange, void 0, void 0, void 0, void 0, void 0, void 0, void 0, void 0, void 0, void 0, r.encryptionScope),
    stringToSign: s
  };
}
class nr extends ba {
  /**
   *
   * Creates an instance of BlobServiceClient from connection string.
   *
   * @param connectionString - Account connection string or a SAS connection string of an Azure storage account.
   *                                  [ Note - Account connection string can only be used in NODE.JS runtime. ]
   *                                  Account connection string example -
   *                                  `DefaultEndpointsProtocol=https;AccountName=myaccount;AccountKey=accountKey;EndpointSuffix=core.windows.net`
   *                                  SAS connection string example -
   *                                  `BlobEndpoint=https://myaccount.blob.core.windows.net/;QueueEndpoint=https://myaccount.queue.core.windows.net/;FileEndpoint=https://myaccount.file.core.windows.net/;TableEndpoint=https://myaccount.table.core.windows.net/;SharedAccessSignature=sasString`
   * @param options - Optional. Options to configure the HTTP pipeline.
   */
  static fromConnectionString(e, t) {
    t = t || {};
    const a = tt(e);
    if (a.kind === "AccountConnString")
      if (W) {
        const n = new K(a.accountName, a.accountKey);
        t.proxyOptions || (t.proxyOptions = Ze(a.proxyUri));
        const i = j(n, t);
        return new nr(a.url, i);
      } else
        throw new Error("Account connection string is only supported in Node.js environment");
    else if (a.kind === "SASConnString") {
      const n = j(new F(), t);
      return new nr(a.url + "?" + a.accountSas, n);
    } else
      throw new Error("Connection string must be either an Account connection string or a SAS connection string");
  }
  constructor(e, t, a) {
    let n;
    _e(t) ? n = t : W && t instanceof K || t instanceof F || le(t) ? n = j(t, a) : n = j(new F(), a), super(e, n), this.serviceContext = this.storageClientContext.service;
  }
  /**
   * Creates a {@link ContainerClient} object
   *
   * @param containerName - A container name
   * @returns A new ContainerClient object for the given container name.
   *
   * Example usage:
   *
   * ```js
   * const containerClient = blobServiceClient.getContainerClient("<container name>");
   * ```
   */
  getContainerClient(e) {
    return new Rg(X(this.url, encodeURIComponent(e)), this.pipeline);
  }
  /**
   * Create a Blob container. @see https://learn.microsoft.com/en-us/rest/api/storageservices/create-container
   *
   * @param containerName - Name of the container to create.
   * @param options - Options to configure Container Create operation.
   * @returns Container creation response and the corresponding container client.
   */
  async createContainer(e, t = {}) {
    return x.withSpan("BlobServiceClient-createContainer", t, async (a) => {
      const n = this.getContainerClient(e), i = await n.create(a);
      return {
        containerClient: n,
        containerCreateResponse: i
      };
    });
  }
  /**
   * Deletes a Blob container.
   *
   * @param containerName - Name of the container to delete.
   * @param options - Options to configure Container Delete operation.
   * @returns Container deletion response.
   */
  async deleteContainer(e, t = {}) {
    return x.withSpan("BlobServiceClient-deleteContainer", t, async (a) => this.getContainerClient(e).delete(a));
  }
  /**
   * Restore a previously deleted Blob container.
   * This API is only functional if Container Soft Delete is enabled for the storage account associated with the container.
   *
   * @param deletedContainerName - Name of the previously deleted container.
   * @param deletedContainerVersion - Version of the previously deleted container, used to uniquely identify the deleted container.
   * @param options - Options to configure Container Restore operation.
   * @returns Container deletion response.
   */
  async undeleteContainer(e, t, a = {}) {
    return x.withSpan("BlobServiceClient-undeleteContainer", a, async (n) => {
      const i = this.getContainerClient(a.destinationContainerName || e), s = i.storageClientContext.container, o = C(await s.restore({
        deletedContainerName: e,
        deletedContainerVersion: t,
        tracingOptions: n.tracingOptions
      }));
      return { containerClient: i, containerUndeleteResponse: o };
    });
  }
  /**
   * Rename an existing Blob Container.
   *
   * @param sourceContainerName - The name of the source container.
   * @param destinationContainerName - The new name of the container.
   * @param options - Options to configure Container Rename operation.
   */
  /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
  // @ts-ignore Need to hide this interface for now. Make it public and turn on the live tests for it when the service is ready.
  async renameContainer(e, t, a = {}) {
    return x.withSpan("BlobServiceClient-renameContainer", a, async (n) => {
      var i;
      const s = this.getContainerClient(t), o = s.storageClientContext.container, l = C(await o.rename(e, Object.assign(Object.assign({}, n), { sourceLeaseId: (i = a.sourceCondition) === null || i === void 0 ? void 0 : i.leaseId })));
      return { containerClient: s, containerRenameResponse: l };
    });
  }
  /**
   * Gets the properties of a storage account’s Blob service, including properties
   * for Storage Analytics and CORS (Cross-Origin Resource Sharing) rules.
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/get-blob-service-properties
   *
   * @param options - Options to the Service Get Properties operation.
   * @returns Response data for the Service Get Properties operation.
   */
  async getProperties(e = {}) {
    return x.withSpan("BlobServiceClient-getProperties", e, async (t) => C(await this.serviceContext.getProperties({
      abortSignal: e.abortSignal,
      tracingOptions: t.tracingOptions
    })));
  }
  /**
   * Sets properties for a storage account’s Blob service endpoint, including properties
   * for Storage Analytics, CORS (Cross-Origin Resource Sharing) rules and soft delete settings.
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/set-blob-service-properties
   *
   * @param properties -
   * @param options - Options to the Service Set Properties operation.
   * @returns Response data for the Service Set Properties operation.
   */
  async setProperties(e, t = {}) {
    return x.withSpan("BlobServiceClient-setProperties", t, async (a) => C(await this.serviceContext.setProperties(e, {
      abortSignal: t.abortSignal,
      tracingOptions: a.tracingOptions
    })));
  }
  /**
   * Retrieves statistics related to replication for the Blob service. It is only
   * available on the secondary location endpoint when read-access geo-redundant
   * replication is enabled for the storage account.
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/get-blob-service-stats
   *
   * @param options - Options to the Service Get Statistics operation.
   * @returns Response data for the Service Get Statistics operation.
   */
  async getStatistics(e = {}) {
    return x.withSpan("BlobServiceClient-getStatistics", e, async (t) => C(await this.serviceContext.getStatistics({
      abortSignal: e.abortSignal,
      tracingOptions: t.tracingOptions
    })));
  }
  /**
   * The Get Account Information operation returns the sku name and account kind
   * for the specified account.
   * The Get Account Information operation is available on service versions beginning
   * with version 2018-03-28.
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/get-account-information
   *
   * @param options - Options to the Service Get Account Info operation.
   * @returns Response data for the Service Get Account Info operation.
   */
  async getAccountInfo(e = {}) {
    return x.withSpan("BlobServiceClient-getAccountInfo", e, async (t) => C(await this.serviceContext.getAccountInfo({
      abortSignal: e.abortSignal,
      tracingOptions: t.tracingOptions
    })));
  }
  /**
   * Returns a list of the containers under the specified account.
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/list-containers2
   *
   * @param marker - A string value that identifies the portion of
   *                        the list of containers to be returned with the next listing operation. The
   *                        operation returns the continuationToken value within the response body if the
   *                        listing operation did not return all containers remaining to be listed
   *                        with the current page. The continuationToken value can be used as the value for
   *                        the marker parameter in a subsequent call to request the next page of list
   *                        items. The marker value is opaque to the client.
   * @param options - Options to the Service List Container Segment operation.
   * @returns Response data for the Service List Container Segment operation.
   */
  async listContainersSegment(e, t = {}) {
    return x.withSpan("BlobServiceClient-listContainersSegment", t, async (a) => C(await this.serviceContext.listContainersSegment(Object.assign(Object.assign({ abortSignal: t.abortSignal, marker: e }, t), { include: typeof t.include == "string" ? [t.include] : t.include, tracingOptions: a.tracingOptions }))));
  }
  /**
   * The Filter Blobs operation enables callers to list blobs across all containers whose tags
   * match a given search expression. Filter blobs searches across all containers within a
   * storage account but can be scoped within the expression to a single container.
   *
   * @param tagFilterSqlExpression - The where parameter enables the caller to query blobs whose tags match a given expression.
   *                                        The given expression must evaluate to true for a blob to be returned in the results.
   *                                        The[OData - ABNF] filter syntax rule defines the formal grammar for the value of the where query parameter;
   *                                        however, only a subset of the OData filter syntax is supported in the Blob service.
   * @param marker - A string value that identifies the portion of
   *                          the list of blobs to be returned with the next listing operation. The
   *                          operation returns the continuationToken value within the response body if the
   *                          listing operation did not return all blobs remaining to be listed
   *                          with the current page. The continuationToken value can be used as the value for
   *                          the marker parameter in a subsequent call to request the next page of list
   *                          items. The marker value is opaque to the client.
   * @param options - Options to find blobs by tags.
   */
  async findBlobsByTagsSegment(e, t, a = {}) {
    return x.withSpan("BlobServiceClient-findBlobsByTagsSegment", a, async (n) => {
      const i = C(await this.serviceContext.filterBlobs({
        abortSignal: a.abortSignal,
        where: e,
        marker: t,
        maxPageSize: a.maxPageSize,
        tracingOptions: n.tracingOptions
      }));
      return Object.assign(Object.assign({}, i), { _response: i._response, blobs: i.blobs.map((o) => {
        var l;
        let m = "";
        return ((l = o.tags) === null || l === void 0 ? void 0 : l.blobTagSet.length) === 1 && (m = o.tags.blobTagSet[0].value), Object.assign(Object.assign({}, o), { tags: Bt(o.tags), tagValue: m });
      }) });
    });
  }
  /**
   * Returns an AsyncIterableIterator for ServiceFindBlobsByTagsSegmentResponse.
   *
   * @param tagFilterSqlExpression -  The where parameter enables the caller to query blobs whose tags match a given expression.
   *                                         The given expression must evaluate to true for a blob to be returned in the results.
   *                                         The[OData - ABNF] filter syntax rule defines the formal grammar for the value of the where query parameter;
   *                                         however, only a subset of the OData filter syntax is supported in the Blob service.
   * @param marker - A string value that identifies the portion of
   *                          the list of blobs to be returned with the next listing operation. The
   *                          operation returns the continuationToken value within the response body if the
   *                          listing operation did not return all blobs remaining to be listed
   *                          with the current page. The continuationToken value can be used as the value for
   *                          the marker parameter in a subsequent call to request the next page of list
   *                          items. The marker value is opaque to the client.
   * @param options - Options to find blobs by tags.
   */
  findBlobsByTagsSegments(e, t) {
    return ne(this, arguments, function* (n, i, s = {}) {
      let o;
      if (i || i === void 0)
        do
          o = yield I(this.findBlobsByTagsSegment(n, i, s)), o.blobs = o.blobs || [], i = o.continuationToken, yield yield I(o);
        while (i);
    });
  }
  /**
   * Returns an AsyncIterableIterator for blobs.
   *
   * @param tagFilterSqlExpression -  The where parameter enables the caller to query blobs whose tags match a given expression.
   *                                         The given expression must evaluate to true for a blob to be returned in the results.
   *                                         The[OData - ABNF] filter syntax rule defines the formal grammar for the value of the where query parameter;
   *                                         however, only a subset of the OData filter syntax is supported in the Blob service.
   * @param options - Options to findBlobsByTagsItems.
   */
  findBlobsByTagsItems(e) {
    return ne(this, arguments, function* (a, n = {}) {
      var i, s, o, l;
      let m;
      try {
        for (var c = !0, d = oe(this.findBlobsByTagsSegments(a, m, n)), p; p = yield I(d.next()), i = p.done, !i; c = !0)
          l = p.value, c = !1, yield I(yield* We(oe(l.blobs)));
      } catch (y) {
        s = { error: y };
      } finally {
        try {
          !c && !i && (o = d.return) && (yield I(o.call(d)));
        } finally {
          if (s) throw s.error;
        }
      }
    });
  }
  /**
   * Returns an async iterable iterator to find all blobs with specified tag
   * under the specified account.
   *
   * .byPage() returns an async iterable iterator to list the blobs in pages.
   *
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/get-blob-service-properties
   *
   * Example using `for await` syntax:
   *
   * ```js
   * let i = 1;
   * for await (const blob of blobServiceClient.findBlobsByTags("tagkey='tagvalue'")) {
   *   console.log(`Blob ${i++}: ${container.name}`);
   * }
   * ```
   *
   * Example using `iter.next()`:
   *
   * ```js
   * let i = 1;
   * const iter = blobServiceClient.findBlobsByTags("tagkey='tagvalue'");
   * let blobItem = await iter.next();
   * while (!blobItem.done) {
   *   console.log(`Blob ${i++}: ${blobItem.value.name}`);
   *   blobItem = await iter.next();
   * }
   * ```
   *
   * Example using `byPage()`:
   *
   * ```js
   * // passing optional maxPageSize in the page settings
   * let i = 1;
   * for await (const response of blobServiceClient.findBlobsByTags("tagkey='tagvalue'").byPage({ maxPageSize: 20 })) {
   *   if (response.blobs) {
   *     for (const blob of response.blobs) {
   *       console.log(`Blob ${i++}: ${blob.name}`);
   *     }
   *   }
   * }
   * ```
   *
   * Example using paging with a marker:
   *
   * ```js
   * let i = 1;
   * let iterator = blobServiceClient.findBlobsByTags("tagkey='tagvalue'").byPage({ maxPageSize: 2 });
   * let response = (await iterator.next()).value;
   *
   * // Prints 2 blob names
   * if (response.blobs) {
   *   for (const blob of response.blobs) {
   *     console.log(`Blob ${i++}: ${blob.name}`);
   *   }
   * }
   *
   * // Gets next marker
   * let marker = response.continuationToken;
   * // Passing next marker as continuationToken
   * iterator = blobServiceClient
   *   .findBlobsByTags("tagkey='tagvalue'")
   *   .byPage({ continuationToken: marker, maxPageSize: 10 });
   * response = (await iterator.next()).value;
   *
   * // Prints blob names
   * if (response.blobs) {
   *   for (const blob of response.blobs) {
   *      console.log(`Blob ${i++}: ${blob.name}`);
   *   }
   * }
   * ```
   *
   * @param tagFilterSqlExpression -  The where parameter enables the caller to query blobs whose tags match a given expression.
   *                                         The given expression must evaluate to true for a blob to be returned in the results.
   *                                         The[OData - ABNF] filter syntax rule defines the formal grammar for the value of the where query parameter;
   *                                         however, only a subset of the OData filter syntax is supported in the Blob service.
   * @param options - Options to find blobs by tags.
   */
  findBlobsByTags(e, t = {}) {
    const a = Object.assign({}, t), n = this.findBlobsByTagsItems(e, a);
    return {
      /**
       * The next method, part of the iteration protocol
       */
      next() {
        return n.next();
      },
      /**
       * The connection to the async iterator, part of the iteration protocol
       */
      [Symbol.asyncIterator]() {
        return this;
      },
      /**
       * Return an AsyncIterableIterator that works a page at a time
       */
      byPage: (i = {}) => this.findBlobsByTagsSegments(e, i.continuationToken, Object.assign({ maxPageSize: i.maxPageSize }, a))
    };
  }
  /**
   * Returns an AsyncIterableIterator for ServiceListContainersSegmentResponses
   *
   * @param marker - A string value that identifies the portion of
   *                        the list of containers to be returned with the next listing operation. The
   *                        operation returns the continuationToken value within the response body if the
   *                        listing operation did not return all containers remaining to be listed
   *                        with the current page. The continuationToken value can be used as the value for
   *                        the marker parameter in a subsequent call to request the next page of list
   *                        items. The marker value is opaque to the client.
   * @param options - Options to list containers operation.
   */
  listSegments(e) {
    return ne(this, arguments, function* (a, n = {}) {
      let i;
      if (a || a === void 0)
        do
          i = yield I(this.listContainersSegment(a, n)), i.containerItems = i.containerItems || [], a = i.continuationToken, yield yield I(yield I(i));
        while (a);
    });
  }
  /**
   * Returns an AsyncIterableIterator for Container Items
   *
   * @param options - Options to list containers operation.
   */
  listItems() {
    return ne(this, arguments, function* (t = {}) {
      var a, n, i, s;
      let o;
      try {
        for (var l = !0, m = oe(this.listSegments(o, t)), c; c = yield I(m.next()), a = c.done, !a; l = !0)
          s = c.value, l = !1, yield I(yield* We(oe(s.containerItems)));
      } catch (d) {
        n = { error: d };
      } finally {
        try {
          !l && !a && (i = m.return) && (yield I(i.call(m)));
        } finally {
          if (n) throw n.error;
        }
      }
    });
  }
  /**
   * Returns an async iterable iterator to list all the containers
   * under the specified account.
   *
   * .byPage() returns an async iterable iterator to list the containers in pages.
   *
   * Example using `for await` syntax:
   *
   * ```js
   * let i = 1;
   * for await (const container of blobServiceClient.listContainers()) {
   *   console.log(`Container ${i++}: ${container.name}`);
   * }
   * ```
   *
   * Example using `iter.next()`:
   *
   * ```js
   * let i = 1;
   * const iter = blobServiceClient.listContainers();
   * let containerItem = await iter.next();
   * while (!containerItem.done) {
   *   console.log(`Container ${i++}: ${containerItem.value.name}`);
   *   containerItem = await iter.next();
   * }
   * ```
   *
   * Example using `byPage()`:
   *
   * ```js
   * // passing optional maxPageSize in the page settings
   * let i = 1;
   * for await (const response of blobServiceClient.listContainers().byPage({ maxPageSize: 20 })) {
   *   if (response.containerItems) {
   *     for (const container of response.containerItems) {
   *       console.log(`Container ${i++}: ${container.name}`);
   *     }
   *   }
   * }
   * ```
   *
   * Example using paging with a marker:
   *
   * ```js
   * let i = 1;
   * let iterator = blobServiceClient.listContainers().byPage({ maxPageSize: 2 });
   * let response = (await iterator.next()).value;
   *
   * // Prints 2 container names
   * if (response.containerItems) {
   *   for (const container of response.containerItems) {
   *     console.log(`Container ${i++}: ${container.name}`);
   *   }
   * }
   *
   * // Gets next marker
   * let marker = response.continuationToken;
   * // Passing next marker as continuationToken
   * iterator = blobServiceClient
   *   .listContainers()
   *   .byPage({ continuationToken: marker, maxPageSize: 10 });
   * response = (await iterator.next()).value;
   *
   * // Prints 10 container names
   * if (response.containerItems) {
   *   for (const container of response.containerItems) {
   *      console.log(`Container ${i++}: ${container.name}`);
   *   }
   * }
   * ```
   *
   * @param options - Options to list containers.
   * @returns An asyncIterableIterator that supports paging.
   */
  listContainers(e = {}) {
    e.prefix === "" && (e.prefix = void 0);
    const t = [];
    e.includeDeleted && t.push("deleted"), e.includeMetadata && t.push("metadata"), e.includeSystem && t.push("system");
    const a = Object.assign(Object.assign({}, e), t.length > 0 ? { include: t } : {}), n = this.listItems(a);
    return {
      /**
       * The next method, part of the iteration protocol
       */
      next() {
        return n.next();
      },
      /**
       * The connection to the async iterator, part of the iteration protocol
       */
      [Symbol.asyncIterator]() {
        return this;
      },
      /**
       * Return an AsyncIterableIterator that works a page at a time
       */
      byPage: (i = {}) => this.listSegments(i.continuationToken, Object.assign({ maxPageSize: i.maxPageSize }, a))
    };
  }
  /**
   * ONLY AVAILABLE WHEN USING BEARER TOKEN AUTHENTICATION (TokenCredential).
   *
   * Retrieves a user delegation key for the Blob service. This is only a valid operation when using
   * bearer token authentication.
   *
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/get-user-delegation-key
   *
   * @param startsOn -      The start time for the user delegation SAS. Must be within 7 days of the current time
   * @param expiresOn -     The end time for the user delegation SAS. Must be within 7 days of the current time
   */
  async getUserDelegationKey(e, t, a = {}) {
    return x.withSpan("BlobServiceClient-getUserDelegationKey", a, async (n) => {
      const i = C(await this.serviceContext.getUserDelegationKey({
        startsOn: k(e, !1),
        expiresOn: k(t, !1)
      }, {
        abortSignal: a.abortSignal,
        tracingOptions: n.tracingOptions
      })), s = {
        signedObjectId: i.signedObjectId,
        signedTenantId: i.signedTenantId,
        signedStartsOn: new Date(i.signedStartsOn),
        signedExpiresOn: new Date(i.signedExpiresOn),
        signedService: i.signedService,
        signedVersion: i.signedVersion,
        value: i.value
      };
      return Object.assign({ _response: i._response, requestId: i.requestId, clientRequestId: i.clientRequestId, version: i.version, date: i.date, errorCode: i.errorCode }, s);
    });
  }
  /**
   * Creates a BlobBatchClient object to conduct batch operations.
   *
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/blob-batch
   *
   * @returns A new BlobBatchClient object for this service.
   */
  getBlobBatchClient() {
    return new wm(this.url, this.pipeline);
  }
  /**
   * Only available for BlobServiceClient constructed with a shared key credential.
   *
   * Generates a Blob account Shared Access Signature (SAS) URI based on the client properties
   * and parameters passed in. The SAS is signed by the shared key credential of the client.
   *
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/create-account-sas
   *
   * @param expiresOn - Optional. The time at which the shared access signature becomes invalid. Default to an hour later if not provided.
   * @param permissions - Specifies the list of permissions to be associated with the SAS.
   * @param resourceTypes - Specifies the resource types associated with the shared access signature.
   * @param options - Optional parameters.
   * @returns An account SAS URI consisting of the URI to the resource represented by this client, followed by the generated SAS token.
   */
  generateAccountSasUrl(e, t = Je.parse("r"), a = "sco", n = {}) {
    if (!(this.credential instanceof K))
      throw RangeError("Can only generate the account SAS when the client is initialized with a shared key credential");
    if (e === void 0) {
      const s = /* @__PURE__ */ new Date();
      e = new Date(s.getTime() + 3600 * 1e3);
    }
    const i = wg(Object.assign({
      permissions: t,
      expiresOn: e,
      resourceTypes: a,
      services: kt.parse("b").toString()
    }, n), this.credential).toString();
    return Ot(this.url, i);
  }
  /**
   * Only available for BlobServiceClient constructed with a shared key credential.
   *
   * Generates string to sign for a Blob account Shared Access Signature (SAS) URI based on
   * the client properties and parameters passed in. The SAS is signed by the shared key credential of the client.
   *
   * @see https://learn.microsoft.com/en-us/rest/api/storageservices/create-account-sas
   *
   * @param expiresOn - Optional. The time at which the shared access signature becomes invalid. Default to an hour later if not provided.
   * @param permissions - Specifies the list of permissions to be associated with the SAS.
   * @param resourceTypes - Specifies the resource types associated with the shared access signature.
   * @param options - Optional parameters.
   * @returns An account SAS URI consisting of the URI to the resource represented by this client, followed by the generated SAS token.
   */
  generateSasStringToSign(e, t = Je.parse("r"), a = "sco", n = {}) {
    if (!(this.credential instanceof K))
      throw RangeError("Can only generate the account SAS when the client is initialized with a shared key credential");
    if (e === void 0) {
      const i = /* @__PURE__ */ new Date();
      e = new Date(i.getTime() + 3600 * 1e3);
    }
    return Bm(Object.assign({
      permissions: t,
      expiresOn: e,
      resourceTypes: a,
      services: kt.parse("b").toString()
    }, n), this.credential).stringToSign;
  }
}
class Mg {
  constructor(e) {
    Sa(this, "sas");
    this.sas = e;
  }
  /** Upload file to azure directly through sas, returns any errors as string */
  async uploadAsync(e, t, a, n, i) {
    var m;
    let s = "", o = 0;
    const l = this.getBlockClient();
    if (!l)
      return "Unable to get client for azure upload";
    try {
      const c = await l.uploadData(
        e,
        {
          blockSize: 4194304,
          //10MB block size
          concurrency: 20,
          onProgress: (d) => {
            o = d.loadedBytes / t * 100, i && typeof i == "function" && i(o);
          },
          blobHTTPHeaders: { blobContentType: a },
          metadata: n,
          tier: Ur.Cold
        }
      );
      (((m = c.errorCode) == null ? void 0 : m.length) || 0) > 0 && (s = "Upload failed with an error code of " + c.errorCode);
    } catch (c) {
      console.log(c), s = c.message;
    }
    return s;
  }
  async uploadFileAsync(e, t) {
    return await this.uploadAsync(e, e.size, e.type, { name: e.name }, t);
  }
  getBlockClient() {
    return this.getContainerClient().getBlockBlobClient(this.sas.storagePath ?? "");
  }
  getContainerClient() {
    const e = j(new F(), {
      retryOptions: { maxTries: 4 },
      // Retry options
      userAgentOptions: { userAgentPrefix: "Daymap" },
      keepAliveOptions: { enable: !1 }
    });
    return new nr(`https://${this.sas.account}.blob.core.windows.net?${this.sas.token}`, e).getContainerClient(this.sas.container ?? "");
  }
}
export {
  Mg as AzureBlobs
};
//# sourceMappingURL=azureblobs.js.map
